import { useMutation, useQuery, useInfiniteQuery, useQueries, useQueryClient, useIsFetching } from '@tanstack/react-query';
import React, { useContext, useState, useCallback, useMemo, useEffect, useImperativeHandle, useLayoutEffect, memo, useRef, useReducer } from 'react';
import { z } from 'zod';
import YAML, { parseDocument } from 'yaml';
import * as Sentry from '@sentry/react';
import { Button as Button$1, Modal, FormControl, Navbar, Form, Dropdown, ProgressBar } from 'react-bootstrap';
import styled, { css, keyframes, createGlobalStyle } from 'styled-components';
import { Link as Link$1, useResolvedPath, useMatch, NavLink, useLocation, useNavigate, useSearchParams, Outlet, useParams, Routes, Route, Navigate } from 'react-router-dom';
import { highlight, languages } from 'prismjs';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-yaml';
import 'prism-themes/themes/prism-atom-dark.css';
import Editor from 'react-simple-code-editor';
import { useTable, useFilters, useSortBy, useExpanded } from 'react-table';
import InfiniteScroll from 'react-infinite-scroll-component';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Prism } from 'react-syntax-highlighter';
import { atomDark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import ReactSelect, { components } from 'react-select';
import ReactTooltip from 'react-tooltip';
import { useDropzone } from 'react-dropzone';
import copy from 'copy-to-clipboard';
import 'allotment/dist/style.css';
import { Allotment } from 'allotment';
import * as monaco from 'monaco-editor';
import { configureMonacoYaml } from 'monaco-yaml';
import Editor$1 from '@monaco-editor/react';
import ReactFlow, { useStore, NodeToolbar, Handle, Position, MarkerType, ReactFlowProvider, useNodesState, useEdgesState, applyNodeChanges, applyEdgeChanges, Controls, isNode, isEdge, getBezierPath, BaseEdge, EdgeLabelRenderer, Panel } from 'reactflow';
import 'reactflow/dist/style.css';
import CreatableSelect from 'react-select/creatable';
import 'graphiql/graphiql.min.css';
import GraphiQL from 'graphiql';
import { visit } from 'graphql';
import { useAuth, AuthProvider } from 'oidc-react';

var defaultFeatureFlags = {
  isGraphQLEnabled: true,
  hasTemplates: true,
  hasAssertions: true,
  hasDirectoryApiBrowser: false
};
var featureFlagsContext = /*#__PURE__*/React.createContext(defaultFeatureFlags);
/**
 * Custom hook that allows accessing the feature flags from the featureFlagsContext.
 * @returns {FeatureFlags} The feature flags object.
 */
var useFeatureFlags = function useFeatureFlags() {
  var featureFlags = useContext(featureFlagsContext);
  return featureFlags;
};
/**
 * Component that provides feature flags to its children.
 *
 * @component
 * @example
 * ```tsx
 * <FeatureFlagsProvider
 *  featureFlags={{
 *    isGraphQLEnabled: true,
 *    hasTemplates: true,
 *    hasAssertions: true,
 *    hasDirectoryApiBrowser: false,
 *  }}
 * >
 *   <App />
 * </FeatureFlagsProvider>
 * ```
 *
 * @param {React.ReactNode} props.children - The child components that will have access to the feature flags.
 * @param {FeatureFlags} props.featureFlags - An object containing the feature flags to be provided to the children.
 * @returns {React.ReactElement} A React element wrapping the children with a `featureFlagsContext.Provider`.
 */
var FeatureFlagsProvider = function FeatureFlagsProvider(_ref) {
  var children = _ref.children,
    featureFlags = _ref.featureFlags;
  return /*#__PURE__*/React.createElement(featureFlagsContext.Provider, {
    value: featureFlags
  }, children);
};

function _arrayLikeToArray$3(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray$3(r);
}

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _unsupportedIterableToArray$3(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$3(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$3(r, a) : void 0;
  }
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray$3(r) || _nonIterableSpread();
}

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var regeneratorRuntime$1 = {exports: {}};

var _typeof$1 = {exports: {}};

var hasRequired_typeof;
function require_typeof () {
	if (hasRequired_typeof) return _typeof$1.exports;
	hasRequired_typeof = 1;
	(function (module) {
		function _typeof(o) {
		  "@babel/helpers - typeof";
		  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
		    return typeof o;
		  } : function (o) {
		    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
		  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
		}
		module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
	} (_typeof$1));
	return _typeof$1.exports;
}

var hasRequiredRegeneratorRuntime;
function requireRegeneratorRuntime () {
	if (hasRequiredRegeneratorRuntime) return regeneratorRuntime$1.exports;
	hasRequiredRegeneratorRuntime = 1;
	(function (module) {
		var _typeof = require_typeof()["default"];
		function _regeneratorRuntime() {
		  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
		    return e;
		  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
		  var t,
		    e = {},
		    r = Object.prototype,
		    n = r.hasOwnProperty,
		    o = Object.defineProperty || function (t, e, r) {
		      t[e] = r.value;
		    },
		    i = "function" == typeof Symbol ? Symbol : {},
		    a = i.iterator || "@@iterator",
		    c = i.asyncIterator || "@@asyncIterator",
		    u = i.toStringTag || "@@toStringTag";
		  function define(t, e, r) {
		    return Object.defineProperty(t, e, {
		      value: r,
		      enumerable: !0,
		      configurable: !0,
		      writable: !0
		    }), t[e];
		  }
		  try {
		    define({}, "");
		  } catch (t) {
		    define = function define(t, e, r) {
		      return t[e] = r;
		    };
		  }
		  function wrap(t, e, r, n) {
		    var i = e && e.prototype instanceof Generator ? e : Generator,
		      a = Object.create(i.prototype),
		      c = new Context(n || []);
		    return o(a, "_invoke", {
		      value: makeInvokeMethod(t, r, c)
		    }), a;
		  }
		  function tryCatch(t, e, r) {
		    try {
		      return {
		        type: "normal",
		        arg: t.call(e, r)
		      };
		    } catch (t) {
		      return {
		        type: "throw",
		        arg: t
		      };
		    }
		  }
		  e.wrap = wrap;
		  var h = "suspendedStart",
		    l = "suspendedYield",
		    f = "executing",
		    s = "completed",
		    y = {};
		  function Generator() {}
		  function GeneratorFunction() {}
		  function GeneratorFunctionPrototype() {}
		  var p = {};
		  define(p, a, function () {
		    return this;
		  });
		  var d = Object.getPrototypeOf,
		    v = d && d(d(values([])));
		  v && v !== r && n.call(v, a) && (p = v);
		  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
		  function defineIteratorMethods(t) {
		    ["next", "throw", "return"].forEach(function (e) {
		      define(t, e, function (t) {
		        return this._invoke(e, t);
		      });
		    });
		  }
		  function AsyncIterator(t, e) {
		    function invoke(r, o, i, a) {
		      var c = tryCatch(t[r], t, o);
		      if ("throw" !== c.type) {
		        var u = c.arg,
		          h = u.value;
		        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
		          invoke("next", t, i, a);
		        }, function (t) {
		          invoke("throw", t, i, a);
		        }) : e.resolve(h).then(function (t) {
		          u.value = t, i(u);
		        }, function (t) {
		          return invoke("throw", t, i, a);
		        });
		      }
		      a(c.arg);
		    }
		    var r;
		    o(this, "_invoke", {
		      value: function value(t, n) {
		        function callInvokeWithMethodAndArg() {
		          return new e(function (e, r) {
		            invoke(t, n, e, r);
		          });
		        }
		        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
		      }
		    });
		  }
		  function makeInvokeMethod(e, r, n) {
		    var o = h;
		    return function (i, a) {
		      if (o === f) throw Error("Generator is already running");
		      if (o === s) {
		        if ("throw" === i) throw a;
		        return {
		          value: t,
		          done: !0
		        };
		      }
		      for (n.method = i, n.arg = a;;) {
		        var c = n.delegate;
		        if (c) {
		          var u = maybeInvokeDelegate(c, n);
		          if (u) {
		            if (u === y) continue;
		            return u;
		          }
		        }
		        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
		          if (o === h) throw o = s, n.arg;
		          n.dispatchException(n.arg);
		        } else "return" === n.method && n.abrupt("return", n.arg);
		        o = f;
		        var p = tryCatch(e, r, n);
		        if ("normal" === p.type) {
		          if (o = n.done ? s : l, p.arg === y) continue;
		          return {
		            value: p.arg,
		            done: n.done
		          };
		        }
		        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
		      }
		    };
		  }
		  function maybeInvokeDelegate(e, r) {
		    var n = r.method,
		      o = e.iterator[n];
		    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
		    var i = tryCatch(o, e.iterator, r.arg);
		    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
		    var a = i.arg;
		    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
		  }
		  function pushTryEntry(t) {
		    var e = {
		      tryLoc: t[0]
		    };
		    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
		  }
		  function resetTryEntry(t) {
		    var e = t.completion || {};
		    e.type = "normal", delete e.arg, t.completion = e;
		  }
		  function Context(t) {
		    this.tryEntries = [{
		      tryLoc: "root"
		    }], t.forEach(pushTryEntry, this), this.reset(!0);
		  }
		  function values(e) {
		    if (e || "" === e) {
		      var r = e[a];
		      if (r) return r.call(e);
		      if ("function" == typeof e.next) return e;
		      if (!isNaN(e.length)) {
		        var o = -1,
		          i = function next() {
		            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
		            return next.value = t, next.done = !0, next;
		          };
		        return i.next = i;
		      }
		    }
		    throw new TypeError(_typeof(e) + " is not iterable");
		  }
		  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
		    value: GeneratorFunctionPrototype,
		    configurable: !0
		  }), o(GeneratorFunctionPrototype, "constructor", {
		    value: GeneratorFunction,
		    configurable: !0
		  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
		    var e = "function" == typeof t && t.constructor;
		    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
		  }, e.mark = function (t) {
		    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
		  }, e.awrap = function (t) {
		    return {
		      __await: t
		    };
		  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
		    return this;
		  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
		    void 0 === i && (i = Promise);
		    var a = new AsyncIterator(wrap(t, r, n, o), i);
		    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
		      return t.done ? t.value : a.next();
		    });
		  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
		    return this;
		  }), define(g, "toString", function () {
		    return "[object Generator]";
		  }), e.keys = function (t) {
		    var e = Object(t),
		      r = [];
		    for (var n in e) r.push(n);
		    return r.reverse(), function next() {
		      for (; r.length;) {
		        var t = r.pop();
		        if (t in e) return next.value = t, next.done = !1, next;
		      }
		      return next.done = !0, next;
		    };
		  }, e.values = values, Context.prototype = {
		    constructor: Context,
		    reset: function reset(e) {
		      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
		    },
		    stop: function stop() {
		      this.done = !0;
		      var t = this.tryEntries[0].completion;
		      if ("throw" === t.type) throw t.arg;
		      return this.rval;
		    },
		    dispatchException: function dispatchException(e) {
		      if (this.done) throw e;
		      var r = this;
		      function handle(n, o) {
		        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
		      }
		      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
		        var i = this.tryEntries[o],
		          a = i.completion;
		        if ("root" === i.tryLoc) return handle("end");
		        if (i.tryLoc <= this.prev) {
		          var c = n.call(i, "catchLoc"),
		            u = n.call(i, "finallyLoc");
		          if (c && u) {
		            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
		            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
		          } else if (c) {
		            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
		          } else {
		            if (!u) throw Error("try statement without catch or finally");
		            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
		          }
		        }
		      }
		    },
		    abrupt: function abrupt(t, e) {
		      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
		        var o = this.tryEntries[r];
		        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
		          var i = o;
		          break;
		        }
		      }
		      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
		      var a = i ? i.completion : {};
		      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
		    },
		    complete: function complete(t, e) {
		      if ("throw" === t.type) throw t.arg;
		      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
		    },
		    finish: function finish(t) {
		      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
		        var r = this.tryEntries[e];
		        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
		      }
		    },
		    "catch": function _catch(t) {
		      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
		        var r = this.tryEntries[e];
		        if (r.tryLoc === t) {
		          var n = r.completion;
		          if ("throw" === n.type) {
		            var o = n.arg;
		            resetTryEntry(r);
		          }
		          return o;
		        }
		      }
		      throw Error("illegal catch attempt");
		    },
		    delegateYield: function delegateYield(e, r, n) {
		      return this.delegate = {
		        iterator: values(e),
		        resultName: r,
		        nextLoc: n
		      }, "next" === this.method && (this.arg = t), y;
		    }
		  }, e;
		}
		module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
	} (regeneratorRuntime$1));
	return regeneratorRuntime$1.exports;
}

var regenerator;
var hasRequiredRegenerator;
function requireRegenerator () {
	if (hasRequiredRegenerator) return regenerator;
	hasRequiredRegenerator = 1;
	var runtime = requireRegeneratorRuntime()();
	regenerator = runtime;
	try {
	  regeneratorRuntime = runtime;
	} catch (accidentalStrictMode) {
	  if (typeof globalThis === "object") {
	    globalThis.regeneratorRuntime = runtime;
	  } else {
	    Function("r", "regeneratorRuntime = r")(runtime);
	  }
	}
	return regenerator;
}

var regeneratorExports = requireRegenerator();
var _regeneratorRuntime = /*@__PURE__*/getDefaultExportFromCjs(regeneratorExports);

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var defaultConfig = {
  getAuthorizerToken: function getAuthorizerToken() {
    return Promise.resolve('');
  },
  getDirectoryToken: function getDirectoryToken() {
    return Promise.resolve('');
  }
};
var backendServicesAuthContext = /*#__PURE__*/React.createContext(defaultConfig);
var useBackendServicesAuth = function useBackendServicesAuth() {
  var config = useContext(backendServicesAuthContext);
  if (config === defaultConfig) {
    throw Error('BackendServicesAuth must be retrieved in the context of an "BackendServicesAuthProvider"');
  }
  return config;
};
var BackendServicesAuthProvider = function BackendServicesAuthProvider(_ref) {
  var children = _ref.children,
    backendServicesAuth = _ref.backendServicesAuth;
  return !backendServicesAuth ? null : (/*#__PURE__*/React.createElement(backendServicesAuthContext.Provider, {
    value: backendServicesAuth
  }, children));
};

var emptyConfig = {
  authorizerServiceUrl: '',
  authorizerApiKey: '',
  directoryReaderServiceUrl: '',
  directoryServiceUrl: '',
  directoryWriterServiceUrl: '',
  directoryModelServiceUrl: '',
  directoryApiKey: ''
};
var configContext = /*#__PURE__*/React.createContext(emptyConfig);
var useConfig = function useConfig() {
  var config = useContext(configContext);
  if (config === emptyConfig) {
    throw 'Config must be retrieved in the context of a <InternalConfigProvider>';
  }
  return config;
};
var InternalConfigProvider = function InternalConfigProvider(_ref) {
  var children = _ref.children,
    config = _ref.config;
  return !config ? null : /*#__PURE__*/React.createElement(configContext.Provider, {
    value: config
  }, children);
};

var identityProviderContext = /*#__PURE__*/React.createContext(undefined);
var useIdentity = function useIdentity() {
  var identity = useContext(identityProviderContext);
  if (identity === undefined) {
    throw Error('Identity must be retrieved in the context of an "IdentityProvider"');
  }
  return identity;
};
var GenericIdentityProvider = function GenericIdentityProvider(_ref) {
  var children = _ref.children,
    identity = _ref.identity;
  return !identity ? null : (/*#__PURE__*/React.createElement(identityProviderContext.Provider, {
    value: identity
  }, children));
};

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray$3(r, e) || _nonIterableRest();
}

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}

function _isNativeReflectConstruct$2() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$2 = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function _construct(t, e, r) {
  if (_isNativeReflectConstruct$2()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}

function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}

function _callSuper$1(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct$1() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() { return !!t; })(); }
var ApiErrorResponseSchema = z.object({
  message: z.string(),
  code: z.number(),
  details: z.array(z.object({
    '@type': z.string(),
    domain: z.string(),
    metadata: z.record(z.unknown()),
    reason: z.string()
  }))
});
var ApiError = function (_Error) {
  function ApiError(message, code, type, reason, metadata) {
    var _this;
    _classCallCheck(this, ApiError);
    _this = _callSuper$1(this, ApiError, [message]);
    _this.code = code;
    _this.type = type;
    _this.reason = reason;
    _this.metadata = metadata;
    return _this;
  }
  _inherits(ApiError, _Error);
  return _createClass(ApiError, null, [{
    key: "fromResponse",
    value: function fromResponse(response) {
      var message = response.message,
        code = response.code,
        details = response.details;
      if (details.length > 0) {
        var _details = _slicedToArray(details, 1),
          _details$ = _details[0],
          type = _details$['@type'],
          metadata = _details$.metadata,
          reason = _details$.reason;
        return new ApiError(message, code, type, reason, metadata);
      }
      return new ApiError(message, code, null, null, null);
    }
  }]);
}(_wrapNativeSuper(Error));

var ensureError = function ensureError(error) {
  if (error instanceof Error) {
    return error;
  }
  var apiErrorResponseParseResult = ApiErrorResponseSchema.safeParse(error);
  if (apiErrorResponseParseResult.success) {
    return ApiError.fromResponse(apiErrorResponseParseResult.data);
  }
  return new Error(JSON.stringify(error, null, 2));
};

var profileProviderContext = /*#__PURE__*/React.createContext(undefined);
var useProfile = function useProfile() {
  var profile = useContext(profileProviderContext);
  if (profile === undefined) {
    return {
      account: null,
      tenantId: undefined,
      setTenantId: undefined
    };
  }
  return Object.assign({}, profile);
};
var InternalProfileProvider = function InternalProfileProvider(_ref) {
  var children = _ref.children,
    profile = _ref.profile;
  return !profile ? null : (/*#__PURE__*/React.createElement(profileProviderContext.Provider, {
    value: profile
  }, children));
};

var storageProviderContext = /*#__PURE__*/React.createContext({
  local: typeof window === 'undefined' ? undefined : window.localStorage,
  session: typeof window === 'undefined' ? undefined : window.sessionStorage
});
var useStorage = function useStorage(key, initialValue) {
  var storageContext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'local';
  var storageProviders = useContext(storageProviderContext);
  var storageImplementation = storageProviders[storageContext];
  var _useState = useState(function () {
      if (!storageImplementation) {
        return initialValue;
      }
      try {
        var item = storageImplementation.getItem(key);
        return !!item && item !== 'undefined' ? JSON.parse(item) : initialValue;
      } catch (_a) {
        return initialValue;
      }
    }),
    _useState2 = _slicedToArray(_useState, 2),
    storedValue = _useState2[0],
    setStoredValue = _useState2[1];
  var setValue = function setValue(value) {
    try {
      var valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      if (!!storageImplementation) {
        if (!!valueToStore) {
          storageImplementation.setItem(key, JSON.stringify(valueToStore));
        } else {
          storageImplementation.removeItem(key);
        }
      }
    } catch (_a) {}
  };
  return [storedValue, setValue];
};
var createMemoryStorage = function createMemoryStorage() {
  var storage = {};
  return {
    get length() {
      return Object.keys(storage).length;
    },
    clear: function clear() {
      var keys = Object.keys(storage);
      keys.map(function (k) {
        delete storage[k];
      });
    },
    getItem: function getItem(key) {
      return storage[key];
    },
    key: function key(index) {
      var keys = Object.keys(storage);
      return index >= keys.length ? null : keys[index];
    },
    removeItem: function removeItem(key) {
      if (!!storage[key]) {
        delete storage[key];
      }
    },
    setItem: function setItem(key, value) {
      storage[key] = value;
    }
  };
};
var MemoryStorageProvider = function MemoryStorageProvider(_ref) {
  var children = _ref.children,
    local = _ref.local,
    session = _ref.session;
  return /*#__PURE__*/React.createElement(storageProviderContext.Provider, {
    value: {
      local: local,
      session: session
    }
  }, children);
};

function flatten(input) {
  var flat = {};
  for (var k in input) {
    var value = input[k];
    if (_typeof(value) === 'object' && value !== null && !Array.isArray(value)) {
      var temp = flatten(value);
      for (var j in temp) {
        flat[k + '.' + j] = temp[j];
      }
    } else {
      flat[k] = value;
    }
  }
  return flat;
}

function useAsertoApi(baseUrl) {
  var _this = this;
  var apiHeaderOverrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var getAuthorizationHeaderValue = arguments.length > 2 ? arguments[2] : undefined;
  var onUnauthorized = arguments.length > 3 ? arguments[3] : undefined;
  var _useProfile = useProfile(),
    tenantId = _useProfile.tenantId,
    setTenantId = _useProfile.setTenantId;
  var _useStorage = useStorage('tenantId', undefined),
    _useStorage2 = _slicedToArray(_useStorage, 1),
    localTenantId = _useStorage2[0];
  var generateHeaders = useCallback(function () {
    for (var _len = arguments.length, args_1 = new Array(_len), _key = 0; _key < _len; _key++) {
      args_1[_key] = arguments[_key];
    }
    return __awaiter(_this, [].concat(args_1), void 0, function () {
      var headerOverrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _regeneratorRuntime.mark(function _callee() {
        var headers;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = Object;
              _context.t1 = Object;
              _context.t2 = {};
              if (!getAuthorizationHeaderValue) {
                _context.next = 12;
                break;
              }
              _context.t4 = "";
              _context.next = 7;
              return getAuthorizationHeaderValue();
            case 7:
              _context.t5 = _context.sent;
              _context.t6 = _context.t4.concat.call(_context.t4, _context.t5);
              _context.t3 = {
                Authorization: _context.t6
              };
              _context.next = 13;
              break;
            case 12:
              _context.t3 = {};
            case 13:
              _context.t7 = _context.t3;
              _context.t8 = _context.t1.assign.call(_context.t1, _context.t2, _context.t7);
              _context.t9 = {
                'Content-Type': 'application/json'
              };
              headers = _context.t0.assign.call(_context.t0, _context.t8, _context.t9);
              if (tenantId) {
                headers['aserto-tenant-id'] = tenantId;
              } else {
                if (localTenantId) {
                  headers['aserto-tenant-id'] = localTenantId;
                }
              }
              Object.assign(headers, apiHeaderOverrides, headerOverrides);
              return _context.abrupt("return", headers);
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    });
  }, [getAuthorizationHeaderValue, tenantId, apiHeaderOverrides, localTenantId]);
  var logoutIfUnauthorized = useCallback(function (status) {
    if (status === 401) {
      onUnauthorized === null || onUnauthorized === void 0 ? void 0 : onUnauthorized();
    }
  }, [onUnauthorized]);
  var invalidateCacheIfAccessDenied = useCallback(function (status, error) {
    if (status === 403 && (error === null || error === void 0 ? void 0 : error.code) === 7) {
      if (localTenantId && tenantId !== localTenantId) {
        setTenantId === null || setTenantId === void 0 ? void 0 : setTenantId(localTenantId);
      }
    }
  }, [setTenantId, localTenantId, tenantId]);
  var fetchFromAsertoApi = useCallback(function (method_1, path_1) {
    for (var _len2 = arguments.length, args_1 = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args_1[_key2 - 2] = arguments[_key2];
    }
    return __awaiter(_this, [method_1, path_1].concat(args_1), void 0, function (method, path) {
      var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var body = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      var headerOverrides = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var abortSignal = arguments.length > 5 ? arguments[5] : undefined;
      return _regeneratorRuntime.mark(function _callee2() {
        var _yield$Promise$all, _yield$Promise$all2, headers, queryPart, url, response, error;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Promise.all([generateHeaders(headerOverrides)]);
            case 2:
              _yield$Promise$all = _context2.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
              headers = _yield$Promise$all2[0];
              queryPart = !!queryParams && Object.keys(queryParams).length > 0 ? "?".concat(new URLSearchParams(queryParams)) : '';
              url = baseUrl;
              if (path !== '') {
                url = "".concat(baseUrl, "/").concat(path).concat(queryPart);
              }
              _context2.next = 10;
              return fetch(url, {
                method: method || 'GET',
                headers: headers,
                body: body,
                signal: abortSignal
              });
            case 10:
              response = _context2.sent;
              if (response.ok) {
                _context2.next = 25;
                break;
              }
              error = ensureError("".concat(response.status, ": ").concat(response.statusText, " from ").concat(method, " ").concat(url));
              _context2.prev = 13;
              _context2.t0 = ensureError;
              _context2.next = 17;
              return response.json();
            case 17:
              _context2.t1 = _context2.sent;
              error = (0, _context2.t0)(_context2.t1);
              _context2.next = 23;
              break;
            case 21:
              _context2.prev = 21;
              _context2.t2 = _context2["catch"](13);
            case 23:
              invalidateCacheIfAccessDenied(response.status, error);
              throw error;
            case 25:
              logoutIfUnauthorized(response.status);
              return _context2.abrupt("return", response);
            case 27:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[13, 21]]);
      })();
    });
  }, [baseUrl, generateHeaders, logoutIfUnauthorized, invalidateCacheIfAccessDenied]);
  return useMemo(function () {
    return {
      del: function del(_a) {
        return __awaiter(_this, [_a], void 0, function (_ref) {
          var abortSignal = _ref.abortSignal,
            _ref$headerOverrides = _ref.headerOverrides,
            headerOverrides = _ref$headerOverrides === void 0 ? {} : _ref$headerOverrides,
            path = _ref.path,
            queryParams = _ref.queryParams;
          return _regeneratorRuntime.mark(function _callee3() {
            var response;
            return _regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return fetchFromAsertoApi('DELETE', path, flatten(queryParams), undefined, headerOverrides, abortSignal);
                case 2:
                  response = _context3.sent;
                  return _context3.abrupt("return", response.json());
                case 4:
                case "end":
                  return _context3.stop();
              }
            }, _callee3);
          })();
        });
      },
      get: function get(_a) {
        return __awaiter(_this, [_a], void 0, function (_ref2) {
          var abortSignal = _ref2.abortSignal,
            _ref2$headerOverrides = _ref2.headerOverrides,
            headerOverrides = _ref2$headerOverrides === void 0 ? {} : _ref2$headerOverrides,
            path = _ref2.path,
            queryParams = _ref2.queryParams;
          return _regeneratorRuntime.mark(function _callee4() {
            var response;
            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return fetchFromAsertoApi('GET', path, flatten(queryParams), undefined, headerOverrides, abortSignal);
                case 2:
                  response = _context4.sent;
                  return _context4.abrupt("return", response.json());
                case 4:
                case "end":
                  return _context4.stop();
              }
            }, _callee4);
          })();
        });
      },
      getBlob: function getBlob(_a) {
        return __awaiter(_this, [_a], void 0, function (_ref3) {
          var abortSignal = _ref3.abortSignal,
            _ref3$headerOverrides = _ref3.headerOverrides,
            headerOverrides = _ref3$headerOverrides === void 0 ? {} : _ref3$headerOverrides,
            path = _ref3.path,
            queryParams = _ref3.queryParams;
          return _regeneratorRuntime.mark(function _callee5() {
            var response, blob, data;
            return _regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return fetchFromAsertoApi('GET', path, flatten(queryParams), undefined, headerOverrides, abortSignal);
                case 2:
                  response = _context5.sent;
                  _context5.next = 5;
                  return response.blob();
                case 5:
                  blob = _context5.sent;
                  data = blob.text();
                  return _context5.abrupt("return", data);
                case 8:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          })();
        });
      },
      patch: function patch(_a) {
        return __awaiter(_this, [_a], void 0, function (_ref4) {
          var abortSignal = _ref4.abortSignal,
            body = _ref4.body,
            _ref4$headerOverrides = _ref4.headerOverrides,
            headerOverrides = _ref4$headerOverrides === void 0 ? {} : _ref4$headerOverrides,
            path = _ref4.path,
            queryParams = _ref4.queryParams;
          return _regeneratorRuntime.mark(function _callee6() {
            var response;
            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return fetchFromAsertoApi('PATCH', path, flatten(queryParams), JSON.stringify(body), headerOverrides, abortSignal);
                case 2:
                  response = _context6.sent;
                  return _context6.abrupt("return", response.json());
                case 4:
                case "end":
                  return _context6.stop();
              }
            }, _callee6);
          })();
        });
      },
      post: function post(_a) {
        return __awaiter(_this, [_a], void 0, function (_ref5) {
          var abortSignal = _ref5.abortSignal,
            body = _ref5.body,
            _ref5$headerOverrides = _ref5.headerOverrides,
            headerOverrides = _ref5$headerOverrides === void 0 ? {} : _ref5$headerOverrides,
            path = _ref5.path,
            queryParams = _ref5.queryParams;
          return _regeneratorRuntime.mark(function _callee7() {
            var response;
            return _regeneratorRuntime.wrap(function _callee7$(_context7) {
              while (1) switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return fetchFromAsertoApi('POST', path, flatten(queryParams), JSON.stringify(body), headerOverrides, abortSignal);
                case 2:
                  response = _context7.sent;
                  if (!(headerOverrides['accept'] === 'application/octet-stream')) {
                    _context7.next = 5;
                    break;
                  }
                  return _context7.abrupt("return", response.blob());
                case 5:
                  return _context7.abrupt("return", response.json());
                case 6:
                case "end":
                  return _context7.stop();
              }
            }, _callee7);
          })();
        });
      },
      postBlob: function postBlob(_a) {
        return __awaiter(_this, [_a], void 0, function (_ref6) {
          var abortSignal = _ref6.abortSignal,
            body = _ref6.body,
            _ref6$headerOverrides = _ref6.headerOverrides,
            headerOverrides = _ref6$headerOverrides === void 0 ? {} : _ref6$headerOverrides,
            path = _ref6.path,
            queryParams = _ref6.queryParams;
          return _regeneratorRuntime.mark(function _callee8() {
            var response;
            return _regeneratorRuntime.wrap(function _callee8$(_context8) {
              while (1) switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return fetchFromAsertoApi('POST', path, flatten(queryParams), body, headerOverrides, abortSignal);
                case 2:
                  response = _context8.sent;
                  return _context8.abrupt("return", response.blob());
                case 4:
                case "end":
                  return _context8.stop();
              }
            }, _callee8);
          })();
        });
      },
      put: function put(_a) {
        return __awaiter(_this, [_a], void 0, function (_ref7) {
          var abortSignal = _ref7.abortSignal,
            body = _ref7.body,
            _ref7$headerOverrides = _ref7.headerOverrides,
            headerOverrides = _ref7$headerOverrides === void 0 ? {} : _ref7$headerOverrides,
            path = _ref7.path,
            queryParams = _ref7.queryParams;
          return _regeneratorRuntime.mark(function _callee9() {
            var response;
            return _regeneratorRuntime.wrap(function _callee9$(_context9) {
              while (1) switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return fetchFromAsertoApi('PUT', path, flatten(queryParams), JSON.stringify(body), headerOverrides, abortSignal);
                case 2:
                  response = _context9.sent;
                  return _context9.abrupt("return", response.json());
                case 4:
                case "end":
                  return _context9.stop();
              }
            }, _callee9);
          })();
        });
      }
    };
  }, [fetchFromAsertoApi]);
}
function v1Api(serviceUrl) {
  return "".concat(serviceUrl, "/api/v1");
}
function v2Api(serviceUrl) {
  return "".concat(serviceUrl, "/api/v2");
}

var useAsertoApiWithAuth = function useAsertoApiWithAuth(baseUrl) {
  var apiHeaderOverrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fetchAccessToken = arguments.length > 2 ? arguments[2] : undefined;
  var _useIdentity = useIdentity(),
    getAccessToken = _useIdentity.getAccessToken,
    logout = _useIdentity.logout;
  var getAuthorizationHeaderValue = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (fetchAccessToken === null || fetchAccessToken === void 0 ? void 0 : fetchAccessToken()) || getAccessToken();
          case 2:
            return _context.abrupt("return", _context.sent);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }, [getAccessToken, fetchAccessToken]);
  var onUnauthorized = useCallback(function () {
    return logout;
  }, [logout]);
  return useAsertoApi(baseUrl, apiHeaderOverrides, getAuthorizationHeaderValue, onUnauthorized);
};

var useRestDirectoryClient = function useRestDirectoryClient(directoryServiceUrl) {
  var _useBackendServicesAu = useBackendServicesAuth(),
    getDirectoryToken = _useBackendServicesAu.getDirectoryToken;
  var client = useAsertoApiWithAuth(directoryServiceUrl, {}, getDirectoryToken);
  return function (_a) {
    return __awaiter(void 0, [_a], void 0, function (_ref) {
      var url = _ref.url,
        method = _ref.method,
        params = _ref.params,
        data = _ref.data,
        signal = _ref.signal,
        responseType = _ref.responseType;
      return _regeneratorRuntime.mark(function _callee() {
        var path, queryParams, body, abortSignal;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              path = url.replace('/', '');
              queryParams = params;
              if (queryParams && queryParams['page.token'] === undefined) {
                delete queryParams['page.token'];
              }
              body = data;
              abortSignal = signal;
              _context.t0 = method.toUpperCase();
              _context.next = _context.t0 === 'GET' ? 8 : _context.t0 === 'POST' ? 15 : _context.t0 === 'PUT' ? 22 : _context.t0 === 'DELETE' ? 25 : 28;
              break;
            case 8:
              if (!(responseType === 'blob')) {
                _context.next = 12;
                break;
              }
              _context.next = 11;
              return client.getBlob({
                abortSignal: abortSignal,
                path: path,
                queryParams: queryParams
              });
            case 11:
              return _context.abrupt("return", _context.sent);
            case 12:
              _context.next = 14;
              return client.get({
                abortSignal: abortSignal,
                path: path,
                queryParams: queryParams
              });
            case 14:
              return _context.abrupt("return", _context.sent);
            case 15:
              if (!(responseType === 'blob' || path.startsWith('api/v3/directory/manifest'))) {
                _context.next = 19;
                break;
              }
              _context.next = 18;
              return client.postBlob({
                abortSignal: abortSignal,
                body: body,
                path: path,
                queryParams: queryParams
              });
            case 18:
              return _context.abrupt("return", _context.sent);
            case 19:
              _context.next = 21;
              return client.post({
                abortSignal: abortSignal,
                body: body,
                path: path,
                queryParams: queryParams
              });
            case 21:
              return _context.abrupt("return", _context.sent);
            case 22:
              _context.next = 24;
              return client.put({
                abortSignal: abortSignal,
                body: body,
                path: path,
                queryParams: queryParams
              });
            case 24:
              return _context.abrupt("return", _context.sent);
            case 25:
              _context.next = 27;
              return client.del({
                abortSignal: abortSignal,
                path: path,
                queryParams: queryParams
              });
            case 27:
              return _context.abrupt("return", _context.sent);
            case 28:
              _context.next = 30;
              return client.get({
                abortSignal: abortSignal,
                path: path,
                queryParams: queryParams
              });
            case 30:
              return _context.abrupt("return", _context.sent);
            case 31:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    });
  };
};
var useDirectoryReaderClient = function useDirectoryReaderClient() {
  var _useConfig = useConfig(),
    directoryReaderServiceUrl = _useConfig.directoryReaderServiceUrl,
    directoryServiceUrl = _useConfig.directoryServiceUrl;
  return useRestDirectoryClient(directoryReaderServiceUrl || directoryServiceUrl);
};
var useDirectoryWriterClient = function useDirectoryWriterClient() {
  var _useConfig2 = useConfig(),
    directoryWriterServiceUrl = _useConfig2.directoryWriterServiceUrl,
    directoryServiceUrl = _useConfig2.directoryServiceUrl;
  return useRestDirectoryClient(directoryWriterServiceUrl || directoryServiceUrl);
};
var useDirectoryModelClient = function useDirectoryModelClient() {
  var _useConfig3 = useConfig(),
    directoryModelServiceUrl = _useConfig3.directoryModelServiceUrl,
    directoryServiceUrl = _useConfig3.directoryServiceUrl;
  return useRestDirectoryClient(directoryModelServiceUrl || directoryServiceUrl);
};

/**
 * Set assertion.
 * @summary Set assertion
 */
var useDirectoryAssertionV3AssertionSetHook = function useDirectoryAssertionV3AssertionSetHook() {
  var directoryAssertionV3AssertionSet = useDirectoryReaderClient();
  return useCallback(function (v3SetAssertionRequest, signal) {
    return directoryAssertionV3AssertionSet({
      url: "/api/v3/directory/assertion",
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: v3SetAssertionRequest,
      signal: signal
    });
  }, [directoryAssertionV3AssertionSet]);
};
var useDirectoryAssertionV3AssertionSetMutationOptions = function useDirectoryAssertionV3AssertionSetMutationOptions(options) {
  var mutationKey = ['directoryAssertionV3AssertionSet'];
  var _ref = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : Object.assign(Object.assign({}, options), {
      mutation: Object.assign(Object.assign({}, options.mutation), {
        mutationKey: mutationKey
      })
    }) : {
      mutation: {
        mutationKey: mutationKey
      }
    },
    mutationOptions = _ref.mutation;
  var directoryAssertionV3AssertionSet = useDirectoryAssertionV3AssertionSetHook();
  var mutationFn = function mutationFn(props) {
    var _ref2 = props !== null && props !== void 0 ? props : {},
      data = _ref2.data;
    return directoryAssertionV3AssertionSet(data);
  };
  return Object.assign({
    mutationFn: mutationFn
  }, mutationOptions);
};
/**
 * @summary Set assertion
 */
var useDirectoryAssertionV3AssertionSet = function useDirectoryAssertionV3AssertionSet(options) {
  var mutationOptions = useDirectoryAssertionV3AssertionSetMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Delete assertion.
 * @summary Delete assertion
 */
var useDirectoryAssertionV3AssertionDeleteHook = function useDirectoryAssertionV3AssertionDeleteHook() {
  var directoryAssertionV3AssertionDelete = useDirectoryReaderClient();
  return useCallback(function (id) {
    return directoryAssertionV3AssertionDelete({
      url: "/api/v3/directory/assertion/".concat(id),
      method: 'DELETE'
    });
  }, [directoryAssertionV3AssertionDelete]);
};
var useDirectoryAssertionV3AssertionDeleteMutationOptions = function useDirectoryAssertionV3AssertionDeleteMutationOptions(options) {
  var mutationKey = ['directoryAssertionV3AssertionDelete'];
  var _ref3 = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : Object.assign(Object.assign({}, options), {
      mutation: Object.assign(Object.assign({}, options.mutation), {
        mutationKey: mutationKey
      })
    }) : {
      mutation: {
        mutationKey: mutationKey
      }
    },
    mutationOptions = _ref3.mutation;
  var directoryAssertionV3AssertionDelete = useDirectoryAssertionV3AssertionDeleteHook();
  var mutationFn = function mutationFn(props) {
    var _ref4 = props !== null && props !== void 0 ? props : {},
      id = _ref4.id;
    return directoryAssertionV3AssertionDelete(id);
  };
  return Object.assign({
    mutationFn: mutationFn
  }, mutationOptions);
};
/**
 * @summary Delete assertion
 */
var useDirectoryAssertionV3AssertionDelete = function useDirectoryAssertionV3AssertionDelete(options) {
  var mutationOptions = useDirectoryAssertionV3AssertionDeleteMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Returns list of assertion instances.
 * @summary List assertions
 */
var useDirectoryAssertionV3AssertionsListHook = function useDirectoryAssertionV3AssertionsListHook() {
  var directoryAssertionV3AssertionsList = useDirectoryReaderClient();
  return useCallback(function (params, signal) {
    return directoryAssertionV3AssertionsList({
      url: "/api/v3/directory/assertions",
      method: 'GET',
      params: params,
      signal: signal
    });
  }, [directoryAssertionV3AssertionsList]);
};
var getDirectoryAssertionV3AssertionsListQueryKey = function getDirectoryAssertionV3AssertionsListQueryKey(params) {
  return ["/api/v3/directory/assertions"].concat(_toConsumableArray(params ? [params] : []));
};
var useDirectoryAssertionV3AssertionsListInfiniteQueryOptions = function useDirectoryAssertionV3AssertionsListInfiniteQueryOptions(params, options) {
  var _a;
  var _ref7 = options !== null && options !== void 0 ? options : {},
    queryOptions = _ref7.query;
  var queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDirectoryAssertionV3AssertionsListQueryKey(params);
  var directoryAssertionV3AssertionsList = useDirectoryAssertionV3AssertionsListHook();
  var queryFn = function queryFn(_ref8) {
    var signal = _ref8.signal,
      pageParam = _ref8.pageParam;
    return directoryAssertionV3AssertionsList(Object.assign(Object.assign({}, params), {
      'page.token': pageParam || (params === null || params === void 0 ? void 0 : params['page.token'])
    }), signal);
  };
  return Object.assign({
    queryKey: queryKey,
    queryFn: queryFn
  }, queryOptions);
};
/**
 * @summary List assertions
 */
function useDirectoryAssertionV3AssertionsListInfinite(params, options) {
  var queryOptions = useDirectoryAssertionV3AssertionsListInfiniteQueryOptions(params, options);
  var query = useInfiniteQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Returns object graph from anchor to subject or object.
 * @summary Get graph
 */
var useDirectoryReaderV3GraphHook = function useDirectoryReaderV3GraphHook() {
  var directoryReaderV3Graph = useDirectoryReaderClient();
  return useCallback(function (objectType, relation, subjectType, params, signal) {
    return directoryReaderV3Graph({
      url: "/api/v3/directory/graph/".concat(objectType, "/").concat(relation, "/").concat(subjectType),
      method: 'GET',
      params: params,
      signal: signal
    });
  }, [directoryReaderV3Graph]);
};
var getDirectoryReaderV3GraphQueryKey = function getDirectoryReaderV3GraphQueryKey(objectType, relation, subjectType, params) {
  return ["/api/v3/directory/graph/".concat(objectType, "/").concat(relation, "/").concat(subjectType)].concat(_toConsumableArray(params ? [params] : []));
};
var useDirectoryReaderV3GraphQueryOptions = function useDirectoryReaderV3GraphQueryOptions(objectType, relation, subjectType, params, options) {
  var _a;
  var _ref19 = options !== null && options !== void 0 ? options : {},
    queryOptions = _ref19.query;
  var queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDirectoryReaderV3GraphQueryKey(objectType, relation, subjectType, params);
  var directoryReaderV3Graph = useDirectoryReaderV3GraphHook();
  var queryFn = function queryFn(_ref20) {
    var signal = _ref20.signal;
    return directoryReaderV3Graph(objectType, relation, subjectType, params, signal);
  };
  return Object.assign({
    queryKey: queryKey,
    queryFn: queryFn,
    enabled: !!(objectType && relation && subjectType)
  }, queryOptions);
};
/**
 * @summary Get graph
 */
function useDirectoryReaderV3Graph(objectType, relation, subjectType, params, options) {
  var queryOptions = useDirectoryReaderV3GraphQueryOptions(objectType, relation, subjectType, params, options);
  var query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Delete manifest.
 * @summary Delete manifest
 */
var useDirectoryModelV3ManifestDeleteHook = function useDirectoryModelV3ManifestDeleteHook() {
  var directoryModelV3ManifestDelete = useDirectoryModelClient();
  return useCallback(function (params) {
    return directoryModelV3ManifestDelete({
      url: "/api/v3/directory/manifest",
      method: 'DELETE',
      params: params
    });
  }, [directoryModelV3ManifestDelete]);
};
var useDirectoryModelV3ManifestDeleteMutationOptions = function useDirectoryModelV3ManifestDeleteMutationOptions(options) {
  var mutationKey = ['directoryModelV3ManifestDelete'];
  var _ref21 = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : Object.assign(Object.assign({}, options), {
      mutation: Object.assign(Object.assign({}, options.mutation), {
        mutationKey: mutationKey
      })
    }) : {
      mutation: {
        mutationKey: mutationKey
      }
    },
    mutationOptions = _ref21.mutation;
  var directoryModelV3ManifestDelete = useDirectoryModelV3ManifestDeleteHook();
  var mutationFn = function mutationFn(props) {
    var _ref22 = props !== null && props !== void 0 ? props : {},
      params = _ref22.params;
    return directoryModelV3ManifestDelete(params);
  };
  return Object.assign({
    mutationFn: mutationFn
  }, mutationOptions);
};
/**
 * @summary Delete manifest
 */
var useDirectoryModelV3ManifestDelete = function useDirectoryModelV3ManifestDelete(options) {
  var mutationOptions = useDirectoryModelV3ManifestDeleteMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Get manifest.
 * @summary Get manifest
 */
var useDirectoryV3ManifestGetHook = function useDirectoryV3ManifestGetHook() {
  var directoryV3ManifestGet = useDirectoryModelClient();
  return useCallback(function (signal) {
    return directoryV3ManifestGet({
      url: "/api/v3/directory/manifest",
      method: 'GET',
      responseType: 'blob',
      signal: signal
    });
  }, [directoryV3ManifestGet]);
};
var getDirectoryV3ManifestGetQueryKey = function getDirectoryV3ManifestGetQueryKey() {
  return ["/api/v3/directory/manifest"];
};
var useDirectoryV3ManifestGetQueryOptions = function useDirectoryV3ManifestGetQueryOptions(options) {
  var _a;
  var _ref23 = options !== null && options !== void 0 ? options : {},
    queryOptions = _ref23.query;
  var queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDirectoryV3ManifestGetQueryKey();
  var directoryV3ManifestGet = useDirectoryV3ManifestGetHook();
  var queryFn = function queryFn(_ref24) {
    var signal = _ref24.signal;
    return directoryV3ManifestGet(signal);
  };
  return Object.assign({
    queryKey: queryKey,
    queryFn: queryFn
  }, queryOptions);
};
/**
 * @summary Get manifest
 */
function useDirectoryV3ManifestGet(options) {
  var queryOptions = useDirectoryV3ManifestGetQueryOptions(options);
  var query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Set manifest.
 * @summary Set manifest
 */
var useDirectoryV3ManifestSetHook = function useDirectoryV3ManifestSetHook() {
  var directoryV3ManifestSet = useDirectoryModelClient();
  return useCallback(function (directoryV3ManifestSetBody, signal) {
    return directoryV3ManifestSet({
      url: "/api/v3/directory/manifest",
      method: 'POST',
      headers: {
        'Content-Type': 'application/yaml'
      },
      data: directoryV3ManifestSetBody,
      signal: signal
    });
  }, [directoryV3ManifestSet]);
};
var useDirectoryV3ManifestSetMutationOptions = function useDirectoryV3ManifestSetMutationOptions(options) {
  var mutationKey = ['directoryV3ManifestSet'];
  var _ref26 = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : Object.assign(Object.assign({}, options), {
      mutation: Object.assign(Object.assign({}, options.mutation), {
        mutationKey: mutationKey
      })
    }) : {
      mutation: {
        mutationKey: mutationKey
      }
    },
    mutationOptions = _ref26.mutation;
  var directoryV3ManifestSet = useDirectoryV3ManifestSetHook();
  var mutationFn = function mutationFn(props) {
    var _ref27 = props !== null && props !== void 0 ? props : {},
      data = _ref27.data;
    return directoryV3ManifestSet(data);
  };
  return Object.assign({
    mutationFn: mutationFn
  }, mutationOptions);
};
/**
 * @summary Set manifest
 */
var useDirectoryV3ManifestSet = function useDirectoryV3ManifestSet(options) {
  var mutationOptions = useDirectoryV3ManifestSetMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Set object.
 * @summary Set object
 */
var useDirectoryWriterV3ObjectSetHook = function useDirectoryWriterV3ObjectSetHook() {
  var directoryWriterV3ObjectSet = useDirectoryWriterClient();
  return useCallback(function (v3SetObjectRequest, signal) {
    return directoryWriterV3ObjectSet({
      url: "/api/v3/directory/object",
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: v3SetObjectRequest,
      signal: signal
    });
  }, [directoryWriterV3ObjectSet]);
};
var useDirectoryWriterV3ObjectSetMutationOptions = function useDirectoryWriterV3ObjectSetMutationOptions(options) {
  var mutationKey = ['directoryWriterV3ObjectSet'];
  var _ref28 = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : Object.assign(Object.assign({}, options), {
      mutation: Object.assign(Object.assign({}, options.mutation), {
        mutationKey: mutationKey
      })
    }) : {
      mutation: {
        mutationKey: mutationKey
      }
    },
    mutationOptions = _ref28.mutation;
  var directoryWriterV3ObjectSet = useDirectoryWriterV3ObjectSetHook();
  var mutationFn = function mutationFn(props) {
    var _ref29 = props !== null && props !== void 0 ? props : {},
      data = _ref29.data;
    return directoryWriterV3ObjectSet(data);
  };
  return Object.assign({
    mutationFn: mutationFn
  }, mutationOptions);
};
/**
 * @summary Set object
 */
var useDirectoryWriterV3ObjectSet = function useDirectoryWriterV3ObjectSet(options) {
  var mutationOptions = useDirectoryWriterV3ObjectSetMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Delete object.
 * @summary Delete object
 */
var useDirectoryWriterV3ObjectDeleteHook = function useDirectoryWriterV3ObjectDeleteHook() {
  var directoryWriterV3ObjectDelete = useDirectoryWriterClient();
  return useCallback(function (objectType, objectId, params) {
    return directoryWriterV3ObjectDelete({
      url: "/api/v3/directory/object/".concat(objectType, "/").concat(objectId),
      method: 'DELETE',
      params: params
    });
  }, [directoryWriterV3ObjectDelete]);
};
var useDirectoryWriterV3ObjectDeleteMutationOptions = function useDirectoryWriterV3ObjectDeleteMutationOptions(options) {
  var mutationKey = ['directoryWriterV3ObjectDelete'];
  var _ref30 = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : Object.assign(Object.assign({}, options), {
      mutation: Object.assign(Object.assign({}, options.mutation), {
        mutationKey: mutationKey
      })
    }) : {
      mutation: {
        mutationKey: mutationKey
      }
    },
    mutationOptions = _ref30.mutation;
  var directoryWriterV3ObjectDelete = useDirectoryWriterV3ObjectDeleteHook();
  var mutationFn = function mutationFn(props) {
    var _ref31 = props !== null && props !== void 0 ? props : {},
      objectType = _ref31.objectType,
      objectId = _ref31.objectId,
      params = _ref31.params;
    return directoryWriterV3ObjectDelete(objectType, objectId, params);
  };
  return Object.assign({
    mutationFn: mutationFn
  }, mutationOptions);
};
/**
 * @summary Delete object
 */
var useDirectoryWriterV3ObjectDelete = function useDirectoryWriterV3ObjectDelete(options) {
  var mutationOptions = useDirectoryWriterV3ObjectDeleteMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Returns single object instance, optionally with relations.
 * @summary Get object instance
 */
var useDirectoryReaderV3ObjectGetHook = function useDirectoryReaderV3ObjectGetHook() {
  var directoryReaderV3ObjectGet = useDirectoryReaderClient();
  return useCallback(function (objectType, objectId, params, signal) {
    return directoryReaderV3ObjectGet({
      url: "/api/v3/directory/object/".concat(objectType, "/").concat(objectId),
      method: 'GET',
      params: params,
      signal: signal
    });
  }, [directoryReaderV3ObjectGet]);
};
var getDirectoryReaderV3ObjectGetQueryKey = function getDirectoryReaderV3ObjectGetQueryKey(objectType, objectId, params) {
  return ["/api/v3/directory/object/".concat(objectType, "/").concat(objectId)].concat(_toConsumableArray(params ? [params] : []));
};
var useDirectoryReaderV3ObjectGetQueryOptions = function useDirectoryReaderV3ObjectGetQueryOptions(objectType, objectId, params, options) {
  var _a;
  var _ref32 = options !== null && options !== void 0 ? options : {},
    queryOptions = _ref32.query;
  var queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDirectoryReaderV3ObjectGetQueryKey(objectType, objectId, params);
  var directoryReaderV3ObjectGet = useDirectoryReaderV3ObjectGetHook();
  var queryFn = function queryFn(_ref33) {
    var signal = _ref33.signal;
    return directoryReaderV3ObjectGet(objectType, objectId, params, signal);
  };
  return Object.assign({
    queryKey: queryKey,
    queryFn: queryFn,
    enabled: !!(objectType && objectId)
  }, queryOptions);
};
/**
 * @summary Get object instance
 */
function useDirectoryReaderV3ObjectGet(objectType, objectId, params, options) {
  var queryOptions = useDirectoryReaderV3ObjectGetQueryOptions(objectType, objectId, params, options);
  var query = useQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Returns list of object instances.
 * @summary List object instances
 */
var useDirectoryReaderV3ObjectsListHook = function useDirectoryReaderV3ObjectsListHook() {
  var directoryReaderV3ObjectsList = useDirectoryReaderClient();
  return useCallback(function (params, signal) {
    return directoryReaderV3ObjectsList({
      url: "/api/v3/directory/objects",
      method: 'GET',
      params: params,
      signal: signal
    });
  }, [directoryReaderV3ObjectsList]);
};
var getDirectoryReaderV3ObjectsListQueryKey = function getDirectoryReaderV3ObjectsListQueryKey(params) {
  return ["/api/v3/directory/objects"].concat(_toConsumableArray(params ? [params] : []));
};
var useDirectoryReaderV3ObjectsListInfiniteQueryOptions = function useDirectoryReaderV3ObjectsListInfiniteQueryOptions(params, options) {
  var _a;
  var _ref34 = options !== null && options !== void 0 ? options : {},
    queryOptions = _ref34.query;
  var queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDirectoryReaderV3ObjectsListQueryKey(params);
  var directoryReaderV3ObjectsList = useDirectoryReaderV3ObjectsListHook();
  var queryFn = function queryFn(_ref35) {
    var signal = _ref35.signal,
      pageParam = _ref35.pageParam;
    return directoryReaderV3ObjectsList(Object.assign(Object.assign({}, params), {
      'page.token': pageParam || (params === null || params === void 0 ? void 0 : params['page.token'])
    }), signal);
  };
  return Object.assign({
    queryKey: queryKey,
    queryFn: queryFn
  }, queryOptions);
};
/**
 * @summary List object instances
 */
function useDirectoryReaderV3ObjectsListInfinite(params, options) {
  var queryOptions = useDirectoryReaderV3ObjectsListInfiniteQueryOptions(params, options);
  var query = useInfiniteQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}
/**
 * Delete relation.
 * @summary Delete relation
 */
var useDirectoryWriterV3RelationDeleteHook = function useDirectoryWriterV3RelationDeleteHook() {
  var directoryWriterV3RelationDelete = useDirectoryWriterClient();
  return useCallback(function (params) {
    return directoryWriterV3RelationDelete({
      url: "/api/v3/directory/relation",
      method: 'DELETE',
      params: params
    });
  }, [directoryWriterV3RelationDelete]);
};
var useDirectoryWriterV3RelationDeleteMutationOptions = function useDirectoryWriterV3RelationDeleteMutationOptions(options) {
  var mutationKey = ['directoryWriterV3RelationDelete'];
  var _ref38 = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : Object.assign(Object.assign({}, options), {
      mutation: Object.assign(Object.assign({}, options.mutation), {
        mutationKey: mutationKey
      })
    }) : {
      mutation: {
        mutationKey: mutationKey
      }
    },
    mutationOptions = _ref38.mutation;
  var directoryWriterV3RelationDelete = useDirectoryWriterV3RelationDeleteHook();
  var mutationFn = function mutationFn(props) {
    var _ref39 = props !== null && props !== void 0 ? props : {},
      params = _ref39.params;
    return directoryWriterV3RelationDelete(params);
  };
  return Object.assign({
    mutationFn: mutationFn
  }, mutationOptions);
};
/**
 * @summary Delete relation
 */
var useDirectoryWriterV3RelationDelete = function useDirectoryWriterV3RelationDelete(options) {
  var mutationOptions = useDirectoryWriterV3RelationDeleteMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Set relation.
 * @summary Set relation
 */
var useDirectoryWriterV3RelationSetHook = function useDirectoryWriterV3RelationSetHook() {
  var directoryWriterV3RelationSet = useDirectoryWriterClient();
  return useCallback(function (v3SetRelationRequest, signal) {
    return directoryWriterV3RelationSet({
      url: "/api/v3/directory/relation",
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: v3SetRelationRequest,
      signal: signal
    });
  }, [directoryWriterV3RelationSet]);
};
var useDirectoryWriterV3RelationSetMutationOptions = function useDirectoryWriterV3RelationSetMutationOptions(options) {
  var mutationKey = ['directoryWriterV3RelationSet'];
  var _ref42 = options ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ? options : Object.assign(Object.assign({}, options), {
      mutation: Object.assign(Object.assign({}, options.mutation), {
        mutationKey: mutationKey
      })
    }) : {
      mutation: {
        mutationKey: mutationKey
      }
    },
    mutationOptions = _ref42.mutation;
  var directoryWriterV3RelationSet = useDirectoryWriterV3RelationSetHook();
  var mutationFn = function mutationFn(props) {
    var _ref43 = props !== null && props !== void 0 ? props : {},
      data = _ref43.data;
    return directoryWriterV3RelationSet(data);
  };
  return Object.assign({
    mutationFn: mutationFn
  }, mutationOptions);
};
/**
 * @summary Set relation
 */
var useDirectoryWriterV3RelationSet = function useDirectoryWriterV3RelationSet(options) {
  var mutationOptions = useDirectoryWriterV3RelationSetMutationOptions(options);
  return useMutation(mutationOptions);
};
/**
 * Returns list of relation instances.
 * @summary List relations instances
 */
var useDirectoryReaderV3RelationsListHook = function useDirectoryReaderV3RelationsListHook() {
  var directoryReaderV3RelationsList = useDirectoryReaderClient();
  return useCallback(function (params, signal) {
    return directoryReaderV3RelationsList({
      url: "/api/v3/directory/relations",
      method: 'GET',
      params: params,
      signal: signal
    });
  }, [directoryReaderV3RelationsList]);
};
var getDirectoryReaderV3RelationsListQueryKey = function getDirectoryReaderV3RelationsListQueryKey(params) {
  return ["/api/v3/directory/relations"].concat(_toConsumableArray(params ? [params] : []));
};
var useDirectoryReaderV3RelationsListInfiniteQueryOptions = function useDirectoryReaderV3RelationsListInfiniteQueryOptions(params, options) {
  var _a;
  var _ref44 = options !== null && options !== void 0 ? options : {},
    queryOptions = _ref44.query;
  var queryKey = (_a = queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.queryKey) !== null && _a !== void 0 ? _a : getDirectoryReaderV3RelationsListQueryKey(params);
  var directoryReaderV3RelationsList = useDirectoryReaderV3RelationsListHook();
  var queryFn = function queryFn(_ref45) {
    var signal = _ref45.signal,
      pageParam = _ref45.pageParam;
    return directoryReaderV3RelationsList(Object.assign(Object.assign({}, params), {
      'page.token': pageParam || (params === null || params === void 0 ? void 0 : params['page.token'])
    }), signal);
  };
  return Object.assign({
    queryKey: queryKey,
    queryFn: queryFn
  }, queryOptions);
};
/**
 * @summary List relations instances
 */
function useDirectoryReaderV3RelationsListInfinite(params, options) {
  var queryOptions = useDirectoryReaderV3RelationsListInfiniteQueryOptions(params, options);
  var query = useInfiniteQuery(queryOptions);
  query.queryKey = queryOptions.queryKey;
  return query;
}

var DISPLAY_NAME_REGEX = /^(## )(display_name: )(.*)( ###)/;
var useManifestData = function useManifestData() {
  return useDirectoryV3ManifestGet();
};
var useManifest = function useManifest() {
  var _a = useManifestData(),
    manifest = _a.data,
    all = __rest(_a, ["data"]);
  var manifestData = useMemo(function () {
    if (!manifest) {
      return undefined;
    }
    try {
      var doc = parseDocument(manifest);
      var displayNames = parseDisplayNames(doc);
      var _manifestData = doc.toJSON();
      Object.entries(_manifestData.types).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          type = _ref2[0],
          typeData = _ref2[1];
        if (typeData !== null) {
          typeData.displayName = displayNames[type] || type;
        } else {
          _manifestData.types[type] = {
            displayName: displayNames[type] || type,
            relations: {},
            permissions: {}
          };
        }
      });
      return _manifestData;
    } catch (_a) {
      return undefined;
    }
  }, [manifest]);
  return Object.assign({
    data: manifestData
  }, all);
};
var useManifestToYaml = function useManifestToYaml(manifest) {
  var manifestData = useMemo(function () {
    try {
      var doc = parseDocument(manifest);
      return doc.toJSON();
    } catch (_a) {}
  }, [manifest]);
  return manifestData;
};
var useParsedManifest = function useParsedManifest() {
  var _a = useManifest(),
    manifest = _a.data,
    all = __rest(_a, ["data"]);
  var parsedObjectTypes = useMemo(function () {
    var types = (manifest === null || manifest === void 0 ? void 0 : manifest.types) || {};
    return Object.keys(types).map(function (objectType) {
      var _a;
      return {
        name: objectType,
        displayName: ((_a = types[objectType]) === null || _a === void 0 ? void 0 : _a.displayName) || objectType
      };
    });
  }, [manifest === null || manifest === void 0 ? void 0 : manifest.types]);
  var parsedRelationTypes = useMemo(function () {
    return parsedObjectTypes.flatMap(function (objectType) {
      var _a, _b;
      var objectTypeName = objectType.name;
      var relationNames = Object.keys(((_b = (_a = manifest === null || manifest === void 0 ? void 0 : manifest.types) === null || _a === void 0 ? void 0 : _a[objectTypeName]) === null || _b === void 0 ? void 0 : _b.relations) || []);
      return relationNames.map(function (relationName) {
        return {
          name: relationName,
          objectType: objectTypeName,
          displayName: relationName
        };
      });
    });
  }, [parsedObjectTypes, manifest === null || manifest === void 0 ? void 0 : manifest.types]);
  var parsedPermissions = useMemo(function () {
    return parsedObjectTypes.flatMap(function (objectType) {
      var _a, _b;
      var objectTypeName = objectType.name;
      var permissionNames = Object.keys(((_b = (_a = manifest === null || manifest === void 0 ? void 0 : manifest.types) === null || _a === void 0 ? void 0 : _a[objectTypeName]) === null || _b === void 0 ? void 0 : _b.permissions) || []);
      return permissionNames.map(function (permissionName) {
        return {
          name: permissionName,
          objectType: objectTypeName,
          displayName: permissionName
        };
      });
    });
  }, [parsedObjectTypes, manifest === null || manifest === void 0 ? void 0 : manifest.types]);
  return Object.assign({
    objectTypes: parsedObjectTypes,
    relationTypes: parsedRelationTypes,
    permissions: parsedPermissions
  }, all);
};
var useLegacyIdentities = function useLegacyIdentities() {
  var _useParsedManifest = useParsedManifest(),
    relationTypes = _useParsedManifest.relationTypes;
  return useMemo(function () {
    if (relationTypes.length === 0) {
      return false;
    }
    return relationTypes.find(function (relation) {
      return relation.objectType === 'identity' && relation.name === 'identifier';
    }) !== undefined;
  }, [relationTypes]);
};
var parseDisplayNames = function parseDisplayNames(doc) {
  var _a, _b, _c, _d, _e, _f;
  var displayNames = {};
  var contents = doc.contents;
  if (!contents) {
    return displayNames;
  }
  var types = contents.items.find(function (i) {
    return i.key.value === 'types';
  });
  if (!types) {
    return displayNames;
  }
  var extractDisplayName = function extractDisplayName(comment) {
    var parts = DISPLAY_NAME_REGEX.exec(comment) || [];
    return parts.length >= 3 ? parts[3] : undefined;
  };
  var mainComment = extractDisplayName(((_a = types.value) === null || _a === void 0 ? void 0 : _a.commentBefore) || '');
  if (mainComment) {
    displayNames[String((_e = (_d = (_c = (_b = types.value) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.key) === null || _e === void 0 ? void 0 : _e.value)] = mainComment;
  }
  (_f = types.value) === null || _f === void 0 ? void 0 : _f.items.forEach(function (item) {
    var comments = (item.key.commentBefore || '').split('\n');
    comments.forEach(function (comment) {
      var displayName = extractDisplayName(comment);
      if (displayName) {
        displayNames[String(item.key.value)] = displayName;
      }
    });
  });
  return displayNames;
};

var useDirectoryV3CheckQuery = function useDirectoryV3CheckQuery(params, options) {
  var directoryV3Check = useDirectoryReaderClient();
  return useQuery(['check', params], function () {
    return directoryV3Check({
      url: "/api/v3/directory/check",
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: params
    });
  }, options);
};
var useDirectoryV3ObjectTypesList = function useDirectoryV3ObjectTypesList(params) {
  var _a = useParsedManifest(),
    objectTypes = _a.objectTypes,
    all = __rest(_a, ["objectTypes"]);
  var results = useMemo(function () {
    return objectTypes && (params === null || params === void 0 ? void 0 : params.name) ? objectTypes.filter(function (objectType) {
      return objectType.name === params.name;
    }) : objectTypes;
  }, [objectTypes, params]);
  return Object.assign({
    data: {
      results: results
    }
  }, all);
};
var useDirectoryV3RelationTypesList = function useDirectoryV3RelationTypesList(params) {
  var _a = useParsedManifest(),
    relationTypes = _a.relationTypes,
    all = __rest(_a, ["relationTypes"]);
  var _ref = params !== null && params !== void 0 ? params : {},
    objectType = _ref.objectType,
    name = _ref.name;
  var filteredRelationTypes = useMemo(function () {
    var filteredRelationTypes = relationTypes;
    if (!!objectType) {
      filteredRelationTypes = relationTypes.filter(function (relationType) {
        return relationType.objectType === objectType;
      });
    }
    if (name) {
      filteredRelationTypes = relationTypes.filter(function (relationType) {
        return relationType.name === name;
      });
    }
    return filteredRelationTypes;
  }, [name, objectType, relationTypes]);
  return Object.assign({
    data: {
      results: filteredRelationTypes
    }
  }, all);
};
var useDirectoryV3PermissionsList = function useDirectoryV3PermissionsList(params) {
  var _a = useParsedManifest(),
    permissions = _a.permissions,
    all = __rest(_a, ["permissions"]);
  var _ref2 = params !== null && params !== void 0 ? params : {},
    objectType = _ref2.objectType,
    name = _ref2.name;
  var filteredPermissions = useMemo(function () {
    var filteredPermissions = permissions;
    if (!!objectType) {
      filteredPermissions = permissions.filter(function (permission) {
        return permission.objectType === objectType;
      });
    }
    if (name) {
      filteredPermissions = permissions.filter(function (permission) {
        return permission.name === name;
      });
    }
    return filteredPermissions;
  }, [name, objectType, permissions]);
  return Object.assign({
    data: {
      results: filteredPermissions
    }
  }, all);
};
var useDirectoryV3ChecksListQuery = function useDirectoryV3ChecksListQuery(params, options) {
  var directoryV3Check = useDirectoryReaderClient();
  return useQueries({
    queries: params.map(function (param) {
      return {
        queryKey: ['check', param],
        queryFn: function queryFn() {
          return directoryV3Check({
            url: "/api/v3/directory/check",
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            data: param
          });
        },
        options: options
      };
    })
  });
};

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function useCentralDirectoryClient(directoryUrl) {
  var _useBackendServicesAu = useBackendServicesAuth(),
    getDirectoryToken = _useBackendServicesAu.getDirectoryToken;
  return useAsertoApiWithAuth(directoryUrl, {}, getDirectoryToken);
}
var useFetchFromDirectory = function useFetchFromDirectory(directoryUrl, query, options) {
  var client = useCentralDirectoryClient(directoryUrl);
  var headers = new Headers(options);
  var headerOverrides = {};
  headers.forEach(function (value, key) {
    return headerOverrides[key] = value;
  });
  return function (variables) {
    return __awaiter(void 0, void 0, void 0, _regeneratorRuntime.mark(function _callee() {
      var body, response, message;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            body = {
              query: query,
              variables: variables
            };
            _context.next = 3;
            return client.post({
              body: body,
              headerOverrides: headerOverrides,
              path: 'graph/query'
            });
          case 3:
            response = _context.sent;
            if (!response.errors) {
              _context.next = 7;
              break;
            }
            message = response.errors.map(function (e) {
              return e.message;
            }).join('\n');
            throw new Error(message);
          case 7:
            return _context.abrupt("return", response.data);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  };
};
var useFetchFromTenantDirectory = function useFetchFromTenantDirectory(query, options) {
  var _useConfig = useConfig(),
    directoryServiceUrl = _useConfig.directoryServiceUrl;
  return useFetchFromDirectory(directoryServiceUrl, query, options);
};

var RelationSide;
(function (RelationSide) {
  RelationSide["Object"] = "OBJECT";
  RelationSide["Subject"] = "SUBJECT";
})(RelationSide || (RelationSide = {}));
var SettableObjectFragmentDoc = "\n    fragment SettableObject on Object {\n  type\n  displayName\n  id\n  properties\n  hash\n  lifecycle {\n    createdAt\n    updatedAt\n  }\n}\n    ";
var ListObjectsByTypeDocument = "\n    query ListObjectsByType($typeName: String!, $first: Int!, $nameAfter: Cursor, $idAfter: Cursor, $displayNamePart: String = null, $id: String = null) {\n  byName: objects(\n    after: $nameAfter\n    first: $first\n    where: {type: $typeName, displayName: {contains: $displayNamePart}, id: {equals: $id}}\n  ) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    nodes {\n      ...SettableObject\n    }\n  }\n  byID: objects(\n    after: $idAfter\n    first: $first\n    where: {type: $typeName, id: {contains: $displayNamePart}}\n  ) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    nodes {\n      ...SettableObject\n    }\n  }\n}\n    ".concat(SettableObjectFragmentDoc);
var useInfiniteListObjectsByTypeQuery = function useInfiniteListObjectsByTypeQuery(variables, options) {
  var query = useFetchFromTenantDirectory(ListObjectsByTypeDocument);
  return useInfiniteQuery(['ListObjectsByType.infinite', variables], function (metaData) {
    var _a;
    return query(Object.assign(Object.assign({}, variables), (_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {}));
  }, options);
};
useInfiniteListObjectsByTypeQuery.getKey = function (variables) {
  return ['ListObjectsByType.infinite', variables];
};
var GetObjectByTypeIdDocument = "\n    query GetObjectByTypeID($typeName: String!, $id: String!) {\n  object(type: $typeName, id: $id) {\n    ...SettableObject\n  }\n}\n    ".concat(SettableObjectFragmentDoc);
var useGetObjectByTypeIdQuery = function useGetObjectByTypeIdQuery(variables, options) {
  return useQuery(['GetObjectByTypeID', variables], useFetchFromTenantDirectory(GetObjectByTypeIdDocument).bind(null, variables), options);
};
useGetObjectByTypeIdQuery.getKey = function (variables) {
  return ['GetObjectByTypeID', variables];
};
var ListRelationsDocument = "\n    query ListRelations($objectType: String, $objectId: String, $subjectType: String, $subjectId: String, $relation: String, $objectIdPart: String, $subjectIdPart: String, $subjectRelation: String, $idAfter: Cursor, $idAfterFilter: Cursor, $first: Int!) {\n  relations(\n    first: $first\n    after: $idAfter\n    where: {subjectType: $subjectType, subjectID: {equals: $subjectId}, objectType: $objectType, objectID: {equals: $objectId}, relation: $relation, subjectRelation: $subjectRelation}\n  ) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    nodes {\n      object {\n        id\n        displayName\n        type\n      }\n      subject {\n        id\n        displayName\n        type\n      }\n      relation\n      subjectRelation\n    }\n  }\n  withFilter: relations(\n    first: $first\n    after: $idAfterFilter\n    where: {subjectType: $subjectType, subjectID: {contains: $subjectIdPart}, objectType: $objectType, objectID: {contains: $objectIdPart}, relation: $relation, subjectRelation: $subjectRelation}\n  ) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    nodes {\n      object {\n        id\n        displayName\n        type\n      }\n      subject {\n        id\n        displayName\n        type\n      }\n      relation\n      subjectRelation\n    }\n  }\n}\n    ";
var useInfiniteListRelationsQuery = function useInfiniteListRelationsQuery(variables, options) {
  var query = useFetchFromTenantDirectory(ListRelationsDocument);
  return useInfiniteQuery(['ListRelations.infinite', variables], function (metaData) {
    var _a;
    return query(Object.assign(Object.assign({}, variables), (_a = metaData.pageParam) !== null && _a !== void 0 ? _a : {}));
  }, options);
};
useInfiniteListRelationsQuery.getKey = function (variables) {
  return ['ListRelations.infinite', variables];
};
var AddRelationInstanceDocument = "\n    mutation AddRelationInstance($objectType: String!, $objectID: String!, $relation: String!, $subjectType: String!, $subjectID: String!, $subjectRelation: String) {\n  setRelation(\n    relation: {object: {id: $objectID, type: $objectType}, relation: $relation, subject: {id: $subjectID, type: $subjectType}, subjectRelation: $subjectRelation}\n  ) {\n    relation {\n      relation\n    }\n  }\n}\n    ";
var useAddRelationInstanceMutation = function useAddRelationInstanceMutation(options) {
  return useMutation(['AddRelationInstance'], useFetchFromTenantDirectory(AddRelationInstanceDocument), options);
};
var RemoveRelationDocument = "\n    mutation RemoveRelation($objectType: String!, $objectID: String!, $relation: String!, $subjectType: String!, $subjectID: String!, $subjectRelation: String) {\n  deleteRelation(\n    relation: {object: {id: $objectID, type: $objectType}, relation: $relation, subject: {id: $subjectID, type: $subjectType}, subjectRelation: $subjectRelation}\n  ) {\n    deleted\n  }\n}\n    ";
var useRemoveRelationMutation = function useRemoveRelationMutation(options) {
  return useMutation(['RemoveRelation'], useFetchFromTenantDirectory(RemoveRelationDocument), options);
};
var UpdateObjectDocument = "\n    mutation UpdateObject($object: SetObjectInput!) {\n  setObject(object: $object) {\n    object {\n      id\n    }\n  }\n}\n    ";
var useUpdateObjectMutation = function useUpdateObjectMutation(options) {
  return useMutation(['UpdateObject'], useFetchFromTenantDirectory(UpdateObjectDocument), options);
};
var DeleteObjectDocument = "\n    mutation DeleteObject($type: String!, $id: String!, $withRelations: Boolean) {\n  deleteObject(type: $type, id: $id, withRelations: $withRelations) {\n    deleted\n  }\n}\n    ";
var useDeleteObjectMutation = function useDeleteObjectMutation(options) {
  return useMutation(['DeleteObject'], useFetchFromTenantDirectory(DeleteObjectDocument), options);
};
var CheckDocument = "\n    query Check($subjectID: String!, $subjectType: String!, $objectID: String!, $objectType: String!, $relation: String!) {\n  check(\n    subject: {id: $subjectID, type: $subjectType}\n    object: {id: $objectID, type: $objectType}\n    relation: $relation\n  ) {\n    allowed\n  }\n}\n    ";
var useCheckQuery = function useCheckQuery(variables, options) {
  return useQuery(['Check', variables], useFetchFromTenantDirectory(CheckDocument).bind(null, variables), options);
};
useCheckQuery.getKey = function (variables) {
  return ['Check', variables];
};

function useCommonQueryOptions(options) {
  return Object.assign({}, options);
}

var GraphQlDirectory = {
  ObjectGet: function ObjectGet(objectType, objectId, _params, options) {
    return useGetObjectByTypeIdQuery({
      typeName: objectType,
      id: objectId
    }, Object.assign({
      select: function select(data) {
        return {
          page: {},
          relations: [],
          result: {
            id: data.object.id,
            type: data.object.type,
            display_name: data.object.displayName,
            properties: data.object.properties,
            created_at: data.object.lifecycle.createdAt,
            updated_at: data.object.lifecycle.updatedAt,
            etag: data.object.hash
          }
        };
      },
      enabled: !!objectType && !!objectId
    }, useCommonQueryOptions(options === null || options === void 0 ? void 0 : options.query)));
  },
  ObjectsListInfinite: function ObjectsListInfinite(params, options) {
    var _a;
    return useInfiniteListObjectsByTypeQuery({
      typeName: (params === null || params === void 0 ? void 0 : params.object_type) || '',
      first: (params === null || params === void 0 ? void 0 : params['page.size']) || 100,
      displayNamePart: params === null || params === void 0 ? void 0 : params.displayNamePart,
      id: params === null || params === void 0 ? void 0 : params.id
    }, Object.assign({
      select: function select(data) {
        return {
          pages: [{
            results: graphQLInfiniteObjectsToV3DirectoryObjects(data, params)
          }],
          pageParams: (data === null || data === void 0 ? void 0 : data.pageParams) || []
        };
      },
      getNextPageParam: function getNextPageParam(lastPage) {
        var nextToken = lastPage.byName.pageInfo.endCursor;
        return !!nextToken && {
          nameAfter: nextToken
        };
      },
      enabled: ((_a = options === null || options === void 0 ? void 0 : options.query) === null || _a === void 0 ? void 0 : _a.enabled) && !!(params === null || params === void 0 ? void 0 : params.object_type)
    }, useCommonQueryOptions(options === null || options === void 0 ? void 0 : options.query)));
  },
  ObjectSet: function ObjectSet(options) {
    return useUpdateObjectMutation({
      onSuccess: function onSuccess(data, variables, context) {
        var _a, _b;
        (_b = (_a = options === null || options === void 0 ? void 0 : options.mutation) === null || _a === void 0 ? void 0 : _a.onSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, {
          result: {
            id: data.setObject.object.id,
            type: data.setObject.object.__typename || ''
          }
        }, {
          data: {
            object: {
              id: variables.object.id,
              type: variables.object.type,
              display_name: variables.object.displayName || '',
              properties: variables.object.properties,
              etag: variables.object.hash
            }
          }
        }, context);
      },
      onError: function onError(error, variables, context) {
        var _a, _b;
        (_b = (_a = options === null || options === void 0 ? void 0 : options.mutation) === null || _a === void 0 ? void 0 : _a.onError) === null || _b === void 0 ? void 0 : _b.call(_a, error, {
          data: {
            object: {
              id: variables.object.id,
              type: variables.object.type,
              display_name: variables.object.displayName || '',
              properties: variables.object.properties,
              etag: variables.object.hash
            }
          }
        }, context);
      },
      onMutate: function onMutate(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        variables.object = {
          type: ((_a = variables === null || variables === void 0 ? void 0 : variables.data) === null || _a === void 0 ? void 0 : _a.object.type) || ((_b = variables === null || variables === void 0 ? void 0 : variables.object) === null || _b === void 0 ? void 0 : _b.type),
          id: ((_c = variables === null || variables === void 0 ? void 0 : variables.data) === null || _c === void 0 ? void 0 : _c.object.id) || ((_d = variables === null || variables === void 0 ? void 0 : variables.object) === null || _d === void 0 ? void 0 : _d.id),
          displayName: ((_e = variables === null || variables === void 0 ? void 0 : variables.data) === null || _e === void 0 ? void 0 : _e.object.display_name) || ((_f = variables === null || variables === void 0 ? void 0 : variables.object) === null || _f === void 0 ? void 0 : _f.displayName) || '',
          properties: ((_g = variables === null || variables === void 0 ? void 0 : variables.data) === null || _g === void 0 ? void 0 : _g.object.properties) || ((_h = variables === null || variables === void 0 ? void 0 : variables.object) === null || _h === void 0 ? void 0 : _h.properties) || {},
          hash: ((_j = variables === null || variables === void 0 ? void 0 : variables.data) === null || _j === void 0 ? void 0 : _j.object.etag) || ((_k = variables === null || variables === void 0 ? void 0 : variables.object) === null || _k === void 0 ? void 0 : _k.hash)
        };
      },
      onSettled: function onSettled(data, error, variables, context) {
        var _a, _b, _c, _d, _e;
        (_b = (_a = options === null || options === void 0 ? void 0 : options.mutation) === null || _a === void 0 ? void 0 : _a.onSettled) === null || _b === void 0 ? void 0 : _b.call(_a, {
          result: {
            id: ((_c = data === null || data === void 0 ? void 0 : data.setObject) === null || _c === void 0 ? void 0 : _c.object.id) || '',
            type: ((_e = (_d = data === null || data === void 0 ? void 0 : data.setObject) === null || _d === void 0 ? void 0 : _d.object) === null || _e === void 0 ? void 0 : _e.__typename) || ''
          }
        }, error, {
          data: {
            object: {
              id: variables.object.id,
              type: variables.object.type,
              display_name: variables.object.displayName || '',
              properties: variables.object.properties,
              etag: variables.object.hash
            }
          }
        }, context);
      }
    });
  },
  ObjectDelete: function ObjectDelete(options) {
    return useDeleteObjectMutation({
      onSuccess: function onSuccess(data, variables, context) {
        var _a, _b;
        (_b = (_a = options === null || options === void 0 ? void 0 : options.mutation) === null || _a === void 0 ? void 0 : _a.onSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, {
          result: data.deleteObject
        }, {
          objectType: variables.type,
          objectId: variables.id
        }, context);
      },
      onError: function onError(error, variables, context) {
        var _a, _b;
        (_b = (_a = options === null || options === void 0 ? void 0 : options.mutation) === null || _a === void 0 ? void 0 : _a.onError) === null || _b === void 0 ? void 0 : _b.call(_a, error, {
          objectType: variables.type,
          objectId: variables.id
        }, context);
      },
      onMutate: function onMutate(variables) {
        variables.type = variables.objectType || variables.type;
        variables.id = variables.objectId || variables.id;
      },
      onSettled: function onSettled(data, error, variables, context) {
        var _a, _b;
        (_b = (_a = options === null || options === void 0 ? void 0 : options.mutation) === null || _a === void 0 ? void 0 : _a.onSettled) === null || _b === void 0 ? void 0 : _b.call(_a, {
          result: data === null || data === void 0 ? void 0 : data.deleteObject
        }, error, {
          objectType: variables.type,
          objectId: variables.id
        }, context);
      }
    });
  },
  RelationsListInfinite: function RelationsListInfinite(params, options) {
    var _a;
    return useInfiniteListRelationsQuery({
      objectType: params === null || params === void 0 ? void 0 : params.object_type,
      objectId: params === null || params === void 0 ? void 0 : params.object_id,
      subjectType: params === null || params === void 0 ? void 0 : params.subject_type,
      subjectId: params === null || params === void 0 ? void 0 : params.subject_id,
      objectIdPart: params === null || params === void 0 ? void 0 : params.objectIdPart,
      subjectIdPart: params === null || params === void 0 ? void 0 : params.subjectIdPart,
      relation: params === null || params === void 0 ? void 0 : params.relation,
      subjectRelation: params === null || params === void 0 ? void 0 : params.subject_relation,
      first: (params === null || params === void 0 ? void 0 : params['page.size']) || 100
    }, Object.assign({
      select: function select(data) {
        var objects = {};
        if (!!(params === null || params === void 0 ? void 0 : params.with_objects)) {
          objects = graphQLInfiniteRelationsToV3DirectoryObjects(data);
        }
        if (!!(params === null || params === void 0 ? void 0 : params.objectIdPart) || !!(params === null || params === void 0 ? void 0 : params.subjectIdPart)) {
          return {
            pages: [{
              results: graphQLInfiniteRelationsWithFilterToV3DirectoryRelations(data),
              objects: objects
            }],
            pageParams: (data === null || data === void 0 ? void 0 : data.pageParams) || []
          };
        }
        return {
          pages: [{
            results: graphQLInfiniteRelationsToV3DirectoryRelations(data),
            objects: objects
          }],
          pageParams: (data === null || data === void 0 ? void 0 : data.pageParams) || []
        };
      },
      enabled: (_a = options === null || options === void 0 ? void 0 : options.query) === null || _a === void 0 ? void 0 : _a.enabled,
      getNextPageParam: function getNextPageParam(lastPage) {
        if (!!(params === null || params === void 0 ? void 0 : params.objectIdPart) || !!(params === null || params === void 0 ? void 0 : params.subjectIdPart)) {
          var _nextToken = lastPage.withFilter.pageInfo.endCursor;
          return !!_nextToken && {
            idAfterFilter: _nextToken
          };
        }
        var nextToken = lastPage.relations.pageInfo.endCursor;
        return !!nextToken && {
          idAfter: nextToken
        };
      }
    }, useCommonQueryOptions(options === null || options === void 0 ? void 0 : options.query)));
  },
  RelationSet: function RelationSet(options) {
    return useAddRelationInstanceMutation({
      onSuccess: function onSuccess(data, variables, context) {
        var _a, _b;
        (_b = (_a = options === null || options === void 0 ? void 0 : options.mutation) === null || _a === void 0 ? void 0 : _a.onSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, {
          result: {
            object_id: variables.objectID,
            object_type: variables.objectType,
            subject_id: variables.subjectID,
            subject_type: variables.subjectType,
            relation: variables.relation,
            subject_relation: variables.subjectRelation
          }
        }, {
          data: {
            relation: {
              object_id: variables.objectID,
              object_type: variables.objectType,
              subject_id: variables.subjectID,
              subject_type: variables.subjectType,
              relation: variables.relation,
              subject_relation: variables.subjectRelation
            }
          }
        }, context);
      },
      onError: function onError(error, variables, context) {
        var _a, _b;
        (_b = (_a = options === null || options === void 0 ? void 0 : options.mutation) === null || _a === void 0 ? void 0 : _a.onError) === null || _b === void 0 ? void 0 : _b.call(_a, error, {
          data: {
            relation: {
              object_id: variables.objectID,
              object_type: variables.objectType,
              subject_id: variables.subjectID,
              subject_type: variables.subjectType,
              relation: variables.relation,
              subject_relation: variables.subjectRelation
            }
          }
        }, context);
      },
      onMutate: function onMutate(variables) {
        var _a, _b, _c, _d, _e, _f;
        variables.objectType = ((_a = variables === null || variables === void 0 ? void 0 : variables.data) === null || _a === void 0 ? void 0 : _a.relation.object_type) || variables.objectType;
        variables.objectID = ((_b = variables === null || variables === void 0 ? void 0 : variables.data) === null || _b === void 0 ? void 0 : _b.relation.object_id) || variables.objectID;
        variables.subjectID = ((_c = variables === null || variables === void 0 ? void 0 : variables.data) === null || _c === void 0 ? void 0 : _c.relation.subject_id) || variables.subjectID;
        variables.subjectType = ((_d = variables === null || variables === void 0 ? void 0 : variables.data) === null || _d === void 0 ? void 0 : _d.relation.subject_type) || variables.subjectType;
        variables.relation = ((_e = variables.data) === null || _e === void 0 ? void 0 : _e.relation.relation) || variables.relation;
        variables.subjectRelation = ((_f = variables.data) === null || _f === void 0 ? void 0 : _f.relation.subject_relation) || variables.subjectRelation;
      },
      onSettled: function onSettled(data, error, variables, context) {
        var _a, _b;
        (_b = (_a = options === null || options === void 0 ? void 0 : options.mutation) === null || _a === void 0 ? void 0 : _a.onSettled) === null || _b === void 0 ? void 0 : _b.call(_a, {
          result: {
            object_id: variables.objectID,
            object_type: variables.objectType,
            subject_id: variables.subjectID,
            subject_type: variables.subjectType,
            relation: variables.relation,
            subject_relation: variables.subjectRelation
          }
        }, error, {
          data: {
            relation: {
              object_id: variables.objectID,
              object_type: variables.objectType,
              subject_id: variables.subjectID,
              subject_type: variables.subjectType,
              relation: variables.relation,
              subject_relation: variables.subjectRelation
            }
          }
        }, context);
      }
    });
  },
  RelationDelete: function RelationDelete(options) {
    return useRemoveRelationMutation({
      onSuccess: function onSuccess(data, variables, context) {
        var _a, _b;
        (_b = (_a = options === null || options === void 0 ? void 0 : options.mutation) === null || _a === void 0 ? void 0 : _a.onSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, {
          result: data.deleteRelation
        }, {
          params: {
            object_type: variables.objectType,
            object_id: variables.objectID,
            subject_type: variables.subjectType,
            subject_id: variables.subjectID,
            relation: variables.relation,
            subject_relation: variables.subjectRelation
          }
        }, context);
      },
      onError: function onError(error, variables, context) {
        var _a, _b;
        (_b = (_a = options === null || options === void 0 ? void 0 : options.mutation) === null || _a === void 0 ? void 0 : _a.onError) === null || _b === void 0 ? void 0 : _b.call(_a, error, {
          params: {
            object_type: variables.objectType,
            object_id: variables.objectID,
            subject_type: variables.subjectType,
            subject_id: variables.subjectID,
            relation: variables.relation,
            subject_relation: variables.subjectRelation
          }
        }, context);
      },
      onMutate: function onMutate(variables) {
        var _a, _b, _c, _d, _e, _f;
        variables.objectType = ((_a = variables === null || variables === void 0 ? void 0 : variables.params) === null || _a === void 0 ? void 0 : _a.object_type) || variables.objectType;
        variables.objectID = ((_b = variables === null || variables === void 0 ? void 0 : variables.params) === null || _b === void 0 ? void 0 : _b.object_id) || variables.objectID;
        variables.subjectID = ((_c = variables === null || variables === void 0 ? void 0 : variables.params) === null || _c === void 0 ? void 0 : _c.subject_id) || variables.subjectID;
        variables.subjectType = ((_d = variables === null || variables === void 0 ? void 0 : variables.params) === null || _d === void 0 ? void 0 : _d.subject_type) || variables.subjectType;
        variables.relation = ((_e = variables.params) === null || _e === void 0 ? void 0 : _e.relation) || variables.relation;
        variables.subjectRelation = ((_f = variables.params) === null || _f === void 0 ? void 0 : _f.subject_relation) || variables.subjectRelation;
      },
      onSettled: function onSettled(data, error, variables, context) {
        var _a, _b;
        (_b = (_a = options === null || options === void 0 ? void 0 : options.mutation) === null || _a === void 0 ? void 0 : _a.onSettled) === null || _b === void 0 ? void 0 : _b.call(_a, {
          result: data === null || data === void 0 ? void 0 : data.deleteRelation
        }, error, {
          params: {
            object_type: variables.objectType,
            object_id: variables.objectID,
            subject_type: variables.subjectType,
            subject_id: variables.subjectID,
            relation: variables.relation,
            subject_relation: variables.subjectRelation
          }
        }, context);
      }
    });
  },
  Check: function Check(params, options) {
    return useCheckQuery({
      subjectID: params.subject_id,
      subjectType: params.subject_type,
      objectID: params.object_id,
      objectType: params.object_type,
      relation: params.relation
    }, {
      select: function select(data) {
        return {
          check: data.check.allowed
        };
      },
      enabled: options === null || options === void 0 ? void 0 : options.enabled
    });
  },
  Checks: function Checks(params, options) {
    return useQueries({
      queries: params.map(function (param) {
        return {
          queryKey: ['Check', {
            subjectID: param.subject_id,
            subjectType: param.subject_type,
            objectID: param.object_id,
            objectType: param.object_type,
            relation: param.relation
          }],
          queryFn: useFetchFromTenantDirectory(CheckDocument).bind(null, {
            subjectID: param.subject_id,
            subjectType: param.subject_type,
            objectID: param.object_id,
            objectType: param.object_type,
            relation: param.relation
          }),
          select: function select(data) {
            return {
              check: data.check.allowed
            };
          },
          enabled: options === null || options === void 0 ? void 0 : options.enabled,
          options: options
        };
      })
    });
  },
  ObjectGetQueryKey: function ObjectGetQueryKey(objectType, objectId, _params) {
    return useGetObjectByTypeIdQuery.getKey({
      typeName: objectType,
      id: objectId
    });
  },
  ObjectsListInfiniteQueryKey: function ObjectsListInfiniteQueryKey(params) {
    return useInfiniteListObjectsByTypeQuery.getKey({
      typeName: (params === null || params === void 0 ? void 0 : params.object_type) || '',
      first: (params === null || params === void 0 ? void 0 : params['page.size']) || 100,
      displayNamePart: (params === null || params === void 0 ? void 0 : params.displayNamePart) || '',
      id: params === null || params === void 0 ? void 0 : params.id
    });
  },
  RelationsListInfiniteQueryKey: function RelationsListInfiniteQueryKey(params) {
    return useInfiniteListRelationsQuery.getKey({
      objectType: params === null || params === void 0 ? void 0 : params.object_type,
      objectId: params === null || params === void 0 ? void 0 : params.object_id,
      subjectType: params === null || params === void 0 ? void 0 : params.subject_type,
      subjectId: params === null || params === void 0 ? void 0 : params.subject_id,
      objectIdPart: params === null || params === void 0 ? void 0 : params.objectIdPart,
      subjectIdPart: params === null || params === void 0 ? void 0 : params.subjectIdPart,
      relation: params === null || params === void 0 ? void 0 : params.relation,
      subjectRelation: params === null || params === void 0 ? void 0 : params.subject_relation,
      first: (params === null || params === void 0 ? void 0 : params['page.size']) || 100
    });
  }
};
var graphQLInfiniteObjectsToV3DirectoryObjects = function graphQLInfiniteObjectsToV3DirectoryObjects(data, params) {
  if (!!(params === null || params === void 0 ? void 0 : params.displayNamePart)) {
    return (data === null || data === void 0 ? void 0 : data.pages.flatMap(function (page) {
      return graphQLObjectsToV3DirectoryObjects(page);
    })) || [];
  }
  return (data === null || data === void 0 ? void 0 : data.pages.flatMap(function (page) {
    return graphQLObjectsByNameToV3DirectoryObjects(page);
  })) || [];
};
var graphQLRelationsToV3DirectoryRelations = function graphQLRelationsToV3DirectoryRelations(data) {
  return data.nodes.flatMap(function (node) {
    return {
      object_id: node.object.id,
      object_type: node.object.type,
      relation: node.relation,
      subject_id: node.subject.id,
      subject_type: node.subject.type,
      object_display_name: node.object.displayName,
      subject_display_name: node.subject.displayName,
      subject_relation: node.subjectRelation
    };
  });
};
var graphQLRelationsToV3DirectoryObjects = function graphQLRelationsToV3DirectoryObjects(data) {
  var obj = {};
  data.nodes.forEach(function (node) {
    var objId = "".concat(node.object.type, ":").concat(node.object.id);
    var subjId = "".concat(node.subject.type, ":").concat(node.subject.id);
    obj[objId] = {
      id: node.object.id,
      type: node.object.type,
      display_name: node.object.displayName
    };
    obj[subjId] = {
      id: node.subject.id,
      type: node.subject.type,
      display_name: node.subject.displayName
    };
  });
  return obj;
};
var graphQLInfiniteRelationsToV3DirectoryObjects = function graphQLInfiniteRelationsToV3DirectoryObjects(data) {
  var result = {};
  data === null || data === void 0 ? void 0 : data.pages.forEach(function (page) {
    Object.assign(result, graphQLRelationsToV3DirectoryObjects(page.relations));
  });
  return result;
};
var graphQLInfiniteRelationsToV3DirectoryRelations = function graphQLInfiniteRelationsToV3DirectoryRelations(data) {
  return (data === null || data === void 0 ? void 0 : data.pages.flatMap(function (page) {
    return graphQLRelationsToV3DirectoryRelations(page.relations);
  })) || [];
};
var graphQLInfiniteRelationsWithFilterToV3DirectoryRelations = function graphQLInfiniteRelationsWithFilterToV3DirectoryRelations(data) {
  return (data === null || data === void 0 ? void 0 : data.pages.flatMap(function (page) {
    return graphQLRelationsToV3DirectoryRelations(page.withFilter);
  })) || [];
};
var graphQLObjectsByNameToV3DirectoryObjects = function graphQLObjectsByNameToV3DirectoryObjects(data) {
  return (data === null || data === void 0 ? void 0 : data.byName.nodes.flatMap(function (node) {
    return {
      id: node.id,
      type: node.type,
      display_name: node.displayName,
      properties: node.properties,
      etag: node.hash
    };
  })) || [];
};
var graphQLObjectsByIDToV3DirectoryObjects = function graphQLObjectsByIDToV3DirectoryObjects(data) {
  return (data === null || data === void 0 ? void 0 : data.byID.nodes.flatMap(function (node) {
    return {
      id: node.id,
      type: node.type,
      display_name: node.displayName,
      properties: node.properties,
      etag: node.hash
    };
  })) || [];
};
var graphQLObjectsToV3DirectoryObjects = function graphQLObjectsToV3DirectoryObjects(data) {
  return Object.values(graphQLObjectsByIDToV3DirectoryObjects(data).concat(graphQLObjectsByNameToV3DirectoryObjects(data)).reduce(function (acc, obj) {
    return Object.assign(Object.assign({}, acc), _defineProperty({}, obj.id, obj));
  }, {}));
};

var RestDirectory = {
  ObjectGet: function ObjectGet(objectType, objectId, params, options) {
    return useDirectoryReaderV3ObjectGet(objectType, encodeURIComponent(objectId), params, options);
  },
  ObjectsListInfinite: function ObjectsListInfinite(params, options) {
    if (params) {
      delete params['displayNamePart'];
    }
    return useDirectoryReaderV3ObjectsListInfinite(params, {
      query: Object.assign({
        getNextPageParam: function getNextPageParam(lastPage) {
          var _a;
          var nextToken = (_a = lastPage.page) === null || _a === void 0 ? void 0 : _a.next_token;
          return !!nextToken && nextToken;
        }
      }, options === null || options === void 0 ? void 0 : options.query)
    });
  },
  ObjectSet: function ObjectSet(options) {
    return useDirectoryWriterV3ObjectSet(options);
  },
  ObjectDelete: function ObjectDelete(options) {
    if (options && options.mutation) {
      options.mutation.onMutate = function (variables) {
        variables.objectId = encodeURIComponent(variables.objectId);
      };
    }
    return useDirectoryWriterV3ObjectDelete(options);
  },
  RelationsListInfinite: function RelationsListInfinite(params, options) {
    if (params) {
      delete params['objectIdPart'];
      delete params['subjectIdPart'];
      !params['object_type'] && delete params['object_type'];
      !params['object_id'] && delete params['object_id'];
      !params['subject_type'] && delete params['subject_type'];
      !params['subject_id'] && delete params['subject_id'];
      !params['relation'] && delete params['relation'];
      !params['subject_relation'] && delete params['subject_relation'];
      params['subject_relation'] === '' && delete params['subject_relation'];
    }
    return useDirectoryReaderV3RelationsListInfinite(params, {
      query: Object.assign({
        getNextPageParam: function getNextPageParam(lastPage) {
          var _a;
          var nextToken = (_a = lastPage.page) === null || _a === void 0 ? void 0 : _a.next_token;
          return !!nextToken && nextToken;
        }
      }, options === null || options === void 0 ? void 0 : options.query)
    });
  },
  RelationSet: function RelationSet(options) {
    return useDirectoryWriterV3RelationSet(options);
  },
  RelationDelete: function RelationDelete(options) {
    return useDirectoryWriterV3RelationDelete(options);
  },
  Check: function Check(params, options) {
    return useDirectoryV3CheckQuery(params, options);
  },
  Checks: function Checks(params, options) {
    return useDirectoryV3ChecksListQuery(params, options);
  },
  ObjectGetQueryKey: function ObjectGetQueryKey(objectType, objectId, params) {
    return getDirectoryReaderV3ObjectGetQueryKey(objectType, encodeURIComponent(objectId), params);
  },
  ObjectsListInfiniteQueryKey: function ObjectsListInfiniteQueryKey(params) {
    return getDirectoryReaderV3ObjectsListQueryKey(params);
  },
  RelationsListInfiniteQueryKey: function RelationsListInfiniteQueryKey(params) {
    return getDirectoryReaderV3RelationsListQueryKey(params);
  }
};

function DirectoryImpl() {
  var _useFeatureFlags = useFeatureFlags(),
    isGraphQLEnabled = _useFeatureFlags.isGraphQLEnabled;
  if (isGraphQLEnabled) {
    return GraphQlDirectory;
  }
  return RestDirectory;
}
function ObjectGet(objectType, objectId, params, options) {
  return DirectoryImpl().ObjectGet(objectType, objectId, params, options);
}
function ObjectsListInfinite(params, options) {
  return DirectoryImpl().ObjectsListInfinite(params, options);
}
function ObjectSet(options) {
  return DirectoryImpl().ObjectSet(options);
}
function ObjectDelete(options) {
  return DirectoryImpl().ObjectDelete(options);
}
function RelationsListInfinite(params, options) {
  return DirectoryImpl().RelationsListInfinite(params, options);
}
function RelationSet(options) {
  return DirectoryImpl().RelationSet(options);
}
function RelationDelete(options) {
  return DirectoryImpl().RelationDelete(options);
}
function Check(params, options) {
  return DirectoryImpl().Check(params, options);
}
function Checks(params, options) {
  return DirectoryImpl().Checks(params, options);
}
function ObjectTypesList(params) {
  return useDirectoryV3ObjectTypesList(params);
}
function RelationTypesList(params) {
  return useDirectoryV3RelationTypesList(params);
}
function PermissionsList(params) {
  return useDirectoryV3PermissionsList(params);
}
function AssertionsList(params, options) {
  return useDirectoryAssertionV3AssertionsListInfinite(params, {
    query: Object.assign({
      getNextPageParam: function getNextPageParam(lastPage) {
        var _a;
        var nextToken = (_a = lastPage.page) === null || _a === void 0 ? void 0 : _a.next_token;
        return !!nextToken && nextToken;
      }
    }, options === null || options === void 0 ? void 0 : options.query)
  });
}
function AssertionSet(options) {
  return useDirectoryAssertionV3AssertionSet(options);
}
function AssertionDelete(options) {
  return useDirectoryAssertionV3AssertionDelete(options);
}
function ManifestDelete(options) {
  var queryClient = useQueryClient();
  var manifestQueryKey = getDirectoryV3ManifestGetQueryKey();
  var assertionsListQueryKey = AssertionsListQueryKey();
  var relationsQueryKey = RelationsListInfiniteQueryKey();
  var objectsQueryKey = ObjectsListInfiniteQueryKey();
  return useDirectoryModelV3ManifestDelete(Object.assign(Object.assign({}, options), {
    mutation: {
      onSuccess: function onSuccess(data, variables, context) {
        var _a, _b;
        queryClient.removeQueries(manifestQueryKey);
        queryClient.removeQueries(relationsQueryKey);
        queryClient.removeQueries(assertionsListQueryKey);
        queryClient.removeQueries(objectsQueryKey);
        (_b = (_a = options.mutation) === null || _a === void 0 ? void 0 : _a.onSuccess) === null || _b === void 0 ? void 0 : _b.call(_a, data, variables, context);
      }
    }
  }));
}
function GetGraph(objectType, relation, subjectType, params, options) {
  return useDirectoryReaderV3Graph(objectType, relation, subjectType, params, options);
}
function ObjectGetQueryKey(objectType, objectId, params) {
  return DirectoryImpl().ObjectGetQueryKey(objectType, objectId, params);
}
function ObjectsListInfiniteQueryKey(params) {
  return DirectoryImpl().ObjectsListInfiniteQueryKey(params);
}
function RelationsListInfiniteQueryKey(params) {
  return DirectoryImpl().RelationsListInfiniteQueryKey(params);
}
function AssertionsListQueryKey(params) {
  return getDirectoryAssertionV3AssertionsListQueryKey(params);
}

function useAuthorizerClient() {
  var _useBackendServicesAu = useBackendServicesAuth(),
    getAuthorizerToken = _useBackendServicesAu.getAuthorizerToken;
  var _useConfig = useConfig(),
    authorizerServiceUrl = _useConfig.authorizerServiceUrl;
  var authorizerApi = v2Api(authorizerServiceUrl);
  return useAsertoApiWithAuth(authorizerApi, {}, getAuthorizerToken);
}

var img$E = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='260' height='160' viewBox='0 0 260 160'%3e %3cdefs%3e %3cradialGradient id='radial-gradient' cx='0.5' cy='0.5' r='0.524' gradientTransform='translate(0 -0.158) scale(1 1.316)' gradientUnits='objectBoundingBox'%3e %3cstop offset='0' stop-color='%23e7e7e7'/%3e %3cstop offset='1' stop-color='%23a0a0a0'/%3e %3c/radialGradient%3e %3cclipPath id='clip-Error_2'%3e %3crect width='260' height='160'/%3e %3c/clipPath%3e %3c/defs%3e %3cg id='Error_2' data-name='Error %e2%80%93 2' clip-path='url(%23clip-Error_2)'%3e %3cg id='Group_5' data-name='Group 5' transform='translate(-17 -67)'%3e %3cg id='Group_2' data-name='Group 2' transform='matrix(0.996%2c 0.087%2c -0.087%2c 0.996%2c 11.428%2c -16.814)'%3e %3cpath id='Path_4' data-name='Path 4' d='M171.625%2c86.3c-6.091%2c6.539-17.974%2c5.906-25.793-.858-7.838-6.776-9.4-16.465-4.14-22.128%2c2.763-2.767%2c17.952-16.582%2c29.578-32.406C183.547%2c15.587%2c192.26-1.741%2c197.122.141c4.745%2c1.6%2c4.759%2c23.57-2.429%2c43.809C188.338%2c64.516%2c174.781%2c83.356%2c171.625%2c86.3Z' transform='translate(24 77.028)' fill='%23888'/%3e %3c/g%3e %3cg id='Group_4' data-name='Group 4' transform='matrix(0.996%2c 0.087%2c -0.087%2c 0.996%2c 13.619%2c -18.759)'%3e %3cpath id='Path_9' data-name='Path 9' d='M177.326%2c103.538c-8.222%2c3.5-18.823-1.9-23.222-11.26-4.411-9.375-1.9-18.864%2c5.2-21.9%2c3.648-1.406%2c23.139-7.861%2c40.189-17.6%2c17.441-9.012%2c32.44-21.308%2c36.119-17.613%2c3.684%2c3.393-5.225%2c23.472-20.012%2c39.046C201.444%2c90.422%2c181.4%2c102.132%2c177.326%2c103.538Z' transform='translate(24 77.028)' fill='%23b8b8b8'/%3e %3c/g%3e %3cpath id='Path_15' data-name='Path 15' d='M170.811%2c119.059c-8.935-.137-16.43-9.379-16.653-19.715-.227-10.358%2c5.917-18.012%2c13.645-17.9%2c3.9.2%2c24.338%2c2.207%2c43.873.226%2c19.6-1.158%2c38.3-6.307%2c40.159-1.437%2c1.99%2c4.6-14.3%2c19.331-34.138%2c27.563C198.177%2c116.862%2c175.109%2c119.43%2c170.811%2c119.059Z' transform='matrix(0.996%2c 0.087%2c -0.087%2c 0.996%2c 33.369%2c 59.704)' fill='%23d0d0d0'/%3e %3cg id='Group_1' data-name='Group 1' transform='matrix(0.996%2c -0.087%2c 0.087%2c 0.996%2c -10.286%2c 9.333)'%3e %3cpath id='Path_19' data-name='Path 19' d='M80.377%2c86.3c6.091%2c6.539%2c17.974%2c5.906%2c25.793-.858%2c7.838-6.776%2c9.4-16.465%2c4.139-22.128-2.762-2.767-17.952-16.582-29.577-32.406C68.455%2c15.587%2c59.742-1.741%2c54.879.141c-4.744%2c1.6-4.758%2c23.57%2c2.429%2c43.809C63.663%2c64.516%2c77.221%2c83.356%2c80.377%2c86.3Z' transform='translate(24 77.028)' fill='%23888'/%3e %3c/g%3e %3cg id='Group_3' data-name='Group 3' transform='matrix(0.996%2c -0.087%2c 0.087%2c 0.996%2c -12.477%2c 7.388)'%3e %3cpath id='Path_24' data-name='Path 24' d='M74.676%2c103.538c8.222%2c3.5%2c18.823-1.9%2c23.221-11.26%2c4.411-9.375%2c1.9-18.864-5.2-21.9-3.648-1.406-23.139-7.861-40.189-17.6-17.441-9.012-32.44-21.308-36.119-17.613C12.7%2c38.556%2c21.61%2c58.634%2c36.4%2c74.209%2c50.558%2c90.422%2c70.6%2c102.132%2c74.676%2c103.538Z' transform='translate(24 77.028)' fill='%23b8b8b8'/%3e %3c/g%3e %3cpath id='Path_30' data-name='Path 30' d='M81.19%2c119.059c8.935-.137%2c16.43-9.379%2c16.653-19.715.226-10.358-5.918-18.012-13.645-17.9-3.9.2-24.338%2c2.207-43.873.226-19.6-1.158-38.3-6.307-40.16-1.437-1.989%2c4.6%2c14.3%2c19.331%2c34.138%2c27.563C53.824%2c116.862%2c76.893%2c119.43%2c81.19%2c119.059Z' transform='matrix(0.996%2c -0.087%2c 0.087%2c 0.996%2c 15.59%2c 81.667)' fill='%23d0d0d0'/%3e %3cpath id='Path_31' data-name='Path 31' d='M63.157%2c103.115c0%2c32.892%2c28.136%2c37.248%2c62.844%2c37.248s62.844-4.357%2c62.844-37.248S160.709%2c39.352%2c126%2c39.352%2c63.157%2c70.225%2c63.157%2c103.115Z' transform='translate(24 80.842)' fill='url(%23radial-gradient)'/%3e %3cpath id='Path_36' data-name='Path 36' d='M86.915%2c98.633a7.106%2c7.106%2c0%2c1%2c0-7.106-7.106A7.106%2c7.106%2c0%2c0%2c0%2c86.915%2c98.633Z' transform='translate(26 77.028)' fill='%233e3d42'/%3e %3cpath id='Path_37' data-name='Path 37' d='M165.971%2c98.633a7.106%2c7.106%2c0%2c1%2c0-7.1-7.106A7.106%2c7.106%2c0%2c0%2c0%2c165.971%2c98.633Z' transform='translate(22 77.028)' fill='%233e3d42'/%3e %3cpath id='Subtraction_1' data-name='Subtraction 1' d='M77.511%2c17.565l0%2c0c-3.1-3.4-8.113-6.278-14.487-8.336A72.721%2c72.721%2c0%2c0%2c0%2c41%2c6%2c72.722%2c72.722%2c0%2c0%2c0%2c18.977%2c9.226C12.606%2c11.284%2c7.6%2c14.165%2c4.492%2c17.56c1.249-4.833%2c5.6-9.273%2c12.249-12.5C23.456%2c1.8%2c32.072%2c0%2c41%2c0S58.544%2c1.8%2c65.26%2c5.057c6.652%2c3.23%2c11%2c7.671%2c12.251%2c12.5Z' transform='translate(108.998 186.888)' fill='%231e1e1e'/%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var theme = {
  primary: '#277F82',
  primaryBlack: '#121212',
  fullWhite: '#fff',
  lochivar100: '#277F82',
  lochivar90: '#257477',
  lochivar80: '#23696C',
  lochivar70: '#215E60',
  lochivar60: '#1F5355',
  lochivar50: '#1C484A',
  lochivar40: '#1A3E3F',
  lochivar30: '#183334',
  lochivar20: '#162828',
  lochivar10: '#141D1D',
  lochivarAccent1: '#2F989C',
  lochivarAccent2: '#36B1B5',
  lochivarAccent3: '#3ECACF',
  lochivarAccent4: '#67CBCF',
  indogo100: '#376EBF',
  indogo90: '#3364AE',
  indogo80: '#305B9D',
  indogo70: '#2C528B',
  indogo60: '#28497A',
  indogo50: '#254069',
  indogo40: '#213757',
  indogo30: '#1D2D46',
  indogo20: '#192435',
  indogo10: '#161B23',
  indogoAccent1: '#3D79D4',
  indogoAccent2: '#4385E8',
  indogoAccent3: '#4A92FF',
  indogoAccent4: '#4A92FF',
  apple100: '#37BF3D',
  apple90: '#33AE38',
  apple80: '#309D34',
  apple70: '#2C8B30',
  apple60: '#287A2C',
  apple50: '#256927',
  apple40: '#215723',
  apple30: '#1D461F',
  apple20: '#19351B',
  apple10: '#162316',
  appleAccent1: '#3DD444',
  appleAccent2: '#43E84A',
  appleAccent3: '#49FF51',
  appleAccent4: '#7DFF83',
  mojo100: '#BF3737',
  mojo90: '#AE3333',
  mojo80: '#9D3030',
  mojo70: '#8B2C2C',
  mojo60: '#7A2828',
  mojo50: '#692525',
  mojo40: '#572121',
  mojo30: '#461D1D',
  mojo20: '#351919',
  mojo10: '#231616',
  mojoAccent1: '#D43D3D',
  mojoAccent2: '#E84343',
  mojoAccent3: '#FF4A4A',
  mojoAccent4: '#FF7D7D',
  cooper100: '#BF7937',
  cooper90: '#AE6E33',
  cooper80: '#9D6430',
  cooper70: '#9D6430',
  cooper60: '#7A5028',
  cooper50: '#694525',
  cooper40: '#573B21',
  cooper30: '#46311D',
  cooper20: '#352619',
  cooper10: '#231C16',
  cooperAccent1: '#D4853D',
  cooperAccent2: '#E89243',
  cooperAccent3: '#FFA14A',
  cooperAccent4: '#FFBB7D',
  plum100: '#693BCC',
  plum90: '#6137B9',
  plum80: '#5833A7',
  plum70: '#4F2F94',
  plum60: '#462B82',
  plum50: '#3E266F',
  plum40: '#35225C',
  plum30: '#2C1E4A',
  plum20: '#231A37',
  plum10: '#1B1625',
  plumAccent1: '#7441E0',
  plumAccent2: '#7E47F5',
  plumAccent3: '#844AFF',
  plumAccent4: '#A77DFF',
  berry100: '#822768',
  berry90: '#75235E',
  berry80: '#681F53',
  berry70: '#5B1B49',
  berry60: '#4E173E',
  berry50: '#411434',
  berry40: '#34102A',
  berry30: '#270C1F',
  berry20: '#1a0815',
  berry10: '#0d040a',
  berryAccent1: '#8f3d77',
  berryAccent2: '#965286',
  berryAccent3: '#a86895',
  berryAccent4: '#b47da4',
  buckthorn100: '#518227',
  buckthorn90: '#497523',
  buckthorn80: '#41681f',
  buckthorn70: '#395b16',
  buckthorn60: '#314e17',
  buckthorn50: '#294114',
  buckthorn40: '#203410',
  buckthorn30: '#18270c',
  buckthorn20: '#101a08',
  buckthorn10: '#080d04',
  buckthornAccent1: '#628f3d',
  buckthornAccent2: '#749652',
  buckthornAccent3: '#85a868',
  buckthornAccent4: '#97b47d',
  grey100: '#E7E7E7',
  grey90: '#D0D0D0',
  grey80: '#B8B8B8',
  grey70: '#A0A0A0',
  grey60: '#888888',
  grey50: '#717171',
  grey40: '#595959',
  grey30: '#414141',
  grey20: '#2A2A2A',
  grey10: '#1E1E1E',
  grey: '#4a4a4a'
};

var BaseButton = styled(Button$1).withConfig({
  displayName: "styles__BaseButton",
  componentId: "ramyn1-0"
})(["border:none;border-radius:4px;font-size:14px;text-align:center;font-weight:500;font-family:'Roboto','Open Sans',sans-serif;", " &:disabled{background-color:", ";}"], function (_ref) {
  var size = _ref.size;
  if (size === 'sm') {
    return css(["font-size:12px;"]);
  } else if (size === 'lg') {
    return css(["height:48px;font-size:1.25rem;"]);
  }
  return css(["height:36px;"]);
}, theme.grey40);
var PrimaryButton = styled(BaseButton).withConfig({
  displayName: "styles__PrimaryButton",
  componentId: "ramyn1-1"
})(["background-color:", ";color:", ";&:hover:not(:disabled),&:visited,&:focus{background-color:", ";box-shadow:none !important;}&:active:enabled{background-color:", " !important;}&:disabled{img{filter:brightness(50%);}background-color:", ";color:", ";}"], theme.lochivar60, theme.fullWhite, theme.lochivar90, theme.primary, theme.lochivar30, theme.grey70);
var SecondaryButton = styled(BaseButton).withConfig({
  displayName: "styles__SecondaryButton",
  componentId: "ramyn1-2"
})(["color:", ";background-color:", ";border:1px solid ", ";&:hover:not(:disabled),&:visited,&:focus{border:1px solid ", " !important;outline:none;box-shadow:none !important;background-color:", ";}&:disabled{background-color:", ";border-color:", ";color:", ";}&:active{border:1px solid ", " !important;background-color:", " !important;}"], theme.grey100, theme.grey20, theme.grey30, theme.grey40, theme.grey40, theme.grey10, theme.grey10, theme.grey40, theme.grey40, theme.grey40);
var DangerButton = styled(BaseButton).withConfig({
  displayName: "styles__DangerButton",
  componentId: "ramyn1-3"
})(["color:", ";background-color:", ";&:hover:not(:disabled){background-color:", ";}&:visited,&:focus{box-shadow:none !important;background-color:", " !important;}&:disabled{background-color:", ";color:", ";}&:active{background-color:", " !important;}"], theme.fullWhite, theme.mojo50, theme.mojo60, theme.mojo80, theme.mojo20, theme.grey50, theme.grey80);
var SecondaryBorderlessButton = styled(BaseButton).withConfig({
  displayName: "styles__SecondaryBorderlessButton",
  componentId: "ramyn1-4"
})(["height:100%;border:none !important;color:", ";background-color:transparent;outline:none;box-shadow:none !important;&:hover:not(:disabled),&:visited,&:focus{outline:none;background-color:", ";}&:disabled{background-color:", ";color:", ";}&:active{background-color:", " !important;}"], theme.grey100, theme.grey40, theme.grey10, theme.grey40, theme.grey40);
var PrimaryOutline = styled(BaseButton).withConfig({
  displayName: "styles__PrimaryOutline",
  componentId: "ramyn1-5"
})(["border:1px solid ", ";font-weight:400;background-color:", ";&:hover:not(:disabled),&:visited,&:focus{border:1px solid ", ";background-color:", ";box-shadow:none !important;}&:active{background-color:", " !important;}&:disabled{background-color:", ";border:1px solid ", ";color:", ";}"], theme.lochivar60, theme.primaryBlack, theme.lochivar90, theme.grey40, theme.grey40, theme.grey10, theme.primary, theme.grey70);

var getButtonFromVariant = function getButtonFromVariant(variant) {
  var variantObj = {
    primary: PrimaryButton,
    secondary: SecondaryButton,
    danger: DangerButton,
    'secondary-borderless': SecondaryBorderlessButton,
    'primary-outline': PrimaryOutline
  };
  return variantObj[variant] || variantObj.primary;
};
var Button = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var _a$variant = _a.variant,
    variant = _a$variant === void 0 ? 'primary' : _a$variant,
    displayState = _a.displayState,
    props = __rest(_a, ["variant", "displayState"]);
  var ButtonComponent = getButtonFromVariant(variant);
  if (!displayState) {
    return /*#__PURE__*/React.createElement(ButtonComponent, Object.assign({
      ref: ref
    }, props));
  }
  if (displayState.visible) {
    if (displayState.enabled) {
      return /*#__PURE__*/React.createElement(ButtonComponent, Object.assign({
        ref: ref
      }, props));
    }
    return /*#__PURE__*/React.createElement(ButtonComponent, Object.assign({
      ref: ref,
      disabled: true
    }, props));
  }
  return null;
});

var getStyleVariantForHeader = function getStyleVariantForHeader() {
  var variant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'primary';
  var theme = arguments.length > 1 ? arguments[1] : undefined;
  var sharedStyle = "background-color: ".concat(theme.mojo50, "; color: ").concat(theme.fullWhite);
  var styleObj = {
    primary: "color: ".concat(theme.grey100, "; background-color: ").concat(theme.grey20, ";"),
    danger: "".concat(sharedStyle, "; border-bottom: 1px solid ").concat(theme.grey50),
    delete_danger: "".concat(sharedStyle, "; border-bottom: 0px solid ").concat(theme.grey50)
  };
  return styleObj[variant];
};
var CardContainer$1 = styled.div.withConfig({
  displayName: "Card__CardContainer",
  componentId: "sc-1l7a2le-0"
})(["border-radius:6px;display:flex;flex-direction:column;height:", ";", ";background-color:", ";position:relative;"], function (_ref) {
  var height = _ref.height,
    $fullHeight = _ref.$fullHeight;
  if ($fullHeight) {
    return '100%';
  }
  if (height) {
    return "".concat(height, "px");
  }
  return '';
}, function (_ref2) {
  var width = _ref2.width;
  return !!width ? "width: ".concat(width, "px") : "width: 100%";
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.grey10;
});
var CardHeader = styled.div.withConfig({
  displayName: "Card__CardHeader",
  componentId: "sc-1l7a2le-1"
})(["border-top-left-radius:6px;border-top-right-radius:6px;display:flex;align-items:center;justify-content:space-between;padding:20px;font-size:20px;font-weight:500;font-family:'Roboto',sans-serif;", ""], function (_ref4) {
  var $variant = _ref4.$variant,
    theme = _ref4.theme;
  return getStyleVariantForHeader($variant, theme);
});
var CardText$2 = styled.div.withConfig({
  displayName: "Card__CardText",
  componentId: "sc-1l7a2le-2"
})(["color:", ";font-weight:", ";", ";border-bottom:1px solid ", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.grey70;
}, function (_ref6) {
  var bold = _ref6.bold;
  return bold ? 'bold' : 500;
}, function (_ref7) {
  var isInModal = _ref7.isInModal;
  return isInModal ? '  padding: 0px 20px 20px;' : 'padding: 20px';
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.grey30;
});
var CardBody = styled.div.withConfig({
  displayName: "Card__CardBody",
  componentId: "sc-1l7a2le-3"
})(["display:flex;align-items:center;justify-content:center;height:100%;&:first-child{margin:auto;width:100%;padding:20px;}"]);
var Overlay = styled.div.withConfig({
  displayName: "Card__Overlay",
  componentId: "sc-1l7a2le-4"
})(["background-color:", ";height:100%;", ";position:absolute;opacity:0.75;z-index:2;"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.primaryBlack;
}, function (_ref10) {
  var width = _ref10.width;
  return !!width ? "width: ".concat(width, "px") : "width: 100%";
});
var HeaderButtons = styled.div.withConfig({
  displayName: "Card__HeaderButtons",
  componentId: "sc-1l7a2le-5"
})(["display:flex;"]);
var Card = function Card(_ref11) {
  var title = _ref11.title,
    text = _ref11.text,
    body = _ref11.body,
    height = _ref11.height,
    inactive = _ref11.inactive,
    width = _ref11.width,
    style = _ref11.style,
    variant = _ref11.variant,
    onClose = _ref11.onClose,
    onRefresh = _ref11.onRefresh,
    _onSubmit = _ref11.onSubmit,
    fullHeight = _ref11.fullHeight,
    fullscreen = _ref11.fullscreen,
    testId = _ref11.testId;
  return /*#__PURE__*/React.createElement(CardContainer$1, {
    "$fullHeight": fullHeight,
    "data-testid": testId,
    height: height,
    style: style,
    width: width
  }, inactive && /*#__PURE__*/React.createElement(Overlay, {
    height: height,
    width: width
  }), title && (/*#__PURE__*/React.createElement(CardHeader, {
    "$variant": variant
  }, title, /*#__PURE__*/React.createElement(HeaderButtons, null, onRefresh && (/*#__PURE__*/React.createElement(Button, {
    style: {
      padding: '2px 10px'
    },
    variant: "secondary-borderless",
    onClick: onRefresh
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-refresh"
  }))), onClose && (/*#__PURE__*/React.createElement(Button, {
    style: {
      padding: '2px 10px'
    },
    variant: "secondary-borderless",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-times"
  })))))), typeof text === 'string' ? /*#__PURE__*/React.createElement(CardText$2, {
    "$variant": variant
  }, text) : text, /*#__PURE__*/React.createElement(CardBody, {
    as: !fullscreen ? 'form' : 'div',
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      _onSubmit === null || _onSubmit === void 0 ? void 0 : _onSubmit();
    }
  }, body));
};

var TabContainer$2 = styled.ul.withConfig({
  displayName: "Styles__TabContainer",
  componentId: "sc-19zpkl6-0"
})(["display:flex;justify-content:flex-start;border-bottom:1px solid #414141;list-style-type:none;padding:0;"]);
var Tab$1 = styled.li.withConfig({
  displayName: "Styles__Tab",
  componentId: "sc-19zpkl6-1"
})(["cursor:pointer;padding:20px 0 20px 5px;width:111px;border-bottom:1px solid ", ";color:", ";"], function (_ref) {
  var checked = _ref.checked;
  return checked ? "#ff4a4a" : "#414141";
}, function (_ref2) {
  var checked = _ref2.checked;
  return checked ? "#e7e7e7" : "#a0a0a0";
});
var CardModalContainer$4 = styled(Modal).withConfig({
  displayName: "Styles__CardModalContainer",
  componentId: "sc-19zpkl6-2"
})(["overflow-x:hidden;border-radius:20px;.modal-content{border-radius:20px;}"]);
var CardContent$7 = styled.div.withConfig({
  displayName: "Styles__CardContent",
  componentId: "sc-19zpkl6-3"
})(["padding:20px;display:flex;flex-direction:column;height:100%;strong{color:", ";}img{align-self:baseline;margin-right:14px;width:120px;}flex-basis:100%;width:100%;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.grey100;
});
var BodyContainer = styled.div.withConfig({
  displayName: "Styles__BodyContainer",
  componentId: "sc-19zpkl6-4"
})(["flex-basis:100%;"]);
var SadAxoLotl = styled.div.withConfig({
  displayName: "Styles__SadAxoLotl",
  componentId: "sc-19zpkl6-5"
})(["display:flex;"]);
var MessageContainer = styled.div.withConfig({
  displayName: "Styles__MessageContainer",
  componentId: "sc-19zpkl6-6"
})(["display:flex;justify-content:flex-start;flex-direction:column;width:100%;margin-left:134px;width:80%;height:332px;overflow-y:scroll;"]);
var ButtonContainer$5 = styled.div.withConfig({
  displayName: "Styles__ButtonContainer",
  componentId: "sc-19zpkl6-7"
})(["button{float:right;margin-left:10px;margin-bottom:10px;}"]);
var MessageText = styled.span.withConfig({
  displayName: "Styles__MessageText",
  componentId: "sc-19zpkl6-8"
})(["margin-bottom:15px;a{color:", ";}word-break:break-word;white-space:pre-wrap;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.lochivarAccent4;
});

var Details = function Details(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(items).map(function (key) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: key
    }, /*#__PURE__*/React.createElement("strong", null, key), /*#__PURE__*/React.createElement(MessageText, null, String(items[key])));
  }));
};

var Overview = function Overview(_ref) {
  var error = _ref.error;
  if (error instanceof ApiError) {
    var code = error.code,
      message = error.message,
      type = error.type,
      reason = error.reason;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, "Code"), /*#__PURE__*/React.createElement(MessageText, null, code), /*#__PURE__*/React.createElement("strong", null, "Message"), /*#__PURE__*/React.createElement(MessageText, null, message), type && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, "Type"), /*#__PURE__*/React.createElement(MessageText, null, type))), reason && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, "Reason"), /*#__PURE__*/React.createElement(MessageText, null, reason))));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, "Message"), /*#__PURE__*/React.createElement(MessageText, null, error.message));
  }
};

var ErrorModal = function ErrorModal(_ref) {
  var error = _ref.error,
    onClose = _ref.onClose,
    onLogout = _ref.onLogout;
  var _a;
  var _useState = useState('overview'),
    _useState2 = _slicedToArray(_useState, 2),
    tab = _useState2[0],
    setTab = _useState2[1];
  var displaySignoutButton = (error === null || error === void 0 ? void 0 : error.message.startsWith('E10032')) && onLogout;
  return /*#__PURE__*/React.createElement(CardModalContainer$4, {
    centered: true,
    "data-testid": "error-modal",
    show: error !== null,
    onHide: onClose
  }, /*#__PURE__*/React.createElement(Card, {
    body: /*#__PURE__*/React.createElement(CardContent$7, null, /*#__PURE__*/React.createElement(BodyContainer, null, /*#__PURE__*/React.createElement(SadAxoLotl, null, /*#__PURE__*/React.createElement("img", {
      src: img$E
    }), /*#__PURE__*/React.createElement(TabContainer$2, null, /*#__PURE__*/React.createElement(Tab$1, {
      checked: tab === 'overview',
      onClick: function onClick() {
        return setTab('overview');
      }
    }, "Overview"), error instanceof ApiError && error.metadata !== null && (/*#__PURE__*/React.createElement(Tab$1, {
      checked: tab === 'details',
      onClick: function onClick() {
        return setTab('details');
      }
    }, "Details")))), /*#__PURE__*/React.createElement(MessageContainer, null, error === null ? null : tab === 'overview' ? (/*#__PURE__*/React.createElement(Overview, {
      error: error
    })) : (
    /*#__PURE__*/
    // Details tab is only viewable if the error is an ApiError and metadata exists
    React.createElement(Details, {
      items: error.metadata
    })))), /*#__PURE__*/React.createElement(ButtonContainer$5, null, /*#__PURE__*/React.createElement(Button, {
      variant: displaySignoutButton ? 'primary' : 'secondary',
      onClick: onClose
    }, "Close"), displaySignoutButton && (/*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: onLogout
    }, "Sign out")))),
    height: 600,
    title: (_a = error === null || error === void 0 ? void 0 : error.title) !== null && _a !== void 0 ? _a : 'Something went wrong',
    variant: "danger",
    width: 700
  }));
};

var ErrorContext = /*#__PURE__*/React.createContext({
  clearError: function clearError() {},
  isErrorVisible: false,
  showError: function showError() {},
  showErrorWithLogout: function showErrorWithLogout() {}
});
var useShowError = function useShowError() {
  var _useContext = useContext(ErrorContext),
    showError = _useContext.showError;
  return showError;
};
var ErrorModalProvider = function ErrorModalProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    logout = _useState2[0],
    setLogout = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var clearError = useCallback(function () {
    return setError(null);
  }, []);
  var showError = useCallback(function (error) {
    setLogout(undefined);
    var ensuredError = ensureError(error);
    Sentry.captureException(ensuredError);
    setError(ensuredError);
  }, []);
  var showErrorWithLogout = useCallback(function (error, logout) {
    setLogout(logout);
    var ensuredError = ensureError(error);
    Sentry.captureException(ensuredError);
    setError(ensuredError);
  }, []);
  return /*#__PURE__*/React.createElement(ErrorContext.Provider, {
    value: {
      clearError: clearError,
      showError: showError,
      isErrorVisible: !!error,
      showErrorWithLogout: showErrorWithLogout
    }
  }, /*#__PURE__*/React.createElement(ErrorModal, {
    error: error,
    onClose: function onClose() {
      return setError(null);
    },
    onLogout: logout
  }), children);
};

function assertUnreachable(value) {
  throw new Error("unexpected value: ".concat(value));
}
var QueryKeys;
(function (QueryKeys) {
  QueryKeys["AuthzDataDecisiontree"] = "authzDataDecisiontree";
  QueryKeys["AuthzDataIs"] = "authzDataIs";
  QueryKeys["AuthzDataQuery"] = "authzDataQuery";
  QueryKeys["GetPolicyState"] = "getPolicyState";
  QueryKeys["ListPolicyModules"] = "ListPolicyModules";
})(QueryKeys || (QueryKeys = {}));
var useMutationOptions = function useMutationOptions(mutationHooks) {
  var queryClient = useQueryClient();
  var showError = useShowError();
  for (var _len = arguments.length, queryKeys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    queryKeys[_key - 1] = arguments[_key];
  }
  var getQueryKeys = queryKeys.map(function (queryKey) {
    if (typeof queryKey === 'function') {
      return queryKey;
    } else {
      return function () {
        return queryKey;
      };
    }
  });
  return Object.assign(Object.assign({}, mutationHooks), {
    onError: function onError(error, variables, context) {
      var _a;
      showError(error);
      (_a = mutationHooks.onError) === null || _a === void 0 ? void 0 : _a.call(mutationHooks, error, variables, context);
    },
    onSuccess: function onSuccess(data, variables, context) {
      var _a;
      getQueryKeys.map(function (getQueryKey) {
        queryClient.invalidateQueries(getQueryKey(data, variables, context));
      });
      (_a = mutationHooks === null || mutationHooks === void 0 ? void 0 : mutationHooks.onSuccess) === null || _a === void 0 ? void 0 : _a.call(mutationHooks, data, variables, context);
    }
  });
};

var useAuthzQuery = function useAuthzQuery() {
  var reactQueryHooks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mutationOptions = useMutationOptions(reactQueryHooks);
  var _useAuthorizerClient = useAuthorizerClient(),
    post = _useAuthorizerClient.post;
  return useMutation([QueryKeys.AuthzDataQuery], function (body) {
    return post({
      path: "authz/query",
      body: body
    });
  }, mutationOptions);
};
var useAuthzIs = function useAuthzIs() {
  var reactQueryHooks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mutationOptions = useMutationOptions(reactQueryHooks);
  var _useAuthorizerClient2 = useAuthorizerClient(),
    post = _useAuthorizerClient2.post;
  return useMutation([QueryKeys.AuthzDataIs], function (body) {
    return post({
      path: "authz/is",
      body: body
    });
  }, mutationOptions);
};
var useAuthzDecisionTree = function useAuthzDecisionTree() {
  var reactQueryHooks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mutationOptions = useMutationOptions(reactQueryHooks);
  var _useAuthorizerClient3 = useAuthorizerClient(),
    post = _useAuthorizerClient3.post;
  return useMutation([QueryKeys.AuthzDataDecisiontree], function (body) {
    return post({
      path: "authz/decisiontree",
      body: body
    });
  }, mutationOptions);
};
var useListPolicyModules = function useListPolicyModules(authorizerPolicyInstance, fieldMask, options) {
  var _useAuthorizerClient4 = useAuthorizerClient(),
    get = _useAuthorizerClient4.get;
  var showError = useShowError();
  var args = {};
  var enabled = false;
  var queryKey = [QueryKeys.ListPolicyModules];
  if (!!authorizerPolicyInstance.authorizerInstance) {
    queryKey.push(authorizerPolicyInstance.authorizerInstance);
    args = {
      field_mask: fieldMask
    };
    enabled = true;
  }
  if (!!authorizerPolicyInstance.policyInstanceLabel && !!authorizerPolicyInstance.policyInstanceName) {
    queryKey.push(authorizerPolicyInstance.policyInstanceName, authorizerPolicyInstance.policyInstanceLabel);
    args = {
      field_mask: fieldMask,
      policy_instance: {
        name: authorizerPolicyInstance.policyInstanceName,
        instance_label: authorizerPolicyInstance.policyInstanceLabel
      }
    };
    enabled = true;
  }
  return useQuery(queryKey, function () {
    return get({
      path: "policies",
      queryParams: args
    });
  }, Object.assign(Object.assign({}, options), {
    enabled: enabled && (options === null || options === void 0 ? void 0 : options.enabled),
    retry: false,
    staleTime: Infinity,
    onError: function onError(error) {
      return showError(error);
    }
  }));
};

var useAsertoApiWithAnonymousAccess = function useAsertoApiWithAnonymousAccess(baseUrl) {
  var apiHeaderOverrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return useAsertoApi(baseUrl, apiHeaderOverrides);
};

var img$D = "data:image/svg+xml,%3csvg width='16' height='16' fill='none' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M10 2.5a7.5 7.5 0 0 1 5.964 12.048l4.743 4.745a1 1 0 0 1-1.32 1.497l-.094-.083-4.745-4.743A7.5 7.5 0 1 1 10 2.5Zm0 2a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Z' fill='%23a0a0a0'/%3e%3c/svg%3e";

var InfoText = styled.div.withConfig({
  displayName: "InfoText",
  componentId: "sc-18q0y1j-0"
})(["font-size:14px;color:", ";margin-top:8px;@media (max-width:720px){max-width:270px;}"], theme.grey70);

var ErrorText = styled(InfoText).withConfig({
  displayName: "ErrorText",
  componentId: "sc-1bx589b-0"
})(["color:", ";"], theme.mojoAccent3);

var Label$1 = styled.label.withConfig({
  displayName: "Label",
  componentId: "q37oi8-0"
})(["", " margin-bottom:8px;color:", ";"], function (_ref) {
  var $small = _ref.$small;
  return $small ? css(["font-size:12px;"]) : css(["font-weight:600;font-size:16px;"]);
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? theme.grey40 : theme.grey100;
});

var img$C = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='16' height='16' viewBox='0 0 16 16'%3e %3cdefs%3e %3cclipPath id='clip-Copy-to-clipboard'%3e %3crect width='16' height='16'/%3e %3c/clipPath%3e %3c/defs%3e %3cg id='Copy-to-clipboard' clip-path='url(%23clip-Copy-to-clipboard)'%3e %3cg id='Group_1' data-name='Group 1' transform='translate(-13 133)'%3e %3cg id='File_Paste_Copy' data-name='File%2c Paste%2c Copy' transform='translate(13 -133)'%3e %3cpath id='Path_1' data-name='Path 1' d='M6.692%2c14.691H4.231V4.231h8.615a.615.615%2c0%2c1%2c0%2c0-1.231H3.615A.615.615%2c0%2c0%2c0%2c3%2c3.615V15.306a.615.615%2c0%2c0%2c0%2c.615.615H6.692a.615.615%2c0%2c0%2c0%2c0-1.231Z' transform='translate(-3 -3)' fill='%23a0a0a0'/%3e %3cpath id='Path_2' data-name='Path 2' d='M21.845%2c8h-9.23A.615.615%2c0%2c0%2c0%2c12%2c8.615V20.306a.615.615%2c0%2c0%2c0%2c.615.615h9.23a.615.615%2c0%2c0%2c0%2c.615-.615V8.615A.615.615%2c0%2c0%2c0%2c21.845%2c8ZM21.23%2c19.691h-8V9.231h8Z' transform='translate(-6.462 -4.923)' fill='%23a0a0a0'/%3e %3cpath id='Path_3' data-name='Path 3' d='M17.615%2c17.231h3.077a.615.615%2c0%2c1%2c0%2c0-1.231H17.615a.615.615%2c0%2c1%2c0%2c0%2c1.231Z' transform='translate(-8.385 -8.001)' fill='%23a0a0a0'/%3e %3cpath id='Path_4' data-name='Path 4' d='M17.615%2c21.231h3.077a.615.615%2c0%2c1%2c0%2c0-1.231H17.615a.615.615%2c0%2c1%2c0%2c0%2c1.231Z' transform='translate(-8.385 -9.54)' fill='%23a0a0a0'/%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$B = "data:image/svg+xml,%3csvg version='1.2' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' overflow='visible' preserveAspectRatio='none' viewBox='0 0 16.024839999999998 16.024839999999998' width='16.024839999999998' height='16.024839999999998'%3e%3cg transform='translate(0%2c 0)'%3e%3cg transform='translate(0.0000049999999997552%2c -0.0000049999999998801) rotate(0)'%3e%3cpath d='M15.87839%2c0.14645c0.19526%2c0.19526 0.19526%2c0.51184 0%2c0.70711l-15.02484%2c15.02484c-0.19526%2c0.19526 -0.51184%2c0.19526 -0.70711%2c0c-0.19526%2c-0.19526 -0.19526%2c-0.51184 0%2c-0.70711l15.02484%2c-15.02484c0.19526%2c-0.19526 0.51184%2c-0.19526 0.70711%2c0zM13.38215%2c4.09942c1.60366%2c1.28762 2.63027%2c2.90005 2.63027%2c3.9555c0%2c2 -3.68629%2c6 -8%2c6c-1.30384%2c0 -2.55037%2c-0.36543 -3.65511%2c-0.93062l1.62309%2c-1.62322c0.59552%2c0.35191 1.29019%2c0.55385 2.03201%2c0.55385c2.20914%2c0 4%2c-1.79086 4%2c-4c0%2c-0.74183 -0.20194%2c-1.43649 -0.55385%2c-2.03201zM8.01242%2c2.05492c1.30391%2c0 2.5505%2c0.36547 3.65527%2c0.93071l-1.62309%2c1.62324c-0.59556%2c-0.35197 -1.29028%2c-0.55394 -2.03218%2c-0.55394c-2.20914%2c0 -4%2c1.79086 -4%2c4c0%2c0.7419 0.20198%2c1.43662 0.55394%2c2.03218l-1.92351%2c1.92346c-1.60376%2c-1.28764 -2.63043%2c-2.90015 -2.63043%2c-3.95564c0%2c-2 3.68629%2c-6 8%2c-6zM9.94473%2c7.53691c0.04413%2c0.16519 0.06769%2c0.33885 0.06769%2c0.51801c0%2c1.10457 -0.89543%2c2 -2%2c2c-0.17915%2c0 -0.35281%2c-0.02356 -0.51803%2c-0.06774zM8.01242%2c6.05492c0.17922%2c0 0.35294%2c0.02357 0.51821%2c0.06779l-2.45043%2c2.45041c-0.04421%2c-0.16527 -0.06778%2c-0.33898 -0.06778%2c-0.51819c0%2c-1.10457 0.89543%2c-2 2%2c-2z' style='stroke-width: 0%3b stroke-linecap: butt%3b stroke-linejoin: miter%3b fill: rgb(160%2c 160%2c 160)%3b' vector-effect='non-scaling-stroke'/%3e%3c/g%3e%3cdefs%3e%3cpath id='path-1617926008240131' d='M15.87839%2c0.14645c0.19526%2c0.19526 0.19526%2c0.51184 0%2c0.70711l-15.02484%2c15.02484c-0.19526%2c0.19526 -0.51184%2c0.19526 -0.70711%2c0c-0.19526%2c-0.19526 -0.19526%2c-0.51184 0%2c-0.70711l15.02484%2c-15.02484c0.19526%2c-0.19526 0.51184%2c-0.19526 0.70711%2c0zM13.38215%2c4.09942c1.60366%2c1.28762 2.63027%2c2.90005 2.63027%2c3.9555c0%2c2 -3.68629%2c6 -8%2c6c-1.30384%2c0 -2.55037%2c-0.36543 -3.65511%2c-0.93062l1.62309%2c-1.62322c0.59552%2c0.35191 1.29019%2c0.55385 2.03201%2c0.55385c2.20914%2c0 4%2c-1.79086 4%2c-4c0%2c-0.74183 -0.20194%2c-1.43649 -0.55385%2c-2.03201zM8.01242%2c2.05492c1.30391%2c0 2.5505%2c0.36547 3.65527%2c0.93071l-1.62309%2c1.62324c-0.59556%2c-0.35197 -1.29028%2c-0.55394 -2.03218%2c-0.55394c-2.20914%2c0 -4%2c1.79086 -4%2c4c0%2c0.7419 0.20198%2c1.43662 0.55394%2c2.03218l-1.92351%2c1.92346c-1.60376%2c-1.28764 -2.63043%2c-2.90015 -2.63043%2c-3.95564c0%2c-2 3.68629%2c-6 8%2c-6zM9.94473%2c7.53691c0.04413%2c0.16519 0.06769%2c0.33885 0.06769%2c0.51801c0%2c1.10457 -0.89543%2c2 -2%2c2c-0.17915%2c0 -0.35281%2c-0.02356 -0.51803%2c-0.06774zM8.01242%2c6.05492c0.17922%2c0 0.35294%2c0.02357 0.51821%2c0.06779l-2.45043%2c2.45041c-0.04421%2c-0.16527 -0.06778%2c-0.33898 -0.06778%2c-0.51819c0%2c-1.10457 0.89543%2c-2 2%2c-2z' vector-effect='non-scaling-stroke'/%3e%3c/defs%3e%3c/g%3e%3c/svg%3e";

var img$A = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1'%3e %3ctext x='0' y='15' fill='%23FF4A4A' font-family='Roboto%2c Helvetica%2c sans-serif' font-weight='bold' font-size='12'%3e INVALID %3c/text%3e%3c/svg%3e";

var img$z = "data:image/svg+xml,%3csvg version='1.2' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' overflow='visible' preserveAspectRatio='none' viewBox='0 0 16 12' width='16' height='12'%3e%3cg transform='translate(0%2c 0)'%3e%3cg transform='translate(0%2c 0) rotate(0)'%3e%3cpath d='M8%2c0c4.31371%2c0 8%2c4 8%2c6c0%2c2 -3.68629%2c6 -8%2c6c-4.31371%2c0 -8%2c-4 -8%2c-6c0%2c-2 3.68629%2c-6 8%2c-6zM8%2c2c-2.20914%2c0 -4%2c1.79086 -4%2c4c0%2c2.20914 1.79086%2c4 4%2c4c2.20914%2c0 4%2c-1.79086 4%2c-4c0%2c-2.20914 -1.79086%2c-4 -4%2c-4zM8%2c4c0.20503%2c0 0.40285%2c0.03085 0.58908%2c0.08817c-0.34736%2c0.15669 -0.58908%2c0.50603 -0.58908%2c0.91183c0%2c0.55228 0.44772%2c1 1%2c1c0.4058%2c0 0.75515%2c-0.24172 0.91192%2c-0.58902c0.05723%2c0.18617 0.08808%2c0.384 0.08808%2c0.58902c0%2c1.10457 -0.89543%2c2 -2%2c2c-1.10457%2c0 -2%2c-0.89543 -2%2c-2c0%2c-1.10457 0.89543%2c-2 2%2c-2z' style='stroke-width: 0%3b stroke-linecap: butt%3b stroke-linejoin: miter%3b fill: rgb(160%2c 160%2c 160)%3b' vector-effect='non-scaling-stroke'/%3e%3c/g%3e%3cdefs%3e%3cpath id='path-1617926008239128' d='M8%2c0c4.31371%2c0 8%2c4 8%2c6c0%2c2 -3.68629%2c6 -8%2c6c-4.31371%2c0 -8%2c-4 -8%2c-6c0%2c-2 3.68629%2c-6 8%2c-6zM8%2c2c-2.20914%2c0 -4%2c1.79086 -4%2c4c0%2c2.20914 1.79086%2c4 4%2c4c2.20914%2c0 4%2c-1.79086 4%2c-4c0%2c-2.20914 -1.79086%2c-4 -4%2c-4zM8%2c4c0.20503%2c0 0.40285%2c0.03085 0.58908%2c0.08817c-0.34736%2c0.15669 -0.58908%2c0.50603 -0.58908%2c0.91183c0%2c0.55228 0.44772%2c1 1%2c1c0.4058%2c0 0.75515%2c-0.24172 0.91192%2c-0.58902c0.05723%2c0.18617 0.08808%2c0.384 0.08808%2c0.58902c0%2c1.10457 -0.89543%2c2 -2%2c2c-1.10457%2c0 -2%2c-0.89543 -2%2c-2c0%2c-1.10457 0.89543%2c-2 2%2c-2z' vector-effect='non-scaling-stroke'/%3e%3c/defs%3e%3c/g%3e%3c/svg%3e";

var img$y = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1'%3e %3ctext x='0' y='15' fill='%23FF4A4A' font-family='Roboto%2c Helvetica%2c sans-serif' font-weight='bold' font-size='12'%3e UNAVAILABLE %3c/text%3e%3c/svg%3e";

var img$x = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1'%3e %3ctext x='0' y='15' fill='%2336b1b5' font-family='Roboto%2c Helvetica%2c sans-serif' font-size='12' font-weight='bold' color='%2336b1b5'%3e AVAILABLE %3c/text%3e%3c/svg%3e";

var getInputValueForState = function getInputValueForState(isValid, isInvalid, isUnavailable) {
  if (isUnavailable) {
    return "border-color: ".concat(theme.mojoAccent3, " !important;background-image: url(\"").concat(img$y, "\") !important; background-size: calc(5.2em + 0.375rem) calc(1em + 0.375rem) !important;");
  } else if (isValid) {
    return "border-color: ".concat(theme.lochivarAccent2, " !important;background-image: url(\"").concat(img$x, "\") !important; background-size: calc(4.2em + 0.375rem) calc(1em + 0.375rem) !important;");
  } else if (isInvalid) {
    return "border-color: ".concat(theme.mojoAccent3, " !important;background-image: url(\"").concat(img$A, "\") !important; background-size: calc(3em + 0.375rem) calc(1em + 0.375rem) !important;");
  }
  return "border-color: ".concat(theme.grey40, ";");
};
var AsertoInput = styled(FormControl).withConfig({
  displayName: "Input__AsertoInput",
  componentId: "sc-1yp5qdf-0"
})(["background-color:", ";color:", ";margin-top:8px;", ";border-color:", ";&:focus{background-color:", ";color:", ";outline:none;box-shadow:none;border-color:", ";-webkit-box-shadow:none;}&:disabled{background-color:", ";border-color:", ";-webkit-text-fill-color:", ";}&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{display:none;}&[type='number']{-moz-appearance:textfield;}", ""], theme.primaryBlack, theme.grey100, function (_ref) {
  var $paddingRight = _ref.$paddingRight;
  return $paddingRight ? "padding-right: ".concat($paddingRight, "px;") : '';
}, theme.grey40, theme.primaryBlack, theme.grey100, theme.lochivarAccent2, theme.grey20, theme.grey20, theme.grey70, function (_ref2) {
  var isValid = _ref2.isValid,
    isInvalid = _ref2.isInvalid,
    $isUnavailable = _ref2.$isUnavailable;
  return getInputValueForState(isValid !== null && isValid !== void 0 ? isValid : false, isInvalid !== null && isInvalid !== void 0 ? isInvalid : false, $isUnavailable !== null && $isUnavailable !== void 0 ? $isUnavailable : false);
});
var InputContainer$2 = styled.div.withConfig({
  displayName: "Input__InputContainer",
  componentId: "sc-1yp5qdf-1"
})(["display:flex;flex-direction:column;", ";"], function (_ref3) {
  var $block = _ref3.$block;
  return $block ? 'width: 100%' : '';
});
var InputButtonBlock = styled.div.withConfig({
  displayName: "Input__InputButtonBlock",
  componentId: "sc-1yp5qdf-2"
})(["display:flex;position:relative;"]);
var ButtonsContainer$d = styled.div.withConfig({
  displayName: "Input__ButtonsContainer",
  componentId: "sc-1yp5qdf-3"
})(["position:absolute;", ";right:0;"], function (_ref4) {
  var $top = _ref4.$top;
  return "top: ".concat($top || 8, "px");
});
var Anm = keyframes(["0%{opacity:0;transform:translateY(-100%);}10%{transform:translateY(-100%);}15%{transform:translateY(0);}30%{transform:translateY(-10%);}40%{transform:translateY(0%);}100%{opacity:1;}"]);
var CopyButton$4 = styled(Button).withConfig({
  displayName: "Input__CopyButton",
  componentId: "sc-1yp5qdf-4"
})(["padding:8px;align-items:center;", ""], function (_ref5) {
  var $wasClicked = _ref5.$wasClicked;
  return $wasClicked ? css(["animation:", " 0.6s 0.1s 1 linear alternate;background-color:transparent !important;"], Anm) : '';
});
var HideShowButton = styled(Button).withConfig({
  displayName: "Input__HideShowButton",
  componentId: "sc-1yp5qdf-5"
})(["padding:8px;"]);
var SearchButton = styled(Button).withConfig({
  displayName: "Input__SearchButton",
  componentId: "sc-1yp5qdf-6"
})(["padding:0px 0px 0px 6px;height:18px;margin:7px;border-radius:0px;border-left:1px solid ", " !important;background-color:transparent !important;&:hover{background-color:transparent !important;img{filter:brightness(130%);}}img{margin-bottom:5px;}"], theme.grey30);
var Info = styled.div.withConfig({
  displayName: "Input__Info",
  componentId: "sc-1yp5qdf-7"
})(["font-size:14px;color:", ";margin-top:8px;@media (max-width:720px){max-width:270px;}"], theme.grey70);
var Input = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var onChange = _a.onChange,
    label = _a.label,
    info = _a.info,
    error = _a.error,
    hideError = _a.hideError,
    isValid = _a.isValid,
    isUnavailable = _a.isUnavailable,
    style = _a.style,
    hasSmallLabel = _a.hasSmallLabel,
    block = _a.block,
    defaultValue = _a.defaultValue,
    id = _a.id,
    onClickCopy = _a.onClickCopy,
    onClickSearch = _a.onClickSearch,
    shouldShowHideShowButton = _a.shouldShowHideShowButton,
    type = _a.type,
    value = _a.value,
    props = __rest(_a, ["onChange", "label", "info", "error", "hideError", "isValid", "isUnavailable", "style", "hasSmallLabel", "block", "defaultValue", "id", "onClickCopy", "onClickSearch", "shouldShowHideShowButton", "type", "value"]);
  var _useState = useState(type || 'text'),
    _useState2 = _slicedToArray(_useState, 2),
    inputType = _useState2[0],
    setInputType = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    wasClicked = _useState4[0],
    setWasClicked = _useState4[1];
  var shouldShowErrorState = !(error === false || error === '' || error === undefined) || isUnavailable;
  var shouldDisplayInfo = !shouldShowErrorState && info;
  var errorMessage = typeof error === 'string' ? error : null;
  useEffect(function () {
    if (wasClicked) {
      var timeoutId = setTimeout(function () {
        setWasClicked(false);
      }, 800);
      return function () {
        return clearTimeout(timeoutId);
      };
    }
  }, [wasClicked]);
  return /*#__PURE__*/React.createElement(InputContainer$2, {
    "$block": block
  }, /*#__PURE__*/React.createElement(Label$1, {
    "$small": hasSmallLabel,
    htmlFor: id
  }, label, /*#__PURE__*/React.createElement(InputButtonBlock, null, /*#__PURE__*/React.createElement(AsertoInput, Object.assign({
    ref: ref,
    "$isUnavailable": isUnavailable,
    "$paddingRight": onClickSearch ? 38 : undefined,
    defaultValue: defaultValue,
    isInvalid: shouldShowErrorState,
    isValid: isValid && !shouldShowErrorState,
    style: style,
    onChange: onChange
  }, props, {
    type: inputType,
    value: value,
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Enter') {
        onClickSearch === null || onClickSearch === void 0 ? void 0 : onClickSearch();
      }
    }
  })), !(error || isUnavailable || isValid) && (/*#__PURE__*/React.createElement(ButtonsContainer$d, {
    "$top": onClickSearch ? 10 : 8
  }, shouldShowHideShowButton && (/*#__PURE__*/React.createElement(React.Fragment, null, inputType === 'password' ? (/*#__PURE__*/React.createElement(HideShowButton, {
    variant: "secondary-borderless",
    onClick: function onClick() {
      return setInputType('text');
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "show",
    src: img$z
  }))) : (/*#__PURE__*/React.createElement(HideShowButton, {
    variant: "secondary-borderless",
    onClick: function onClick() {
      return setInputType('password');
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "hide",
    src: img$B
  }))))), onClickCopy && (/*#__PURE__*/React.createElement(CopyButton$4, {
    "$wasClicked": wasClicked,
    variant: "secondary-borderless",
    onClick: function onClick(event) {
      event.preventDefault();
      setWasClicked(true);
      event.currentTarget.blur();
      onClickCopy(String(value));
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "copy",
    src: img$C
  }))), onClickSearch && (/*#__PURE__*/React.createElement(SearchButton, {
    disabled: props.disabled,
    variant: "secondary-borderless",
    onClick: function onClick(event) {
      event.preventDefault();
      event.currentTarget.blur();
      onClickSearch();
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "search",
    src: img$D
  }))))))), shouldDisplayInfo && /*#__PURE__*/React.createElement(InfoText, null, info), errorMessage && !hideError && /*#__PURE__*/React.createElement(ErrorText, null, errorMessage));
});

var Link = styled(Link$1).withConfig({
  displayName: "UndecoratedLink__Link",
  componentId: "cl9hih-0"
})(["text-decoration:none;"]);
var UndecoratedLink = styled(Link).withConfig({
  displayName: "UndecoratedLink",
  componentId: "cl9hih-1"
})(["&:hover{text-decoration:none;}"]);

var CenteredRow = styled.div.withConfig({
  displayName: "ActionableInput__CenteredRow",
  componentId: "sc-1tc4i7y-0"
})(["display:flex;align-items:center;position:relative;"]);
var ActionableInputContainer = styled.div.withConfig({
  displayName: "ActionableInput__ActionableInputContainer",
  componentId: "sc-1tc4i7y-1"
})(["display:flex;flex-direction:row;align-items:flex-end;"]);
var StyledInput = styled(Input).withConfig({
  displayName: "ActionableInput__StyledInput",
  componentId: "sc-1tc4i7y-2"
})(["&:focus{background-color:", ";border-color:", ";outline:none;box-shadow:none;-webkit-box-shadow:none;color:", ";}color:", ";cursor:pointer;background-color:", ";border-color:", ";"], theme.grey20, theme.grey20, theme.lochivarAccent4, theme.lochivarAccent4, theme.grey20, theme.grey20);
var ActionableInput = function ActionableInput(_a) {
  var testId = _a.testId,
    label = _a.label,
    type = _a.type,
    linkValue = _a.linkValue,
    inputProps = __rest(_a, ["testId", "label", "type", "linkValue"]);
  return /*#__PURE__*/React.createElement(ActionableInputContainer, null, /*#__PURE__*/React.createElement(Label$1, null, label, /*#__PURE__*/React.createElement(CenteredRow, null, !!linkValue ? (/*#__PURE__*/React.createElement(Link, {
    to: linkValue
  }, /*#__PURE__*/React.createElement(StyledInput, Object.assign({}, inputProps, {
    "data-testid": testId,
    type: type
  })))) : (/*#__PURE__*/React.createElement(Input, Object.assign({}, inputProps, {
    "data-testid": testId,
    type: type
  }))))));
};

var img$w = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='131' height='48' viewBox='0 0 131 48'%3e %3cdefs%3e %3clinearGradient id='linear-gradient' x1='0.5' x2='0.5' y2='1' gradientUnits='objectBoundingBox'%3e %3cstop offset='0' stop-color='%2370d0d3' /%3e %3cstop offset='1' stop-color='%23048a8f' /%3e %3c/linearGradient%3e %3cclipPath id='clip-aserto-horizontal-white-text'%3e %3crect width='131' height='48.033' /%3e %3c/clipPath%3e %3c/defs%3e %3cg id='aserto-horizontal-white-text' clip-path='url(%23clip-aserto-horizontal-white-text)'%3e %3cg id='Group_1' transform='translate(-294.001 -78.674)'%3e %3cg id='Group_8'%3e %3cg id='Group_3' transform='translate(347.737 94.026)'%3e %3cpath id='Path_2' d='M350.609%2c71.44q-.35-1.023-.724-2.021t-.724-2.046h-7.291q-.35%2c1.048-.712%2c2.058t-.711%2c2.009h-3.264q.97-2.769%2c1.842-5.114t1.705-4.442q.833-2.1%2c1.655-3.992t1.693-3.743h3q.872%2c1.847%2c1.694%2c3.743t1.656%2c3.992q.835%2c2.1%2c1.719%2c4.441T354%2c71.44Zm-5.094-13.948q-.573%2c1.323-1.308%2c3.219t-1.532%2c4.117h5.679q-.8-2.22-1.544-4.142t-1.3-3.194' transform='translate(-337.183 -54.149)' fill='white' /%3e %3cpath id='Path_3' d='M479.3%2c94.918a3.96%2c3.96%2c0%2c0%2c0%2c1.744-.287%2c1.019%2c1.019%2c0%2c0%2c0%2c.548-.985A1.279%2c1.279%2c0%2c0%2c0%2c481%2c92.572a8.606%2c8.606%2c0%2c0%2c0-1.931-.923%2c15.162%2c15.162%2c0%2c0%2c1-1.507-.636%2c5.13%2c5.13%2c0%2c0%2c1-1.183-.786%2c3.218%2c3.218%2c0%2c0%2c1-.785-1.085%2c3.788%2c3.788%2c0%2c0%2c1-.287-1.559%2c3.4%2c3.4%2c0%2c0%2c1%2c1.32-2.832%2c5.666%2c5.666%2c0%2c0%2c1%2c3.587-1.036%2c11.032%2c11.032%2c0%2c0%2c1%2c2.192.212%2c10.686%2c10.686%2c0%2c0%2c1%2c1.569.412l-.548%2c2.446a7.359%2c7.359%2c0%2c0%2c0-1.27-.412%2c7.668%2c7.668%2c0%2c0%2c0-1.793-.187%2c3.116%2c3.116%2c0%2c0%2c0-1.494.312%2c1.024%2c1.024%2c0%2c0%2c0-.573.961%2c1.386%2c1.386%2c0%2c0%2c0%2c.112.574%2c1.231%2c1.231%2c0%2c0%2c0%2c.386.461%2c3.921%2c3.921%2c0%2c0%2c0%2c.722.424%2c11.055%2c11.055%2c0%2c0%2c0%2c1.1.437%2c16.775%2c16.775%2c0%2c0%2c1%2c1.818.786%2c4.929%2c4.929%2c0%2c0%2c1%2c1.233.873%2c2.988%2c2.988%2c0%2c0%2c1%2c.71%2c1.11%2c4.442%2c4.442%2c0%2c0%2c1%2c.224%2c1.5%2c3.227%2c3.227%2c0%2c0%2c1-1.382%2c2.832%2c6.873%2c6.873%2c0%2c0%2c1-3.948.961%2c10.775%2c10.775%2c0%2c0%2c1-2.764-.287%2c14.2%2c14.2%2c0%2c0%2c1-1.47-.461l.523-2.52a13.479%2c13.479%2c0%2c0%2c0%2c1.607.524%2c8.275%2c8.275%2c0%2c0%2c0%2c2.129.249' transform='translate(-456.806 -80.137)' fill='white' /%3e %3cpath id='Path_4' d='M564.1%2c90.621a8.21%2c8.21%2c0%2c0%2c1%2c.511-3.019%2c6.343%2c6.343%2c0%2c0%2c1%2c1.357-2.159%2c5.616%2c5.616%2c0%2c0%2c1%2c1.943-1.3%2c6.008%2c6.008%2c0%2c0%2c1%2c2.242-.437%2c5.361%2c5.361%2c0%2c0%2c1%2c4.2%2c1.672%2c7.243%2c7.243%2c0%2c0%2c1%2c1.507%2c4.992q0%2c.25-.012.562t-.037.562h-8.593a3.444%2c3.444%2c0%2c0%2c0%2c1.108%2c2.433%2c4.206%2c4.206%2c0%2c0%2c0%2c2.852.861%2c9.341%2c9.341%2c0%2c0%2c0%2c2-.2%2c8.241%2c8.241%2c0%2c0%2c0%2c1.432-.424l.4%2c2.47a4.765%2c4.765%2c0%2c0%2c1-.685.262%2c9.551%2c9.551%2c0%2c0%2c1-1%2c.25q-.561.112-1.208.187a11.487%2c11.487%2c0%2c0%2c1-1.32.075%2c7.976%2c7.976%2c0%2c0%2c1-2.989-.512%2c5.559%2c5.559%2c0%2c0%2c1-2.092-1.422%2c5.827%2c5.827%2c0%2c0%2c1-1.221-2.146%2c8.773%2c8.773%2c0%2c0%2c1-.4-2.707m8.742-1.347a3.988%2c3.988%2c0%2c0%2c0-.174-1.185%2c2.863%2c2.863%2c0%2c0%2c0-.511-.973%2c2.417%2c2.417%2c0%2c0%2c0-.822-.649%2c2.619%2c2.619%2c0%2c0%2c0-1.158-.237%2c2.694%2c2.694%2c0%2c0%2c0-1.221.262%2c2.783%2c2.783%2c0%2c0%2c0-.884.686%2c3.131%2c3.131%2c0%2c0%2c0-.56.973%2c5.265%2c5.265%2c0%2c0%2c0-.274%2c1.123Z' transform='translate(-534.088 -80.132)' fill='white' /%3e %3cpath id='Path_5' d='M685.471%2c87.083a9.719%2c9.719%2c0%2c0%2c0-1.034-.262%2c7.617%2c7.617%2c0%2c0%2c0-1.532-.137%2c6.084%2c6.084%2c0%2c0%2c0-1.058.1%2c6.418%2c6.418%2c0%2c0%2c0-.785.175V97.413h-3.014V84.987a16.6%2c16.6%2c0%2c0%2c1%2c2.179-.611%2c13.58%2c13.58%2c0%2c0%2c1%2c2.9-.287q.3%2c0%2c.7.037t.8.1q.4.062.772.15t.6.162Z' transform='translate(-632.967 -80.114)' fill='white' /%3e %3cpath id='Path_6' d='M753.749%2c56.908l3.014-.5v3.942H761.4v2.52h-4.633v5.315a3.867%2c3.867%2c0%2c0%2c0%2c.5%2c2.246%2c1.97%2c1.97%2c0%2c0%2c0%2c1.694.674%2c5.509%2c5.509%2c0%2c0%2c0%2c1.457-.175%2c9.734%2c9.734%2c0%2c0%2c0%2c1.009-.324l.5%2c2.4a11.283%2c11.283%2c0%2c0%2c1-1.37.461%2c7.444%2c7.444%2c0%2c0%2c1-1.992.237%2c6.292%2c6.292%2c0%2c0%2c1-2.329-.374%2c3.431%2c3.431%2c0%2c0%2c1-1.482-1.085%2c4.306%2c4.306%2c0%2c0%2c1-.772-1.722%2c10.709%2c10.709%2c0%2c0%2c1-.224-2.308Z' transform='translate(-698.654 -56.409)' fill='white' /%3e %3cpath id='Path_7' d='M839.326%2c90.549a8.436%2c8.436%2c0%2c0%2c1-.448%2c2.82%2c6.243%2c6.243%2c0%2c0%2c1-1.27%2c2.171%2c5.707%2c5.707%2c0%2c0%2c1-1.981%2c1.4%2c6.391%2c6.391%2c0%2c0%2c1-2.553.5%2c6.3%2c6.3%2c0%2c0%2c1-2.541-.5%2c5.735%2c5.735%2c0%2c0%2c1-1.968-1.4%2c6.4%2c6.4%2c0%2c0%2c1-1.283-2.171%2c8.224%2c8.224%2c0%2c0%2c1-.461-2.82%2c8.12%2c8.12%2c0%2c0%2c1%2c.461-2.807%2c6.313%2c6.313%2c0%2c0%2c1%2c1.3-2.158%2c5.727%2c5.727%2c0%2c0%2c1%2c1.98-1.385%2c6.373%2c6.373%2c0%2c0%2c1%2c2.516-.487%2c6.466%2c6.466%2c0%2c0%2c1%2c2.528.487%2c5.579%2c5.579%2c0%2c0%2c1%2c1.98%2c1.385%2c6.425%2c6.425%2c0%2c0%2c1%2c1.283%2c2.158%2c8.128%2c8.128%2c0%2c0%2c1%2c.461%2c2.807m-3.088%2c0a5.1%2c5.1%2c0%2c0%2c0-.834-3.081%2c2.956%2c2.956%2c0%2c0%2c0-4.658%2c0%2c5.1%2c5.1%2c0%2c0%2c0-.834%2c3.081%2c5.2%2c5.2%2c0%2c0%2c0%2c.834%2c3.119%2c2.937%2c2.937%2c0%2c0%2c0%2c4.658%2c0%2c5.207%2c5.207%2c0%2c0%2c0%2c.834-3.119' transform='translate(-762.064 -80.135)' fill='white' /%3e %3c/g%3e %3cpath id='Subtraction_117' d='M-4025.98-3951.967a24.268%2c24.268%2c0%2c0%2c1-4.413-.4%2c23.863%2c23.863%2c0%2c0%2c1-4.132-1.16l13.348-26.174%2c11.083%2c21.734a24.174%2c24.174%2c0%2c0%2c1-3.411%2c2.515%2c23.979%2c23.979%2c0%2c0%2c1-3.836%2c1.889%2c23.9%2c23.9%2c0%2c0%2c1-4.183%2c1.189A24.221%2c24.221%2c0%2c0%2c1-4025.98-3951.967Zm19.185-9.567L-4025.98-4000a24.2%2c24.2%2c0%2c0%2c1%2c4.84.488%2c23.887%2c23.887%2c0%2c0%2c1%2c4.508%2c1.4%2c24.024%2c24.024%2c0%2c0%2c1%2c4.08%2c2.215%2c24.2%2c24.2%2c0%2c0%2c1%2c3.555%2c2.933%2c24.279%2c24.279%2c0%2c0%2c1%2c2.933%2c3.554%2c24.059%2c24.059%2c0%2c0%2c1%2c2.214%2c4.08%2c23.864%2c23.864%2c0%2c0%2c1%2c1.4%2c4.509%2c24.189%2c24.189%2c0%2c0%2c1%2c.488%2c4.839%2c23.982%2c23.982%2c0%2c0%2c1-1.278%2c7.751%2c23.937%2c23.937%2c0%2c0%2c1-3.553%2c6.7Zm-38.37%2c0a23.918%2c23.918%2c0%2c0%2c1-3.553-6.7%2c23.985%2c23.985%2c0%2c0%2c1-1.278-7.752%2c24.222%2c24.222%2c0%2c0%2c1%2c.49-4.85%2c23.929%2c23.929%2c0%2c0%2c1%2c1.4-4.5%2c24.025%2c24.025%2c0%2c0%2c1%2c2.215-4.08%2c24.223%2c24.223%2c0%2c0%2c1%2c2.933-3.555%2c24.2%2c24.2%2c0%2c0%2c1%2c3.554-2.932%2c24.02%2c24.02%2c0%2c0%2c1%2c4.079-2.216%2c23.9%2c23.9%2c0%2c0%2c1%2c4.509-1.4%2c24.206%2c24.206%2c0%2c0%2c1%2c4.839-.488Z' transform='translate(4343.998 4078.674)' fill='url(%23linear-gradient)' /%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$v = "data:image/svg+xml,%3csvg version='1.2' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' overflow='visible' preserveAspectRatio='none' viewBox='0 0 1 36' width='1' height='36'%3e %3cg transform='translate(0%2c 0)'%3e %3cdefs%3e %3cpath id='path-161971994306555' d='M0 0 C0 0 1 0 1 0 C1 0 1 36.00000000000001 1 36.00000000000001 C1 36.00000000000001 0 36.00000000000001 0 36.00000000000001 C0 36.00000000000001 0 0 0 0 Z' vector-effect='non-scaling-stroke' /%3e %3c/defs%3e %3cg transform='translate(0%2c 0)'%3e %3cpath d='M0 0 C0 0 1 0 1 0 C1 0 1 36.00000000000001 1 36.00000000000001 C1 36.00000000000001 0 36.00000000000001 0 36.00000000000001 C0 36.00000000000001 0 0 0 0 Z' style='stroke: rgb(140%2c 140%2c 140)%3b stroke-width: 0%3b stroke-linecap: butt%3b stroke-linejoin: miter%3b fill: rgb(65%2c 65%2c 65)%3b' vector-effect='non-scaling-stroke' /%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var NavBarContainer = styled.div.withConfig({
  displayName: "styles__NavBarContainer",
  componentId: "fsdo4m-0"
})(["position:fixed;width:100%;z-index:10;.navbar-toggler{font-size:1.1rem;margin-right:24px;&:focus{outline:none;box-shadow:none;}}.navbar{background-color:", ";min-height:80px;border-bottom:1px solid ", ";white-space:nowrap;padding:0;}.dropdown-menu{top:65px;}.nav-item{margin-top:20px;height:59px;}a.nav-link{height:59px;}.navbar-nav .nav-link{margin:0 40px 0 0;text-decoration:none;}.navbar-nav .nav-link:hover{color:", ";}.navbar .active{border-bottom:1px solid ", ";color:", " !important;}.navbar-brand{margin-left:24px;}@media (min-width:1200px) and (max-width:1260px){.navbar-brand{margin-left:10px;}}@media (max-width:", "px){.navbar{padding:10px;display:flex;align-items:center;}.navbar-text{flex:1;}.nav-item{margin-top:0px;height:50px;}.nav-item .nav-link::before{content:'';display:inline-block;background:rgb(30,30,30);width:4px;height:40px;margin-bottom:-12px;margin-right:12px;border-radius:140px;border:none;}.nav-item .nav-link.active::before{background:", ";}.nav-item .nav-link.active{border-bottom:0;}.navbar-nav:first-child{margin-top:1.5em;}}}"], theme.grey10, theme.grey30, theme.grey100, theme.lochivarAccent4, theme.grey100, function (_ref) {
  var $expand = _ref.$expand;
  return $expand;
}, theme.lochivarAccent3);
var NavBarBrand = Navbar.Brand;
var Separator = styled.img.withConfig({
  displayName: "styles__Separator",
  componentId: "fsdo4m-1"
})(["margin-right:30px;@media (max-width:", "px){display:none;}"], function (_ref2) {
  var $hideBreakpoint = _ref2.$hideBreakpoint;
  return $hideBreakpoint;
});

var styleBreakpointsMap = {
  sm: 575,
  md: 767,
  lg: 991,
  xl: 1199,
  xxl: 1399
};
var DEFAULT_LOGO = /*#__PURE__*/React.createElement("img", {
  alt: "logo",
  src: img$w
});
var DEFAULT_EXPAND = 'xl';
var AsertoNavLink = /*#__PURE__*/React.memo(function (_ref) {
  var to = _ref.to,
    title = _ref.title,
    end = _ref.end;
  var resolved = useResolvedPath(to);
  var pathname = useMemo(function () {
    return end ? resolved.pathname.replace(end, '') : resolved.pathname;
  }, [resolved, end]);
  var match = useMatch({
    path: pathname,
    end: false
  });
  return /*#__PURE__*/React.createElement(NavLink, {
    "aria-current": match ? 'page' : undefined,
    className: match ? 'nav-link active' : 'nav-link',
    to: to
  }, title);
});
var AsertoNavBar = function AsertoNavBar(_a) {
  var children = _a.children,
    expand = _a.expand,
    _a$logo = _a.logo,
    logo = _a$logo === void 0 ? DEFAULT_LOGO : _a$logo,
    showBrandSeparator = _a.showBrandSeparator,
    topPosition = _a.topPosition,
    uncollapsableContent = _a.uncollapsableContent,
    props = __rest(_a, ["children", "expand", "logo", "showBrandSeparator", "topPosition", "uncollapsableContent"]);
  return /*#__PURE__*/React.createElement(NavBarContainer, Object.assign({
    "$expand": styleBreakpointsMap[expand !== null && expand !== void 0 ? expand : DEFAULT_EXPAND],
    "$topPosition": topPosition
  }, props), /*#__PURE__*/React.createElement(Navbar, {
    className: "navbar-dark",
    collapseOnSelect: true,
    expand: expand !== null && expand !== void 0 ? expand : DEFAULT_EXPAND
  }, /*#__PURE__*/React.createElement(NavBarBrand, null, logo), uncollapsableContent && /*#__PURE__*/React.createElement(Navbar.Text, null, uncollapsableContent), showBrandSeparator && (/*#__PURE__*/React.createElement(Separator, {
    "$hideBreakpoint": styleBreakpointsMap[expand !== null && expand !== void 0 ? expand : DEFAULT_EXPAND],
    src: img$v
  })), children && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Navbar.Toggle, null), /*#__PURE__*/React.createElement(Navbar.Collapse, null, children)))));
};

var StyledButtonComponent = styled(Button).withConfig({
  displayName: "styles__StyledButtonComponent",
  componentId: "sc-1uheuj8-0"
})(["width:93px;"]);

var BaseButtonWithIconElement = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var icon = _a.icon,
    text = _a.text,
    props = __rest(_a, ["icon", "text"]);
  return /*#__PURE__*/React.createElement(StyledButtonComponent, Object.assign({
    ref: ref
  }, props), text, icon);
});

var Col = styled.div.withConfig({
  displayName: "Col",
  componentId: "sc-13ey7m7-0"
})(["display:flex;flex-direction:column;", " ", ""], function (_ref) {
  var $gap = _ref.$gap;
  return $gap ? "gap: ".concat($gap, "px") : '';
}, function (_ref2) {
  var $flex = _ref2.$flex;
  return $flex ? "flex: ".concat($flex) : '';
});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "\ntextarea.form-control {\n  background-color: #161719;\n  color: #d7d8d8;\n  border-color: #595959;\n  font-family: 'Ubuntu', monospace;\n}\n\n/* focus for textarea */\ntextarea.form-control:focus {\n  background-color: #161719;\n  color: #d7d8d8;\n  outline: none;\n  border-color: #7d7a7a;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.form-control::placeholder { \n  color: #666e75;\n}\n";
styleInject(css_248z);

var TextArea$1 = function TextArea(_a) {
  var value = _a.value,
    onChange = _a.onChange,
    style = _a.style,
    props = __rest(_a, ["value", "onChange", "style"]);
  return /*#__PURE__*/React.createElement(FormControl, Object.assign({
    as: "textarea",
    style: style,
    value: value,
    onChange: onChange
  }, props));
};

var CardModalContainer$3 = styled(Modal).withConfig({
  displayName: "BigErrorCardModal__CardModalContainer",
  componentId: "rj6y8p-0"
})(["overflow:hidden;border-radius:20px;.modal-content{border-radius:20px;}"]);
var Row$3 = styled.div.withConfig({
  displayName: "BigErrorCardModal__Row",
  componentId: "rj6y8p-1"
})(["display:flex;align-items:center;justify-content:center;img{width:100px;margin-right:30px;height:111px;}div{flex:1;line-height:22px;overflow:scroll;p{margin-top:12px;}}"]);
var CardContent$6 = styled.div.withConfig({
  displayName: "BigErrorCardModal__CardContent",
  componentId: "rj6y8p-2"
})(["color:", ";padding:20px;display:flex;width:100%;"], function (_ref) {
  var theme = _ref.theme;
  return theme.grey100;
});
var ButtonContainer$4 = styled.div.withConfig({
  displayName: "BigErrorCardModal__ButtonContainer",
  componentId: "rj6y8p-3"
})(["display:flex;align-items:flex-end;width:100%;flex:1;justify-content:flex-end;"]);
var ErrorTextArea = styled(TextArea$1).withConfig({
  displayName: "BigErrorCardModal__ErrorTextArea",
  componentId: "rj6y8p-4"
})(["height:200px;"]);
var Image$1 = styled.img.withConfig({
  displayName: "BigErrorCardModal__Image",
  componentId: "rj6y8p-5"
})(["width:124px;margin-right:10px;height:69px;"]);
var errorMapper$1 = {
  'Failed to fetch': "Can't reach the Aserto service."
};
var BigErrorCardModal = function BigErrorCardModal(_ref2) {
  var title = _ref2.title,
    onHide = _ref2.onHide,
    message = _ref2.message;
  return /*#__PURE__*/React.createElement(CardModalContainer$3, {
    centered: true,
    "data-testid": "error-modal",
    show: !!message,
    onHide: onHide
  }, /*#__PURE__*/React.createElement(Card, {
    body: /*#__PURE__*/React.createElement(CardContent$6, {
      style: {
        height: '100%'
      }
    }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Image$1, {
      alt: "axolotl",
      src: img$E
    })), /*#__PURE__*/React.createElement(Col, {
      "$flex": 1
    }, /*#__PURE__*/React.createElement(Row$3, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Label$1, null, "Error"), /*#__PURE__*/React.createElement(ErrorTextArea, {
      rows: 7,
      value: message === 'Failed to fetch' ? errorMapper$1[message] : message !== null && message !== void 0 ? message : ''
    }))), /*#__PURE__*/React.createElement(ButtonContainer$4, null, /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: onHide
    }, "Close")))),
    height: 386,
    style: {
      width: '100%'
    },
    title: title,
    variant: "danger"
  }));
};

var BreadcrumbContainer = styled.div.withConfig({
  displayName: "Breadcrumb__BreadcrumbContainer",
  componentId: "sc-1sfubr9-0"
})(["width:100%;font-size:", ";color:", ";"], function (_ref) {
  var variant = _ref.variant;
  return variant === 'large' ? "24px" : "16px";
}, theme.grey100);
var Breadcrumb = function Breadcrumb(_ref2) {
  var title = _ref2.title,
    usePathAsBreadcrumb = _ref2.usePathAsBreadcrumb,
    breadcrumbParts = _ref2.breadcrumbParts,
    testId = _ref2.testId,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'large' : _ref2$variant;
  // if the flag was passed as true, construct the breadcrumb from the path
  if (usePathAsBreadcrumb) {
    var path = window.location.pathname;
    var components = path.split('/');
    if (components.length > 1) {
      var tabName = components[1];
      var capitalizedTabName = tabName.charAt(0).toUpperCase() + tabName.slice(1);
      var breadcrumb = /*#__PURE__*/React.createElement(Link, {
        to: "/".concat(tabName)
      }, capitalizedTabName);
      return /*#__PURE__*/React.createElement(BreadcrumbContainer, {
        variant: variant
      }, breadcrumb, " / ", title);
    }
    // no path to construct breadcrumb from, so return just the title
    return /*#__PURE__*/React.createElement(BreadcrumbContainer, {
      variant: variant
    }, title);
  }
  // if multiple breadcrumb parts were passed in, construct the breadcrumb from them
  if (breadcrumbParts) {
    return /*#__PURE__*/React.createElement(BreadcrumbContainer, {
      variant: variant
    }, breadcrumbParts.map(function (part, index) {
      return part.url ? (/*#__PURE__*/React.createElement("span", {
        key: index
      }, index > 0 && ' / ', /*#__PURE__*/React.createElement(Link, {
        to: "".concat(part.url)
      }, part.text))) : (/*#__PURE__*/React.createElement("span", {
        key: index
      }, index > 0 && ' / ', part.text));
    }));
  }
  // as a last resort, just use the title
  return /*#__PURE__*/React.createElement(BreadcrumbContainer, {
    "data-testid": testId,
    variant: variant
  }, title);
};

var useQueryParam = function useQueryParam(search) {
  return new URLSearchParams(search);
};
var useDeviceDetect = function useDeviceDetect() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setMobile = _useState2[1];
  useEffect(function () {
    if (window.innerWidth <= 920) {
      setMobile(true);
      return;
    } else {
      setMobile(false);
      return;
    }
  }, []);
  return {
    isMobile: isMobile
  };
};

var CardModalContainer$2 = styled(Modal).withConfig({
  displayName: "CardModal__CardModalContainer",
  componentId: "sc-6ac57p-0"
})(["overflow-x:hidden;border-radius:20px;.modal-dialog{min-width:", ";}.modal-content{", " border-radius:20px;background-color:", ";color:", ";min-width:", ";}background-color:", ";"], function (_ref) {
  var $minWidth = _ref.$minWidth;
  return $minWidth;
}, function (_ref2) {
  var fullscreen = _ref2.fullscreen;
  return !fullscreen && "max-width: 85vw;";
}, theme.grey20, theme.grey100, function (_ref3) {
  var $minWidth = _ref3.$minWidth;
  return $minWidth;
}, function (_ref4) {
  var backgroundcolor = _ref4.backgroundcolor;
  return backgroundcolor;
});
var CardModal = function CardModal(_ref5) {
  var children = _ref5.children,
    backgroundColor = _ref5.backgroundColor,
    _ref5$centered = _ref5.centered,
    centered = _ref5$centered === void 0 ? true : _ref5$centered,
    title = _ref5.title,
    show = _ref5.show,
    onHide = _ref5.onHide,
    onSubmit = _ref5.onSubmit,
    cardHeight = _ref5.cardHeight,
    _ref5$cardWidth = _ref5.cardWidth,
    cardWidth = _ref5$cardWidth === void 0 ? 500 : _ref5$cardWidth,
    fullscreen = _ref5.fullscreen,
    size = _ref5.size,
    text = _ref5.text,
    variant = _ref5.variant,
    closeButton = _ref5.closeButton,
    minWidth = _ref5.minWidth;
  var _useDeviceDetect = useDeviceDetect(),
    isMobile = _useDeviceDetect.isMobile;
  var minHeight = String(isMobile ? 225 : 215) + 'px';
  return /*#__PURE__*/React.createElement(CardModalContainer$2, {
    "$minWidth": minWidth,
    backgroundcolor: backgroundColor,
    centered: centered,
    "data-testid": "modal",
    fullscreen: fullscreen,
    show: show,
    size: size,
    onHide: onHide
  }, /*#__PURE__*/React.createElement(Card, {
    body: children,
    fullscreen: fullscreen,
    height: cardHeight,
    style: {
      minHeight: minHeight
    },
    text: text,
    title: title,
    variant: variant,
    width: cardWidth,
    onClose: closeButton ? onHide : undefined,
    onSubmit: onSubmit
  }));
};

var CheckboxContainer = styled.div.withConfig({
  displayName: "Checkbox__CheckboxContainer",
  componentId: "sc-1d34qld-0"
})(["display:flex;vertical-align:middle;"]);
var HiddenCheckbox = styled.input.attrs({
  type: 'checkbox'
}).withConfig({
  displayName: "Checkbox__HiddenCheckbox",
  componentId: "sc-1d34qld-1"
})(["border:0;clip:rect(0 0 0 0);clippath:inset(50%);height:1px;margin:-1px;overflow:hidden;padding:0;display:block;position:relative;overflow:hidden;white-space:nowrap;width:1px;"]);
var Icon$3 = styled.svg.withConfig({
  displayName: "Checkbox__Icon",
  componentId: "sc-1d34qld-2"
})(["fill:none;stroke:", ";stroke-width:2px;"], theme.fullWhite);
var StyledCheckbox = styled.div.withConfig({
  displayName: "Checkbox__StyledCheckbox",
  componentId: "sc-1d34qld-3"
})(["display:inline-block;border:1px solid ", ";", " width:16px;height:16px;background:", ";display:flex;transition:all 150ms;", ":focus + &{box-shadow:0 0 0 3px ", ";}", ";"], function (props) {
  return props.checked ? theme.primary : theme.grey50;
}, function (_ref) {
  var hasLabel = _ref.hasLabel;
  return hasLabel ? 'margin-right: 10px;' : '';
}, function (props) {
  return props.checked ? theme.primary : 'transparent';
}, HiddenCheckbox, theme.grey40, function (_ref2) {
  var $disabled = _ref2.$disabled;
  return $disabled ? css(["pointer-events:none;background-color:", ";border-color:", ";svg{stroke:", ";}"], theme.grey10, theme.grey30, theme.grey40) : '';
});
var HorizontalLabel = styled(Label$1).withConfig({
  displayName: "Checkbox__HorizontalLabel",
  componentId: "sc-1d34qld-4"
})(["display:flex;margin-bottom:0px;align-items:center;"]);
var Checkbox = function Checkbox(_a) {
  var onChange = _a.onChange,
    label = _a.label,
    disabled = _a.disabled,
    checked = _a.checked,
    className = _a.className,
    checkboxProps = __rest(_a, ["onChange", "label", "disabled", "checked", "className"]);
  var onCheckboxChange = useCallback(function (event) {
    return onChange === null || onChange === void 0 ? void 0 : onChange(event.target.checked);
  }, [onChange]);
  return /*#__PURE__*/React.createElement(CheckboxContainer, null, /*#__PURE__*/React.createElement(HorizontalLabel, {
    "$small": true
  }, /*#__PURE__*/React.createElement(HiddenCheckbox, Object.assign({
    checked: checked,
    disabled: disabled,
    onChange: onCheckboxChange
  }, checkboxProps)), /*#__PURE__*/React.createElement(StyledCheckbox, {
    "$disabled": disabled,
    checked: checked === undefined ? false : checked,
    className: className,
    hasLabel: !!label
  }, checked && (/*#__PURE__*/React.createElement(Icon$3, {
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "20 6 9 17 4 12"
  })))), label));
};

var StyledCodeEditor = styled(Editor).withConfig({
  displayName: "styles__StyledCodeEditor",
  componentId: "zz6unf-0"
})(["background-color:", ";border-color:", ";border-radius:4px;border-style:solid;border-width:1px;color:", ";font-family:'Fira Code',monospace;font-size:14px;font-weight:500;max-width:100%;min-width:200px;width:max-content;&:focus-within{background-color:", ";color:", ";box-shadow:none;border-color:", ";-webkit-box-shadow:none;}&:disabled{background-color:", ";border-color:", ";-webkit-text-fill-color:", ";}.styledpre{color:", ";min-height:100px;height:auto;}textarea:focus{outline:none;}"], theme.primaryBlack, function (_ref) {
  var $hasError = _ref.$hasError;
  return $hasError ? theme.mojoAccent3 : theme.grey40;
}, theme.grey100, theme.primaryBlack, theme.grey100, function (_ref2) {
  var $hasError = _ref2.$hasError;
  return $hasError ? theme.mojoAccent3 : theme.lochivarAccent2;
}, theme.grey20, theme.grey20, theme.grey70, theme.mojoAccent3);

var CodeEditor = function CodeEditor(_ref) {
  var _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? true : _ref$readOnly,
    value = _ref.value,
    language = _ref.language,
    _ref$onValueChange = _ref.onValueChange,
    onValueChange = _ref$onValueChange === void 0 ? function () {} : _ref$onValueChange;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledCodeEditor, {
    "$hasError": hasError,
    disabled: readOnly,
    highlight: function highlight$1(value) {
      return highlight(value, languages[language || 'json'], language || 'json');
    },
    ignoreTabKey: false,
    padding: "10px",
    preClassName: "styledpre",
    readOnly: readOnly,
    value: value || '',
    onValueChange: onValueChange
  }));
};

var ModalCardContent = styled.div.withConfig({
  displayName: "ConfirmationModal__ModalCardContent",
  componentId: "g0tjy9-0"
})(["padding:20px;&:first-child{color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.grey100;
});
var ModalCardButtonsContainer = styled.div.withConfig({
  displayName: "ConfirmationModal__ModalCardButtonsContainer",
  componentId: "g0tjy9-1"
})(["margin-top:30px;justify-content:flex-end;display:flex;button{margin-left:10px;}"]);
var ConfirmationModal = function ConfirmationModal(_ref2) {
  var title = _ref2.title,
    text = _ref2.text,
    show = _ref2.show,
    onHide = _ref2.onHide,
    onClickAccept = _ref2.onClickAccept,
    cancelButtonText = _ref2.cancelButtonText,
    acceptButtonText = _ref2.acceptButtonText;
  return /*#__PURE__*/React.createElement(CardModal, {
    cardHeight: "100%",
    show: show,
    title: title,
    onHide: onHide
  }, /*#__PURE__*/React.createElement(ModalCardContent, null, /*#__PURE__*/React.createElement("div", null, text), /*#__PURE__*/React.createElement(ModalCardButtonsContainer, null, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "confirmation-modal-cancel-btn",
    variant: "secondary",
    onClick: onHide
  }, cancelButtonText), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "confirmation-modal-accept-btn",
    variant: "danger",
    onClick: onClickAccept
  }, acceptButtonText))));
};

var img$u = "data:image/svg+xml,%3csvg width='18px' height='18px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M21.2287 6.60355C21.6193 6.99407 21.6193 7.62723 21.2287 8.01776L10.2559 18.9906C9.86788 19.3786 9.23962 19.3814 8.84811 18.9969L2.66257 12.9218C2.26855 12.5349 2.26284 11.9017 2.64983 11.5077L3.35054 10.7942C3.73753 10.4002 4.37067 10.3945 4.7647 10.7815L9.53613 15.4677L19.1074 5.89644C19.4979 5.50592 20.1311 5.50591 20.5216 5.89644L21.2287 6.60355Z' fill=' rgb(61%2c 212%2c 68)' /%3e%3c/svg%3e";

var Row$2 = styled.div.withConfig({
  displayName: "Row",
  componentId: "kvq2vt-0"
})(["display:flex;flex-direction:row;", ";", ";", ";", ";"], function (_ref) {
  var $centered = _ref.$centered;
  return $centered ? 'align-items: center' : '';
}, function (_ref2) {
  var $marginTop = _ref2.$marginTop;
  return $marginTop ? "margin-top: ".concat($marginTop, "px") : '';
}, function (_ref3) {
  var $marginLeft = _ref3.$marginLeft;
  return $marginLeft ? "margin-left: ".concat($marginLeft, "px") : '';
}, function (_ref4) {
  var $flex = _ref4.$flex;
  return $flex ? "flex: 1" : '';
});

var ConnectedText = styled.div.withConfig({
  displayName: "styles__ConnectedText",
  componentId: "sc-1sg3dif-0"
})(["margin-top:", "px;margin-left:", "px;display:flex;align-items:center;color:", ";font-size:16px;font-weight:600;text-transform:uppercase;height:36px;img{width:24px;height:24px;margin-left:10px;}"], function (_ref) {
  var marginTop = _ref.marginTop;
  return marginTop || 30;
}, function (_ref2) {
  var marginLeft = _ref2.marginLeft;
  return marginLeft || 0;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.grey100;
});

var CreateRepoButton = function CreateRepoButton(_ref) {
  var completed = _ref.completed,
    disabled = _ref.disabled,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Row$2, {
    "$centered": true
  }, completed ? (/*#__PURE__*/React.createElement(ConnectedText, {
    marginTop: 25
  }, "Source code repository created", /*#__PURE__*/React.createElement("img", {
    alt: "check",
    src: img$u
  }))) : (/*#__PURE__*/React.createElement(Button, {
    "data-testid": "create-repo-btn",
    disabled: disabled,
    id: "button-create-source-code-repo",
    onClick: onClick
  }, "Create source code repository")));
};

var StyledHeader = styled(Modal.Header).withConfig({
  displayName: "CreateTenantModal__StyledHeader",
  componentId: "sc-16jmcu2-0"
})(["background-color:", ";border:none;padding:20px;"], function (_ref) {
  var variant = _ref.variant,
    theme = _ref.theme;
  return variant === 'success' ? theme.apple50 : theme.grey20;
});
var StyledTitle = styled(Modal.Title).withConfig({
  displayName: "CreateTenantModal__StyledTitle",
  componentId: "sc-16jmcu2-1"
})(["font-size:20px;font-weight:500;color:", ";"], theme.grey100);
var StyledBody = styled(Modal.Body).withConfig({
  displayName: "CreateTenantModal__StyledBody",
  componentId: "sc-16jmcu2-2"
})(["background-color:", ";padding:20px;"], theme.grey10);
var StyledFooter = styled(Modal.Footer).withConfig({
  displayName: "CreateTenantModal__StyledFooter",
  componentId: "sc-16jmcu2-3"
})(["background-color:", ";border:none;"], theme.grey10);
var CreateTenantModal = Object.assign(styled(Modal).attrs({
  centered: true
}).withConfig({
  displayName: "CreateTenantModal",
  componentId: "sc-16jmcu2-4"
})([""]), {
  Header: StyledHeader,
  Title: StyledTitle,
  Body: StyledBody,
  Footer: StyledFooter,
  Form: Form
});

var ASERTO_NAME_REGEXP = /^[a-z][a-z0-9-]{3,29}$/;
var ASERTO_NAME_FRAGMENT_REGEXP = /^[a-z][a-z0-9-]{0,29}$/;
var getValidityOf = function getValidityOf(name) {
  if (ASERTO_NAME_REGEXP.test(name)) {
    return 'VALID';
  } else if (name.length === 0 || ASERTO_NAME_FRAGMENT_REGEXP.test(name)) {
    return 'VALID_FRAGMENT';
  }
  return 'INVALID';
};
var isValid = function isValid(name) {
  return getValidityOf(name) === 'VALID';
};
var AsertoNameValidator = {
  getValidityOf: getValidityOf,
  isValid: isValid,
  ruleText: 'Start with a letter. Must be 4 to 30 lowercase alphanumeric characters or dashes.'
};

var AccountNameValidator = AsertoNameValidator;

var visualStates = {
  CLAIMED: {
    errorMessage: undefined,
    isClaimable: false,
    isClaimed: true,
    isEditable: false,
    isLoading: false,
    isUnavailable: false,
    isValid: true,
    kind: 'claimed'
  },
  CLAIMING: {
    errorMessage: undefined,
    isClaimable: false,
    isClaimed: false,
    isEditable: false,
    isLoading: true,
    isUnavailable: false,
    isValid: true,
    kind: 'claiming'
  },
  CLAIMING_FAILED: {
    errorMessage: 'Something went wrong',
    isClaimable: false,
    isClaimed: false,
    isEditable: false,
    isLoading: false,
    isUnavailable: false,
    isValid: true,
    kind: 'claiming_failed'
  },
  INVALID: {
    errorMessage: 'Start with a letter. Must be 4 to 30 lowercase alphanumeric characters or dashes.',
    isClaimable: false,
    isClaimed: false,
    isEditable: true,
    isLoading: false,
    isUnavailable: false,
    isValid: false,
    kind: 'invalid'
  },
  INVALID_RESERVED: {
    errorMessage: 'ASERTO is a reserved word and cannot be used.',
    isClaimable: false,
    isClaimed: false,
    isEditable: true,
    isLoading: false,
    isUnavailable: true,
    isValid: false,
    kind: 'reserved'
  },
  INVALID_UNAVAILABLE: {
    errorMessage: 'That name is already in use.',
    isClaimable: false,
    isClaimed: false,
    isEditable: true,
    isLoading: false,
    isUnavailable: true,
    isValid: false,
    kind: 'unavailable'
  },
  INVALID_UNKNOWN: {
    errorMessage: 'Something is not right with your tenant name.',
    isClaimable: false,
    isClaimed: false,
    isEditable: true,
    isLoading: false,
    isUnavailable: false,
    isValid: false,
    kind: 'unknown'
  },
  INVALID_MARKED_DELETED: {
    errorMessage: 'The name is marked for deletion.',
    isClaimable: false,
    isClaimed: false,
    isEditable: true,
    isLoading: false,
    isUnavailable: true,
    isValid: false,
    kind: 'marked_deleted'
  },
  VALID: {
    errorMessage: undefined,
    isClaimable: true,
    isClaimed: false,
    isEditable: true,
    isLoading: false,
    isUnavailable: false,
    isValid: true,
    kind: 'valid'
  },
  VALID_FRAGMENT: {
    errorMessage: undefined,
    isClaimable: false,
    isClaimed: false,
    isEditable: true,
    isLoading: false,
    isUnavailable: false,
    isValid: true,
    kind: 'valid'
  }
};
var VisualStates = Object.assign({}, visualStates);

var getVisualState = function getVisualState(previousVisualState, accountName, nameAvailabilityState, claimMutationState) {
  if (!claimMutationState.isIdle) {
    return getSubmittedFormValidationState(claimMutationState);
  }
  if (!AccountNameValidator.isValid(accountName)) {
    return VisualStates.INVALID;
  }
  var isValidating = nameAvailabilityState.isLoading;
  if (isValidating) {
    return previousVisualState;
  }
  return getValidationRequestValidationState(nameAvailabilityState);
};
function getValidationRequestValidationState(nameAvailabilityState) {
  var validationResult = nameAvailabilityState.data,
    validationError = nameAvailabilityState.error;
  if (validationError) {
    return VisualStates.INVALID;
  }
  switch (validationResult === null || validationResult === void 0 ? void 0 : validationResult.availability) {
    case 'TENANT_AVAILABILITY_AVAILABLE':
      return VisualStates.VALID;
    case 'TENANT_AVAILABILITY_UNAVAILABLE':
      return VisualStates.INVALID_UNAVAILABLE;
    case 'TENANT_AVAILABILITY_RESERVED':
      return VisualStates.INVALID_RESERVED;
    case 'TENANT_AVAILABILITY_INVALID':
      return VisualStates.INVALID;
    case 'TENANT_AVAILABILITY_MARKED_DELETED':
      return VisualStates.INVALID_MARKED_DELETED;
    default:
      return VisualStates.INVALID_UNKNOWN;
  }
}
function getSubmittedFormValidationState(claimMutationState) {
  var claimError = claimMutationState.error,
    isClaiming = claimMutationState.isLoading;
  if (isClaiming) {
    return VisualStates.CLAIMING;
  }
  if (claimError) {
    return Object.assign(Object.assign({}, VisualStates.CLAIMING_FAILED), {
      errorMessage: claimError.message || VisualStates.CLAIMING_FAILED.errorMessage
    });
  }
  return VisualStates.CLAIMED;
}

var DataLoader = function DataLoader(_ref) {
  var children = _ref.children,
    paging = _ref.paging;
  if (!paging) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(InfiniteScroll, {
    dataLength: paging.dataLength,
    hasMore: !!(paging === null || paging === void 0 ? void 0 : paging.hasMore()),
    loader: paging.loader,
    next: function next() {
      return paging === null || paging === void 0 ? void 0 : paging.getNext();
    },
    scrollableTarget: paging.scrollableTarget
  }, children);
};

var Tbody = styled.tbody.withConfig({
  displayName: "TableBody__Tbody",
  componentId: "jk1tza-0"
})(["transition:visibility 700ms ease,opacity 500ms ease;"]);
var RowComponent = styled.tr.withConfig({
  displayName: "TableBody__RowComponent",
  componentId: "jk1tza-1"
})(["", ""], function (_ref) {
  var isExpanded = _ref.isExpanded;
  if (isExpanded) {
    return css(["background-color:", ";color:", " !important;cursor:pointer;"], theme.grey30, theme.grey100);
  }
});
var TableBody = function TableBody(_ref2) {
  var getCellProps = _ref2.getCellProps,
    getTableBodyProps = _ref2.getTableBodyProps,
    prepareRow = _ref2.prepareRow,
    renderRowSubComponent = _ref2.renderRowSubComponent,
    rowComponent = _ref2.rowComponent,
    rows = _ref2.rows,
    visibleColumns = _ref2.visibleColumns;
  return /*#__PURE__*/React.createElement(Tbody, Object.assign({}, getTableBodyProps()), rows.map(function (row) {
    prepareRow(row);
    var shouldShowSubRow = !!renderRowSubComponent && row.isExpanded;
    var Tr = rowComponent || RowComponent;
    var rowProps = row.getRowProps();
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: rowProps.key
    }, /*#__PURE__*/React.createElement(Tr, Object.assign({
      isExpanded: row.isExpanded,
      row: row
    }, rowProps), row.cells.map(function (cell) {
      var _a, _b;
      var customCellProps = getCellProps ? getCellProps(cell) : {};
      var cellProps = cell.getCellProps();
      return /*#__PURE__*/React.createElement("td", Object.assign({}, cellProps, customCellProps, {
        key: cellProps.key,
        width: ((_b = (_a = cell.column) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.cellWidth) ? cell.column.style.cellWidth : ''
      }), cell.render('Cell'));
    })), /*#__PURE__*/React.createElement("tr", {
      style: {
        backgroundColor: theme.grey10
      }
    }, /*#__PURE__*/React.createElement("td", {
      colSpan: visibleColumns.length,
      style: Object.assign({
        backgroundColor: theme.grey10,
        padding: 20,
        transition: 'max-height 900ms ease, opacity 900ms, padding-top 200ms',
        maxHeight: 300,
        opacity: 1
      }, !shouldShowSubRow && {
        maxHeight: 0,
        height: 0,
        padding: 0,
        opacity: 0,
        overflow: 'hidden'
      })
    }, /*#__PURE__*/React.createElement("div", {
      style: Object.assign({
        transition: 'all 10ms'
      }, !shouldShowSubRow && {
        visibility: 'hidden',
        height: 0
      })
    }, shouldShowSubRow && renderRowSubComponent({
      row: row
    })))));
  }));
};

var img$t = "data:image/svg+xml,%3csvg width='16' height='8' viewBox='0 0 16 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cg clip-path='url(%23clip0)'%3e %3cpath d='M7.43111 7.7855C7.75111 8.0715 8.26667 8.0715 8.56889 7.7855L15.7333 1.38233C16.0889 1.06455 16.0889 0.556104 15.7333 0.238327C15.3778 -0.0794424 14.8089 -0.0794424 14.4533 0.238327L8.56889 5.49752C8.24889 5.78352 7.73333 5.78352 7.43111 5.49752L1.54667 0.25422C1.19111 -0.0635578 0.622222 -0.0635578 0.266666 0.25422C-0.0888892 0.571998 -0.0888892 1.08043 0.266666 1.39821L7.43111 7.7855Z' fill='%233ECACF' /%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0'%3e %3crect width='16' height='8' fill='white' /%3e %3c/clipPath%3e %3c/defs%3e%3c/svg%3e";

var img$s = "data:image/svg+xml,%3csvg version='1.2' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' overflow='visible' preserveAspectRatio='none' viewBox='0 0 16 8' width='16' height='8'%3e %3cg transform='translate(0%2c 0)'%3e %3cdefs%3e %3cpath id='path-16196542201702383' d='M8.568888888888887 0.21449780518582723 C8.248888888888887 -0.0715007202473131 7.733333333333332 -0.07150072024731312 7.431111111111109 0.21449691629682474 C7.431111111111109 0.21449691629682474 0.2666666666666666 6.617671956702422 0.2666666666666666 6.617671956702422 C-0.0888888888888889 6.935449775085138 -0.0888888888888889 7.443894284497484 0.2666666666666666 7.7616721028802 C0.6222222222222221 8.079441032372891 1.191111111111111 8.079441032372891 1.5466666666666664 7.7616721028802 C1.5466666666666664 7.7616721028802 7.431111111111109 2.502480319761334 7.431111111111109 2.502480319761334 C7.75111111111111 2.2164802832168893 8.266666666666666 2.2164802832168893 8.568888888888887 2.502480319761334 C8.568888888888887 2.502480319761334 14.453333333333331 7.745778767516052 14.453333333333331 7.745778767516052 C14.808888888888886 8.063556585898768 15.377777777777776 8.063556585898768 15.73333333333333 7.745778767516052 C16.08888888888889 7.428000949133335 16.08888888888889 6.919565328611014 15.73333333333333 6.601787510228299 C15.73333333333333 6.601787510228299 8.568888888888887 0.21449780518582723 8.568888888888887 0.21449780518582723 Z' vector-effect='non-scaling-stroke' /%3e %3c/defs%3e %3cg transform='translate(2.7755575615628914e-17%2c 0.000001350000145693142)'%3e %3cpath d='M8.568888888888887 0.21449780518582723 C8.248888888888887 -0.0715007202473131 7.733333333333332 -0.07150072024731312 7.431111111111109 0.21449691629682474 C7.431111111111109 0.21449691629682474 0.2666666666666666 6.617671956702422 0.2666666666666666 6.617671956702422 C-0.0888888888888889 6.935449775085138 -0.0888888888888889 7.443894284497484 0.2666666666666666 7.7616721028802 C0.6222222222222221 8.079441032372891 1.191111111111111 8.079441032372891 1.5466666666666664 7.7616721028802 C1.5466666666666664 7.7616721028802 7.431111111111109 2.502480319761334 7.431111111111109 2.502480319761334 C7.75111111111111 2.2164802832168893 8.266666666666666 2.2164802832168893 8.568888888888887 2.502480319761334 C8.568888888888887 2.502480319761334 14.453333333333331 7.745778767516052 14.453333333333331 7.745778767516052 C14.808888888888886 8.063556585898768 15.377777777777776 8.063556585898768 15.73333333333333 7.745778767516052 C16.08888888888889 7.428000949133335 16.08888888888889 6.919565328611014 15.73333333333333 6.601787510228299 C15.73333333333333 6.601787510228299 8.568888888888887 0.21449780518582723 8.568888888888887 0.21449780518582723 Z' style='stroke-width: 0%3b stroke-linecap: butt%3b stroke-linejoin: miter%3b fill: rgb(62%2c 202%2c 207)%3b' vector-effect='non-scaling-stroke' /%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var Icon$2 = styled.img.withConfig({
  displayName: "TableHeader__Icon",
  componentId: "sc-153im5d-0"
})(["margin-left:8px;"]);
var TableHeader = function TableHeader(_ref) {
  var headerGroups = _ref.headerGroups;
  return /*#__PURE__*/React.createElement("thead", null, headerGroups.map(function (headerGroup) {
    var headerGroupProps = headerGroup.getHeaderGroupProps();
    return /*#__PURE__*/React.createElement("tr", Object.assign({}, headerGroupProps, {
      key: headerGroupProps.key
    }), headerGroup.headers.map(function (column) {
      var _a;
      var headerProps = column.getHeaderProps(column.getSortByToggleProps());
      return /*#__PURE__*/React.createElement("th", Object.assign({}, headerProps, {
        key: headerProps.key,
        style: (_a = column.style) === null || _a === void 0 ? void 0 : _a.headerCell
      }), column.render('Header'), /*#__PURE__*/React.createElement("span", null, column.isSorted ? column.isSortedDesc ? (/*#__PURE__*/React.createElement(Icon$2, {
        src: img$s
      })) : (/*#__PURE__*/React.createElement(Icon$2, {
        src: img$t
      })) : ''), /*#__PURE__*/React.createElement("div", null, column.canFilter ? column.render('Filter') : null));
    }));
  }));
};

var TableContainer = styled.div.withConfig({
  displayName: "DataTable__TableContainer",
  componentId: "cj6doy-0"
})([".tableWrap{border-bottom:1px solid black;}", ";overflow-x:auto;overflow-y:hidden;width:100%;"], function (_ref) {
  var $sticky = _ref.$sticky;
  return $sticky && css([".scrollTarget{", ";overflow:auto;}"], function (_ref2) {
    var $topDistance = _ref2.$topDistance;
    return "height: calc(100vh - ".concat($topDistance || 0, "px)");
  });
});
var Table = styled.table.withConfig({
  displayName: "DataTable__Table",
  componentId: "cj6doy-1"
})(["width:98%;margin-left:auto;margin-right:auto;", ";thead{th{min-width:120px;vertical-align:top;padding:20px;}tr{color:", ";font-weight:bold;font-size:16px;}}tbody{font-size:14px;tr{color:", ";box-shadow:inset 0px 0px 0px 1px ", ";td{padding:20px;}}}"], function (_ref3) {
  var $sticky = _ref3.$sticky;
  return $sticky && css(["thead{top:0;position:sticky;z-index:1;width:fit-content;background-color:", ";}"], theme.primaryBlack);
}, theme.grey100, theme.grey70, theme.grey20);
var _DataTable = function DataTable(_ref4) {
  var columns = _ref4.columns,
    data = _ref4.data,
    getCellProps = _ref4.getCellProps,
    _ref4$hideHeaders = _ref4.hideHeaders,
    hideHeaders = _ref4$hideHeaders === void 0 ? false : _ref4$hideHeaders,
    paging = _ref4.paging,
    renderRowSubComponent = _ref4.renderRowSubComponent,
    rowComponent = _ref4.rowComponent,
    initialState = _ref4.initialState,
    mRef = _ref4.mRef,
    sticky = _ref4.sticky;
  var _a, _b;
  var defaultColumn = {
    Filter: ''
  };
  var instance = useTable({
    defaultColumn: defaultColumn,
    autoResetExpanded: false,
    columns: columns,
    data: data,
    expandSubRows: false,
    initialState: initialState,
    disableSortRemove: true,
    autoResetFilters: false
  }, useFilters, useSortBy, useExpanded);
  var getTableProps = instance.getTableProps,
    getTableBodyProps = instance.getTableBodyProps,
    headerGroups = instance.headerGroups,
    rows = instance.rows,
    prepareRow = instance.prepareRow,
    visibleColumns = instance.visibleColumns;
  useImperativeHandle(mRef, function () {
    return instance;
  });
  useEffect(function () {
    if (sticky) {
      document.body.classList.add('overflow-y-hidden');
      return function () {
        document.body.classList.remove('overflow-y-hidden');
      };
    }
  }, [sticky]);
  var elDistanceToTop = window.scrollY + (((_b = (_a = document.getElementById('tableContainer')) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.top) || 0);
  var _useState = useState(200),
    _useState2 = _slicedToArray(_useState, 2),
    top = _useState2[0],
    setTop = _useState2[1];
  useEffect(function () {
    setTop(elDistanceToTop);
  }, [elDistanceToTop]);
  return /*#__PURE__*/React.createElement(TableContainer, {
    "$sticky": sticky,
    "$topDistance": top,
    id: "tableContainer"
  }, /*#__PURE__*/React.createElement(DataLoader, {
    paging: paging && {
      dataLength: data.length,
      loader: /*#__PURE__*/React.createElement(_DataTable, {
        columns: columns,
        data: paging.loadingContent,
        hideHeaders: true
      }),
      hasMore: function hasMore() {
        return !!(paging === null || paging === void 0 ? void 0 : paging.hasMore());
      },
      getNext: function getNext() {
        paging === null || paging === void 0 ? void 0 : paging.getNext();
      },
      scrollableTarget: paging.scrollableTarget || 'scrollTarget'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "scrollTarget",
    id: "scrollTarget"
  }, /*#__PURE__*/React.createElement(Table, Object.assign({
    "$sticky": sticky
  }, getTableProps()), !hideHeaders && /*#__PURE__*/React.createElement(TableHeader, {
    headerGroups: headerGroups
  }), /*#__PURE__*/React.createElement(TableBody, {
    getCellProps: getCellProps,
    getTableBodyProps: getTableBodyProps,
    prepareRow: prepareRow,
    renderRowSubComponent: renderRowSubComponent,
    rowComponent: rowComponent,
    rows: rows,
    visibleColumns: visibleColumns
  })))));
};

var Delayed = function Delayed(_ref) {
  var waitBeforeShow = _ref.waitBeforeShow,
    children = _ref.children;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    hidden = _useState2[0],
    setHidden = _useState2[1];
  useEffect(function () {
    var timer = setTimeout(function () {
      return setHidden(false);
    }, waitBeforeShow);
    return function () {
      return clearTimeout(timer);
    };
  }, [waitBeforeShow]);
  return hidden ? null : /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

var createExactMatchValidator = function createExactMatchValidator(expectedName) {
  var getValidityOf = function getValidityOf(name) {
    if (name === expectedName) {
      return 'VALID';
    }
    return 'INVALID';
  };
  return {
    getValidityOf: getValidityOf,
    isValid: function isValid(name) {
      return getValidityOf(name) === 'VALID';
    },
    ruleText: ''
  };
};

var AlwaysValidValidator = {
  getValidityOf: function getValidityOf() {
    return 'VALID';
  },
  isValid: function isValid() {
    return true;
  },
  ruleText: ''
};
var IdValidator = {
  isValid: function isValid(s) {
    return isValidId(s);
  },
  getValidityOf: function getValidityOf(s) {
    return isValidId(s) ? 'VALID' : 'INVALID';
  },
  ruleText: 'Must be at most 256 characters and cannot contain whitespaces'
};
var isValidId = function isValidId(value) {
  var regex = /^\S{1,256}$/;
  return regex.test(value);
};
var DisplayNameValidator = {
  isValid: function isValid(s) {
    return isValidDisplayName(s);
  },
  getValidityOf: function getValidityOf(s) {
    return isValidDisplayName(s) ? 'VALID' : 'INVALID';
  },
  ruleText: 'Must not contain angled brackets, ampersands, or double quotes'
};
var isValidDisplayName = function isValidDisplayName(s) {
  var regex = /[<&">]/;
  return !regex.test(s);
};

var ValidatedInput = function ValidatedInput(_a) {
  var value = _a.value,
    defaultValue = _a.defaultValue,
    onChange = _a.onChange,
    _a$useIsAvailable = _a.useIsAvailable,
    useIsAvailable = _a$useIsAvailable === void 0 ? function () {
      return {
        isAvailable: true,
        reason: ''
      };
    } : _a$useIsAvailable,
    _a$onSubmit = _a.onSubmit,
    onSubmit = _a$onSubmit === void 0 ? function () {} : _a$onSubmit,
    _a$validator = _a.validator,
    validator = _a$validator === void 0 ? AlwaysValidValidator : _a$validator,
    props = __rest(_a, ["value", "defaultValue", "onChange", "useIsAvailable", "onSubmit", "validator"]);
  var onKeyPress = useCallback(function (target) {
    var pressedEnter = target.key === 'Enter';
    if (pressedEnter) {
      onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
    }
  }, [onSubmit]);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    displayedValue = _useState2[0],
    setDisplayedValue = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    outputValue = _useState4[0],
    setOutputValue = _useState4[1];
  var _useIsAvailable = useIsAvailable(displayedValue, defaultValue),
    isAvailable = _useIsAvailable.isAvailable,
    reason = _useIsAvailable.reason;
  var isValid = useMemo(function () {
    return validator === null || validator === void 0 ? void 0 : validator.isValid(displayedValue);
  }, [validator, displayedValue]);
  useEffect(function () {
    value !== undefined && setDisplayedValue(value);
  }, [value]);
  useEffect(function () {
    if (isValid && isAvailable) {
      setOutputValue(displayedValue);
    } else {
      setOutputValue(undefined);
    }
  }, [isValid, displayedValue, isAvailable, validator.ruleText]);
  useEffect(function () {
    onChange(outputValue);
  }, [onChange, outputValue]);
  var error = useMemo(function () {
    if (!isValid && !!displayedValue) {
      return validator.ruleText;
    } else if (!isAvailable) {
      return reason || 'That name is already in use.';
    } else {
      return '';
    }
  }, [isAvailable, isValid, validator.ruleText, displayedValue, reason]);
  return /*#__PURE__*/React.createElement(Input, Object.assign({
    "data-testid": "input",
    error: error,
    info: validator.ruleText,
    isUnavailable: !isAvailable,
    value: displayedValue,
    onChange: function onChange(c) {
      return setDisplayedValue(c.target.value);
    },
    onKeyPress: onKeyPress
  }, props));
};

var ContentContainer$a = styled.div.withConfig({
  displayName: "styles__ContentContainer",
  componentId: "kic8k8-0"
})(["padding:20px;width:100%;height:fit-content;"]);
var TextArea = styled.div.withConfig({
  displayName: "styles__TextArea",
  componentId: "kic8k8-1"
})(["font-weight:600;font-size:16px;color:#ff4a4a;"]);
var Text$2 = styled.div.withConfig({
  displayName: "styles__Text",
  componentId: "kic8k8-2"
})(["display:flex;font-weight:", ";"], function (_ref) {
  var bold = _ref.bold;
  return bold ? 'bold' : 500;
});
var InputContainer$1 = styled.div.withConfig({
  displayName: "styles__InputContainer",
  componentId: "kic8k8-3"
})(["input{width:600px;}"]);
var ButtonsContainer$c = styled.div.withConfig({
  displayName: "styles__ButtonsContainer",
  componentId: "kic8k8-4"
})(["width:100%;flex:1 1 0%;justify-content:flex-end;align-items:flex-end;float:right;display:flex;margin-top:20px;button:first-of-type{margin-right:10px;}"]);

var DeleteConfirmationModal = function DeleteConfirmationModal(_ref) {
  var onHide = _ref.onHide,
    show = _ref.show,
    subject = _ref.subject,
    entityName = _ref.entityName,
    onClickRemove = _ref.onClickRemove,
    content = _ref.content;
  var onClickHideButton = onHide;
  var validatedUserInput = useMemo(function () {
    return createExactMatchValidator(entityName);
  }, [entityName]);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    validationText = _useState2[0],
    setValidationText = _useState2[1];
  var capitalizedSubject = subject.charAt(0).toUpperCase() + subject.slice(1);
  var disableDeleteButton = !validationText ? {
    disabled: true
  } : {};
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardModal, {
    cardHeight: "100%",
    show: show,
    title: "Delete ".concat(subject),
    variant: "delete_danger",
    onHide: onClickHideButton,
    onSubmit: onClickRemove
  }, /*#__PURE__*/React.createElement(ContentContainer$a, null, content ? content : subject !== 'policy' && subject !== 'directory' && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextArea, null, "We will immediately delete all of your ", subject, " artifacts (policies, images, directory data, and connections)."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Text$2, null, "Your ", subject, " name cannot be reused until we recycle it, within the next 7 days. It will then be available for anyone to claim."), /*#__PURE__*/React.createElement("br", null))), /*#__PURE__*/React.createElement(InputContainer$1, null, /*#__PURE__*/React.createElement(ValidatedInput, {
    autoFocus: true,
    "data-testid": "input",
    label: subject !== 'manifest' ? "".concat(capitalizedSubject, " name") : undefined,
    validator: validatedUserInput,
    onChange: setValidationText
  }), /*#__PURE__*/React.createElement(Info, null, /*#__PURE__*/React.createElement(Text$2, null, /*#__PURE__*/React.createElement(Text$2, null, "Please type", /*#__PURE__*/React.createElement(Text$2, {
    bold: true
  }, "\xA0 ", entityName, " \xA0", /*#__PURE__*/React.createElement(Text$2, null, "to confirm.")))))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TextArea, null, "Are you sure you want to delete your ", subject, "?", /*#__PURE__*/React.createElement("br", null), " This cannot be undone."), /*#__PURE__*/React.createElement(ButtonsContainer$c, null, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: onClickHideButton
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, Object.assign({
    "data-testid": "delete-subject"
  }, disableDeleteButton, {
    type: "submit",
    variant: "danger"
  }), "Delete ", subject)))));
};

var DeleteModal = function DeleteModal(_ref) {
  var onHide = _ref.onHide,
    show = _ref.show,
    subject = _ref.subject,
    onClickRemove = _ref.onClickRemove,
    content = _ref.content,
    title = _ref.title,
    _ref$yesLabel = _ref.yesLabel,
    yesLabel = _ref$yesLabel === void 0 ? 'Delete' : _ref$yesLabel,
    _ref$noLabel = _ref.noLabel,
    noLabel = _ref$noLabel === void 0 ? 'Cancel' : _ref$noLabel;
  var onClickHideButton = onHide;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardModal, {
    cardHeight: "100%",
    show: show,
    title: title ? title : "Delete ".concat(subject),
    variant: "delete_danger",
    onHide: onClickHideButton
  }, /*#__PURE__*/React.createElement(ContentContainer$a, null, content ? content : /*#__PURE__*/React.createElement(Text$2, null, "Are you sure you want to delete ", subject, "?"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ButtonsContainer$c, null, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: onClickHideButton
  }, noLabel), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "delete-subject",
    variant: "danger",
    onClick: onClickRemove
  }, yesLabel)))));
};

var img$r = "data:image/svg+xml,%3csvg version='1.2' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' overflow='visible' preserveAspectRatio='none' viewBox='0 0 400 400' width='400' height='400'%3e%3cg transform='translate(0%2c 0)'%3e%3cdefs%3e%3cpath id='path-164348121322978' d='M0 200 C0 89.5430500338413 89.5430500338413 0 200 0 C310.45694996615885 0 400 89.5430500338413 400 200 C400 310.45694996615885 310.45694996615885 400 200 400 C89.5430500338413 400 0 310.45694996615885 0 200 Z' vector-effect='non-scaling-stroke'/%3e%3cradialGradient id='gradient-164348121323581' vector-effect='non-scaling-stroke'%3e%3cstop offset='0%25' stop-color='rgba(231%2c231%2c231%2c0.6)' stop-opacity='0.6' vector-effect='non-scaling-stroke'/%3e%3cstop offset='100%25' stop-color='rgba(42%2c42%2c42%2c0)' stop-opacity='0' vector-effect='non-scaling-stroke'/%3e%3c/radialGradient%3e%3c/defs%3e%3cg transform='translate(0%2c 0)'%3e%3cpath d='M0 200 C0 89.5430500338413 89.5430500338413 0 200 0 C310.45694996615885 0 400 89.5430500338413 400 200 C400 310.45694996615885 310.45694996615885 400 200 400 C89.5430500338413 400 0 310.45694996615885 0 200 Z' style='stroke-width: 0%3b stroke-linecap: butt%3b stroke-linejoin: miter%3b fill: url(%26quot%3b%23gradient-164348121323581%26quot%3b)%3b' vector-effect='non-scaling-stroke'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

var Container$a = styled.div.withConfig({
  displayName: "EmptyTablePlaceholder__Container",
  componentId: "sc-15u9jro-0"
})(["align-items:center;display:flex;flex-direction:column;width:100%;"]);
var BackgroundImage = styled.img.withConfig({
  displayName: "EmptyTablePlaceholder__BackgroundImage",
  componentId: "sc-15u9jro-1"
})(["width:400px;height:300px;position:absolute;"]);
var ForegroundImage = styled.img.withConfig({
  displayName: "EmptyTablePlaceholder__ForegroundImage",
  componentId: "sc-15u9jro-2"
})(["width:82px;height:82px;fill:", ";margin-top:159px;"], theme.grey100);
var HeaderText = styled.span.withConfig({
  displayName: "EmptyTablePlaceholder__HeaderText",
  componentId: "sc-15u9jro-3"
})(["margin-top:", "px;height:31px;background-size:cover;font-family:Roboto;font-size:16px;color:", ";text-decoration:none solid ", ";line-height:24px;text-align:center;"], function (_ref) {
  var hasButton = _ref.hasButton;
  return hasButton ? '0' : '27';
}, theme.grey100, theme.grey100);
var BodyText = styled.span.withConfig({
  displayName: "EmptyTablePlaceholder__BodyText",
  componentId: "sc-15u9jro-4"
})(["height:31px;background-size:cover;font-family:Roboto;font-size:14px;color:", ";text-decoration:none solid ", ";line-height:24px;text-align:center;white-space:pre-line;"], theme.grey70, theme.grey70);
var EmptyTablePlaceholder = function EmptyTablePlaceholder(_ref2) {
  var imgAlt = _ref2.imgAlt,
    imgSrc = _ref2.imgSrc,
    header = _ref2.header,
    node = _ref2.node,
    body = _ref2.body;
  return /*#__PURE__*/React.createElement(Container$a, null, !node && /*#__PURE__*/React.createElement(BackgroundImage, {
    alt: "background radial gradient",
    src: img$r
  }), /*#__PURE__*/React.createElement(Container$a, null, /*#__PURE__*/React.createElement(ForegroundImage, {
    alt: imgAlt,
    src: imgSrc
  }), /*#__PURE__*/React.createElement(HeaderText, {
    hasButton: !!node
  }, /*#__PURE__*/React.createElement("b", null, header)), node, /*#__PURE__*/React.createElement(BodyText, null, body)));
};

var CardModalContainer$1 = styled(Modal).withConfig({
  displayName: "ErrorCardModal__CardModalContainer",
  componentId: "zgakz2-0"
})(["overflow:hidden;border-radius:20px;.modal-content{border-radius:20px;}"]);
var Row$1 = styled.div.withConfig({
  displayName: "ErrorCardModal__Row",
  componentId: "zgakz2-1"
})(["display:flex;align-items:center;justify-content:center;img{width:100px;margin-right:30px;align-self:baseline;}div{flex:1;line-height:22px;overflow:scroll;height:105px;p{margin-top:12px;}}"]);
var CardContent$5 = styled.div.withConfig({
  displayName: "ErrorCardModal__CardContent",
  componentId: "zgakz2-2"
})(["color:", ";padding:20px;width:100%;"], function (_ref) {
  var theme = _ref.theme;
  return theme.grey100;
});
var ButtonContainer$3 = styled.div.withConfig({
  displayName: "ErrorCardModal__ButtonContainer",
  componentId: "zgakz2-3"
})(["display:flex;align-items:flex-end;width:100%;justify-content:flex-end;"]);
var errorMapper = {
  'Failed to fetch': "Can't reach the Aserto service."
};
var ErrorCardModal = function ErrorCardModal(_ref2) {
  var title = _ref2.title,
    onHide = _ref2.onHide,
    cardHeight = _ref2.cardHeight,
    message = _ref2.message,
    _ref2$closeButtonText = _ref2.closeButtonText,
    closeButtonText = _ref2$closeButtonText === void 0 ? 'Close' : _ref2$closeButtonText;
  return /*#__PURE__*/React.createElement(CardModalContainer$1, {
    centered: true,
    "data-testid": "error-modal",
    show: !!message,
    onHide: onHide
  }, /*#__PURE__*/React.createElement(Card, {
    body: /*#__PURE__*/React.createElement(CardContent$5, null, /*#__PURE__*/React.createElement(Row$1, null, /*#__PURE__*/React.createElement("img", {
      src: img$E
    }), /*#__PURE__*/React.createElement("div", null, message === 'Failed to fetch' ? errorMapper[message] : message !== null && message !== void 0 ? message : '')), /*#__PURE__*/React.createElement(ButtonContainer$3, null, /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: onHide
    }, closeButtonText))),
    height: cardHeight || 267,
    style: {
      width: '100%'
    },
    title: title,
    variant: "danger"
  }));
};

var EvaluateDisplayStateComponent = function EvaluateDisplayStateComponent(_ref) {
  var children = _ref.children,
    displayState = _ref.displayState;
  var isVisible = displayState.visible;
  var isEnabled = displayState.enabled;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isVisible && /*#__PURE__*/React.cloneElement(children, {
    disabled: !isEnabled
  }));
};
var EvaluateDisplayState = /*#__PURE__*/React.memo(EvaluateDisplayStateComponent);

var img$q = "data:image/svg+xml,%3csvg width='120' height='12' viewBox='0 0 120 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect width='120' height='12' fill='%23595959' /%3e%3c/svg%3e";

var FullScreenModalContainer = styled(Modal).withConfig({
  displayName: "FullScreenModal__FullScreenModalContainer",
  componentId: "touevd-0"
})(["overflow-x:hidden;padding-left:0!important;.logo{height:48px;margin:16px 0 0 16px;}.modal-content{background-color:", ";color:", ";}", "}"], theme.grey20, theme.grey100, function (_ref) {
  var $fade = _ref.$fade;
  return !!$fade && css(["filter:brightness(50%);"]);
});
var ModalContents = styled.div.withConfig({
  displayName: "FullScreenModal__ModalContents",
  componentId: "touevd-1"
})(["height:100vh;width:100vw;"]);
var StepperIndicator = styled.div.withConfig({
  displayName: "FullScreenModal__StepperIndicator",
  componentId: "touevd-2"
})(["margin-top:-28px;display:flex;gap:12px;justify-content:center;.active{filter:brightness(300%);}"]);
var StepContent = styled.div.withConfig({
  displayName: "FullScreenModal__StepContent",
  componentId: "touevd-3"
})(["display:flex;flex-direction:column;align-items:center;margin-top:96px;background-color:", ";"], theme.grey20);
var Title$1 = styled.div.withConfig({
  displayName: "FullScreenModal__Title",
  componentId: "touevd-4"
})(["font-size:24px;line-height:28px;margin-bottom:20px;"]);
var Body$1 = styled.div.withConfig({
  displayName: "FullScreenModal__Body",
  componentId: "touevd-5"
})(["font-size:16px;line-height:20px;margin-bottom:20px;"]);
var Content$1 = styled.div.withConfig({
  displayName: "FullScreenModal__Content",
  componentId: "touevd-6"
})(["display:flex;width:600px;flex-direction:column;"]);
var Bar = styled.div.withConfig({
  displayName: "FullScreenModal__Bar",
  componentId: "touevd-7"
})(["position:fixed;width:calc(100vw - 10px);background-color:", ";height:80px;"], theme.grey20);
var FullScreenModal = function FullScreenModal(_ref2) {
  var children = _ref2.children,
    fade = _ref2.fade,
    steps = _ref2.steps,
    title = _ref2.title,
    show = _ref2.show,
    onHide = _ref2.onHide;
  var renderStepperIndicator = function renderStepperIndicator(_ref3) {
    var current = _ref3.current,
      total = _ref3.total;
    var imgs = [];
    for (var i = 1; i <= total; i++) {
      imgs.push(/*#__PURE__*/React.createElement("img", {
        key: i,
        alt: "step",
        className: i === current ? 'active' : '',
        src: img$q
      }));
    }
    return imgs;
  };
  return /*#__PURE__*/React.createElement(FullScreenModalContainer, {
    "$fade": fade,
    "data-testid": "modal",
    fullscreen: true,
    show: show,
    onHide: onHide
  }, /*#__PURE__*/React.createElement(ModalContents, null, /*#__PURE__*/React.createElement(Bar, null, /*#__PURE__*/React.createElement("img", {
    alt: "aserto",
    className: "logo",
    src: img$w
  }), !!steps && /*#__PURE__*/React.createElement(StepperIndicator, null, renderStepperIndicator(steps))), /*#__PURE__*/React.createElement(StepContent, null, /*#__PURE__*/React.createElement(Content$1, null, /*#__PURE__*/React.createElement(Title$1, null, title), /*#__PURE__*/React.createElement(Body$1, null, children)))));
};

var FullScreenContainer = styled.div.withConfig({
  displayName: "FullScreenOnMobile__FullScreenContainer",
  componentId: "sfll69-0"
})(["flex:1;@media (min-width:1028px){width:50%;}@media (max-width:1028px){", ";width:100%;position:fixed;overflow-y:auto;top:0;left:0;height:100%;background-color:", ";z-index:200;}"], function (_ref) {
  var $show = _ref.$show;
  return $show ? 'display: block' : 'display: none';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.primaryBlack;
});
var CloseButton = styled.div.withConfig({
  displayName: "FullScreenOnMobile__CloseButton",
  componentId: "sfll69-1"
})(["display:none;cursor:pointer;@media (max-width:1028px){display:block;position:fixed;top:20px;right:20px;z-index:201;font-size:16px;}"]);
var FullScreenOnMobile = function FullScreenOnMobile(_ref3) {
  var children = _ref3.children,
    onCloseMobile = _ref3.onCloseMobile,
    show = _ref3.show;
  var _useDeviceDetect = useDeviceDetect(),
    isMobile = _useDeviceDetect.isMobile;
  var removeOverflowFromBody = function removeOverflowFromBody() {
    document.querySelector('body').style.overflow = 'hidden';
  };
  var addOverflowToBody = function addOverflowToBody() {
    document.querySelector('body').style.overflow = 'auto';
  };
  useLayoutEffect(function () {
    if (show && isMobile) {
      removeOverflowFromBody();
    } else {
      addOverflowToBody();
    }
    return function () {
      return addOverflowToBody();
    };
  }, [show, isMobile]);
  return /*#__PURE__*/React.createElement(FullScreenContainer, {
    "$show": show
  }, /*#__PURE__*/React.createElement(CloseButton, {
    onClick: onCloseMobile
  }, "Close"), children);
};

var Ellipsis = function Ellipsis() {
  return /*#__PURE__*/React.createElement("svg", {
    height: "16",
    style: {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 1.41421
    },
    version: "1.1",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-2,0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "8",
    r: "2",
    style: {
      fill: '#a0a0a0'
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10,0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "8",
    r: "2",
    style: {
      fill: '#a0a0a0'
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4,0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "8",
    r: "2",
    style: {
      fill: '#a0a0a0'
    }
  })));
};

var img$p = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='16' height='16' viewBox='0 0 16 16'%3e %3cdefs%3e %3cclipPath id='clip-Copy-to-clipboard'%3e %3crect width='16' height='16'/%3e %3c/clipPath%3e %3c/defs%3e %3cg id='Copy-to-clipboard' clip-path='url(%23clip-Copy-to-clipboard)'%3e %3cg id='Group_1' data-name='Group 1' transform='translate(-13 133)'%3e %3cg id='File_Paste_Copy' data-name='File%2c Paste%2c Copy' transform='translate(13 -133)'%3e %3cpath id='Path_1' data-name='Path 1' d='M6.692%2c14.691H4.231V4.231h8.615a.615.615%2c0%2c1%2c0%2c0-1.231H3.615A.615.615%2c0%2c0%2c0%2c3%2c3.615V15.306a.615.615%2c0%2c0%2c0%2c.615.615H6.692a.615.615%2c0%2c0%2c0%2c0-1.231Z' transform='translate(-3 -3)' fill='%23a0a0a0'/%3e %3cpath id='Path_2' data-name='Path 2' d='M21.845%2c8h-9.23A.615.615%2c0%2c0%2c0%2c12%2c8.615V20.306a.615.615%2c0%2c0%2c0%2c.615.615h9.23a.615.615%2c0%2c0%2c0%2c.615-.615V8.615A.615.615%2c0%2c0%2c0%2c21.845%2c8ZM21.23%2c19.691h-8V9.231h8Z' transform='translate(-6.462 -4.923)' fill='%23a0a0a0'/%3e %3cpath id='Path_3' data-name='Path 3' d='M17.615%2c17.231h3.077a.615.615%2c0%2c1%2c0%2c0-1.231H17.615a.615.615%2c0%2c1%2c0%2c0%2c1.231Z' transform='translate(-8.385 -8.001)' fill='%23a0a0a0'/%3e %3cpath id='Path_4' data-name='Path 4' d='M17.615%2c21.231h3.077a.615.615%2c0%2c1%2c0%2c0-1.231H17.615a.615.615%2c0%2c1%2c0%2c0%2c1.231Z' transform='translate(-8.385 -9.54)' fill='%23a0a0a0'/%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var customAtomDark = Object.assign(Object.assign({}, atomDark), {
  'pre[class*="language-"]': {
    background: 'inherit',
    fontFamily: '"Fira Code", monospace',
    fontSize: '14px',
    fontWeight: '500'
  },
  ':not(pre) > code[class*="language-"]': {
    background: 'inherit'
  }
});
var CodeContainer = styled.div.withConfig({
  displayName: "styles__CodeContainer",
  componentId: "tozou7-0"
})(["background:", ";border-radius:4px;display:flex;flex-direction:row;"], function (_ref) {
  var $copyToClipboard = _ref.$copyToClipboard;
  return $copyToClipboard ? theme.grey10 : theme.primaryBlack;
});
var CodeDiv = styled.div.withConfig({
  displayName: "styles__CodeDiv",
  componentId: "tozou7-1"
})(["padding:10px 0px 0px 10px;height:", "px;"], function (_ref2) {
  var $height = _ref2.$height;
  return $height;
});
var CopyButton$3 = styled.button.withConfig({
  displayName: "styles__CopyButton",
  componentId: "tozou7-2"
})(["background:", ";border-radius:4px;border:0px;height:fit-content;margin-left:auto;margin-right:2px;margin-top:2px;&:hover{background:", ";}&:active{box-shadow:0 5px ", ";transform:translateY(4px);}"], theme.grey10, theme.grey40, theme.grey20);

var Highlight = function Highlight(_ref) {
  var children = _ref.children,
    language = _ref.language,
    copyToClipboard = _ref.copyToClipboard,
    height = _ref.height;
  var memoizedHighlighter = useMemo(function () {
    return /*#__PURE__*/React.createElement(Prism, {
      language: language,
      lineProps: {
        style: {
          whiteSpace: 'break-spaces'
        }
      },
      style: customAtomDark,
      wrapLines: true
    }, children);
  }, [children, language]);
  return /*#__PURE__*/React.createElement(CodeContainer, {
    "$copyToClipboard": copyToClipboard
  }, /*#__PURE__*/React.createElement(CodeDiv, {
    "$height": height
  }, memoizedHighlighter), copyToClipboard && (/*#__PURE__*/React.createElement(CopyToClipboard, {
    text: children
  }, /*#__PURE__*/React.createElement(CopyButton$3, null, /*#__PURE__*/React.createElement("img", {
    alt: "copy",
    src: img$p
  })))));
};

var Logout = function Logout() {
  var _useIdentity = useIdentity(),
    logout = _useIdentity.logout;
  logout();
  return null;
};

var img$o = "data:image/svg+xml,%3csvg width='9' height='24' viewBox='0 0 9 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3c/svg%3e";

var img$n = "data:image/svg+xml,%3csvg width='9' height='24' viewBox='0 0 9 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle cx='4.5' cy='12' r='4.5' fill='%2367CBCF' /%3e%3c/svg%3e";

var TabContainer$1 = styled.div.withConfig({
  displayName: "styles__TabContainer",
  componentId: "lubx14-0"
})(["width:100%;display:flex;position:fixed;max-width:250px;flex-direction:column;height:100%;", " &:last-child{border-bottom:none;}"], function (_ref) {
  var theme = _ref.theme;
  return css(["border:1px solid ", ";"], theme.grey20);
});
var TabSectionOptions = styled.div.withConfig({
  displayName: "styles__TabSectionOptions",
  componentId: "lubx14-1"
})(["display:", ";"], function (_ref2) {
  var show = _ref2.show;
  return show ? 'block' : 'none';
});
var VerticalTab$1 = styled(NavLink).withConfig({
  displayName: "styles__VerticalTab",
  componentId: "lubx14-2"
})(["", " ", ""], function (_ref3) {
  var theme = _ref3.theme;
  return css(["align-items:center;color:", ";cursor:pointer;display:flex;flex-direction:row;font-weight:400;gap:8px;padding:6px 25px;text-decoration:none;&:hover{text-decoration:none;color:", ";background-color:", ";}> img{visibility:hidden;}&.active{color:", ";> img{visibility:visible;}}"], theme.grey70, theme.grey100, theme.grey10, theme.grey100);
}, function (_ref4) {
  var depth = _ref4.depth,
    theme = _ref4.theme;
  return depth === 0 ? css(["border-bottom:1px solid ", ";padding:8px 0px;color:", ";:nth-child(odd){margin-top:-1px;}&.active{color:", ";background-color:", ";border-left:5px solid ", ";}"], theme.grey20, theme.grey70, theme.grey100, theme.grey20, theme.lochivarAccent3) : undefined;
});
var AddTypeButton = styled.div.withConfig({
  displayName: "styles__AddTypeButton",
  componentId: "lubx14-3"
})(["", "}"], function (_ref5) {
  var theme = _ref5.theme;
  return "\n      color: ".concat(theme.grey70, ";\n      cursor: pointer;\n      display: flex;\n      padding: 6px 42px;\n      margin-bottom: 10px;\n      span {\n        border-bottom: 2px dotted ").concat(theme.grey70, ";\n      }\n      &:hover {\n        color: ").concat(theme.grey100, ";\n      }\n    ");
});

var _NestedVerticalTab = function NestedVerticalTab(_ref) {
  var children = _ref.children,
    depth = _ref.depth,
    subLinks = _ref.subLinks,
    to = _ref.to;
  var resolved = useResolvedPath(to);
  var active = useMatch({
    path: "".concat(resolved.pathname, "/*"),
    end: false
  });
  var icon;
  switch (depth) {
    case 0:
      icon = img$o;
      break;
    default:
      icon = img$n;
      break;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VerticalTab$1, {
    depth: depth,
    to: to
  }, /*#__PURE__*/React.createElement("img", {
    alt: "show",
    src: icon
  }), children), /*#__PURE__*/React.createElement(TabSectionOptions, {
    show: !!active
  }, subLinks === null || subLinks === void 0 ? void 0 : subLinks.map(function (s) {
    return s.redirects ? (/*#__PURE__*/React.createElement(_NestedVerticalTab, {
      key: s.value,
      depth: depth + 1,
      to: s.value
    }, s.label)) : (/*#__PURE__*/React.createElement(AddTypeButton, {
      key: s.label,
      onClick: s.onClick
    }, /*#__PURE__*/React.createElement("span", null, s.label)));
  })));
};
var VerticalTabs = function VerticalTabs(_ref2) {
  var options = _ref2.options;
  return /*#__PURE__*/React.createElement(TabContainer$1, null, options.map(function (option) {
    return /*#__PURE__*/React.createElement("div", {
      key: option.section.value
    }, /*#__PURE__*/React.createElement(_NestedVerticalTab, {
      depth: 0,
      subLinks: option.subOptions,
      to: option.section.value
    }, option.section.label));
  }));
};

var img$m = "data:image/svg+xml,%3csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M0 1.93053L1.93053 0L7 5.08421L12.0695 0L14 1.93053L7 8.93053L0 1.93053Z' fill='%23E7E7E7' /%3e%3c/svg%3e";

var OptionsButton = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var props = __rest(_a, []);
  return /*#__PURE__*/React.createElement(BaseButtonWithIconElement, Object.assign({
    ref: ref
  }, props, {
    icon: /*#__PURE__*/React.createElement("img", {
      src: img$m
    }),
    text: "Options ".concat(' '),
    title: "Options",
    variant: "secondary"
  }));
});

var groupLabelStyle$1 = {
  position: 'relative',
  marginTop: -8,
  marginBottom: -3,
  marginLeft: -11,
  marginRight: -11,
  backgroundColor: theme.grey
};
var formatGroupLabel$3 = function formatGroupLabel() {
  return /*#__PURE__*/React.createElement("div", {
    style: groupLabelStyle$1
  });
};
var OptionsSelect = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var options = _a.options,
    defaultValue = _a.defaultValue,
    onChange = _a.onChange,
    label = _a.label,
    disabled = _a.disabled,
    style = _a.style,
    disableLabel = _a.disableLabel,
    modifyCustomStyle = _a.modifyCustomStyle,
    name = _a.name,
    shouldDisableOptions = _a.shouldDisableOptions,
    _onBlur = _a.onBlur,
    props = __rest(_a, ["options", "defaultValue", "onChange", "label", "disabled", "style", "disableLabel", "modifyCustomStyle", "name", "shouldDisableOptions", "onBlur"]);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    firstSelectedOption = _useState2[0],
    setFirstSelectedOption = _useState2[1];
  var removeFocusBox = {
    outline: 'none',
    webkitBoxShadow: 'none',
    boxShadow: 'none'
  };
  useEffect(function () {
    if (defaultValue) {
      setFirstSelectedOption(defaultValue);
    }
  }, [defaultValue]);
  var Option = useCallback(function (props) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(components.Option, Object.assign({}, props, {
      innerProps: Object.assign(Object.assign({}, props.innerProps), {
        onMouseDown: function onMouseDown(e) {
          var _a, _b;
          if (shouldDisableOptions) {
            return;
          }
          if (props.data.shouldStopPropagation) {
            e.stopPropagation();
            (_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a);
          }
        }
      }),
      isDisabled: shouldDisableOptions || false
    })));
  }, [shouldDisableOptions]);
  var DropdownIndicator = function DropdownIndicator(props) {
    return /*#__PURE__*/React.createElement(components.DropdownIndicator, Object.assign({}, props), /*#__PURE__*/React.createElement("img", {
      alt: "dropdown",
      src: img$m
    }));
  };
  var colourStyles = {
    control: function control(styles, _ref) {
      var isDisabled = _ref.isDisabled,
        isFocused = _ref.isFocused;
      return Object.assign(Object.assign({}, styles), {
        width: 93,
        height: 36,
        backgroundColor: isFocused ? theme.grey40 : theme.grey20,
        border: "1px solid ".concat(theme.grey30),
        color: theme.grey70,
        opacity: isDisabled ? 0.6 : 1,
        outline: isFocused ? 'none' : '',
        boxShadow: 'none',
        borderWidth: 1,
        ':hover': Object.assign(Object.assign({}, styles[':hover']), {
          backgroundColor: theme.grey40,
          borderColor: theme.grey40
        })
      });
    },
    option: function option(styles, _ref2) {
      var isDisabled = _ref2.isDisabled,
        isFocused = _ref2.isFocused;
      return Object.assign(Object.assign({}, styles), {
        backgroundColor: isFocused ? theme.grey40 : theme.grey20,
        color: isFocused ? theme.grey100 : theme.grey70,
        height: 36,
        cursor: isDisabled ? 'not-allowed' : 'default',
        ':active': Object.assign(Object.assign({}, styles[':active']), {
          backgroundColor: theme.grey30
        })
      });
    },
    group: function group(styles) {
      return Object.assign(Object.assign({}, styles), {
        backgroundColor: theme.grey30,
        paddingBottom: 0,
        paddingTop: 6
      });
    },
    input: function input(styles) {
      return Object.assign(Object.assign({}, styles), {
        color: theme.grey100
      });
    },
    placeholder: function placeholder(styles) {
      return Object.assign(Object.assign({}, styles), {
        color: theme.grey100,
        fontWeight: '600',
        width: 10
      });
    },
    singleValue: function singleValue(styles, _ref3) {
      var isDisabled = _ref3.isDisabled;
      return Object.assign(Object.assign(Object.assign({}, styles), {
        color: isDisabled ? theme.grey40 : theme.grey100,
        width: '100%',
        textAlign: 'left',
        overflow: 'auto'
      }), removeFocusBox);
    },
    menu: function menu(styles) {
      return Object.assign(Object.assign({}, styles), {
        width: 250,
        zIndex: 0,
        marginTop: 3,
        backgroundColor: 'none',
        marginLeft: -155
      });
    },
    dropdownIndicator: function dropdownIndicator(styles) {
      return Object.assign(Object.assign({}, styles), {
        padding: 0,
        width: 25,
        color: theme.grey100,
        ':hover': Object.assign(Object.assign({}, styles[':hover']), {
          color: theme.grey100
        })
      });
    },
    menuList: function menuList(style) {
      return Object.assign(Object.assign({}, style), {
        zIndex: -10,
        padding: 0,
        border: "1px solid ".concat(theme.grey60)
      });
    },
    indicatorSeparator: function indicatorSeparator(styles) {
      return Object.assign(Object.assign({}, styles), {
        display: 'none'
      });
    },
    valueContainer: function valueContainer(styles) {
      return Object.assign(Object.assign({}, styles), {
        overflow: 'none'
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    style: style
  }, label && (/*#__PURE__*/React.createElement(Label$1, {
    disabled: disableLabel,
    htmlFor: name
  }, label)), /*#__PURE__*/React.createElement(ReactSelect, Object.assign({}, props, {
    ref: ref,
    closeMenuOnSelect: false,
    components: {
      Option: Option,
      DropdownIndicator: DropdownIndicator
    },
    defaultValue: defaultValue,
    formatGroupLabel: formatGroupLabel$3,
    inputId: name,
    isClearable: false,
    isDisabled: disabled,
    isSearchable: false,
    menuPlacement: "auto",
    menuPosition: "fixed",
    name: name,
    options: options,
    styles: modifyCustomStyle ? modifyCustomStyle(colourStyles) : colourStyles,
    onBlur: function onBlur() {
      _onBlur && _onBlur(firstSelectedOption || undefined);
    },
    onChange: onChange,
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  })));
});

var PaddedContent = styled.div.withConfig({
  displayName: "PaddedContent",
  componentId: "sc-19tfyuz-0"
})(["padding-top:140px;"]);

var Title = styled.div.withConfig({
  displayName: "PageTitle__Title",
  componentId: "sc-1oontos-0"
})(["font-size:24px;width:100%;min-width:200px;color:", ";"], theme.grey100);
var PageTitle = function PageTitle(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/React.createElement(Title, null, title);
};

var RefreshButtonContainer = styled(Button).withConfig({
  displayName: "RefreshButton__RefreshButtonContainer",
  componentId: "sc-8bijeq-0"
})(["position:absolute;right:20px;border:1px solid ", ";border-radius:4px;background-color:", ";background-size:cover;font-size:14px;color:", ";text-align:center;font-weight:600;display:flex;flex-direction:row;align-items:center;box-shadow:none;outline:none;gap:4px;@media (max-width:600px){width:auto;i{margin:auto;}span{display:none;}}"], theme.grey, theme.grey20, theme.grey100);
var LoadKeyFrame$1 = keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var SpinAnimator = styled.div.withConfig({
  displayName: "RefreshButton__SpinAnimator",
  componentId: "sc-8bijeq-1"
})(["margin:auto;width:50%;animation:", " ", " infinite linear;"], LoadKeyFrame$1, function (_ref) {
  var $spin = _ref.$spin;
  return $spin ? '1000ms' : '0ms';
});
var RefreshButton = function RefreshButton(_ref2) {
  var load = _ref2.load,
    loading = _ref2.loading,
    testId = _ref2.testId;
  return /*#__PURE__*/React.createElement(RefreshButtonContainer, {
    "data-testid": testId,
    variant: "secondary",
    onClick: load
  }, loading ? (/*#__PURE__*/React.createElement(SpinAnimator, {
    "$spin": loading
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-refresh"
  }))) : (/*#__PURE__*/React.createElement("i", {
    className: "fa fa-refresh"
  })), /*#__PURE__*/React.createElement("span", null, "\xA0Refresh"));
};

var PageHeaderContainer = styled.div.withConfig({
  displayName: "PageHeader__PageHeaderContainer",
  componentId: "osptqd-0"
})(["padding:20px;position:fixed;width:100%;top:80px;", ";height:60px;display:flex;align-items:center;z-index:9;background-color:", ";@media (max-width:600px){padding-top:10px;padding-bottom:10px;}"], function (_ref) {
  var $hasBorderBottom = _ref.$hasBorderBottom;
  return $hasBorderBottom ? "border-bottom: 1px solid ".concat(theme.grey20) : '';
}, theme.primaryBlack);
var PageHeader = function PageHeader(_ref2) {
  var title = _ref2.title,
    subtitle = _ref2.subtitle,
    load = _ref2.load,
    loading = _ref2.loading,
    hasBorderBottom = _ref2.hasBorderBottom,
    id = _ref2.id,
    mobileBreakpoint = _ref2.mobileBreakpoint,
    testId = _ref2.testId,
    children = _ref2.children;
  var queryClient = useQueryClient();
  var queryClientFetching = useIsFetching();
  var refresh = useCallback(function () {
    queryClient.refetchQueries({
      type: 'active'
    });
  }, [queryClient]);
  return /*#__PURE__*/React.createElement(PageHeaderContainer, {
    "$hasBorderBottom": hasBorderBottom,
    "$mobileBreakpoint": mobileBreakpoint,
    "data-testid": testId,
    id: id
  }, /*#__PURE__*/React.createElement(RefreshButton, {
    load: load || refresh,
    loading: loading || queryClientFetching > 0
  }), /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement(PageTitle, {
    title: title
  }), subtitle && /*#__PURE__*/React.createElement("div", null, subtitle)), children);
};

// TODO: Remove once `PageHeader` is properly styled
var PageHeaderContent = styled.div.withConfig({
  displayName: "PageHeaderContent",
  componentId: "rfwf2g-0"
})(["width:100%;display:flex;flex-direction:row;gap:10px;justify-content:flex-end;margin-right:108px;position:relative;white-space:nowrap;"]);

var Icon$1 = styled.div.withConfig({
  displayName: "PlayButton__Icon",
  componentId: "sc-2miekb-0"
})(["background-color:", ";cursor:pointer;border:8px solid ", ";border-radius:30px;", ""], theme.primaryBlack, theme.primaryBlack, function (_ref) {
  var $disabled = _ref.$disabled;
  return !!$disabled && "pointer-events: none;";
});
var ButtonPath = styled.path.withConfig({
  displayName: "PlayButton__ButtonPath",
  componentId: "sc-2miekb-1"
})(["stroke-width:0;stroke-linecap:butt;stroke-linejoin:miter;fill:", ";&:hover{fill:", ";}"], function (_ref2) {
  var theme = _ref2.theme,
    $disabled = _ref2.$disabled;
  return !$disabled ? theme.lochivar70 : theme.grey20;
}, function (_ref3) {
  var theme = _ref3.theme,
    $disabled = _ref3.$disabled;
  return !$disabled && theme.lochivar100;
});
var PlayButton = function PlayButton(_ref4) {
  var onSubmit = _ref4.onSubmit,
    disabled = _ref4.disabled;
  return /*#__PURE__*/React.createElement(Icon$1, {
    "$disabled": disabled,
    "aria-label": "Run operation",
    onClick: onSubmit
  }, /*#__PURE__*/React.createElement("svg", {
    height: "41.99999601375708",
    overflow: "visible",
    preserveAspectRatio: "none",
    version: "1.2",
    viewBox: "0 0 41.99999699397481 41.99999601375708",
    width: "41.99999699397481"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.721301208598927e-7, -0.000003331672143458819) rotate(0)"
  }, /*#__PURE__*/React.createElement(ButtonPath, {
    "$disabled": disabled,
    d: "M21.18749,0.00104c-9.34969,-0.09325 -17.93495,6.11204 -20.46684,15.56138c-3.00075,11.19921 3.6434,22.71612 14.84234,25.71692c11.19899,3.0008 22.71559,-3.6435 25.71638,-14.84271c3.0007,-11.19921 -3.6435,-22.71608 -14.84239,-25.7169c-1.7498,-0.46887 -3.5181,-0.70142 -5.2495,-0.71869zM16.00049,11.50021l15.99849,9.49941l-15.99849,9.49931z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.18749,0.00104c-9.34969,-0.09325 -17.93495,6.11204 -20.46684,15.56138c-3.00075,11.19921 3.6434,22.71612 14.84234,25.71692c11.19899,3.0008 22.71559,-3.6435 25.71638,-14.84271c3.0007,-11.19921 -3.6435,-22.71608 -14.84239,-25.7169c-1.7498,-0.46887 -3.5181,-0.70142 -5.2495,-0.71869zM16.00049,11.50021l15.99849,9.49941l-15.99849,9.49931z"
  })))));
};

var TooltipDialog = styled.div.withConfig({
  displayName: "TooltipDialog",
  componentId: "sc-1hmo2bw-0"
})(["display:flex;flex-direction:column;font-size:12px;color:", ";max-width:240px;margin:0px;padding:0px;list-style-position:outside;"], theme.grey100);

var img$l = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' style='margin: auto%3b background: transparent%3b display: block%3b shape-rendering: auto%3b' width='200px' height='200px' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid'%3e %3ccircle cx='50' cy='50' fill='none' stroke='%23277f82' stroke-width='10' r='35' stroke-dasharray='164.93361431346415 56.97787143782138'%3e %3canimateTransform attributeName='transform' type='rotate' repeatCount='indefinite' dur='1s' values='0 50 50%3b360 50 50' keyTimes='0%3b1'%3e%3c/animateTransform%3e %3c/circle%3e %3c!-- %5bldio%5d generated by https://loading.io/ --%3e%3c/svg%3e";

var WorkingSpinnerContainer = styled.div.withConfig({
  displayName: "PolicyInstanceLogo__WorkingSpinnerContainer",
  componentId: "dei80q-0"
})(["align-items:center;color:", ";display:flex;flex-direction:column;font-size:12px;font-weight:600;height:", ";img{width:35px;margin-bottom:4px;}justify-content:center;left:0;position:absolute;top:0;width:", ";@media (max-width:500px){div{display:nonze;}left:23px;img{width:28px;}top:35px;}"], theme.grey100, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});
var ErrorMessage$2 = styled.div.withConfig({
  displayName: "PolicyInstanceLogo__ErrorMessage",
  componentId: "dei80q-1"
})(["color:", ";cursor:default;height:100%;left:0;line-height:", ";pointer-events:auto;position:absolute;right:0;text-align:center;text-decoration-line:underline;text-decoration-style:dotted;top:0;width:", ";"], theme.grey100, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});
var PendingMessage = styled.div.withConfig({
  displayName: "PolicyInstanceLogo__PendingMessage",
  componentId: "dei80q-2"
})(["font-size:9px;"]);
var getSvgProps = function getSvgProps(size) {
  return {
    fill: 'none',
    height: size,
    viewBox: '0 0 100 100',
    width: size,
    xmlns: 'http://www.w3.org/2000/svg'
  };
};
var HoverSvg = styled.svg.withConfig({
  displayName: "PolicyInstanceLogo__HoverSvg",
  componentId: "dei80q-3"
})(["fill:#a0a0a0;&:hover{fill:#e7e7e7;}", ":hover &{fill:#e7e7e7;}"], function (props) {
  return props.$parent;
});
var PolicyInstanceLogo = function PolicyInstanceLogo(_ref) {
  var errorContent = _ref.errorContent,
    parent = _ref.parent,
    size = _ref.size,
    variant = _ref.variant;
  switch (variant) {
    case 'error':
      return getErrorLogo({
        errorContent: errorContent,
        size: size
      });
    case 'loaded':
      return getLoadedLogo({
        parent: parent,
        size: size
      });
    case 'pending':
      return getPendingLogo({
        size: size
      });
  }
};
var getLoadedLogo = function getLoadedLogo(_ref2) {
  var parent = _ref2.parent,
    size = _ref2.size;
  return /*#__PURE__*/React.createElement(HoverSvg, Object.assign({}, getSvgProps(size), {
    "$parent": parent
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1771 0.192355L14.2896 12.9844C12.9476 13.4758 11.9876 14.8624 12.0001 16.2915V56.9935C12.0001 66.5228 17.3786 74.3898 24.3929 81.0872C31.4071 87.7849 40.2309 93.5992 48.3412 99.3663C49.5178 100.211 51.2349 100.211 52.4114 99.3663C60.5227 93.5982 69.3464 87.7846 76.3597 81.0872C83.3736 74.3895 88.7526 66.5217 88.7526 56.9935V16.2915C88.765 14.8624 87.805 13.4758 86.4631 12.9844L51.5756 0.192355C50.7276 -0.138882 49.6086 0.0231416 49.1771 0.192355ZM50.3763 7.20619V92.2076C42.778 86.8492 35.0423 81.5892 29.2258 76.0353C22.8842 69.9796 18.9776 63.8993 18.9776 56.9926V18.7249L50.3763 7.20619Z"
  }));
};
var getPendingLogo = function getPendingLogo(_ref3) {
  var size = _ref3.size;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", Object.assign({
    "data-chromatic": "ignore"
  }, getSvgProps(size)), /*#__PURE__*/React.createElement("path", {
    d: "M49.177.192,14.29,12.984A3.582,3.582,0,0,0,12,16.292v40.7c0,9.529,5.378,17.4,12.393,24.094S40.231,93.6,48.341,99.366a3.585,3.585,0,0,0,4.07,0C60.523,93.6,69.346,87.785,76.36,81.087S88.753,66.522,88.753,56.993v-40.7a3.583,3.583,0,0,0-2.29-3.307L51.576.192A3.864,3.864,0,0,0,49.177.192Zm-30.2,16.1h-3.3L17.5,65.865c-7.6-5.358,17.542,15.724,11.725,10.17C22.884,69.98,17.5,63.9,17.5,56.993v-40.7Z",
    fill: "#595959",
    id: "Authorizer2",
    transform: "translate(-0.376 0)"
  })), /*#__PURE__*/React.createElement(WorkingSpinnerContainer, {
    size: size
  }, /*#__PURE__*/React.createElement("img", {
    alt: "working-spinner",
    src: img$l
  }), /*#__PURE__*/React.createElement(PendingMessage, null, " Pending ")));
};
var getErrorLogo = function getErrorLogo(_ref4) {
  var errorContent = _ref4.errorContent,
    size = _ref4.size;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "data-for": "registerTip",
    "data-tip": true
  }, /*#__PURE__*/React.createElement("svg", Object.assign({}, getSvgProps(size)), /*#__PURE__*/React.createElement("path", {
    d: "M49.177.192,14.29,12.984A3.582,3.582,0,0,0,12,16.292v40.7c0,9.529,5.378,17.4,12.393,24.094S40.231,93.6,48.341,99.366a3.585,3.585,0,0,0,4.07,0C60.523,93.6,69.346,87.785,76.36,81.087S88.753,66.522,88.753,56.993v-40.7a3.583,3.583,0,0,0-2.29-3.307L51.576.192A3.864,3.864,0,0,0,49.177.192Zm-30.2,16.1h-3.3L17.5,65.865c-7.6-5.358,17.542,15.724,11.725,10.17C22.884,69.98,17.5,63.9,17.5,56.993v-40.7Z",
    fill: "#7a2828",
    id: "Authorizer2",
    transform: "translate(-0.376 0)"
  })), /*#__PURE__*/React.createElement(ErrorMessage$2, {
    size: size
  }, "Error")), /*#__PURE__*/React.createElement(ReactTooltip, {
    clickable: true,
    delayHide: 1000,
    id: "registerTip",
    place: "right"
  }, /*#__PURE__*/React.createElement(TooltipDialog, null, errorContent)));
};

var img$k = "data:image/svg+xml,%3csvg version='1.2' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' overflow='visible' preserveAspectRatio='none' viewBox='0 0 12 12' width='12' height='12'%3e %3cg transform='translate(0%2c 0)'%3e %3cdefs%3e %3cpath id='path-161601693481644' d='M9.343705799151346 20.144271570014144 C9.343705799151346 20.144271570014144 14.144271570014148 15.343705799151346 14.144271570014148 15.343705799151346 C14.144271570014148 15.343705799151346 18.944837340876948 20.144271570014144 18.944837340876948 20.144271570014144 C18.944837340876948 20.144271570014144 20.144271570014144 18.944837340876948 20.144271570014144 18.944837340876948 C20.144271570014144 18.944837340876948 15.343705799151346 14.144271570014148 15.343705799151346 14.144271570014148 C15.343705799151346 14.144271570014148 20.144271570014144 9.343705799151346 20.144271570014144 9.343705799151346 C20.144271570014144 9.343705799151346 18.944837340876948 8.144271570014146 18.944837340876948 8.144271570014146 C18.944837340876948 8.144271570014146 14.144271570014148 12.944837340876944 14.144271570014148 12.944837340876944 C14.144271570014148 12.944837340876944 9.343705799151346 8.144271570014146 9.343705799151346 8.144271570014146 C9.343705799151346 8.144271570014146 8.144271570014146 9.343705799151346 8.144271570014146 9.343705799151346 C8.144271570014146 9.343705799151346 12.944837340876944 14.144271570014148 12.944837340876944 14.144271570014148 C12.944837340876944 14.144271570014148 8.144271570014146 18.944837340876948 8.144271570014146 18.944837340876948 C8.144271570014146 18.944837340876948 9.343705799151346 20.144271570014144 9.343705799151346 20.144271570014144 Z' vector-effect='non-scaling-stroke'/%3e %3c/defs%3e %3cg transform='translate(-8.144271570014146%2c -8.144271570014146)'%3e %3cpath d='M9.343705799151346 20.144271570014144 C9.343705799151346 20.144271570014144 14.144271570014148 15.343705799151346 14.144271570014148 15.343705799151346 C14.144271570014148 15.343705799151346 18.944837340876948 20.144271570014144 18.944837340876948 20.144271570014144 C18.944837340876948 20.144271570014144 20.144271570014144 18.944837340876948 20.144271570014144 18.944837340876948 C20.144271570014144 18.944837340876948 15.343705799151346 14.144271570014148 15.343705799151346 14.144271570014148 C15.343705799151346 14.144271570014148 20.144271570014144 9.343705799151346 20.144271570014144 9.343705799151346 C20.144271570014144 9.343705799151346 18.944837340876948 8.144271570014146 18.944837340876948 8.144271570014146 C18.944837340876948 8.144271570014146 14.144271570014148 12.944837340876944 14.144271570014148 12.944837340876944 C14.144271570014148 12.944837340876944 9.343705799151346 8.144271570014146 9.343705799151346 8.144271570014146 C9.343705799151346 8.144271570014146 8.144271570014146 9.343705799151346 8.144271570014146 9.343705799151346 C8.144271570014146 9.343705799151346 12.944837340876944 14.144271570014148 12.944837340876944 14.144271570014148 C12.944837340876944 14.144271570014148 8.144271570014146 18.944837340876948 8.144271570014146 18.944837340876948 C8.144271570014146 18.944837340876948 9.343705799151346 20.144271570014144 9.343705799151346 20.144271570014144 Z' style='stroke-width: 0%3b stroke-linecap: butt%3b stroke-linejoin: miter%3b fill: rgb(160%2c 160%2c 160)%3b' vector-effect='non-scaling-stroke'/%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var Icon = styled.img.withConfig({
  displayName: "PolicyCard__Icon",
  componentId: "sc-1mnxdi5-0"
})(["display:none;cursor:pointer;position:absolute;top:10px;right:10px;"]);
var CardContent$4 = styled.div.withConfig({
  displayName: "PolicyCard__CardContent",
  componentId: "sc-1mnxdi5-1"
})(["width:100%;"]);
var CardLogoContainer = styled.div.withConfig({
  displayName: "PolicyCard__CardLogoContainer",
  componentId: "sc-1mnxdi5-2"
})(["height:100px;position:relative;width:100px;"]);
var CardImg = styled.img.withConfig({
  displayName: "PolicyCard__CardImg",
  componentId: "sc-1mnxdi5-3"
})([""]);
var PolicyCardContainer = styled.div.withConfig({
  displayName: "PolicyCard__PolicyCardContainer",
  componentId: "sc-1mnxdi5-4"
})(["padding:10px;position:relative;min-width:428px;max-width:428px;height:104px;border-radius:5px;background-color:", ";color:", ";display:flex;justify-content:center;background-size:cover;&:hover{background-color:", ";background-size:cover;cursor:pointer;", "{display:block;}}div:first-child{display:flex;align-items:center;}", "{margin-right:10px;width:82px;color:#a0a0a0;}", ";@media (max-width:500px){min-width:100%;height:91px;", "{width:56px;}", "{display:block;}}"], theme.grey20, theme.grey100, theme.grey30, Icon, CardImg, function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? css(["background-color:", ";color:", ";&:hover{background-color:", ";cursor:auto;}", "{pointer-events:none;}", "{opacity:0.4;}"], theme.grey10, theme.grey40, theme.grey10, CardContent$4, CardImg) : '';
}, CardImg, Icon);
var CardText$1 = styled.div.withConfig({
  displayName: "PolicyCard__CardText",
  componentId: "sc-1mnxdi5-5"
})(["font-size:14px;text-overflow:ellipsis;overflow-wrap:break-word;width:310px;@media (max-width:500px){max-width:210px;}margin-left:10px;font-weight:", ";"], function (_ref2) {
  var bold = _ref2.bold;
  return bold ? 'bold' : 500;
});
var TextContainer = styled.div.withConfig({
  displayName: "PolicyCard__TextContainer",
  componentId: "sc-1mnxdi5-6"
})(["justify-content:center;display:flex;flex-direction:column;"]);
var PolicyCard = function PolicyCard(_a) {
  var name = _a.name,
    repoUrl = _a.repoUrl,
    onClickRemoveIcon = _a.onClickRemoveIcon,
    disabled = _a.disabled,
    policyIconVariant = _a.policyIconVariant,
    errors = _a.errors,
    props = __rest(_a, ["name", "repoUrl", "onClickRemoveIcon", "disabled", "policyIconVariant", "errors"]);
  var formatErrorsToDisplay = function formatErrorsToDisplay(errors) {
    return /*#__PURE__*/React.createElement("ul", {
      style: {
        padding: '0px'
      }
    }, errors === null || errors === void 0 ? void 0 : errors.map(function (error) {
      return /*#__PURE__*/React.createElement("li", {
        key: error
      }, error);
    }));
  };
  var errorContent = policyIconVariant === 'error' ? formatErrorsToDisplay(errors) : undefined;
  return /*#__PURE__*/React.createElement(UndecoratedLink, {
    to: "/ui/policies/".concat(name)
  }, /*#__PURE__*/React.createElement(PolicyCardContainer, Object.assign({
    "data-testid": name
  }, props, {
    disabled: disabled
  }), /*#__PURE__*/React.createElement(CardContent$4, {
    "data-testid": "".concat(name, "-content")
  }, /*#__PURE__*/React.createElement(CardLogoContainer, null, /*#__PURE__*/React.createElement(PolicyInstanceLogo, {
    errorContent: errorContent,
    parent: PolicyCardContainer,
    size: "80px",
    variant: policyIconVariant
  })), /*#__PURE__*/React.createElement(TextContainer, null, /*#__PURE__*/React.createElement(CardText$1, {
    bold: true
  }, name), repoUrl && /*#__PURE__*/React.createElement(CardText$1, null, repoUrl))), onClickRemoveIcon && (/*#__PURE__*/React.createElement(Icon, {
    alt: "remove",
    "data-testid": "".concat(name, "-remove-btn"),
    src: img$k,
    onClick: function onClick(e) {
      onClickRemoveIcon();
      e.preventDefault();
    }
  }))));
};

var StyledMenu = styled(Dropdown.Menu).withConfig({
  displayName: "PopoverMenu__StyledMenu",
  componentId: "sc-1lj7xnv-0"
})(["width:250px;border-radius:0;padding:0;border:1px solid ", ";background-color:", ";font-size:14px;"], theme.grey50, theme.grey20);
var StyledItem = styled(Dropdown.Item).withConfig({
  displayName: "PopoverMenu__StyledItem",
  componentId: "sc-1lj7xnv-1"
})(["width:100%;height:36px;padding:8px 12px;border:none;background:transparent;color:", ";text-align:left;&:hover:not(:disabled),&:focus{background-color:", ";color:", ";}&:disabled{background-color:", ";}"], theme.grey70, theme.grey40, theme.grey100, theme.grey20);
var StyledDivider = styled(Dropdown.Divider).withConfig({
  displayName: "PopoverMenu__StyledDivider",
  componentId: "sc-1lj7xnv-2"
})(["margin:0;border-color:", ";"], theme.grey50);
var PopoverMenuContainer = function PopoverMenuContainer(_ref) {
  var onSelectProp = _ref.onSelect,
    children = _ref.children;
  var onSelect = useCallback(function (name) {
    // Dispatch asynchronously so that the menu has enough time to close,
    setTimeout(function () {
      return onSelectProp === null || onSelectProp === void 0 ? void 0 : onSelectProp(name);
    }, 0);
  }, [onSelectProp]);
  return /*#__PURE__*/React.createElement(Dropdown, {
    onSelect: onSelect
  }, children);
};
var PopoverMenuTrigger = function PopoverMenuTrigger(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(Dropdown.Toggle, Object.assign({
    key: children.key,
    as: children.type,
    bsPrefix: "p-6"
  }, children.props));
};
var PopoverMenuItem = function PopoverMenuItem(_ref3) {
  var name = _ref3.name,
    children = _ref3.children;
  return /*#__PURE__*/React.createElement(StyledItem, {
    eventKey: name
  }, children);
};
var PopoverMenuDivider = function PopoverMenuDivider() {
  return /*#__PURE__*/React.createElement(StyledDivider, null);
};
var PopoverMenu = Object.assign(function (_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement(StyledMenu, null, children);
}, {
  Container: PopoverMenuContainer,
  Trigger: PopoverMenuTrigger,
  Item: PopoverMenuItem,
  Divider: PopoverMenuDivider
});

var formatGroupLabel$2 = function formatGroupLabel(group) {
  return /*#__PURE__*/React.createElement("div", null, group.label);
};
var removeFocusBox = {
  outline: 'none',
  webkitBoxShadow: 'none',
  boxShadow: 'none'
};
var colourStyles = {
  control: function control(styles, _ref) {
    var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused;
    return Object.assign(Object.assign({}, styles), {
      minHeight: 36,
      height: '100%',
      backgroundColor: isDisabled ? theme.grey20 : theme.primaryBlack,
      color: isDisabled ? theme.grey40 : theme.grey100,
      borderColor: isFocused ? theme.lochivarAccent2 : theme.grey40,
      opacity: isDisabled ? 0.6 : 1,
      outline: isFocused ? 'none' : '',
      boxShadow: 'none',
      borderWidth: 1,
      ':hover': Object.assign(Object.assign({}, styles[':hover']), {
        backgroundColor: theme.grey10,
        borderColor: theme.lochivarAccent1,
        color: theme.grey100
      })
    });
  },
  option: function option(styles, _ref2) {
    var isDisabled = _ref2.isDisabled,
      isFocused = _ref2.isFocused,
      isSelected = _ref2.isSelected;
    return Object.assign(Object.assign({}, styles), {
      backgroundColor: isDisabled ? theme.grey20 : isFocused ? theme.grey40 : isSelected ? theme.grey20 : theme.grey20,
      borderLeft: isSelected ? "5px solid ".concat(theme.lochivarAccent3) : "5px solid transparent",
      color: isFocused ? theme.grey100 : theme.grey70,
      height: '100%',
      minHeight: 36,
      fontSize: 14,
      lineHeight: '20px',
      cursor: isDisabled ? 'not-allowed' : 'default',
      ':active': Object.assign(Object.assign({}, styles[':active']), {
        backgroundColor: theme.grey40
      }),
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    });
  },
  groupHeading: function groupHeading(styles, props) {
    if (!props.data.label) {
      return Object.assign(Object.assign({}, styles), {
        height: 1,
        backgroundColor: theme.grey,
        margin: 0
      });
    } else {
      return Object.assign(Object.assign({}, styles), {
        display: 'flex',
        alignItems: 'center',
        margin: 0,
        minHeight: 36,
        height: '100%',
        backgroundColor: theme.grey20,
        color: theme.grey100,
        fontSize: 14,
        paddingLeft: 6,
        fontWeight: 'bold'
      });
    }
  },
  group: function group(styles) {
    return Object.assign(Object.assign({}, styles), {
      padding: 0
    });
  },
  input: function input(styles) {
    return Object.assign(Object.assign({}, styles), {
      color: theme.grey100,
      borderColor: theme.grey60
    });
  },
  placeholder: function placeholder(styles, _ref3) {
    var isDisabled = _ref3.isDisabled;
    return Object.assign(Object.assign({}, styles), {
      color: isDisabled ? theme.grey40 : theme.grey90
    });
  },
  singleValue: function singleValue(styles, _ref4) {
    var isDisabled = _ref4.isDisabled;
    return Object.assign(Object.assign(Object.assign({}, styles), {
      color: isDisabled ? theme.grey40 : theme.grey100
    }), removeFocusBox);
  },
  menu: function menu(styles) {
    return Object.assign(Object.assign({}, styles), {
      backgroundColor: theme.grey40,
      zIndex: 6,
      marginTop: 0,
      boxShadow: '0px 2px 6px 4px rgba(0,0,0,0.3)'
    });
  },
  dropdownIndicator: function dropdownIndicator(styles, _ref5) {
    var isDisabled = _ref5.isDisabled;
    return Object.assign(Object.assign({}, styles), {
      color: isDisabled ? theme.grey40 : theme.grey70,
      padding: 7
    });
  },
  menuList: function menuList(style) {
    return Object.assign(Object.assign({}, style), {
      zIndex: 5,
      padding: 0,
      border: "1px solid ".concat(theme.grey40),
      borderBottomLeftRadius: '4px',
      borderBottomRightRadius: '4px'
    });
  },
  indicatorSeparator: function indicatorSeparator(styles, _ref6) {
    var isDisabled = _ref6.isDisabled;
    return Object.assign(Object.assign({}, styles), {
      backgroundColor: isDisabled ? theme.grey30 : theme.grey30
    });
  },
  valueContainer: function valueContainer(styles) {
    return Object.assign(Object.assign({}, styles), {
      fontSize: 14
    });
  },
  noOptionsMessage: function noOptionsMessage(styles) {
    return Object.assign(Object.assign({}, styles), {
      backgroundColor: theme.grey20
    });
  },
  loadingMessage: function loadingMessage(styles) {
    return Object.assign(Object.assign({}, styles), {
      backgroundColor: theme.grey20,
      minHeight: 36
    });
  }
};

var Select = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var onChange = _a.onChange,
    label = _a.label,
    disabled = _a.disabled,
    style = _a.style,
    value = _a.value,
    disableLabel = _a.disableLabel,
    name = _a.name,
    modifyCustomStyle = _a.modifyCustomStyle,
    props = __rest(_a, ["onChange", "label", "disabled", "style", "value", "disableLabel", "name", "modifyCustomStyle"]);
  var Option = useCallback(function (props) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(components.Option, Object.assign({}, props, {
      innerProps: Object.assign(Object.assign({}, props.innerProps), {
        onMouseDown: function onMouseDown(e) {
          var _a, _b;
          if (props.data.shouldStopPropagation) {
            e.stopPropagation();
            (_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a);
          }
        }
      })
    })));
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    style: style
  }, label && (/*#__PURE__*/React.createElement(Label$1, {
    disabled: disableLabel,
    htmlFor: name
  }, label)), /*#__PURE__*/React.createElement(ReactSelect, Object.assign({
    ref: ref,
    formatGroupLabel: formatGroupLabel$2,
    inputId: name,
    isDisabled: disabled,
    name: name,
    value: value,
    onChange: onChange
  }, props, {
    components: {
      Option: Option
    },
    menuShouldScrollIntoView: false,
    styles: modifyCustomStyle ? modifyCustomStyle(colourStyles) : colourStyles
  })));
});

var SelectContainer$4 = styled.div.withConfig({
  displayName: "SelectContainer",
  componentId: "sc-1tmty4-0"
})(["width:100%;padding:20px;button{margin-top:25px;}", ""], function (_ref) {
  var hasMany = _ref.hasMany;
  return hasMany ? css([">:not(:last-child){margin-bottom:20px;}"]) : '';
});

var ImageContainer = styled.div.withConfig({
  displayName: "SelectDirectory__ImageContainer",
  componentId: "sc-1e4xg7q-0"
})(["display:flex:flex-direction:column;height:40px;img{padding-right:5px;margin-left:5px;}"]);
var CircleContainer = styled.div.withConfig({
  displayName: "SelectDirectory__CircleContainer",
  componentId: "sc-1e4xg7q-1"
})(["display:flex;gap:8px;"]);
var formatGroupLabel$1 = function formatGroupLabel(group) {
  return /*#__PURE__*/React.createElement("div", null, group.label);
};
var SelectDirectory = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var onChange = _a.onChange,
    label = _a.label,
    disabled = _a.disabled,
    style = _a.style,
    value = _a.value,
    disableLabel = _a.disableLabel,
    name = _a.name,
    modifyCustomStyle = _a.modifyCustomStyle,
    props = __rest(_a, ["onChange", "label", "disabled", "style", "value", "disableLabel", "name", "modifyCustomStyle"]);
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var defaultSelectedGroup = pathname.substring(pathname.lastIndexOf('/') + 1);
  var _useState = useState(defaultSelectedGroup),
    _useState2 = _slicedToArray(_useState, 2),
    selectedGroup = _useState2[0],
    setSelectedGroup = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    menuIsOpen = _useState4[0],
    setMenuIsOpen = _useState4[1];
  var removeFocusBox = {
    outline: 'none',
    webkitBoxShadow: 'none',
    boxShadow: 'none'
  };
  var Option = useCallback(function (props) {
    return /*#__PURE__*/React.createElement(ImageContainer, {
      style: {
        display: !props.data.label ? 'none' : ''
      }
    }, /*#__PURE__*/React.createElement(components.Option, Object.assign({}, props, {
      innerProps: Object.assign(Object.assign({}, props.innerProps), {
        onMouseDown: function onMouseDown(e) {
          var _a, _b;
          setSelectedGroup('');
          if (props.data.shouldStopPropagation) {
            e.stopPropagation();
            (_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a);
          }
        }
      })
    }), props.isSelected && /*#__PURE__*/React.createElement("img", {
      alt: "plus",
      src: img$n
    }), " ", props.children));
  }, []);
  var GroupHeading = function GroupHeading(props) {
    var _a;
    return /*#__PURE__*/React.createElement(UndecoratedLink, {
      to: String(props.data.options[0].value),
      onClick: function onClick() {
        setMenuIsOpen(false);
        setSelectedGroup(props.data.options.length <= 1 ? props.data.label || '' : '');
      }
    }, /*#__PURE__*/React.createElement(components.GroupHeading, Object.assign({}, props), /*#__PURE__*/React.createElement(CircleContainer, null, ((_a = props.data.label) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === selectedGroup.toUpperCase() ? (/*#__PURE__*/React.createElement("img", {
      alt: "circle",
      src: img$n
    })) : (/*#__PURE__*/React.createElement("img", {
      alt: "transparent_circle",
      src: img$o
    })), props.children)));
  };
  var colourStyles = {
    control: function control(styles, _ref) {
      var isDisabled = _ref.isDisabled,
        isFocused = _ref.isFocused;
      return Object.assign(Object.assign({}, styles), {
        marginLeft: 24,
        overflowY: 'hidden',
        minHeight: 36,
        backgroundColor: isDisabled ? theme.grey40 : theme.primaryBlack,
        color: isDisabled ? theme.grey40 : theme.grey100,
        borderColor: isFocused ? theme.lochivarAccent2 : theme.grey40,
        opacity: isDisabled ? 0.6 : 1,
        outline: isFocused ? 'none' : '',
        boxShadow: 'none',
        ':hover': Object.assign(Object.assign({}, styles[':hover']), {
          backgroundColor: theme.grey10,
          borderColor: theme.lochivarAccent1,
          color: theme.grey100
        })
      });
    },
    option: function option(styles, _ref2) {
      var isDisabled = _ref2.isDisabled,
        isSelected = _ref2.isSelected;
      return Object.assign(Object.assign({}, styles), {
        backgroundColor: isDisabled ? theme.grey20 : isSelected ? theme.grey20 : theme.grey20,
        ':hover': {
          backgroundColor: theme.grey40,
          color: theme.grey100
        },
        height: '100%',
        minHeight: 30,
        fontSize: 14,
        paddingLeft: isSelected ? '16px' : '38px',
        cursor: isDisabled ? 'not-allowed' : 'default',
        ':active': Object.assign(Object.assign({}, styles[':active']), {
          backgroundColor: theme.grey40
        })
      });
    },
    groupHeading: function groupHeading(styles) {
      return Object.assign(Object.assign({}, styles), {
        paddingLeft: 6,
        margin: 0,
        minHeight: 40,
        fontSize: 14,
        height: '100%',
        color: theme.grey100,
        backgroundColor: theme.grey20,
        ':hover': {
          backgroundColor: theme.grey40
        }
      });
    },
    group: function group(styles) {
      return Object.assign(Object.assign({}, styles), {
        padding: 0
      });
    },
    input: function input(styles) {
      return Object.assign(Object.assign({}, styles), {
        color: theme.grey100,
        borderColor: theme.grey60
      });
    },
    placeholder: function placeholder(styles, _ref3) {
      var isDisabled = _ref3.isDisabled;
      return Object.assign(Object.assign({}, styles), {
        color: isDisabled ? theme.grey40 : theme.grey90
      });
    },
    menu: function menu(styles) {
      return Object.assign(Object.assign({}, styles), {
        marginLeft: 23,
        zIndex: 2,
        width: '96%',
        marginTop: 1,
        backgroundColor: theme.grey20,
        boxShadow: '0px 2px 6px 4px rgba(0,0,0,0.3)'
      });
    },
    menuList: function menuList(style) {
      return Object.assign(Object.assign({}, style), {
        zIndex: 5,
        padding: 0,
        border: "1px solid ".concat(theme.grey40),
        borderBottomLeftRadius: '4px',
        borderBottomRightRadius: '2px',
        minHeight: 284
      });
    },
    dropdownIndicator: function dropdownIndicator(styles, _ref4) {
      var isDisabled = _ref4.isDisabled;
      return Object.assign(Object.assign({}, styles), {
        color: isDisabled ? theme.grey40 : theme.grey70,
        padding: 7
      });
    },
    indicatorSeparator: function indicatorSeparator(styles, _ref5) {
      var isDisabled = _ref5.isDisabled;
      return Object.assign(Object.assign({}, styles), {
        backgroundColor: isDisabled ? theme.grey30 : theme.grey30
      });
    },
    valueContainer: function valueContainer(styles) {
      return Object.assign(Object.assign({}, styles), {
        fontSize: 14
      });
    },
    noOptionsMessage: function noOptionsMessage(styles) {
      return Object.assign(Object.assign({}, styles), {
        backgroundColor: theme.grey20
      });
    },
    loadingMessage: function loadingMessage(styles) {
      return Object.assign(Object.assign({}, styles), {
        backgroundColor: theme.grey20,
        minHeight: 36
      });
    },
    singleValue: function singleValue(styles, _ref6) {
      var isDisabled = _ref6.isDisabled;
      return Object.assign(Object.assign(Object.assign({}, styles), {
        color: isDisabled ? theme.grey40 : theme.grey100
      }), removeFocusBox);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    style: style
  }, label && (/*#__PURE__*/React.createElement(Label$1, {
    disabled: disableLabel,
    htmlFor: name
  }, label)), /*#__PURE__*/React.createElement(ReactSelect, Object.assign({
    ref: ref,
    formatGroupLabel: formatGroupLabel$1,
    inputId: name,
    isDisabled: disabled,
    isSearchable: false,
    menuIsOpen: menuIsOpen,
    name: name,
    value: value,
    onChange: onChange,
    onMenuClose: function onMenuClose() {
      return setMenuIsOpen(false);
    },
    onMenuOpen: function onMenuOpen() {
      return setMenuIsOpen(true);
    }
  }, props, {
    components: {
      Option: Option,
      GroupHeading: GroupHeading
    },
    styles: modifyCustomStyle ? modifyCustomStyle(colourStyles) : colourStyles
  })));
});

var groupLabelStyle = {
  position: 'relative',
  marginTop: -8,
  marginBottom: -3,
  marginLeft: -11,
  marginRight: -11,
  height: 1,
  backgroundColor: theme.grey
};
var formatGroupLabel = function formatGroupLabel() {
  return /*#__PURE__*/React.createElement("div", {
    style: groupLabelStyle
  });
};
var SelectWithoutControl = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var options = _a.options,
    defaultValue = _a.defaultValue,
    onChange = _a.onChange,
    label = _a.label,
    disabled = _a.disabled,
    style = _a.style,
    disableLabel = _a.disableLabel,
    name = _a.name,
    shouldDisableOptions = _a.shouldDisableOptions,
    _onBlur = _a.onBlur,
    props = __rest(_a, ["options", "defaultValue", "onChange", "label", "disabled", "style", "disableLabel", "name", "shouldDisableOptions", "onBlur"]);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    firstSelectedOption = _useState2[0],
    setFirstSelectedOption = _useState2[1];
  var removeFocusBox = {
    outline: 'none',
    webkitBoxShadow: 'none',
    boxShadow: 'none'
  };
  useEffect(function () {
    if (defaultValue) {
      setFirstSelectedOption(defaultValue);
    }
  }, [defaultValue]);
  var Option = useCallback(function (props) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(components.Option, Object.assign({}, props, {
      innerProps: Object.assign(Object.assign({}, props.innerProps), {
        onMouseDown: function onMouseDown(e) {
          var _a, _b;
          if (shouldDisableOptions) {
            return;
          }
          if (props.data.shouldStopPropagation) {
            e.stopPropagation();
            (_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.onClick) === null || _b === void 0 ? void 0 : _b.call(_a);
          }
        }
      }),
      isDisabled: shouldDisableOptions || false
    })));
  }, [shouldDisableOptions]);
  var colourStyles = {
    control: function control(styles, _ref) {
      var isDisabled = _ref.isDisabled,
        isFocused = _ref.isFocused;
      return Object.assign(Object.assign({}, styles), {
        width: 120,
        marginTop: -4,
        marginLeft: -20,
        backgroundColor: 'transparent',
        color: theme.grey70,
        border: 'none',
        opacity: isDisabled ? 0.6 : 1,
        outline: isFocused ? 'none' : '',
        boxShadow: 'none',
        borderWidth: 1,
        ':hover': Object.assign(Object.assign({}, styles[':hover']), {
          backgroundColor: theme.grey10,
          borderColor: theme.lochivarAccent1,
          color: theme.grey100
        })
      });
    },
    option: function option(styles, _ref2) {
      var isDisabled = _ref2.isDisabled,
        isFocused = _ref2.isFocused,
        isSelected = _ref2.isSelected;
      return Object.assign(Object.assign({}, styles), {
        backgroundColor: isDisabled ? theme.grey20 : isFocused ? theme.grey30 : isSelected ? theme.grey20 : theme.grey20,
        borderLeft: isSelected ? "5px solid ".concat(theme.lochivarAccent3) : '',
        color: isFocused ? theme.grey100 : theme.grey70,
        height: 36,
        fontSize: 14,
        cursor: isDisabled ? 'not-allowed' : 'default',
        ':active': Object.assign(Object.assign({}, styles[':active']), {
          backgroundColor: theme.grey30
        })
      });
    },
    group: function group(styles) {
      return Object.assign(Object.assign({}, styles), {
        paddingBottom: 0
      });
    },
    input: function input(styles) {
      return Object.assign(Object.assign({}, styles), {
        color: theme.grey100,
        borderColor: theme.grey60
      });
    },
    placeholder: function placeholder(styles, _ref3) {
      var isDisabled = _ref3.isDisabled;
      return Object.assign(Object.assign({}, styles), {
        color: isDisabled ? theme.grey40 : theme.grey90
      });
    },
    singleValue: function singleValue(styles, _ref4) {
      var isDisabled = _ref4.isDisabled;
      return Object.assign(Object.assign(Object.assign({}, styles), {
        color: isDisabled ? theme.grey40 : theme.grey100,
        width: '100%',
        textAlign: 'left',
        overflow: 'auto'
      }), removeFocusBox);
    },
    menu: function menu(styles) {
      return Object.assign(Object.assign({}, styles), {
        width: 250,
        backgroundColor: theme.primaryBlack,
        zIndex: 6,
        marginTop: -5
      });
    },
    dropdownIndicator: function dropdownIndicator(styles, _ref5) {
      var isDisabled = _ref5.isDisabled;
      return Object.assign(Object.assign({}, styles), {
        paddingRight: 22,
        color: isDisabled ? theme.grey40 : theme.grey70
      });
    },
    menuList: function menuList(style) {
      return Object.assign(Object.assign({}, style), {
        zIndex: 5,
        borderRadius: 6
      });
    },
    indicatorSeparator: function indicatorSeparator(styles) {
      return Object.assign(Object.assign({}, styles), {
        display: 'none'
      });
    },
    valueContainer: function valueContainer(styles) {
      return Object.assign(Object.assign({}, styles), {
        overflow: 'none'
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    style: style
  }, label && (/*#__PURE__*/React.createElement(Label$1, {
    disabled: disableLabel,
    htmlFor: name
  }, label)), /*#__PURE__*/React.createElement(ReactSelect, Object.assign({}, props, {
    ref: ref,
    closeMenuOnSelect: false,
    components: {
      Option: Option
    },
    defaultValue: defaultValue,
    formatGroupLabel: formatGroupLabel,
    inputId: name,
    isClearable: false,
    isDisabled: disabled,
    isSearchable: false,
    menuPlacement: "auto",
    menuPosition: "fixed",
    name: name,
    options: options,
    styles: colourStyles,
    onBlur: function onBlur() {
      _onBlur && _onBlur(firstSelectedOption || undefined);
    },
    onChange: onChange
  })));
});

var Ball = styled.div.withConfig({
  displayName: "StatusBallWithText__Ball",
  componentId: "buqlpe-0"
})(["width:16px;height:16px;min-width:16px;min-height:16px;border-radius:10px;background-color:", ";"], function (_ref) {
  var $color = _ref.$color;
  return $color;
});
var Text$1 = styled.div.withConfig({
  displayName: "StatusBallWithText__Text",
  componentId: "buqlpe-1"
})(["margin-left:10px;"]);
var Container$9 = styled(Row$2).withConfig({
  displayName: "StatusBallWithText__Container",
  componentId: "buqlpe-2"
})(["align-items:center;"]);
var StatusBallWithText = function StatusBallWithText(_ref2) {
  var testId = _ref2.testId,
    color = _ref2.color,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement(Container$9, {
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(Ball, {
    "$color": color,
    "data-testid": "".concat(testId, "-ball")
  }), /*#__PURE__*/React.createElement(Text$1, null, children));
};

var SubHeader$1 = styled.div.withConfig({
  displayName: "SubHeader",
  componentId: "sc-1a1ur6c-0"
})(["display:flex;padding:11px 20px;z-index:1;border-bottom:1px solid ", ";justify-content:space-between;"], function (_ref) {
  var theme = _ref.theme;
  return theme.grey20;
});

var SwitchBackground = styled.div.withConfig({
  displayName: "SwitchButton__SwitchBackground",
  componentId: "dq8pq-0"
})(["bottom:0;left:0;right:0;top:0;position:absolute;-webkit-transition:background-color 0.2s;-moz-transition:background-color 0.2s;transition:background-color 0.2s;border-radius:34px;"]);
var SwitchLabel = styled.label.withConfig({
  displayName: "SwitchButton__SwitchLabel",
  componentId: "dq8pq-1"
})(["display:inline-block;height:31px;position:relative;width:56px;margin-bottom:0;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;"]);
var SwitchInput = styled.input.withConfig({
  displayName: "SwitchButton__SwitchInput",
  componentId: "dq8pq-2"
})(["width:0;border:1px solid #2a2a2a;visibility:hidden !important;height:0;overflow:hidden;"]);
var SwitchHandle = styled.div.withConfig({
  displayName: "SwitchButton__SwitchHandle",
  componentId: "dq8pq-3"
})(["bottom:2px;height:27px;left:2px;position:absolute;width:27px;border-radius:50%;transform:translateX(0);outline:none;", ";background-color:", ";"], function (_ref) {
  var $isChecked = _ref.$isChecked;
  return $isChecked ? 'transform: translateX(26px)' : '';
}, theme.fullWhite);
var SwitchButton = function SwitchButton(_a) {
  var checked = _a.checked,
    onChange = _a.onChange,
    onColor = _a.onColor,
    offColor = _a.offColor,
    focusShadow = _a.focusShadow,
    disabled = _a.disabled,
    testId = _a.testId,
    labelProps = __rest(_a, ["checked", "onChange", "onColor", "offColor", "focusShadow", "disabled", "testId"]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasOutline = _useState2[0],
    setOutline = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    lastMouseUpTime = _useState4[0],
    setMouseUpTime = _useState4[1];
  var handleChange = function handleChange() {
    onChange === null || onChange === void 0 ? void 0 : onChange(!checked);
  };
  var onMouseUp = function onMouseUp() {
    setMouseUpTime(Date.now());
  };
  useEffect(function () {
    window.addEventListener('mouseup', onMouseUp);
    return function () {
      window.removeEventListener('mouseup', onMouseUp);
    };
  }, []);
  return /*#__PURE__*/React.createElement(SwitchLabel, Object.assign({
    style: {
      cursor: disabled ? 'not-allowed' : 'pointer',
      filter: disabled ? 'brightness(0.8)' : 'unset'
    }
  }, labelProps, {
    "data-testid": testId
  }), /*#__PURE__*/React.createElement(SwitchBackground, {
    style: {
      backgroundColor: checked ? onColor || theme.lochivarAccent2 : offColor || theme.grey30
    }
  }), /*#__PURE__*/React.createElement(SwitchHandle, {
    "$isChecked": checked,
    "data-testid": "".concat(testId, "-handle"),
    style: {
      WebkitTransition: 'transform .2s',
      MozTransition: 'transform .2s',
      transition: 'transform .2s',
      boxShadow: hasOutline ? focusShadow || 'rgba(0,0,0,0.5) 0px 0px 2px 3px' : undefined
    }
  }), /*#__PURE__*/React.createElement(SwitchInput, {
    "aria-checked": checked,
    "data-testid": "".concat(testId, "-switch-input"),
    defaultChecked: checked,
    disabled: disabled,
    role: "switch",
    type: "checkbox",
    onBlur: function onBlur() {
      setOutline(false);
    },
    onChange: handleChange,
    onFocus: function onFocus() {
      // prevent focus after user clicked switch, allows keyboard to focus switch
      if (Date.now() - lastMouseUpTime > 25) {
        setOutline(true);
      }
    }
  }));
};

var img$j = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='82' height='82' viewBox='0 0 82 82'%3e %3cdefs%3e %3cclipPath id='clip-User'%3e %3crect width='82' height='82'/%3e %3c/clipPath%3e %3c/defs%3e %3cg id='User' clip-path='url(%23clip-User)'%3e %3cg id='noun_User_1994976' transform='translate(-3.913 -2.5)'%3e %3cg id='Group_2' data-name='Group 2' transform='translate(12.7 2.5)'%3e %3cg id='Group_1' data-name='Group 1'%3e %3cpath id='Path_1' data-name='Path 1' d='M61.84%2c48.965a1.293%2c1.293%2c0%2c0%2c0-1.555.086%2c25.591%2c25.591%2c0%2c0%2c1-15.372%2c5.009A26.175%2c26.175%2c0%2c0%2c1%2c29.54%2c49.052a1.451%2c1.451%2c0%2c0%2c0-1.555-.086C17.8%2c55.529%2c12.7%2c68.4%2c12.7%2c83.164c0%2c10.191%2c64.425%2c10.191%2c64.425%2c0C77.125%2c68.4%2c72.03%2c55.529%2c61.84%2c48.965Z' transform='translate(-12.7 -8.807)' fill='%238a959f'/%3e %3ccircle id='Ellipse_1' data-name='Ellipse 1' cx='19.259' cy='19.259' r='19.259' transform='translate(12.954)' fill='%238a959f'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var CardContainer = styled.div.withConfig({
  displayName: "UserCard__CardContainer",
  componentId: "sc-12wavg3-0"
})(["width:100%;min-width:320px;max-height:102px;display:flex;align-items:center;padding:8px 10px;border-radius:5px;background-color:", ";background-size:cover;color:", ";&:hover{background-color:", ";cursor:pointer;}", ""], theme.grey20, theme.grey100, theme.grey30, function (_ref) {
  var $disabled = _ref.$disabled;
  return $disabled ? css(["pointer-events:none;background-color:", ";color:", ";"], theme.grey10, theme.grey40) : '';
});
var CardContent$3 = styled.div.withConfig({
  displayName: "UserCard__CardContent",
  componentId: "sc-12wavg3-1"
})(["overflow:hidden;"]);
var CardText = styled.div.withConfig({
  displayName: "UserCard__CardText",
  componentId: "sc-12wavg3-2"
})(["", ";", ";"], function (_ref2) {
  var $bold = _ref2.$bold;
  return $bold ? 'font-weight: bold' : '';
}, function (_ref3) {
  var $small = _ref3.$small;
  return $small ? 'font-size: 12px; margin-top: 5px' : '';
});
var CardImageContainer = styled.div.withConfig({
  displayName: "UserCard__CardImageContainer",
  componentId: "sc-12wavg3-3"
})(["margin-right:30px;img{width:84px;height:84px;}"]);
var UserCard = function UserCard(_a) {
  var user = _a.user,
    disabled = _a.disabled,
    testId = _a.testId,
    props = __rest(_a, ["user", "disabled", "testId"]);
  return /*#__PURE__*/React.createElement(CardContainer, Object.assign({
    "data-testid": testId
  }, props, {
    "$disabled": disabled
  }), /*#__PURE__*/React.createElement(CardImageContainer, null, /*#__PURE__*/React.createElement("img", {
    alt: "picture",
    src: user.picture || img$j
  })), /*#__PURE__*/React.createElement(CardContent$3, null, /*#__PURE__*/React.createElement(CardText, {
    "$bold": true
  }, user.display_name), /*#__PURE__*/React.createElement(CardText, null, user.email), /*#__PURE__*/React.createElement(CardText, {
    "$small": true
  }, user.id)));
};

var TabContainer = styled.div.withConfig({
  displayName: "VerticalTab__TabContainer",
  componentId: "sc-1iu4v4-0"
})(["width:100%;display:flex;position:fixed;max-width:250px;flex-direction:column;height:100%;", " &:last-child{border-bottom:none;}"], function (_ref) {
  var theme = _ref.theme;
  return css(["border:1px solid ", ";"], theme.grey20);
});
var TabItem = styled.div.withConfig({
  displayName: "VerticalTab__TabItem",
  componentId: "sc-1iu4v4-1"
})(["padding:12px 20px;", " &:hover{color:", ";background-color:", ";}", ""], function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? css(["background-color:", ";border-bottom:1px solid ", ";color:", ";pointer-events:none;"], function (_ref3) {
    var theme = _ref3.theme;
    return theme.grey10;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.grey10;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.grey40;
  }) : css(["cursor:pointer;background-color:", ";border-bottom:1px solid ", ";color:", ";"], function (_ref6) {
    var theme = _ref6.theme;
    return theme.primaryBlack;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.grey20;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.grey70;
  });
}, theme.grey100, theme.grey10, function (_ref9) {
  var selected = _ref9.selected,
    theme = _ref9.theme;
  return selected ? css(["border-left:5px solid ", ";background-color:", ";color:", ";"], theme.lochivarAccent3, theme.grey10, theme.grey100) : css(["border-left:5px solid ", ";"], theme.primaryBlack);
});
var ComingSoonText = styled.span.withConfig({
  displayName: "VerticalTab__ComingSoonText",
  componentId: "sc-1iu4v4-2"
})(["color:", ";font-size:11px;"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.grey70;
});
var VerticalTab = function VerticalTab(_ref11) {
  var options = _ref11.options,
    selectedValue = _ref11.selectedValue,
    onChange = _ref11.onChange,
    title = _ref11.title,
    addVerticalTabButton = _ref11.addVerticalTabButton;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabContainer, null, title && (/*#__PURE__*/React.createElement(TabItem, null, /*#__PURE__*/React.createElement("h6", null, title))), options.map(function (option) {
    return /*#__PURE__*/React.createElement(TabItem, {
      key: option.value,
      "data-testid": option.value,
      disabled: option.isDisabled,
      hidden: option.hidden,
      selected: selectedValue === option.value,
      onClick: function onClick() {
        return onChange(option.value);
      }
    }, option.label, option.isDisabled && /*#__PURE__*/React.createElement(ComingSoonText, null, "\xA0(not available)"));
  }), addVerticalTabButton));
};

var LoadKeyFrame = keyframes(["0%{-o-transforms:translate(0px,0px),rotate(0deg);box-shadow:0px 40px 0px 0px #2F989C,0px -40px 0px 0px #2F989C,40px 0px 0px 0px #2F989C,-40px 0px 0px 0px #2F989C,40px 40px 0px 0px #2F989C,-40px -40px 0px 0px #2F989C,40px -40px 0px 0px #2F989C,-40px 40px 0px 0px #2F989C;}25%{box-shadow:0px 40px 0px 0px #2F989C,0px -40px 0px 0px #2F989C,40px 0px 0px 0px #2F989C,-40px 0px 0px 0px #2F989C,-40px -40px 0px 0px #2F989C,40px 40px 0px 0px #2F989C,-40px 40px 0px 0px #2F989C,40px -40px 0px 0px #2F989C;}50%{box-shadow:0px -40px 0px 0px #2F989C,0px 40px 0px 0px #2F989C,-40px 0px 0px 0px #2F989C,40px 0px 0px 0px #2F989C,-40px -40px 0px 0px #2F989C,40px 40px 0px 0px #2F989C,-40px 40px 0px 0px #2F989C,40px -40px 0px 0px #2F989C;}70%{box-shadow:0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C;}75%{box-shadow:0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C;height:10px;width:10px;}80%{-o-transforms:translate(0px,0px) rotate(360deg);box-shadow:0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C;background-color:#2F989C;height:40px;width:40px;}85%{-o-transforms:translate(0px,0px) rotate(360deg);box-shadow:0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C;background-color:#2F989C;height:40px;width:40px;}90%{-o-transforms:translate(0px,0px) rotate(360deg);box-shadow:0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C,0px 0px 0px 0px #2F989C;background-color:#2F989C;height:10px;width:10px;}95%{box-shadow:0px 40px 0px 0px #2F989C,0px -40px 0px 0px #2F989C,40px 0px 0px 0px #2F989C,-40px 0px 0px 0px #2F989C,40px 40px 0px 0px #2F989C,-40px -40px 0px 0px #2F989C,40px -40px 0px 0px #2F989C,-40px 40px 0px 0px #2F989C;}100%{-o-transforms:rotate(360deg);box-shadow:0px 40px 0px 0px #2F989C,0px -40px 0px 0px #2F989C,40px 0px 0px 0px #2F989C,-40px 0px 0px 0px #2F989C,40px 40px 0px 0px #2F989C,-40px -40px 0px 0px #2F989C,40px -40px 0px 0px #2F989C,-40px 40px 0px 0px #2F989C;}"]);
var Container$8 = styled.div.withConfig({
  displayName: "Spinner__Container",
  componentId: "sc-1hl5asj-0"
})(["width:80px;height:100px;position:relative;display:block;"]);
var Dots = styled.div.withConfig({
  displayName: "Spinner__Dots",
  componentId: "sc-1hl5asj-1"
})(["border-radius:100%;height:10px;width:10px;background-color:#2f989c;position:absolute;left:0;right:0;margin:auto;top:0;bottom:0;box-shadow:0px 40px 0px 0px #2f989c,0px -40px 0px 0px #2f989c,40px 0px 0px 0px #2f989c,-40px 0px 0px 0px #2f989c,40px 40px 0px 0px #2f989c,-40px -40px 0px 0px #2f989c,40px -40px 0px 0px #2f989c,-40px 40px 0px 0px #2f989c;animation:", " 3s infinite linear;"], LoadKeyFrame);
var Spinner = function Spinner(_ref) {
  var testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Container$8, {
    "data-testid": testId
  }, /*#__PURE__*/React.createElement(Dots, null));
};

var SpinnerContainer = styled.div.withConfig({
  displayName: "SpinnerFull__SpinnerContainer",
  componentId: "mmm8c6-0"
})(["display:flex;justify-content:center;align-items:center;background-color:", ";opacity:0.85;z-index:10000;height:100%;top:0;position:fixed;bottom:0;left:0;right:0;"], function (_ref) {
  var theme = _ref.theme;
  return theme.primaryBlack;
});
var SpinnerFull = function SpinnerFull() {
  return /*#__PURE__*/React.createElement(SpinnerContainer, {
    "data-testid": "spinner-full"
  }, /*#__PURE__*/React.createElement(Spinner, null));
};

var SpinnerContext = /*#__PURE__*/React.createContext({
  setSpinnerVisibility: function setSpinnerVisibility() {},
  isSpinnerVisible: false
});
var SpinnerToggle = function SpinnerToggle(_ref) {
  var _ref$show = _ref.show,
    show = _ref$show === void 0 ? true : _ref$show;
  var _useState = useState(Math.random().toString()),
    _useState2 = _slicedToArray(_useState, 1),
    randomId = _useState2[0];
  var _useContext = useContext(SpinnerContext),
    setSpinnerVisibility = _useContext.setSpinnerVisibility;
  useEffect(function () {
    return setSpinnerVisibility(randomId, show);
  }, [randomId, show, setSpinnerVisibility]);
  return null;
};
var SpinnerProvider = function SpinnerProvider(_ref2) {
  var children = _ref2.children;
  var _useState3 = useState(new Set()),
    _useState4 = _slicedToArray(_useState3, 2),
    spinnerSet = _useState4[0],
    setSpinnerSet = _useState4[1];
  var showSpinner = useMemo(function () {
    return spinnerSet.size !== 0;
  }, [spinnerSet.size]);
  var setSpinnerVisibility = useCallback(function (id, show) {
    show ? setSpinnerSet(function (prev) {
      return new Set([].concat(_toConsumableArray(prev), [id]));
    }) : setSpinnerSet(function (prev) {
      return new Set(_toConsumableArray(prev).filter(function (item) {
        return item !== id;
      }));
    });
    return function () {
      return setSpinnerSet(function (prev) {
        return new Set(_toConsumableArray(prev).filter(function (item) {
          return item !== id;
        }));
      });
    };
  }, []);
  return /*#__PURE__*/React.createElement(SpinnerContext.Provider, {
    value: {
      setSpinnerVisibility: setSpinnerVisibility,
      isSpinnerVisible: showSpinner
    }
  }, showSpinner && /*#__PURE__*/React.createElement(SpinnerFull, null), children);
};

var LeftContainer$2 = styled.div.withConfig({
  displayName: "VerticalTabsLayout__LeftContainer",
  componentId: "p75fy2-0"
})(["min-width:220px;margin-right:30px;@media (max-width:846px){display:none;}"]);
var RightContainer$1 = styled.div.withConfig({
  displayName: "VerticalTabsLayout__RightContainer",
  componentId: "p75fy2-1"
})(["padding-top:20px;flex:1;width:100%;height:calc(100% - 56px);@media (min-width:846px){overflow-x:hidden;height:100%;}"]);
var SelectContainer$3 = styled.div.withConfig({
  displayName: "VerticalTabsLayout__SelectContainer",
  componentId: "p75fy2-2"
})(["width:100%;display:none;margin-bottom:20px;@media (max-width:846px){display:block;width:100%;}"]);
var RowContainer = styled(Row$2).withConfig({
  displayName: "VerticalTabsLayout__RowContainer",
  componentId: "p75fy2-3"
})(["flex-wrap:wrap;overflow-x:hidden;height:100%;@media (max-width:846px){padding:40px 20px 0;overflow:auto;}"]);
var StyledPaddedContent = styled(PaddedContent).withConfig({
  displayName: "VerticalTabsLayout__StyledPaddedContent",
  componentId: "p75fy2-4"
})(["height:100%;"]);
var VerticalTabsLayout = function VerticalTabsLayout(_ref) {
  var verticalTabOptions = _ref.verticalTabOptions,
    defaultSelected = _ref.defaultSelected,
    isLoading = _ref.isLoading,
    children = _ref.children,
    onChange = _ref.onChange,
    value = _ref.value;
  var navigate = useNavigate();
  var location = useLocation();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  var queryParams = useQueryParam(location.search);
  var onChangeVerticalTab = function onChangeVerticalTab(value) {
    setSelectedTab(value);
    onChange && onChange(value);
  };
  useEffect(function () {
    if (value) {
      setSelectedTab(value);
    }
  }, [value]);
  var selectedOption = useMemo(function () {
    return verticalTabOptions.find(function (option) {
      return option.value === selectedTab;
    });
  }, [verticalTabOptions, selectedTab]);
  useEffect(function () {
    navigate("".concat(location.pathname, "?selected=").concat(selectedTab || defaultSelected));
  }, [selectedTab, navigate, defaultSelected, location.pathname]);
  var queryParamSelectedTab = queryParams.get('selected');
  useEffect(function () {
    if (queryParamSelectedTab && !selectedTab) {
      setSelectedTab(queryParamSelectedTab);
    }
  }, [selectedTab, queryParamSelectedTab]);
  return /*#__PURE__*/React.createElement(StyledPaddedContent, null, /*#__PURE__*/React.createElement(RowContainer, null, /*#__PURE__*/React.createElement(LeftContainer$2, null, /*#__PURE__*/React.createElement(VerticalTab, {
    options: verticalTabOptions,
    selectedValue: selectedTab,
    onChange: onChangeVerticalTab
  })), /*#__PURE__*/React.createElement(RightContainer$1, null, /*#__PURE__*/React.createElement(SelectContainer$3, null, /*#__PURE__*/React.createElement(Select, {
    "aria-label": "Select",
    options: verticalTabOptions,
    value: selectedOption,
    onChange: function onChange(option) {
      return option && onChangeVerticalTab(String(option.value));
    }
  })), isLoading ? (/*#__PURE__*/React.createElement(SpinnerToggle, null)) : Array.isArray(children) ? children.find(function (c) {
    return c.key === selectedTab;
  }) : children)));
};

var CardModalContainer = styled(Modal).withConfig({
  displayName: "WarningCardModal__CardModalContainer",
  componentId: "cwck6d-0"
})(["overflow:hidden;border-radius:20px;.modal-content{width:400px;margin:auto;border-radius:20px;}.modal-title{font-size:16px;}"]);
var Row = styled.div.withConfig({
  displayName: "WarningCardModal__Row",
  componentId: "cwck6d-1"
})(["display:flex;align-items:center;justify-content:center;margin-bottom:20px;flex:1;line-height:22px;overflow:scroll;"]);
var CardContent$2 = styled.div.withConfig({
  displayName: "WarningCardModal__CardContent",
  componentId: "cwck6d-2"
})(["color:", ";padding:20px;width:100%;"], function (_ref) {
  var theme = _ref.theme;
  return theme.grey100;
});
var StrongMessage = styled.span.withConfig({
  displayName: "WarningCardModal__StrongMessage",
  componentId: "cwck6d-3"
})(["font-weight:bold;text-transform:uppercase;"]);
var ButtonContainer$2 = styled.div.withConfig({
  displayName: "WarningCardModal__ButtonContainer",
  componentId: "cwck6d-4"
})(["display:flex;width:100%;justify-content:flex-end;"]);
var ModalButton = styled(Button).withConfig({
  displayName: "WarningCardModal__ModalButton",
  componentId: "cwck6d-5"
})(["width:110px;margin-left:10px;"]);
var warningMessage = 'Are you sure you want to perform this action?';
var WarningCardModal = function WarningCardModal(_ref2) {
  var _ref2$title = _ref2.title,
    title = _ref2$title === void 0 ? 'Action' : _ref2$title,
    onHide = _ref2.onHide,
    onClickAction = _ref2.onClickAction,
    _ref2$message = _ref2.message,
    message = _ref2$message === void 0 ? warningMessage : _ref2$message,
    _ref2$closeButtonText = _ref2.closeButtonText,
    closeButtonText = _ref2$closeButtonText === void 0 ? 'Cancel' : _ref2$closeButtonText,
    _ref2$performActionTe = _ref2.performActionText,
    performActionText = _ref2$performActionTe === void 0 ? 'Action' : _ref2$performActionTe;
  return /*#__PURE__*/React.createElement(CardModalContainer, {
    centered: true,
    "data-testid": "error-modal",
    show: !!message,
    onHide: onHide
  }, /*#__PURE__*/React.createElement(Card, {
    body: /*#__PURE__*/React.createElement(CardContent$2, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StrongMessage, null, "Warning"), ": ", message)), /*#__PURE__*/React.createElement(ButtonContainer$2, null, /*#__PURE__*/React.createElement(ModalButton, {
      variant: "secondary",
      onClick: onHide
    }, closeButtonText), /*#__PURE__*/React.createElement(ModalButton, {
      variant: "danger",
      onClick: onClickAction
    }, performActionText))),
    title: title,
    variant: "danger"
  }));
};

var DataContainer$1 = styled.div.withConfig({
  displayName: "styles__DataContainer",
  componentId: "sc-1kcwbfr-0"
})(["width:100%;@media (max-width:912px){padding-top:12px;}"]);
var TableWrapper$1 = styled.div.withConfig({
  displayName: "styles__TableWrapper",
  componentId: "sc-1kcwbfr-1"
})(["margin-top:64px;overflow-x:auto;table{margin-left:12px;}thead th{padding:14px 8px;text-align:left;font-size:14px;}thead th:first-child{min-width:12px;}thead th:last-child{min-width:24px;}tbody tr td{padding:14px;height:52px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;max-width:180px;}"]);
var ButtonContainer$1 = styled.div.withConfig({
  displayName: "styles__ButtonContainer",
  componentId: "sc-1kcwbfr-2"
})(["display:inline-flex;flex-direction:row;padding:12px;gap:12px;width:100%;background-color:", ";position:fixed;z-index:2;button{height:38px;}@media (max-width:912px){margin-left:12px;}"], theme.primaryBlack);
var ActionContainer = styled.div.withConfig({
  displayName: "styles__ActionContainer",
  componentId: "sc-1kcwbfr-3"
})(["display:inline-flex;gap:8px;margin-left:-12px;"]);
var Results = styled.div.withConfig({
  displayName: "styles__Results",
  componentId: "sc-1kcwbfr-4"
})(["display:inline-flex;gap:8px;img{width:16px;}"]);
var EmptyTableContainer$1 = styled.div.withConfig({
  displayName: "styles__EmptyTableContainer",
  componentId: "sc-1kcwbfr-5"
})(["margin-top:200px;"]);
var SelectWrapper = styled(Select).withConfig({
  displayName: "styles__SelectWrapper",
  componentId: "sc-1kcwbfr-6"
})(["margin-top:8px;font-weight:400;"]);
var FilterInput$1 = styled(Input).withConfig({
  displayName: "styles__FilterInput",
  componentId: "sc-1kcwbfr-7"
})(["font-size:14px;height:36px;"]);
var HeaderCheckbox = styled(Checkbox).withConfig({
  displayName: "styles__HeaderCheckbox",
  componentId: "sc-1kcwbfr-8"
})(["margin-top:39px;margin-left:6px;"]);

var img$i = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e %3c!--!Font Awesome Free 6.5.1 by %40fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons%2c Inc.--%3e %3cpath fill='%23692525' d='M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z' /%3e%3c/svg%3e";

var img$h = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e %3c!--!Font Awesome Free 6.5.1 by %40fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons%2c Inc.--%3e %3cpath fill='%23256927' d='M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z' /%3e%3c/svg%3e";

var img$g = "data:image/svg+xml,%3csvg width='100' height='101' viewBox='0 0 100 101' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M23 30.8047H4C1.79086 30.8047 0 32.5955 0 34.8047V96.8047C0 99.0138 1.79086 100.805 4 100.805H66C68.2091 100.805 70 99.0138 70 96.8047V77.8047H63V91.8047C63 92.9093 62.1043 93.8047 60.9997 93.8047H9.0003C7.89573 93.8047 7 92.9093 7 91.8047V39.8047C7 38.7001 7.89543 37.8047 9 37.8047H23V30.8047ZM30 37.8047H36V30.8047H30V37.8047ZM61 37.8047H43V30.8047H66C68.2091 30.8047 70 32.5955 70 34.8047V57.8047H63V39.8047C63 38.7001 62.1046 37.8047 61 37.8047ZM70 64.8047H63V70.8047H70V64.8047Z' fill='%23E7E7E7'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M34 0.804688C31.7909 0.804688 30 2.59555 30 4.80469V66.8047C30 69.0138 31.7909 70.8047 34 70.8047H96C98.2091 70.8047 100 69.0138 100 66.8047V4.80469C100 2.59555 98.2091 0.804688 96 0.804688H34ZM39 7.80469C37.8954 7.80469 37 8.70012 37 9.80469V61.8047C37 62.9093 37.8957 63.8047 39.0003 63.8047H90.9997C92.1043 63.8047 93 62.9093 93 61.8047V9.80469C93 8.70012 92.1046 7.80469 91 7.80469H39Z' fill='%23E7E7E7'/%3e%3c/svg%3e";

var DEFAULT_STATE = {
  enabled: false,
  visible: true
};
var DirectoryContext = /*#__PURE__*/React.createContext({
  model: {
    visible: false,
    code: '',
    setVisible: function setVisible() {},
    setCode: function setCode() {}
  },
  evaluator: {
    request: '',
    subjectType: '',
    subjectInstance: {
      label: '',
      value: ''
    },
    relationType: {
      label: '',
      value: ''
    },
    objectType: '',
    objectInstance: {
      label: '',
      value: ''
    },
    setRequest: function setRequest() {},
    setSubjectType: function setSubjectType() {},
    setSubjectInstance: function setSubjectInstance() {},
    setRelationType: function setRelationType() {},
    setObjectType: function setObjectType() {},
    setObjectInstance: function setObjectInstance() {}
  },
  data: {
    objectType: undefined,
    setObjectType: function setObjectType() {},
    subjectType: undefined,
    setSubjectType: function setSubjectType() {},
    relation: undefined,
    setRelation: function setRelation() {},
    objectIdPart: undefined,
    setObjectIdPart: function setObjectIdPart() {},
    subjectIdPart: undefined,
    setSubjectIdPart: function setSubjectIdPart() {},
    subjectRelation: undefined,
    setSubjectRelation: function setSubjectRelation() {},
    objectId: undefined,
    setObjectId: function setObjectId() {},
    subjectId: undefined,
    setSubjectId: function setSubjectId() {},
    relationsQueryKey: undefined,
    setRelationsQueryKey: function setRelationsQueryKey() {}
  },
  displayState: {
    canAddObject: DEFAULT_STATE,
    canAddRelation: DEFAULT_STATE,
    canDeleteDirectory: DEFAULT_STATE,
    canEditManifest: DEFAULT_STATE,
    canEditObject: DEFAULT_STATE,
    canRemoveRelation: DEFAULT_STATE,
    canAddAssertion: DEFAULT_STATE,
    canRemoveAssertion: DEFAULT_STATE,
    canEditAssertion: DEFAULT_STATE
  }
});
var useDirectoryContext = function useDirectoryContext() {
  return useContext(DirectoryContext);
};
var useDirectoryModelContext = function useDirectoryModelContext() {
  return useDirectoryContext().model;
};
var useDirectoryEvaluatorContext = function useDirectoryEvaluatorContext() {
  return useDirectoryContext().evaluator;
};
var useDirectoryDataContext = function useDirectoryDataContext() {
  return useDirectoryContext().data;
};
var useDirectoryDisplayState = function useDirectoryDisplayState() {
  return useDirectoryContext().displayState;
};
var DirectoryContextProvider = function DirectoryContextProvider(_ref) {
  var displayState = _ref.displayState,
    children = _ref.children;
  var _a, _b;
  // model State
  var location = useLocation();
  var _ref2 = location.state || {},
    object_type = _ref2.object_type,
    object_id = _ref2.object_id,
    subject_type = _ref2.subject_type,
    subject_id = _ref2.subject_id,
    check_relation = _ref2.relation;
  var object = ObjectGet(object_type, object_id);
  var subject = ObjectGet(subject_type, subject_id);
  var defaultRelationInstace = useMemo(function () {
    if (!check_relation) {
      return;
    }
    return {
      label: check_relation,
      value: check_relation
    };
  }, [check_relation]);
  var defaultObjectInstance = useMemo(function () {
    var _a;
    var obj = (_a = object.data) === null || _a === void 0 ? void 0 : _a.result;
    if (!obj) {
      return;
    }
    return {
      label: obj.display_name || obj.id,
      value: obj.id
    };
  }, [(_a = object.data) === null || _a === void 0 ? void 0 : _a.result]);
  var defaultSubjectInstance = useMemo(function () {
    var _a;
    var obj = (_a = subject.data) === null || _a === void 0 ? void 0 : _a.result;
    if (!obj) {
      return;
    }
    return {
      label: obj.display_name || obj.id,
      value: obj.id
    };
  }, [(_b = subject.data) === null || _b === void 0 ? void 0 : _b.result]);
  // model
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    code = _useState4[0],
    setCode = _useState4[1];
  var _useState5 = useState('check'),
    _useState6 = _slicedToArray(_useState5, 2),
    request = _useState6[0],
    setRequest = _useState6[1];
  var _useState7 = useState('user'),
    _useState8 = _slicedToArray(_useState7, 2),
    subjectType = _useState8[0],
    setSubjectType = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    subjectInstance = _useState10[0],
    setSubjectInstance = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    relationType = _useState12[0],
    setRelationType = _useState12[1];
  var _useState13 = useState('group'),
    _useState14 = _slicedToArray(_useState13, 2),
    objectType = _useState14[0],
    setObjectType = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    objectInstance = _useState16[0],
    setObjectInstance = _useState16[1];
  // data
  var _useState17 = useState(undefined),
    _useState18 = _slicedToArray(_useState17, 2),
    dataObjectType = _useState18[0],
    setDataObjectType = _useState18[1];
  var _useState19 = useState(undefined),
    _useState20 = _slicedToArray(_useState19, 2),
    dataSubjectType = _useState20[0],
    setDataSubjectType = _useState20[1];
  var _useState21 = useState(undefined),
    _useState22 = _slicedToArray(_useState21, 2),
    relation = _useState22[0],
    setRelation = _useState22[1];
  var _useState23 = useState(undefined),
    _useState24 = _slicedToArray(_useState23, 2),
    objectIdPart = _useState24[0],
    setObjectIdPart = _useState24[1];
  var _useState25 = useState(undefined),
    _useState26 = _slicedToArray(_useState25, 2),
    subjectIdPart = _useState26[0],
    setSubjectIdPart = _useState26[1];
  var _useState27 = useState(undefined),
    _useState28 = _slicedToArray(_useState27, 2),
    subjectRelation = _useState28[0],
    setSubjectRelation = _useState28[1];
  var _useState29 = useState(undefined),
    _useState30 = _slicedToArray(_useState29, 2),
    relationsQueryKey = _useState30[0],
    setRelationsQueryKey = _useState30[1];
  var _useState31 = useState(undefined),
    _useState32 = _slicedToArray(_useState31, 2),
    objectId = _useState32[0],
    setObjectId = _useState32[1];
  var _useState33 = useState(undefined),
    _useState34 = _slicedToArray(_useState33, 2),
    subjectId = _useState34[0],
    setSubjectId = _useState34[1];
  // default state
  useEffect(function () {
    defaultObjectInstance && setObjectInstance(defaultObjectInstance);
  }, [setObjectInstance, defaultObjectInstance]);
  useEffect(function () {
    defaultSubjectInstance && setSubjectInstance(defaultSubjectInstance);
  }, [setSubjectInstance, defaultSubjectInstance]);
  useEffect(function () {
    defaultRelationInstace && setRelationType(defaultRelationInstace);
  }, [setRelationType, defaultRelationInstace]);
  useEffect(function () {
    location.state !== null && setObjectType(object_type);
  }, [location.state, setObjectType, object_type]);
  useEffect(function () {
    location.state !== null && setSubjectType(subject_type);
  }, [location.state, setSubjectType, subject_type]);
  var value = useMemo(function () {
    return {
      model: {
        visible: visible,
        setVisible: setVisible,
        code: code,
        setCode: setCode
      },
      evaluator: {
        request: request,
        subjectType: subjectType,
        subjectInstance: subjectInstance,
        relationType: relationType,
        objectType: objectType,
        objectInstance: objectInstance,
        setRequest: setRequest,
        setSubjectType: setSubjectType,
        setSubjectInstance: setSubjectInstance,
        setRelationType: setRelationType,
        setObjectType: setObjectType,
        setObjectInstance: setObjectInstance
      },
      data: {
        objectType: dataObjectType,
        setObjectType: setDataObjectType,
        subjectType: dataSubjectType,
        setSubjectType: setDataSubjectType,
        relation: relation,
        setRelation: setRelation,
        objectIdPart: objectIdPart,
        setObjectIdPart: setObjectIdPart,
        subjectIdPart: subjectIdPart,
        setSubjectIdPart: setSubjectIdPart,
        subjectRelation: subjectRelation,
        setSubjectRelation: setSubjectRelation,
        objectId: objectId,
        setObjectId: setObjectId,
        subjectId: subjectId,
        setSubjectId: setSubjectId,
        relationsQueryKey: relationsQueryKey,
        setRelationsQueryKey: setRelationsQueryKey
      },
      displayState: displayState
    };
  }, [visible, setVisible, code, setCode, request, subjectType, subjectInstance, relationType, objectType, objectInstance, setRequest, setSubjectType, setSubjectInstance, setRelationType, setObjectType, setObjectInstance, dataObjectType, setDataObjectType, dataSubjectType, setDataSubjectType, relation, setRelation, objectIdPart, setObjectIdPart, subjectIdPart, setSubjectIdPart, subjectRelation, setSubjectRelation, objectId, subjectId, relationsQueryKey, setRelationsQueryKey, displayState]);
  return /*#__PURE__*/React.createElement(DirectoryContext.Provider, {
    value: value
  }, children);
};

var useIsScrollable = function useIsScrollable(_ref) {
  var isFetching = _ref.isFetching,
    hasMoreData = _ref.hasMoreData,
    fetchNextData = _ref.fetchNextData;
  var fetchData = useCallback(function () {
    fetchNextData();
  }, [fetchNextData]);
  useEffect(function () {
    if (document.body.scrollHeight <= document.body.clientHeight && !isFetching && hasMoreData) {
      setTimeout(function () {
        fetchData();
      }, 100);
    }
  }, [fetchData, fetchNextData, isFetching, hasMoreData]);
  return fetchData;
};

function useDebounce(value, delay) {
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    debouncedValue = _useState2[0],
    setDebouncedValue = _useState2[1];
  useEffect(function () {
    var timer = setTimeout(function () {
      return setDebouncedValue(value);
    }, delay || 500);
    return function () {
      clearTimeout(timer);
    };
  }, [value, delay]);
  return debouncedValue;
}

var SelectContainer$2 = styled.div.withConfig({
  displayName: "AssertionSelect__SelectContainer",
  componentId: "sc-1q76j3o-0"
})(["display:flex;flex-direction:row;padding:12px 0px;gap:8px;justify-content:center;> div:not(:last-child){width:156px;}label{white-space:nowrap;}"]);
var ButtonContainer = styled.div.withConfig({
  displayName: "AssertionSelect__ButtonContainer",
  componentId: "sc-1q76j3o-1"
})(["display:flex;align-items:flex-end;gap:8px;"]);
var AssertionSelect = function AssertionSelect(_ref) {
  var index = _ref.index,
    assertion = _ref.assertion,
    updateAssertionsList = _ref.updateAssertionsList,
    addItem = _ref.addItem,
    removeItem = _ref.removeItem,
    duplicateItem = _ref.duplicateItem;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
  var _ObjectTypesList = ObjectTypesList(),
    objectTypesData = _ObjectTypesList.data;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    subjectsFilter = _useState2[0],
    setSubjectsFilter = _useState2[1];
  var debouncedSubjectsFilter = useDebounce(subjectsFilter);
  var _ObjectsListInfinite = ObjectsListInfinite({
      object_type: (_a = assertion.check) === null || _a === void 0 ? void 0 : _a.subject_type,
      'page.size': 100,
      displayNamePart: debouncedSubjectsFilter
    }, {
      query: {
        enabled: !!((_b = assertion.check) === null || _b === void 0 ? void 0 : _b.subject_type)
      }
    }),
    subjectsData = _ObjectsListInfinite.data,
    hasMoreSubjects = _ObjectsListInfinite.hasNextPage,
    fetchNextSubjectsData = _ObjectsListInfinite.fetchNextPage;
  var subjects = useMemo(function () {
    var _a;
    return (_a = subjectsData === null || subjectsData === void 0 ? void 0 : subjectsData.pages.map(function (page) {
      return page.results || [];
    }).flat().map(function (object) {
      return {
        label: object.display_name || object.id,
        value: object.id
      };
    })) !== null && _a !== void 0 ? _a : [];
  }, [subjectsData === null || subjectsData === void 0 ? void 0 : subjectsData.pages]);
  var _ObjectGet = ObjectGet(((_c = assertion.check) === null || _c === void 0 ? void 0 : _c.subject_type) || '', ((_d = assertion.check) === null || _d === void 0 ? void 0 : _d.subject_id) || '', {}, {
      query: {
        enabled: !!((_e = assertion.check) === null || _e === void 0 ? void 0 : _e.subject_type) && !!((_f = assertion.check) === null || _f === void 0 ? void 0 : _f.subject_id)
      }
    }),
    selectedSubjectInstance = _ObjectGet.data;
  var selectedSubject = !!((_g = assertion.check) === null || _g === void 0 ? void 0 : _g.subject_type) && !!((_h = assertion.check) === null || _h === void 0 ? void 0 : _h.subject_id) ? {
    label: ((_j = selectedSubjectInstance === null || selectedSubjectInstance === void 0 ? void 0 : selectedSubjectInstance.result) === null || _j === void 0 ? void 0 : _j.display_name) || '',
    value: ((_k = selectedSubjectInstance === null || selectedSubjectInstance === void 0 ? void 0 : selectedSubjectInstance.result) === null || _k === void 0 ? void 0 : _k.id) || ''
  } : undefined;
  var _PermissionsList = PermissionsList({
      objectType: (_l = assertion.check) === null || _l === void 0 ? void 0 : _l.object_type
    }),
    permissionsData = _PermissionsList.data;
  var permissions = useMemo(function () {
    var _a;
    return ((_a = permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.results) === null || _a === void 0 ? void 0 : _a.map(function (p) {
      return {
        label: p.displayName || p.name,
        value: p.name
      };
    })) || [];
  }, [permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.results]);
  var _RelationTypesList = RelationTypesList(),
    relationTypesData = _RelationTypesList.data;
  var relations = useMemo(function () {
    var _a;
    return (_a = relationTypesData === null || relationTypesData === void 0 ? void 0 : relationTypesData.results) === null || _a === void 0 ? void 0 : _a.filter(function (relation) {
      var _a;
      return relation.objectType === ((_a = assertion.check) === null || _a === void 0 ? void 0 : _a.object_type);
    }).map(function (n) {
      return {
        label: n.displayName || n.name,
        value: n.name
      };
    });
  }, [(_m = assertion.check) === null || _m === void 0 ? void 0 : _m.object_type, relationTypesData === null || relationTypesData === void 0 ? void 0 : relationTypesData.results]);
  var relationsPermissions = useMemo(function () {
    return [{
      label: 'Relations',
      options: relations || []
    }, {
      label: 'Permissions',
      options: permissions || []
    }];
  }, [relations, permissions]);
  var objectTypes = useMemo(function () {
    var _a;
    if (!objectTypesData || !objectTypesData.results) {
      return [];
    }
    return (_a = objectTypesData === null || objectTypesData === void 0 ? void 0 : objectTypesData.results) === null || _a === void 0 ? void 0 : _a.map(function (o) {
      return {
        label: o.displayName || o.name,
        value: o.name
      };
    });
  }, [objectTypesData]);
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    objectsFilter = _useState4[0],
    setObjectsFilter = _useState4[1];
  var debouncedObjectsFilter = useDebounce(objectsFilter);
  var _ObjectsListInfinite2 = ObjectsListInfinite({
      object_type: (_o = assertion.check) === null || _o === void 0 ? void 0 : _o.object_type,
      'page.size': 100,
      displayNamePart: debouncedObjectsFilter
    }, {
      query: {
        enabled: !!((_p = assertion.check) === null || _p === void 0 ? void 0 : _p.object_type)
      }
    }),
    objectsData = _ObjectsListInfinite2.data,
    hasMoreObjects = _ObjectsListInfinite2.hasNextPage,
    fetchMoreObjects = _ObjectsListInfinite2.fetchNextPage;
  var objectInstances = useMemo(function () {
    var _a;
    return (_a = objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages.map(function (page) {
      return page.results || [];
    }).flat().map(function (object) {
      return {
        label: object.display_name || object.id,
        value: object.id
      };
    })) !== null && _a !== void 0 ? _a : [];
  }, [objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages]);
  var _ObjectGet2 = ObjectGet(((_q = assertion.check) === null || _q === void 0 ? void 0 : _q.object_type) || '', ((_r = assertion.check) === null || _r === void 0 ? void 0 : _r.object_id) || '', {}, {
      query: {
        enabled: !!((_s = assertion.check) === null || _s === void 0 ? void 0 : _s.object_type) && !!((_t = assertion.check) === null || _t === void 0 ? void 0 : _t.object_id)
      }
    }),
    selectedObjectInstance = _ObjectGet2.data;
  var selectedObject = !!((_u = assertion.check) === null || _u === void 0 ? void 0 : _u.object_type) && !!((_v = assertion.check) === null || _v === void 0 ? void 0 : _v.object_id) ? {
    label: ((_w = selectedObjectInstance === null || selectedObjectInstance === void 0 ? void 0 : selectedObjectInstance.result) === null || _w === void 0 ? void 0 : _w.display_name) || '',
    value: ((_x = selectedObjectInstance === null || selectedObjectInstance === void 0 ? void 0 : selectedObjectInstance.result) === null || _x === void 0 ? void 0 : _x.id) || ''
  } : undefined;
  var expectedOptions = [{
    label: 'True',
    value: 1
  }, {
    label: 'False',
    value: 0
  }];
  return /*#__PURE__*/React.createElement(SelectContainer$2, null, /*#__PURE__*/React.createElement(Select, {
    label: "Object Type",
    options: objectTypes,
    value: objectTypes.find(function (_ref2) {
      var value = _ref2.value;
      var _a;
      return value === ((_a = assertion.check) === null || _a === void 0 ? void 0 : _a.object_type);
    }),
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        updateAssertionsList(function (prev) {
          return prev.map(function (item, i) {
            if (i === index) {
              item = Object.assign(Object.assign({}, item), {
                check: Object.assign(Object.assign({}, item.check), {
                  object_type: String(option.value)
                })
              });
            }
            return item;
          });
        });
      }
    }
  }), /*#__PURE__*/React.createElement(Select, {
    label: "Instance",
    options: objectInstances,
    value: objectInstances.find(function (_ref3) {
      var value = _ref3.value;
      var _a;
      return value === ((_a = assertion.check) === null || _a === void 0 ? void 0 : _a.object_id);
    }) || selectedObject,
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        updateAssertionsList(function (prev) {
          return prev.map(function (item, i) {
            if (i === index) {
              item = Object.assign(Object.assign({}, item), {
                check: Object.assign(Object.assign({}, item.check), {
                  object_id: String(option.value)
                })
              });
            }
            return item;
          });
        });
      }
    },
    onInputChange: setObjectsFilter,
    onMenuScrollToBottom: function onMenuScrollToBottom() {
      hasMoreObjects && fetchMoreObjects && fetchMoreObjects();
    }
  }), /*#__PURE__*/React.createElement(Select, {
    label: "Relation",
    options: relationsPermissions,
    value: relationsPermissions.map(function (r) {
      return r.options;
    }).flat().find(function (_ref4) {
      var value = _ref4.value;
      var _a;
      return value === ((_a = assertion.check) === null || _a === void 0 ? void 0 : _a.relation);
    }),
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        updateAssertionsList(function (prev) {
          return prev.map(function (item, i) {
            if (i === index) {
              item = Object.assign(Object.assign({}, item), {
                check: Object.assign(Object.assign({}, item.check), {
                  relation: String(option.value)
                })
              });
            }
            return item;
          });
        });
      }
    }
  }), /*#__PURE__*/React.createElement(Select, {
    label: "Subject Type",
    options: objectTypes,
    value: objectTypes.find(function (_ref5) {
      var value = _ref5.value;
      var _a;
      return value === ((_a = assertion.check) === null || _a === void 0 ? void 0 : _a.subject_type);
    }),
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        updateAssertionsList(function (prev) {
          return prev.map(function (item, i) {
            if (i === index) {
              item = Object.assign(Object.assign({}, item), {
                check: Object.assign(Object.assign({}, item.check), {
                  subject_type: String(option.value)
                })
              });
            }
            return item;
          });
        });
      }
    }
  }), /*#__PURE__*/React.createElement(Select, {
    label: "Subject",
    options: subjects,
    value: subjects.find(function (_ref6) {
      var value = _ref6.value;
      var _a;
      return value === ((_a = assertion.check) === null || _a === void 0 ? void 0 : _a.subject_id);
    }) || selectedSubject,
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        updateAssertionsList(function (prev) {
          return prev.map(function (item, i) {
            if (i === index) {
              item = Object.assign(Object.assign({}, item), {
                check: Object.assign(Object.assign({}, item.check), {
                  subject_id: String(option.value)
                })
              });
            }
            return item;
          });
        });
      }
    },
    onInputChange: setSubjectsFilter,
    onMenuScrollToBottom: function onMenuScrollToBottom() {
      hasMoreSubjects && fetchNextSubjectsData && fetchNextSubjectsData();
    }
  }), /*#__PURE__*/React.createElement(Select, {
    label: "Expected",
    options: expectedOptions,
    value: expectedOptions.find(function (_ref7) {
      var value = _ref7.value;
      return !!value === assertion.expected;
    }),
    onChange: function onChange(option) {
      updateAssertionsList(function (prev) {
        return prev.map(function (item, i) {
          if (i === index) {
            item = Object.assign(Object.assign({}, item), {
              expected: !!(option === null || option === void 0 ? void 0 : option.value)
            });
          }
          return item;
        });
      });
    }
  }), /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: addItem
  }, "+"), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: function onClick() {
      return duplicateItem(index);
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "copy",
    src: img$p
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: function onClick() {
      return removeItem(index);
    }
  }, "-")));
};

var SelectContainer$1 = styled.div.withConfig({
  displayName: "EditAssertion__SelectContainer",
  componentId: "sc-1oie940-0"
})(["display:flex;flex-direction:row;gap:8px;justify-content:space-between;> div{width:180px;}"]);
var EditAssertion = function EditAssertion(_ref) {
  var assertion = _ref.assertion,
    setEditedAssertion = _ref.setEditedAssertion;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
  var _ObjectTypesList = ObjectTypesList(),
    objectTypesData = _ObjectTypesList.data;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    subjectsFilter = _useState2[0],
    setSubjectsFilter = _useState2[1];
  var debouncedSubjectsFilter = useDebounce(subjectsFilter);
  var _ObjectsListInfinite = ObjectsListInfinite({
      object_type: (_a = assertion.check) === null || _a === void 0 ? void 0 : _a.subject_type,
      'page.size': 100,
      displayNamePart: debouncedSubjectsFilter
    }, {
      query: {
        enabled: !!((_b = assertion.check) === null || _b === void 0 ? void 0 : _b.subject_type)
      }
    }),
    subjectsData = _ObjectsListInfinite.data,
    hasMoreSubjects = _ObjectsListInfinite.hasNextPage,
    fetchNextSubjectsData = _ObjectsListInfinite.fetchNextPage;
  var subjects = useMemo(function () {
    var _a;
    return (_a = subjectsData === null || subjectsData === void 0 ? void 0 : subjectsData.pages.map(function (page) {
      return page.results || [];
    }).flat().map(function (object) {
      return {
        label: object.display_name || object.id,
        value: object.id
      };
    })) !== null && _a !== void 0 ? _a : [];
  }, [subjectsData === null || subjectsData === void 0 ? void 0 : subjectsData.pages]);
  var _ObjectGet = ObjectGet(((_c = assertion.check) === null || _c === void 0 ? void 0 : _c.subject_type) || '', ((_d = assertion.check) === null || _d === void 0 ? void 0 : _d.subject_id) || '', {}, {
      query: {
        enabled: !!((_e = assertion.check) === null || _e === void 0 ? void 0 : _e.subject_type) && !!((_f = assertion.check) === null || _f === void 0 ? void 0 : _f.subject_id)
      }
    }),
    assertionSubjectInstance = _ObjectGet.data;
  var selectedSubject = {
    label: ((_g = assertionSubjectInstance === null || assertionSubjectInstance === void 0 ? void 0 : assertionSubjectInstance.result) === null || _g === void 0 ? void 0 : _g.display_name) || '',
    value: ((_h = assertionSubjectInstance === null || assertionSubjectInstance === void 0 ? void 0 : assertionSubjectInstance.result) === null || _h === void 0 ? void 0 : _h.id) || ''
  };
  var _PermissionsList = PermissionsList({
      objectType: (_j = assertion.check) === null || _j === void 0 ? void 0 : _j.object_type
    }),
    permissionsData = _PermissionsList.data;
  var permissions = useMemo(function () {
    var _a;
    return ((_a = permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.results) === null || _a === void 0 ? void 0 : _a.map(function (p) {
      return {
        label: p.displayName || p.name,
        value: p.name
      };
    })) || [];
  }, [permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.results]);
  var _RelationTypesList = RelationTypesList(),
    relationTypesData = _RelationTypesList.data;
  var relations = useMemo(function () {
    var _a;
    return (_a = relationTypesData === null || relationTypesData === void 0 ? void 0 : relationTypesData.results) === null || _a === void 0 ? void 0 : _a.filter(function (relation) {
      var _a;
      return relation.objectType === ((_a = assertion.check) === null || _a === void 0 ? void 0 : _a.object_type);
    }).map(function (n) {
      return {
        label: n.displayName || n.name,
        value: n.name
      };
    });
  }, [(_k = assertion.check) === null || _k === void 0 ? void 0 : _k.object_type, relationTypesData === null || relationTypesData === void 0 ? void 0 : relationTypesData.results]);
  var relationsPermissions = useMemo(function () {
    return [{
      label: 'Relations',
      options: relations || []
    }, {
      label: 'Permissions',
      options: permissions || []
    }];
  }, [relations, permissions]);
  var objectTypes = useMemo(function () {
    var _a;
    if (!objectTypesData || !objectTypesData.results) {
      return [];
    }
    return (_a = objectTypesData === null || objectTypesData === void 0 ? void 0 : objectTypesData.results) === null || _a === void 0 ? void 0 : _a.map(function (o) {
      return {
        label: o.displayName || o.name,
        value: o.name
      };
    });
  }, [objectTypesData]);
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    objectsFilter = _useState4[0],
    setObjectsFilter = _useState4[1];
  var debouncedObjectsFilter = useDebounce(objectsFilter);
  var _ObjectsListInfinite2 = ObjectsListInfinite({
      object_type: (_l = assertion.check) === null || _l === void 0 ? void 0 : _l.object_type,
      'page.size': 100,
      displayNamePart: debouncedObjectsFilter
    }, {
      query: {
        enabled: !!((_m = assertion.check) === null || _m === void 0 ? void 0 : _m.object_type)
      }
    }),
    objectsData = _ObjectsListInfinite2.data,
    hasMoreObjects = _ObjectsListInfinite2.hasNextPage,
    fetchMoreObjects = _ObjectsListInfinite2.fetchNextPage;
  var objectInstances = useMemo(function () {
    var _a;
    return (_a = objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages.map(function (page) {
      return page.results || [];
    }).flat().map(function (object) {
      return {
        label: object.display_name || object.id,
        value: object.id
      };
    })) !== null && _a !== void 0 ? _a : [];
  }, [objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages]);
  var _ObjectGet2 = ObjectGet(((_o = assertion.check) === null || _o === void 0 ? void 0 : _o.object_type) || '', ((_p = assertion.check) === null || _p === void 0 ? void 0 : _p.object_id) || '', {}, {
      query: {
        enabled: !!((_q = assertion.check) === null || _q === void 0 ? void 0 : _q.object_type) && !!((_r = assertion.check) === null || _r === void 0 ? void 0 : _r.object_id)
      }
    }),
    assertionObjectInstance = _ObjectGet2.data;
  var selectedObject = {
    label: ((_s = assertionObjectInstance === null || assertionObjectInstance === void 0 ? void 0 : assertionObjectInstance.result) === null || _s === void 0 ? void 0 : _s.display_name) || '',
    value: ((_t = assertionObjectInstance === null || assertionObjectInstance === void 0 ? void 0 : assertionObjectInstance.result) === null || _t === void 0 ? void 0 : _t.id) || ''
  };
  var expectedOptions = [{
    label: 'True',
    value: 1
  }, {
    label: 'False',
    value: 0
  }];
  return /*#__PURE__*/React.createElement(SelectContainer$1, null, /*#__PURE__*/React.createElement(Select, {
    label: "Object Type",
    options: objectTypes,
    value: objectTypes.find(function (_ref2) {
      var value = _ref2.value;
      var _a;
      return value === ((_a = assertion.check) === null || _a === void 0 ? void 0 : _a.object_type);
    }),
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        setEditedAssertion({
          check: Object.assign(Object.assign({}, assertion.check), {
            object_type: String(option.value),
            object_id: '',
            relation: ''
          }),
          expected: assertion.expected
        });
      }
    }
  }), /*#__PURE__*/React.createElement(Select, {
    label: "Instance",
    options: objectInstances,
    value: objectInstances.find(function (_ref3) {
      var value = _ref3.value;
      var _a;
      return value === ((_a = assertion.check) === null || _a === void 0 ? void 0 : _a.object_id);
    }) || selectedObject,
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        setEditedAssertion({
          check: Object.assign(Object.assign({}, assertion.check), {
            object_id: String(option.value)
          }),
          expected: assertion.expected
        });
      }
    },
    onInputChange: setObjectsFilter,
    onMenuScrollToBottom: function onMenuScrollToBottom() {
      hasMoreObjects && fetchMoreObjects && fetchMoreObjects();
    }
  }), /*#__PURE__*/React.createElement(Select, {
    label: "Relation",
    options: relationsPermissions,
    value: relationsPermissions.map(function (r) {
      return r.options;
    }).flat().find(function (_ref4) {
      var value = _ref4.value;
      var _a;
      return value === ((_a = assertion.check) === null || _a === void 0 ? void 0 : _a.relation);
    }),
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        setEditedAssertion({
          check: Object.assign(Object.assign({}, assertion.check), {
            relation: String(option.value)
          }),
          expected: assertion.expected
        });
      }
    }
  }), /*#__PURE__*/React.createElement(Select, {
    label: "Subject Type",
    options: objectTypes,
    value: objectTypes.find(function (_ref5) {
      var value = _ref5.value;
      var _a;
      return value === ((_a = assertion.check) === null || _a === void 0 ? void 0 : _a.subject_type);
    }),
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        setEditedAssertion({
          check: Object.assign(Object.assign({}, assertion.check), {
            subject_type: String(option.value),
            subject_id: ''
          }),
          expected: assertion.expected
        });
      }
    }
  }), /*#__PURE__*/React.createElement(Select, {
    label: "Subject",
    options: subjects,
    value: subjects.find(function (_ref6) {
      var value = _ref6.value;
      var _a;
      return value === ((_a = assertion.check) === null || _a === void 0 ? void 0 : _a.subject_id);
    }) || selectedSubject,
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        setEditedAssertion({
          check: Object.assign(Object.assign({}, assertion.check), {
            subject_id: String(option.value)
          }),
          expected: assertion.expected
        });
      }
    },
    onInputChange: setSubjectsFilter,
    onMenuScrollToBottom: function onMenuScrollToBottom() {
      hasMoreSubjects && fetchNextSubjectsData && fetchNextSubjectsData();
    }
  }), /*#__PURE__*/React.createElement(Select, {
    label: "Expected",
    options: expectedOptions,
    value: expectedOptions.find(function (_ref7) {
      var value = _ref7.value;
      return !!value === assertion.expected;
    }),
    onChange: function onChange(option) {
      setEditedAssertion({
        expected: !!(option === null || option === void 0 ? void 0 : option.value)
      });
    }
  }));
};

function _createForOfIteratorHelper$2(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$2(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$2(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$2(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$2(r, a) : void 0; } }
function _arrayLikeToArray$2(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var CardContent$1 = styled.div.withConfig({
  displayName: "AddAssertionsModal__CardContent",
  componentId: "f7ch7u-0"
})(["width:100%;padding:20px;&:first-child{color:", ";}@media (max-width:500px){font-size:14px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.grey100;
});
var ButtonsContainer$b = styled.div.withConfig({
  displayName: "AddAssertionsModal__ButtonsContainer",
  componentId: "f7ch7u-1"
})(["width:100%;flex:1 1 0%;justify-content:flex-end;align-items:flex-end;float:right;display:flex;margin-top:20px;button:first-of-type{margin-right:10px;}"]);
var AddAssertionsModal = function AddAssertionsModal(_ref2) {
  var onHide = _ref2.onHide,
    show = _ref2.show,
    assertionToEdit = _ref2.assertionToEdit;
  var emptyAssertion = {
    check: {
      object_id: '',
      object_type: '',
      subject_id: '',
      subject_type: '',
      relation: ''
    },
    expected: false
  };
  var _useState = useState([emptyAssertion]),
    _useState2 = _slicedToArray(_useState, 2),
    newAssertions = _useState2[0],
    setNewAssertions = _useState2[1];
  var showError = useShowError();
  var queryClient = useQueryClient();
  useEffect(function () {
    if (!!assertionToEdit) {
      setNewAssertions([assertionToEdit]);
    }
  }, [assertionToEdit]);
  var assertionsListQueryKey = AssertionsListQueryKey();
  var _AssertionSet = AssertionSet({
      mutation: {
        onError: function onError(e) {
          showError(e);
        },
        onSuccess: function onSuccess() {
          return queryClient.invalidateQueries(assertionsListQueryKey);
        }
      }
    }),
    addAssertion = _AssertionSet.mutate,
    isLoading = _AssertionSet.isLoading;
  var addAllAssertions = useCallback(function () {
    var _iterator = _createForOfIteratorHelper$2(newAssertions),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var a = _step.value;
        addAssertion({
          data: {
            assert: a
          }
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, [addAssertion, newAssertions]);
  var addItem = function addItem() {
    if (newAssertions.length) {
      setNewAssertions([].concat(_toConsumableArray(newAssertions), [emptyAssertion]));
    } else {
      setNewAssertions([emptyAssertion]);
    }
  };
  var removeItem = function removeItem(index) {
    setNewAssertions(newAssertions.filter(function (o, i) {
      return index !== i;
    }));
  };
  var duplicateItem = function duplicateItem(index) {
    var duplicate = newAssertions[index];
    setNewAssertions([].concat(_toConsumableArray(newAssertions), [duplicate]));
  };
  var clearModal = function clearModal() {
    setNewAssertions([emptyAssertion]);
    onHide();
  };
  var allAssertionsValid = useMemo(function () {
    return newAssertions.every(function (assertion) {
      var _a, _b, _c, _d;
      return !!((_a = assertion.check) === null || _a === void 0 ? void 0 : _a.object_type) && !!((_b = assertion.check) === null || _b === void 0 ? void 0 : _b.object_id) && !!((_c = assertion.check) === null || _c === void 0 ? void 0 : _c.subject_type) && !!((_d = assertion.check) === null || _d === void 0 ? void 0 : _d.subject_id) && assertion.expected !== undefined;
    });
  }, [newAssertions]);
  return /*#__PURE__*/React.createElement(CardModal, {
    cardHeight: "100%",
    cardWidth: "100%",
    centered: false,
    closeButton: true,
    minWidth: "700px",
    show: show,
    size: "xl",
    title: !!assertionToEdit ? 'Edit Assertion' : 'Add Assertions',
    onHide: clearModal
  }, /*#__PURE__*/React.createElement(CardContent$1, null, !!assertionToEdit ? (/*#__PURE__*/React.createElement(EditAssertion, {
    assertion: newAssertions[0],
    setEditedAssertion: function setEditedAssertion(assertion) {
      return setNewAssertions([Object.assign(Object.assign({}, newAssertions[0]), assertion)]);
    }
  })) : newAssertions.map(function (item, i) {
    return /*#__PURE__*/React.createElement(AssertionSelect, {
      key: i,
      addItem: addItem,
      assertion: item,
      duplicateItem: duplicateItem,
      index: i,
      removeItem: removeItem,
      updateAssertionsList: setNewAssertions
    });
  }), /*#__PURE__*/React.createElement(ButtonsContainer$b, null, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: clearModal
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "add-assertion",
    disabled: !allAssertionsValid || isLoading,
    type: "submit",
    onClick: function onClick() {
      addAllAssertions();
      clearModal();
    }
  }, !!assertionToEdit ? 'Save' : 'Confirm'))));
};

var ContentContainer$9 = styled.div.withConfig({
  displayName: "DirectoryDeleteModal__ContentContainer",
  componentId: "sc-1hf29bc-0"
})(["padding:20px;width:100%;"]);
var ButtonsContainer$a = styled.div.withConfig({
  displayName: "DirectoryDeleteModal__ButtonsContainer",
  componentId: "sc-1hf29bc-1"
})(["width:100%;flex:1 1 0%;justify-content:flex-end;align-items:flex-end;float:right;display:flex;margin-top:20px;button:first-of-type{margin-right:10px;}"]);
var DirectoryDeleteModal = function DirectoryDeleteModal(_ref) {
  var deleteData = _ref.deleteData,
    show = _ref.show,
    onHide = _ref.onHide,
    onClickRemove = _ref.onClickRemove,
    specificText = _ref.specificText;
  return /*#__PURE__*/React.createElement(CardModal, {
    cardHeight: "100%",
    show: show,
    title: "Delete ".concat(deleteData.type),
    variant: "delete_danger",
    onHide: onHide
  }, /*#__PURE__*/React.createElement(ContentContainer$9, null, /*#__PURE__*/React.createElement("div", null, specificText || "Delete the\n              ".concat(deleteData.type.toLocaleLowerCase(), "\n              \"").concat(deleteData.name, "\" from the directory.")), /*#__PURE__*/React.createElement(ButtonsContainer$a, null, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "cancel-btn",
    variant: "secondary",
    onClick: onHide
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "delete-".concat(deleteData.type.toLocaleLowerCase()),
    id: "delete-".concat(deleteData.type.toLocaleLowerCase()),
    variant: "danger",
    onClick: function onClick() {
      onClickRemove();
      onHide();
    }
  }, "Delete"))));
};

var customStyles = {
  control: function control(styles, _ref) {
    var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused;
    return Object.assign(Object.assign({}, styles), {
      width: 36,
      height: 36,
      backgroundColor: isFocused ? theme.grey40 : theme.grey20,
      border: "1px solid ".concat(theme.grey30),
      color: theme.grey70,
      opacity: isDisabled ? 0.6 : 1,
      outline: isFocused ? 'none' : '',
      boxShadow: 'none',
      borderWidth: 1,
      ':hover': Object.assign(Object.assign({}, styles[':hover']), {
        backgroundColor: theme.grey40,
        borderColor: theme.grey40
      })
    });
  },
  menuList: function menuList(styles) {
    return Object.assign(Object.assign({}, styles), {
      zIndex: -10,
      padding: 0,
      border: "1px solid ".concat(theme.grey60),
      marginRight: 58
    });
  },
  placeholder: function placeholder(styles) {
    return Object.assign(Object.assign({}, styles), {
      color: theme.grey100,
      fontWeight: '600'
    });
  },
  valueContainer: function valueContainer(styles) {
    return Object.assign(Object.assign({}, styles), {
      overflow: 'none',
      padding: 0
    });
  }
};

var AssertionRowOptions = function AssertionRowOptions(_ref) {
  var assertion = _ref.assertion,
    editAssertion = _ref.editAssertion;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showDeleteModal = _useState2[0],
    setShowDeleteModal = _useState2[1];
  var navigate = useNavigate();
  var displayState = useDirectoryDisplayState();
  var showError = useShowError();
  var queryClient = useQueryClient();
  var assertionsListQueryKey = AssertionsListQueryKey();
  var _AssertionSet = AssertionSet({
      mutation: {
        onError: function onError(e) {
          showError(e);
        },
        onSuccess: function onSuccess() {
          return queryClient.invalidateQueries(assertionsListQueryKey);
        }
      }
    }),
    addAssertion = _AssertionSet.mutate;
  var _AssertionDelete = AssertionDelete({
      mutation: {
        onError: function onError(e) {
          return showError(e);
        },
        onSuccess: function onSuccess() {
          return queryClient.invalidateQueries(assertionsListQueryKey);
        }
      }
    }),
    deleteAssertion = _AssertionDelete.mutate;
  var options = useMemo(function () {
    return [{
      label: 'Edit',
      value: 'edit',
      shouldStopPropagation: true,
      visible: displayState.canEditAssertion.enabled,
      onClick: editAssertion
    }, {
      label: 'Duplicate',
      value: 'duplicate',
      shouldStopPropagation: true,
      visible: displayState.canAddAssertion.enabled,
      onClick: function onClick() {
        return addAssertion({
          data: {
            assert: {
              check: assertion.check,
              expected: assertion.expected
            }
          }
        });
      }
    }, {
      label: 'Remove',
      value: 'remove',
      shouldStopPropagation: true,
      visible: displayState.canRemoveAssertion.enabled,
      onClick: function onClick() {
        return setShowDeleteModal(true);
      }
    }, {
      label: 'Open in Evaluator',
      value: 'open_in_evaluator',
      shouldStopPropagation: true,
      visible: true,
      onClick: function onClick() {
        return navigate('/ui/directory/evaluator', {
          state: assertion.check
        });
      }
    }];
  }, [addAssertion, assertion, editAssertion, navigate, displayState.canEditAssertion.enabled, displayState.canRemoveAssertion.enabled, displayState.canAddAssertion.enabled]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DirectoryDeleteModal, {
    deleteData: {
      type: 'assertion',
      name: ''
    },
    show: showDeleteModal,
    specificText: "Delete this assertion from directory.",
    onClickRemove: function onClickRemove() {
      return deleteAssertion({
        id: assertion.id
      });
    },
    onHide: function onHide() {
      return setShowDeleteModal(false);
    }
  }), /*#__PURE__*/React.createElement(OptionsSelect, {
    closeMenuOnScroll: function closeMenuOnScroll(e) {
      return e.target === document;
    },
    modifyCustomStyle: function modifyCustomStyle(style) {
      return Object.assign(Object.assign({}, style), customStyles);
    },
    options: options,
    placeholder: " "
  }));
};

var RunButton = styled(Button).withConfig({
  displayName: "CheckAssertion__RunButton",
  componentId: "sc-1ce59vy-0"
})(["display:flex;flex-direction:row;align-items:center;gap:4px;color:", ";"], theme.grey70);
var CheckAssertion$1 = function CheckAssertion(_ref) {
  var checkReq = _ref.checkReq,
    updateAssertions = _ref.updateAssertions;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    checkRequest = _useState2[0],
    setCheckRequest = _useState2[1];
  var _Check = Check(Object.assign({}, checkRequest), {
      enabled: !!checkRequest
    }),
    checkResult = _Check.data;
  var createCheckReq = useCallback(function () {
    setCheckRequest(checkReq);
  }, [checkReq]);
  useEffect(function () {
    if (!!checkResult) {
      updateAssertions(checkResult.check);
    }
  }, [checkResult, updateAssertions]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RunButton, {
    variant: "secondary-borderless",
    onClick: createCheckReq
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-play"
  }), " Run"));
};
var CheckAssertion$2 = /*#__PURE__*/memo(CheckAssertion$1);

var CheckAssertion = function CheckAssertion(_ref) {
  var checkRequests = _ref.checkRequests,
    updateAssertions = _ref.updateAssertions;
  var checkData = Checks(checkRequests);
  var isFetched = useMemo(function () {
    return checkData.every(function (c) {
      return c.isFetched;
    });
  }, [checkData]);
  useEffect(function () {
    if (isFetched) {
      updateAssertions(checkData);
    }
  }, [checkData, isFetched, updateAssertions]);
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
var CheckManyAssertions = /*#__PURE__*/memo(CheckAssertion);

var ExportOptions = function ExportOptions(_ref) {
  var exportSelected = _ref.exportSelected,
    exportAll = _ref.exportAll;
  var options = useMemo(function () {
    return [{
      label: 'Export Selected',
      value: 'export_selected',
      shouldStopPropagation: true,
      onClick: exportSelected
    }, {
      label: 'Export All',
      value: 'export_all',
      shouldStopPropagation: true,
      onClick: exportAll
    }];
  }, [exportSelected, exportAll]);
  return /*#__PURE__*/React.createElement(OptionsSelect, {
    closeMenuOnScroll: function closeMenuOnScroll(e) {
      return !(e.target === document);
    },
    modifyCustomStyle: function modifyCustomStyle(style) {
      return Object.assign(Object.assign({}, style), {
        menu: function menu(styles) {
          return Object.assign(Object.assign({}, styles), {
            width: 150,
            zIndex: 0,
            marginTop: 3,
            backgroundColor: 'none',
            marginLeft: 0
          });
        }
      });
    },
    options: options,
    placeholder: "Export"
  });
};

function _createForOfIteratorHelper$1(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$1(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$1(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0; } }
function _arrayLikeToArray$1(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var CardContent = styled.div.withConfig({
  displayName: "ImportAssertionsModal__CardContent",
  componentId: "sc-1pjdxmk-0"
})(["width:100%;padding:20px 40px;"]);
var ProgressContainer = styled.div.withConfig({
  displayName: "ImportAssertionsModal__ProgressContainer",
  componentId: "sc-1pjdxmk-1"
})(["padding:24px 0px;"]);
var ButtonsContainer$9 = styled.div.withConfig({
  displayName: "ImportAssertionsModal__ButtonsContainer",
  componentId: "sc-1pjdxmk-2"
})(["width:100%;flex:1 1 0%;justify-content:flex-end;align-items:flex-end;float:right;display:flex;margin-top:20px;"]);
var ErrorMessage$1 = styled.span.withConfig({
  displayName: "ImportAssertionsModal__ErrorMessage",
  componentId: "sc-1pjdxmk-3"
})(["text-align:left;color:", ";display:block;margin-bottom:12px;"], theme.mojoAccent1);
var UploadArea = styled.div.withConfig({
  displayName: "ImportAssertionsModal__UploadArea",
  componentId: "sc-1pjdxmk-4"
})(["margin-top:1.25rem;padding-left:24px;padding-right:24px;font-size:18px;font-weight:400;border:none;background-image:linear-gradient(to right,", " 50%,transparent 50%),linear-gradient(to right,", " 50%,transparent 50%),linear-gradient(to bottom,", " 50%,transparent 50%),linear-gradient(to bottom,", " 50%,transparent 50%);background-position:left top,left bottom,left top,right top;background-repeat:repeat-x,repeat-x,repeat-y,repeat-y;background-size:20px 2px,20px 2px,2px 20px,2px 20px;background-color:transparent;padding:3rem;width:100%;display:flex;cursor:pointer;flex-direction:column;align-items:center;&:hover,&:focus{background-image:linear-gradient(to right,", " 50%,transparent 50%),linear-gradient(to right,", " 50%,transparent 50%),linear-gradient(to bottom,", " 50%,transparent 50%),linear-gradient(to bottom,", " 50%,transparent 50%);background-position:left top,left bottom,left top,right top;background-repeat:repeat-x,repeat-x,repeat-y,repeat-y;background-size:20px 2px,20px 2px,2px 20px,2px 20px;}&.disabled{pointer-events:none;}"], theme.grey60, theme.grey60, theme.grey60, theme.grey60, theme.primary, theme.primary, theme.primary, theme.primary);
var ImportAssertionsModal = function ImportAssertionsModal(_ref) {
  var onHide = _ref.onHide,
    show = _ref.show;
  var _useState = useState('{}'),
    _useState2 = _slicedToArray(_useState, 2),
    files = _useState2[0],
    setFiles = _useState2[1];
  var queryClient = useQueryClient();
  var assertionsListQueryKey = AssertionsListQueryKey();
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    importCount = _useState4[0],
    setImportCount = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    done = _useState6[0],
    setDone = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    errors = _useState8[0],
    setErrors = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    assertionsToImport = _useState10[0],
    setassertionsToImport = _useState10[1];
  var onDrop = useCallback(function (acceptedFiles) {
    setassertionsToImport([]);
    setErrors([]);
    setImportCount(0);
    setDone(false);
    acceptedFiles.forEach(function (file) {
      var reader = new FileReader();
      reader.onabort = function () {
        return setErrors(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            error: 'file reading was aborted'
          }]);
        });
      };
      reader.onerror = function () {
        return setErrors(function (prev) {
          return [].concat(_toConsumableArray(prev), [{
            error: 'file reading has failed'
          }]);
        });
      };
      reader.onload = function () {
        var binaryStr = reader.result;
        setFiles(String(binaryStr));
      };
      reader.readAsText(file);
    });
  }, [setFiles, setErrors, setassertionsToImport, setImportCount, setDone]);
  var _useDropzone = useDropzone({
      onDrop: onDrop,
      multiple: false,
      accept: {
        'application/json': []
      }
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    open = _useDropzone.open;
  var parsedAssertionsToImport = useMemo(function () {
    var _a;
    try {
      return ((_a = JSON.parse(files)) === null || _a === void 0 ? void 0 : _a.assertions) || [];
    } catch (error) {
      setErrors(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          error: error.message
        }]);
      });
      return [];
    }
  }, [files, setErrors]);
  var _AssertionSet = AssertionSet({
      mutation: {
        onSuccess: function onSuccess() {
          queryClient.invalidateQueries(assertionsListQueryKey);
          setImportCount(function (prev) {
            return prev + 1;
          });
        },
        onError: function onError(error) {
          setErrors(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              assertionNumber: prev.length + 1,
              error: error.message
            }]);
          });
        }
      }
    }),
    addAssertion = _AssertionSet.mutate;
  var addAllAssertions = useCallback(function () {
    var _iterator = _createForOfIteratorHelper$1(assertionsToImport),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var a = _step.value;
        addAssertion({
          data: {
            assert: a
          }
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, [addAssertion, assertionsToImport]);
  var onClear = function onClear() {
    setImportCount(0);
    setassertionsToImport([]);
    setErrors([]);
    onHide();
  };
  useEffect(function () {
    setassertionsToImport(parsedAssertionsToImport);
  }, [setassertionsToImport, parsedAssertionsToImport]);
  useEffect(function () {
    addAllAssertions();
  }, [setDone, addAllAssertions]);
  useEffect(function () {
    if (assertionsToImport.length > 0 && assertionsToImport.length === importCount + errors.length) {
      var timeout = setTimeout(function () {
        setDone(true);
      }, 1000);
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [setDone, assertionsToImport.length, importCount, errors.length]);
  return /*#__PURE__*/React.createElement(CardModal, {
    cardHeight: "100%",
    cardWidth: "100%",
    centered: false,
    closeButton: true,
    minWidth: "700px",
    show: show,
    size: "lg",
    title: "Import Assertions",
    onHide: onClear
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(UploadArea, Object.assign({}, getRootProps({
    className: 'dropzone'
  }), {
    onClick: function onClick() {
      setassertionsToImport([]);
      setErrors([]);
      setDone(false);
      setImportCount(0);
      open();
    }
  }), /*#__PURE__*/React.createElement("input", Object.assign({}, getInputProps())), /*#__PURE__*/React.createElement("p", null, "Drag a file that contains JSON assertions, or click to select a file.")), /*#__PURE__*/React.createElement(ProgressContainer, null, /*#__PURE__*/React.createElement(ProgressBar, {
    hidden: assertionsToImport.length === 0,
    label: "Successfully imported ".concat(importCount, "/").concat(assertionsToImport.length, " assertions"),
    max: assertionsToImport.length,
    min: 0,
    now: importCount,
    style: {
      height: '32px',
      fontSize: '14px'
    },
    variant: "success",
    visuallyHidden: !done
  })), errors.map(function (error) {
    return /*#__PURE__*/React.createElement(ErrorMessage$1, {
      key: error.assertionNumber || 'general'
    }, error.assertionNumber ? "Assertion(".concat(error.assertionNumber, "): ").concat(error.error) : "".concat(error.error));
  }), /*#__PURE__*/React.createElement(ButtonsContainer$9, null, /*#__PURE__*/React.createElement(Button, {
    disabled: assertionsToImport.length > 0 && !done,
    variant: "secondary",
    onClick: onClear
  }, "Close"))));
};

var RunOptions = function RunOptions(_ref) {
  var runSelected = _ref.runSelected,
    runAll = _ref.runAll;
  var options = useMemo(function () {
    return [{
      label: 'Run Selected',
      value: 'selected',
      shouldStopPropagation: true,
      onClick: runSelected
    }, {
      label: 'Run All',
      value: 'all',
      shouldStopPropagation: true,
      onClick: runAll
    }];
  }, [runAll, runSelected]);
  return /*#__PURE__*/React.createElement(OptionsSelect, {
    closeMenuOnScroll: function closeMenuOnScroll(e) {
      return !(e.target === document);
    },
    modifyCustomStyle: function modifyCustomStyle(style) {
      return Object.assign(Object.assign({}, style), {
        menu: function menu(styles) {
          return Object.assign(Object.assign({}, styles), {
            width: 150,
            zIndex: 0,
            marginTop: 3,
            backgroundColor: 'none',
            marginLeft: 0
          });
        }
      });
    },
    options: options,
    placeholder: "Run"
  });
};

var useListAssertions = function useListAssertions() {
  var _AssertionsList = AssertionsList({
      'page.size': 100
    }),
    assertionsListData = _AssertionsList.data,
    isFetching = _AssertionsList.isFetching,
    hasNextPage = _AssertionsList.hasNextPage,
    fetchNextPage = _AssertionsList.fetchNextPage;
  var assertions = useMemo(function () {
    return (assertionsListData === null || assertionsListData === void 0 ? void 0 : assertionsListData.pages.flatMap(function (page) {
      return page.results || [];
    })) || [];
  }, [assertionsListData === null || assertionsListData === void 0 ? void 0 : assertionsListData.pages]);
  return {
    data: assertions,
    isFetching: isFetching,
    hasNextPage: hasNextPage,
    fetchNextPage: fetchNextPage
  };
};

var AssertionsTable = function AssertionsTable() {
  var _a;
  var _useListAssertions = useListAssertions(),
    assertionData = _useListAssertions.data,
    hasNextPage = _useListAssertions.hasNextPage,
    fetchNextPage = _useListAssertions.fetchNextPage,
    isFetching = _useListAssertions.isFetching;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAssertionsModal = _useState2[0],
    setShowAssertionsModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showImportAssertionsModal = _useState4[0],
    setShowImportAssertionsModal = _useState4[1];
  var displayState = useDirectoryDisplayState();
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    assertionToEdit = _useState6[0],
    setAssertionToEdit = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    checkedRows = _useState8[0],
    setCheckedRows = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    runRows = _useState10[0],
    setRunRows = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    runAll = _useState12[0],
    setRunAll = _useState12[1];
  var tableRef = useRef();
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    assertions = _useState14[0],
    setAssertions = _useState14[1];
  var isChecked = function isChecked(checkedRows, id) {
    return checkedRows.some(function (assertion) {
      return assertion.id === id;
    });
  };
  var isCheckedAll = function isCheckedAll() {
    var _a;
    var allChecked = new Set(checkedRows.map(function (c) {
      return c.id;
    }));
    var allAssertions = new Set((((_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.filteredRows) || []).map(function (row) {
      return row.original;
    }).map(function (a) {
      return a.id;
    }));
    return allAssertions.size !== 0 && allChecked.size === allAssertions.size && _toConsumableArray(allAssertions).every(function (value) {
      return allChecked.has(value);
    });
  };
  var downloadJson = useCallback(function (assertions) {
    var jsonString = "data:text/json;chatset=utf-8,".concat(encodeURIComponent(JSON.stringify({
      assertions: assertions.map(function (assertion) {
        return {
          check: assertion.check,
          expected: assertion.expected
        };
      })
    })));
    var link = document.createElement('a');
    link.href = jsonString;
    link.download = 'assertions.json';
    link.click();
  }, []);
  var _exportAll = function exportAll() {
    var _a;
    downloadJson((((_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.filteredRows) || []).map(function (row) {
      return row.original;
    }));
  };
  var _exportSelected = function exportSelected() {
    var _a;
    var allAssertions = new Set((((_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.filteredRows) || []).map(function (row) {
      return row.original;
    }).map(function (a) {
      return a.id;
    }));
    downloadJson(checkedRows.filter(function (row) {
      return allAssertions.has(row.id);
    }));
  };
  var InputFilter = function InputFilter(_ref) {
    var _ref$column = _ref.column,
      filterValue = _ref$column.filterValue,
      setFilter = _ref$column.setFilter;
    return /*#__PURE__*/React.createElement(FilterInput$1, {
      defaultValue: filterValue,
      onChange: function onChange(e) {
        setFilter(e.target.value);
      }
    });
  };
  useEffect(function () {
    if (assertionData.length) {
      setAssertions(function (prev) {
        return assertionData.map(function (assertion) {
          var _a;
          return Object.assign(Object.assign({}, assertion), {
            result: (_a = prev.find(function (prevAssertion) {
              return prevAssertion.id === assertion.id;
            })) === null || _a === void 0 ? void 0 : _a.result
          });
        });
      });
    }
  }, [assertionData]);
  var fetchData = useIsScrollable({
    isFetching: isFetching,
    hasMoreData: hasNextPage || false,
    fetchNextData: fetchNextPage
  });
  useCallback(function () {
    fetchData();
  }, [fetchData]);
  var DropdownFilter = function DropdownFilter(_ref2) {
    var _ref2$column = _ref2.column,
      filterValue = _ref2$column.filterValue,
      setFilter = _ref2$column.setFilter,
      preFilteredRows = _ref2$column.preFilteredRows,
      id = _ref2$column.id;
    var options = React.useMemo(function () {
      var options = new Set();
      preFilteredRows.forEach(function (row) {
        options.add(row.values[id]);
      });
      return [{
        label: 'All',
        value: ''
      }].concat(_toConsumableArray(options.values()).map(function (option) {
        return {
          value: option,
          label: option
        };
      }));
    }, [id, preFilteredRows]);
    return /*#__PURE__*/React.createElement(SelectWrapper, {
      defaultValue: {
        label: 'All',
        value: ''
      },
      options: options,
      value: options.find(function (option) {
        return option.value === filterValue;
      }),
      onChange: function onChange(e) {
        setFilter(e === null || e === void 0 ? void 0 : e.value);
      }
    });
  };
  var columns = [{
    id: 'Select',
    style: {
      cellWidth: '2%'
    },
    Header: function Header(_ref3) {
      var rows = _ref3.rows;
      return /*#__PURE__*/React.createElement(HeaderCheckbox, {
        checked: isCheckedAll(),
        onChange: function onChange(e) {
          e ? setCheckedRows(rows.map(function (row) {
            return row.original;
          })) : setCheckedRows([]);
        }
      });
    },
    Cell: function Cell(_ref4) {
      var row = _ref4.row;
      var _a = row.original;
        _a.result;
        var selectedRow = __rest(_a, ["result"]);
      var checked = isChecked(checkedRows, row.original.id);
      return /*#__PURE__*/React.createElement(Checkbox, {
        checked: checked,
        onChange: function onChange(e) {
          return e ? setCheckedRows(function (prev) {
            return [].concat(_toConsumableArray(prev), [selectedRow]);
          }) : setCheckedRows(function (prev) {
            return prev.filter(function (p) {
              return p.id !== row.original.id;
            });
          });
        }
      });
    }
  }, {
    Header: 'Object Type',
    style: {
      cellWidth: '14%'
    },
    Filter: DropdownFilter,
    accessor: function accessor(data) {
      var _a;
      return (_a = data.check) === null || _a === void 0 ? void 0 : _a.object_type;
    },
    disableSortBy: true
  }, {
    Header: 'Object ID',
    style: {
      cellWidth: '14%'
    },
    Filter: InputFilter,
    accessor: function accessor(data) {
      var _a;
      return (_a = data.check) === null || _a === void 0 ? void 0 : _a.object_id;
    },
    disableSortBy: true
  }, {
    Header: 'Relation',
    style: {
      cellWidth: '14%'
    },
    Filter: DropdownFilter,
    accessor: function accessor(data) {
      var _a;
      return (_a = data.check) === null || _a === void 0 ? void 0 : _a.relation;
    },
    disableSortBy: true
  }, {
    Header: 'Subject Type',
    style: {
      cellWidth: '14%'
    },
    Filter: DropdownFilter,
    accessor: function accessor(data) {
      var _a;
      return (_a = data.check) === null || _a === void 0 ? void 0 : _a.subject_type;
    },
    disableSortBy: true
  }, {
    Header: 'Subject ID',
    style: {
      cellWidth: '14%'
    },
    Filter: InputFilter,
    accessor: function accessor(data) {
      var _a;
      return (_a = data.check) === null || _a === void 0 ? void 0 : _a.subject_id;
    },
    disableSortBy: true
  }, {
    id: 'expected',
    Header: 'Expected',
    style: {
      cellWidth: '8%'
    },
    Filter: DropdownFilter,
    accessor: function accessor(data) {
      return String(data.expected);
    },
    disableSortBy: true
  }, {
    Header: 'Action',
    style: {
      cellWidth: '8%'
    },
    Cell: function Cell(_ref5) {
      var row = _ref5.row;
      var _row$original = row.original,
        id = _row$original.id,
        expected = _row$original.expected;
        _row$original.result;
        var check = _row$original.check;
      return /*#__PURE__*/React.createElement(ActionContainer, null, /*#__PURE__*/React.createElement(CheckAssertion$2, {
        checkReq: check,
        updateAssertions: function updateAssertions(check) {
          setAssertions(function (prev) {
            return prev.map(function (a) {
              if (a.id === row.original.id) {
                return Object.assign(Object.assign({}, a), {
                  result: check === a.expected ? 'Pass' : 'Fail'
                });
              }
              return a;
            });
          });
        }
      }), /*#__PURE__*/React.createElement(AssertionRowOptions, {
        assertion: {
          id: id,
          expected: expected,
          check: check
        },
        editAssertion: function editAssertion() {
          setAssertionToEdit({
            id: id,
            expected: expected,
            check: check
          });
          setShowAssertionsModal(true);
        }
      }));
    },
    disableSortBy: true
  }, {
    Header: 'Result',
    style: {
      cellWidth: '8%'
    },
    Cell: function Cell(_ref6) {
      var row = _ref6.row;
      return /*#__PURE__*/React.createElement(Results, null, row.original.result === 'Pass' && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
        alt: "pass",
        className: "pass",
        src: img$h
      }), /*#__PURE__*/React.createElement("span", null, "Pass"))), row.original.result === 'Fail' && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
        alt: "fail",
        className: "fail",
        src: img$i
      }), /*#__PURE__*/React.createElement("span", null, "Fail"))));
    },
    disableSortBy: true
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AddAssertionsModal, {
    assertionToEdit: assertionToEdit,
    show: showAssertionsModal,
    onHide: function onHide() {
      setShowAssertionsModal(false);
      setAssertionToEdit(undefined);
    }
  }), /*#__PURE__*/React.createElement(ImportAssertionsModal, {
    show: showImportAssertionsModal,
    onHide: function onHide() {
      setShowImportAssertionsModal(false);
    }
  }), /*#__PURE__*/React.createElement(ButtonContainer$1, null, /*#__PURE__*/React.createElement(RunOptions, {
    runAll: function runAll() {
      setRunAll(true);
    },
    runSelected: function runSelected() {
      return setRunRows(true);
    }
  }), /*#__PURE__*/React.createElement(ExportOptions, {
    exportAll: function exportAll() {
      _exportAll();
    },
    exportSelected: function exportSelected() {
      _exportSelected();
    }
  }), /*#__PURE__*/React.createElement(EvaluateDisplayState, {
    displayState: displayState.canAddAssertion
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setShowAssertionsModal(true);
    }
  }, "Add Assertion"), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return setShowImportAssertionsModal(true);
    }
  }, "Import Assertions")))), (runRows || runAll) && (/*#__PURE__*/React.createElement(CheckManyAssertions, {
    checkRequests: runRows ? checkedRows.map(function (c) {
      var check = c.check;
      return check;
    }) : (((_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.filteredRows) || []).map(function (row) {
      return row.original.check;
    }),
    updateAssertions: function updateAssertions(checkResultData) {
      setAssertions(function (prev) {
        return prev.map(function (assertion) {
          var _a, _b;
          var rows = runRows ? checkedRows : (((_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.filteredRows) || []).map(function (row) {
            return row.original;
          });
          var index = rows.findIndex(function (a) {
            return a.id === assertion.id;
          });
          if (index > -1) {
            var check = (_b = checkResultData[index].data) === null || _b === void 0 ? void 0 : _b.check;
            var result = assertion.expected === check ? 'Pass' : 'Fail';
            return Object.assign(Object.assign({}, assertion), {
              result: result
            });
          }
          return assertion;
        });
      });
      setRunRows(false);
      setRunAll(false);
    }
  })), !!assertions.length ? (/*#__PURE__*/React.createElement(TableWrapper$1, null, /*#__PURE__*/React.createElement(_DataTable, {
    columns: columns,
    data: assertions,
    mRef: tableRef,
    paging: {
      dataLength: assertions.length,
      loadingContent: [{
        id: 0,
        check: {
          object_type: '...',
          object_id: '...',
          relation: '...',
          subject_type: '...',
          subject_id: '...'
        },
        expected: true
      }],
      hasMore: function hasMore() {
        return !!hasNextPage;
      },
      getNext: function getNext() {
        return fetchNextPage();
      }
    },
    sticky: true
  }))) : (/*#__PURE__*/React.createElement(EmptyTableContainer$1, null, /*#__PURE__*/React.createElement(EmptyTablePlaceholder, {
    body: "",
    header: "No assertions",
    imgAlt: "Empty Directory",
    imgSrc: img$g
  }))));
};

var Assertions = function Assertions() {
  return /*#__PURE__*/React.createElement(DataContainer$1, null, /*#__PURE__*/React.createElement(AssertionsTable, null));
};

var img$f = "data:image/svg+xml,%3csvg version='1.2' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' overflow='visible' preserveAspectRatio='none' viewBox='0 0 12 12' width='12' height='12'%3e%3cg transform='translate(0%2c 0)'%3e%3cdefs%3e%3cpath id='path-161601693481644' d='M9.343705799151346 20.144271570014144 C9.343705799151346 20.144271570014144 14.144271570014148 15.343705799151346 14.144271570014148 15.343705799151346 C14.144271570014148 15.343705799151346 18.944837340876948 20.144271570014144 18.944837340876948 20.144271570014144 C18.944837340876948 20.144271570014144 20.144271570014144 18.944837340876948 20.144271570014144 18.944837340876948 C20.144271570014144 18.944837340876948 15.343705799151346 14.144271570014148 15.343705799151346 14.144271570014148 C15.343705799151346 14.144271570014148 20.144271570014144 9.343705799151346 20.144271570014144 9.343705799151346 C20.144271570014144 9.343705799151346 18.944837340876948 8.144271570014146 18.944837340876948 8.144271570014146 C18.944837340876948 8.144271570014146 14.144271570014148 12.944837340876944 14.144271570014148 12.944837340876944 C14.144271570014148 12.944837340876944 9.343705799151346 8.144271570014146 9.343705799151346 8.144271570014146 C9.343705799151346 8.144271570014146 8.144271570014146 9.343705799151346 8.144271570014146 9.343705799151346 C8.144271570014146 9.343705799151346 12.944837340876944 14.144271570014148 12.944837340876944 14.144271570014148 C12.944837340876944 14.144271570014148 8.144271570014146 18.944837340876948 8.144271570014146 18.944837340876948 C8.144271570014146 18.944837340876948 9.343705799151346 20.144271570014144 9.343705799151346 20.144271570014144 Z' vector-effect='non-scaling-stroke'/%3e%3c/defs%3e%3cg transform='translate(-8.144271570014146%2c -8.144271570014146)'%3e%3cpath d='M9.343705799151346 20.144271570014144 C9.343705799151346 20.144271570014144 14.144271570014148 15.343705799151346 14.144271570014148 15.343705799151346 C14.144271570014148 15.343705799151346 18.944837340876948 20.144271570014144 18.944837340876948 20.144271570014144 C18.944837340876948 20.144271570014144 20.144271570014144 18.944837340876948 20.144271570014144 18.944837340876948 C20.144271570014144 18.944837340876948 15.343705799151346 14.144271570014148 15.343705799151346 14.144271570014148 C15.343705799151346 14.144271570014148 20.144271570014144 9.343705799151346 20.144271570014144 9.343705799151346 C20.144271570014144 9.343705799151346 18.944837340876948 8.144271570014146 18.944837340876948 8.144271570014146 C18.944837340876948 8.144271570014146 14.144271570014148 12.944837340876944 14.144271570014148 12.944837340876944 C14.144271570014148 12.944837340876944 9.343705799151346 8.144271570014146 9.343705799151346 8.144271570014146 C9.343705799151346 8.144271570014146 8.144271570014146 9.343705799151346 8.144271570014146 9.343705799151346 C8.144271570014146 9.343705799151346 12.944837340876944 14.144271570014148 12.944837340876944 14.144271570014148 C12.944837340876944 14.144271570014148 8.144271570014146 18.944837340876948 8.144271570014146 18.944837340876948 C8.144271570014146 18.944837340876948 9.343705799151346 20.144271570014144 9.343705799151346 20.144271570014144 Z' style='stroke-width: 0%3b stroke-linecap: butt%3b stroke-linejoin: miter%3b fill: %23e7e7e7%3b' vector-effect='non-scaling-stroke'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

var SuccessContent = styled.div.withConfig({
  displayName: "style__SuccessContent",
  componentId: "un4fd9-0"
})(["height:31px;width:304px;display:flex;top:0;transition:top 0.75s ease-out;", ";align-items:center;justify-content:center;margin:auto;position:fixed;left:calc(50% - 152px);font-weight:bold;font-size:14px;border-bottom-left-radius:6px;border-bottom-right-radius:6px;z-index:11;color:", ";background-color:", ";@media (max-width:720px){width:100%;height:16px;font-size:12px;left:0;}img{cursor:pointer;width:11px;height:11px;right:10px;position:absolute;}"], function (_ref) {
  var show = _ref.show;
  return show ? 'top: 0' : 'top: -31px';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.grey100;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.apple50;
});

var SuccessMessageContext = /*#__PURE__*/React.createContext({
  clearMessage: function clearMessage() {},
  showMessage: function showMessage() {}
});
var useShowSuccessMessage = function useShowSuccessMessage() {
  var _useContext = useContext(SuccessMessageContext),
    showMessage = _useContext.showMessage;
  return showMessage;
};
var SuccessBannerProvider = function SuccessBannerProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    message = _useState2[0],
    setMessage = _useState2[1];
  var clearMessage = useCallback(function () {
    return setMessage(null);
  }, []);
  var showMessage = useCallback(function (message) {
    return setMessage(message);
  }, []);
  return /*#__PURE__*/React.createElement(SuccessMessageContext.Provider, {
    value: {
      clearMessage: clearMessage,
      showMessage: showMessage
    }
  }, /*#__PURE__*/React.createElement(SuccessContent, {
    show: !!message
  }, message, /*#__PURE__*/React.createElement("img", {
    alt: "close success banner",
    src: img$f,
    onClick: clearMessage
  })), children);
};

var DeleteContainer = styled.div.withConfig({
  displayName: "DangerZone__DeleteContainer",
  componentId: "sc-112oe8p-0"
})(["font-family:Roboto;padding:22px 30px;"]);
var Text = styled.div.withConfig({
  displayName: "DangerZone__Text",
  componentId: "sc-112oe8p-1"
})(["font-weight:", ";font-size:", ";color:", ";padding-top:8px;"], function (_ref) {
  var bold = _ref.bold;
  return bold ? 'bold' : 100;
}, function (_ref2) {
  var size = _ref2.size;
  return size;
}, function (_ref3) {
  var color = _ref3.color;
  return color;
});
var Hr = styled.hr.withConfig({
  displayName: "DangerZone__Hr",
  componentId: "sc-112oe8p-2"
})(["margin:30px 0 22px;"]);
var DangerZone = function DangerZone() {
  var navigate = useNavigate();
  var _useDirectoryModelCon = useDirectoryModelContext(),
    setCode = _useDirectoryModelCon.setCode;
  var _useFeatureFlags = useFeatureFlags(),
    hasTemplates = _useFeatureFlags.hasTemplates;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showDeleteModal = _useState2[0],
    setShowDeleteModal = _useState2[1];
  var showError = useShowError();
  var showSuccessMessage = useShowSuccessMessage();
  var _ManifestDelete = ManifestDelete({
      mutation: {
        onError: function onError(error) {
          showError(error);
        },
        onSuccess: function onSuccess() {
          setCode('');
          setShowDeleteModal(false);
          showSuccessMessage('Directory deleted successfully');
        }
      }
    }),
    deleteManifest = _ManifestDelete.mutate,
    isDeletingManifest = _ManifestDelete.isLoading;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DeleteConfirmationModal, {
    entityName: "delete",
    show: showDeleteModal,
    subject: "directory",
    onClickRemove: function onClickRemove() {
      return deleteManifest({});
    },
    onHide: function onHide() {
      return setShowDeleteModal(false);
    }
  }), /*#__PURE__*/React.createElement(DeleteContainer, null, hasTemplates && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    color: theme.grey100,
    size: "16px"
  }, "DANGER ZONE"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Text, {
    bold: true,
    color: theme.grey100,
    size: "14px"
  }, "Reinitialize the directory by applying a template"), /*#__PURE__*/React.createElement(Text, {
    color: theme.mojoAccent3,
    size: "14px"
  }, "Permanently delete all data in the directory and start over from a template.", /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "replace-template",
    onClick: function onClick() {
      return navigate('/ui/policies/createpolicy/fromtemplateschema');
    }
  }, "Apply a template"), /*#__PURE__*/React.createElement(Hr, null))), /*#__PURE__*/React.createElement(Text, {
    bold: true,
    color: theme.grey100,
    size: "14px"
  }, "Reset to an empty directory"), /*#__PURE__*/React.createElement(Text, {
    color: theme.mojoAccent3,
    size: "14px"
  }, "Permanently delete the model and all the data in the directory.".concat(hasTemplates ? 'You can select a template later by clicking “Create an instance” in the Policies section.' : ''), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "reset-template",
    variant: "danger",
    onClick: function onClick() {
      return setShowDeleteModal(true);
    }
  }, "Delete directory")), /*#__PURE__*/React.createElement(SpinnerToggle, {
    show: isDeletingManifest
  }));
};

var Grid = styled.div.withConfig({
  displayName: "styles__Grid",
  componentId: "v9ar3j-0"
})(["width:100%;height:100%;display:grid;grid-template-columns:1fr;grid-template-rows:0 50px 1fr;gap:0px 0px;grid-template-areas:'header' 'sidebar' 'content';@media (min-width:913px){display:grid;grid-template-columns:250px 1.3fr 1fr;grid-template-rows:0 1.7fr 1fr;gap:0px 0px;grid-template-areas:'header header header' 'sidebar content content' 'sidebar content content';}"]);
var Sidebar = styled.div.withConfig({
  displayName: "styles__Sidebar",
  componentId: "v9ar3j-1"
})(["position:fixed;width:100%;background-color:", ";z-index:2;@media (min-width:913px){grid-area:sidebar;}"], theme.primaryBlack);
var Content = styled.div.withConfig({
  displayName: "styles__Content",
  componentId: "v9ar3j-2"
})(["grid-area:content;display:flex;width:100%;"]);
var ObjectHeaderContainer = styled.div.withConfig({
  displayName: "styles__ObjectHeaderContainer",
  componentId: "v9ar3j-3"
})(["padding:12px 20px;display:flex;flex-direction:row;justify-content:space-between;align-items:center;background-color:", ";color:", ";z-index:1;position:-webkit-sticky;position:sticky;top:140px;@media (max-width:912px){position:fixed;top:184px;width:100%;border-bottom:1px solid ", ";margin:20px 0;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.primaryBlack;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.grey100;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.grey20;
});
var HeaderButtonContainer = styled.div.withConfig({
  displayName: "styles__HeaderButtonContainer",
  componentId: "v9ar3j-4"
})(["display:flex;gap:10px;"]);
var ImageButton = styled.div.withConfig({
  displayName: "styles__ImageButton",
  componentId: "v9ar3j-5"
})(["display:flex;align-items:center;padding:2px;background-color:inherit;white-space:nowrap;gap:10px;color:", ";&:focus,&:hover:not(:disabled){color:", ";cursor:pointer;img{filter:brightness(150%);}}span{font-weight:400;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.grey70;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.grey100;
});
var AddButton$1 = styled(Button).withConfig({
  displayName: "styles__AddButton",
  componentId: "v9ar3j-6"
})(["align-items:center;display:flex;flex-direction:row;gap:5px;"]);

var Header$4 = styled.div.withConfig({
  displayName: "styles__Header",
  componentId: "sc-171eopy-0"
})(["@media (min-width:912px){grid-area:header;}"]);
var LeftContainer$1 = styled.div.withConfig({
  displayName: "styles__LeftContainer",
  componentId: "sc-171eopy-1"
})(["min-width:250px;@media (max-width:912px){display:none;}"]);
var SelectContainerDirectory = styled.div.withConfig({
  displayName: "styles__SelectContainerDirectory",
  componentId: "sc-171eopy-2"
})(["width:97%;margin-top:20px;margin-bottom:10px;button{margin-top:25px;}@media (min-width:913px){display:none;}"]);
var EditImage = styled.img.withConfig({
  displayName: "styles__EditImage",
  componentId: "sc-171eopy-3"
})(["height:12px;width:12px;filter:brightness(150%);"]);
var EditButton = styled(Button).withConfig({
  displayName: "styles__EditButton",
  componentId: "sc-171eopy-4"
})(["line-height:18px;"]);

var DirectorySidebar = function DirectorySidebar() {
  var navigate = useNavigate();
  var _useFeatureFlags = useFeatureFlags(),
    isGraphQLEnabled = _useFeatureFlags.isGraphQLEnabled,
    hasDirectoryApiBrowser = _useFeatureFlags.hasDirectoryApiBrowser,
    hasAssertions = _useFeatureFlags.hasAssertions;
  var _ObjectTypesList = ObjectTypesList(),
    data = _ObjectTypesList.data;
  var displayState = useDirectoryDisplayState();
  var objectTypes = useMemo(function () {
    return (data === null || data === void 0 ? void 0 : data.results) || [];
  }, [data === null || data === void 0 ? void 0 : data.results]);
  var verticalTabOptions = [{
    section: {
      label: 'Model',
      value: '/ui/directory/model',
      redirects: true
    }
  }, {
    section: {
      label: 'Relations',
      value: '/ui/directory/relations',
      redirects: true
    }
  }];
  if (objectTypes.length > 0) {
    verticalTabOptions.push({
      section: {
        label: 'Objects',
        value: '/ui/directory/objects',
        redirects: true
      },
      subOptions: _toConsumableArray(objectTypes.map(function (o) {
        return {
          label: o.displayName || o.name,
          value: "/ui/directory/objects/".concat(encodeURIComponent(o.name)),
          redirects: true
        };
      }))
    });
  }
  verticalTabOptions.push({
    section: {
      label: 'Evaluator',
      value: '/ui/directory/evaluator',
      redirects: true
    }
  });
  if (hasAssertions) {
    verticalTabOptions.push({
      section: {
        label: 'Assertions',
        value: '/ui/directory/assertions',
        redirects: true
      }
    });
  }
  if (isGraphQLEnabled) {
    verticalTabOptions.push({
      section: {
        label: 'Playground',
        value: '/ui/directory/playground',
        redirects: true
      }
    });
  }
  if (hasDirectoryApiBrowser) {
    verticalTabOptions.push({
      section: {
        label: 'API Browser',
        value: '/ui/directory/apidocs',
        redirects: true
      }
    });
  }
  if (displayState.canDeleteDirectory.enabled) {
    verticalTabOptions.push({
      section: {
        label: 'Danger Zone',
        value: '/ui/directory/danger',
        redirects: true
      }
    });
  }
  var selectOptions = verticalTabOptions.map(function (o) {
    return {
      label: o.section.label,
      options: !!o.subOptions ? o.subOptions.filter(function (so) {
        return so.redirects;
      }).map(function (so) {
        return {
          label: so.label,
          value: so.value,
          group: o.section.label
        };
      }) : [{
        label: '',
        value: o.section.value,
        group: o.section.label
      }]
    };
  });
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var selectedOption = pathname;
  var onChangeVerticalTab = function onChangeVerticalTab(path) {
    navigate(path);
  };
  var formatOptionLabel = function formatOptionLabel(option, meta) {
    return meta.context === 'value' ? option.label !== '' ? "".concat(option.group.endsWith('s') ? option.group.slice(0, -1) : option.group, ": ").concat(option.label) : option.group : option.label;
  };
  return /*#__PURE__*/React.createElement(Row$2, null, /*#__PURE__*/React.createElement(LeftContainer$1, null, /*#__PURE__*/React.createElement(VerticalTabs, {
    options: verticalTabOptions
  })), /*#__PURE__*/React.createElement(SelectContainerDirectory, null, /*#__PURE__*/React.createElement(SelectDirectory, {
    "aria-label": "Sections",
    formatGroupLabel: function formatGroupLabel(a) {
      return !!(a === null || a === void 0 ? void 0 : a.label) ? (/*#__PURE__*/React.createElement("div", {
        style: {
          alignItems: 'center',
          borderTop: '1px #414141 solid',
          display: 'flex',
          minHeight: '36px'
        }
      }, a.label)) : undefined;
    },
    formatOptionLabel: formatOptionLabel,
    options: selectOptions,
    value: (selectOptions.find(function (option) {
      return option.options.find(function (option) {
        return option.value === selectedOption;
      });
    }) || selectOptions[0]).options.find(function (option) {
      return option.value === selectedOption;
    }),
    onChange: function onChange(option) {
      return onChangeVerticalTab(String(option === null || option === void 0 ? void 0 : option.value));
    }
  })));
};

var img$e = "data:image/svg+xml,%3csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M13.0014 0C12.2342 0 11.467 0.292401 10.8827 0.876817C7.53146 4.22809 4.18006 7.57949 0.828788 10.9308L5.06923 15.1712C8.4205 11.8199 11.7719 8.46853 15.1232 5.11726C16.2919 3.94851 16.2891 2.04568 15.1203 0.876817C14.5358 0.292441 13.7688 0 13.0014 0H13.0014ZM0.308347 11.8251L0.00178857 15.4583C-0.0240402 15.7665 0.233467 16.024 0.541692 15.9982L4.17291 15.6897L0.308347 11.8251Z' fill='%23A0A0A0' /%3e%3c/svg%3e";

var HeaderComponent = function HeaderComponent() {
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 2),
    searchParams = _useSearchParams2[0],
    setSearchParams = _useSearchParams2[1];
  var addConnectionModalRequested = searchParams.get('showAddConnectionModal');
  var _useDirectoryModelCon = useDirectoryModelContext(),
    visible = _useDirectoryModelCon.visible,
    setVisible = _useDirectoryModelCon.setVisible;
  var queryClient = useQueryClient();
  var pathname = window.location.pathname;
  var displayState = useDirectoryDisplayState();
  var refresh = useCallback(function () {
    queryClient.refetchQueries({
      type: 'active'
    });
  }, [queryClient]);
  useEffect(function () {
    if (!!addConnectionModalRequested) {
      setSearchParams({});
    }
  }, [addConnectionModalRequested, setSearchParams]);
  useEffect(function () {
    if (!localStorage.getItem('graphiql:theme')) {
      localStorage.setItem('graphiql:theme', 'dark');
    }
  }, []);
  return /*#__PURE__*/React.createElement(Header$4, null, /*#__PURE__*/React.createElement(PageHeader, {
    hasBorderBottom: true,
    load: refresh,
    mobileBreakpoint: 912,
    title: "Directory"
  }, /*#__PURE__*/React.createElement(PageHeaderContent, null, pathname === '/ui/directory/model' && (/*#__PURE__*/React.createElement(EvaluateDisplayState, {
    displayState: displayState.canAddObject
  }, /*#__PURE__*/React.createElement(EditButton, {
    hidden: visible,
    onClick: function onClick() {
      return setVisible(true);
    }
  }, /*#__PURE__*/React.createElement(EditImage, {
    alt: "plus",
    src: img$e
  }), "\xA0\xA0Edit manifest"))))));
};

var Frame = function Frame() {
  return /*#__PURE__*/React.createElement(PaddedContent, null, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(HeaderComponent, null), /*#__PURE__*/React.createElement(Sidebar, null, /*#__PURE__*/React.createElement(DirectorySidebar, null)), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Outlet, null))));
};

var NavContainer = styled.div.withConfig({
  displayName: "styles__NavContainer",
  componentId: "sc-19zo9mz-0"
})(["background-color:", ";margin-top:4px;padding:12px 0px;width:100%;"], theme.grey10);
var NavTab$1 = styled.span.withConfig({
  displayName: "styles__NavTab",
  componentId: "sc-19zo9mz-1"
})(["margin-left:24px;padding:12px 6px;cursor:pointer;text-decoration:none;white-space:nowrap;font-weight:500;font-size:14px;&:hover{color:", ";}", " ", ""], theme.grey100, function (_ref) {
  var $disabled = _ref.$disabled;
  return !!$disabled && "pointer-events: none;";
}, function (_ref2) {
  var $active = _ref2.$active;
  if ($active) {
    return css(["border-bottom:1px solid ", ";color:", ";"], theme.lochivarAccent4, theme.grey100);
  }
});
var Container$7 = styled.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-19zo9mz-2"
})(["width:100%;display:inline-flex;margin-top:75px;@media (max-width:1198px){margin-top:0;display:flex;flex-direction:column;align-items:center;gap:20px;}@media (max-width:912px){margin-top:20px;}"]);
var Header$3 = styled.div.withConfig({
  displayName: "styles__Header",
  componentId: "sc-19zo9mz-3"
})(["background-color:", ";padding:20px;height:80px;width:100%;@media (min-width:1199px){position:fixed;top:0px;width:calc(100% - 250px);z-index:9;transform:translateY(175%);}"], theme.grey20);
var PlayButtonHeader = styled.div.withConfig({
  displayName: "styles__PlayButtonHeader",
  componentId: "sc-19zo9mz-4"
})(["padding:20px;position:fixed;top:0;left:calc(50% + 75px);height:80px;z-index:10;transform:translateY(175%);@media (max-width:1198px){display:none;}"]);
var SmallScreenPlayDiv = styled.div.withConfig({
  displayName: "styles__SmallScreenPlayDiv",
  componentId: "sc-19zo9mz-5"
})(["@media (min-width:1199px){display:none;}"]);
var HeaderSelectContainer$1 = styled.div.withConfig({
  displayName: "styles__HeaderSelectContainer",
  componentId: "sc-19zo9mz-6"
})(["flex:1;max-width:300px;margin-left:10px;"]);
var HeaderTitle$1 = styled.div.withConfig({
  displayName: "styles__HeaderTitle",
  componentId: "sc-19zo9mz-7"
})(["font-size:16px;font-weight:bold;color:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.grey100;
});
var EvaluatorContainer$2 = styled.div.withConfig({
  displayName: "styles__EvaluatorContainer",
  componentId: "sc-19zo9mz-8"
})(["display:flex;height:50px;justify-content:space-between;"]);
var ResultsContainer = styled.div.withConfig({
  displayName: "styles__ResultsContainer",
  componentId: "sc-19zo9mz-9"
})(["display:flex;height:40px;justify-content:space-between;"]);
var ButtonsContainer$8 = styled.div.withConfig({
  displayName: "styles__ButtonsContainer",
  componentId: "sc-19zo9mz-10"
})(["display:flex;margin-right:-8px;margin-top:17px;"]);
var ResultButtonsContainer = styled.div.withConfig({
  displayName: "styles__ResultButtonsContainer",
  componentId: "sc-19zo9mz-11"
})(["display:flex;margin-right:-8px;margin-top:8px;align-items:center;"]);
var ObjectDiv = styled.div.withConfig({
  displayName: "styles__ObjectDiv",
  componentId: "sc-19zo9mz-12"
})(["display:inline-flex;gap:15px;> div{width:100%;}"]);
var SubContainer = styled.div.withConfig({
  displayName: "styles__SubContainer",
  componentId: "sc-19zo9mz-13"
})(["width:50%;display:flex;flex-direction:column;@media (min-width:1199px){border-bottom:1px solid ", ";border-left:1px solid ", ";height:calc(100vh - 13.6rem);overflow-y:auto;}@media (max-width:1198px){width:100%;}@media (max-width:912px){border:1px solid ", ";border-radius:4px;padding-bottom:20px;}"], theme.grey10, theme.grey10, theme.grey10);
var LeftContainer = styled.div.withConfig({
  displayName: "styles__LeftContainer",
  componentId: "sc-19zo9mz-14"
})(["display:flex;flex-direction:column;gap:30px;margin:30px 0;padding:0 30px;"]);
var RightContainer = styled.div.withConfig({
  displayName: "styles__RightContainer",
  componentId: "sc-19zo9mz-15"
})(["padding:0 30px 30px;"]);
var TextBox = styled.div.withConfig({
  displayName: "styles__TextBox",
  componentId: "sc-19zo9mz-16"
})(["background-color:", ";border:1px solid ", ";border-radius:4px;margin-top:", "px;height:", "px;overflow-y:auto;"], theme.primaryBlack, theme.grey40, function (_ref4) {
  var $margin = _ref4.$margin;
  return $margin;
}, function (_ref5) {
  var $height = _ref5.$height;
  return $height || 245;
});
var CopyButton$2 = styled(Button).withConfig({
  displayName: "styles__CopyButton",
  componentId: "sc-19zo9mz-17"
})(["margin:10px 10px 40px 0;height:22px;line-height:50%;"]);
var EvaluatorLabel = styled(Label$1).withConfig({
  displayName: "styles__EvaluatorLabel",
  componentId: "sc-19zo9mz-18"
})(["margin-top:28px;"]);

var AddAssertion = function AddAssertion(_ref) {
  var assert = _ref.assert;
  var showError = useShowError();
  var queryClient = useQueryClient();
  var assertionsListQueryKey = AssertionsListQueryKey();
  var navigate = useNavigate();
  var _AssertionSet = AssertionSet({
      mutation: {
        onError: function onError(e) {
          showError(e);
        },
        onSuccess: function onSuccess() {
          queryClient.invalidateQueries(assertionsListQueryKey);
          navigate('/ui/directory/assertions');
        }
      }
    }),
    addAssertion = _AssertionSet.mutate;
  return /*#__PURE__*/React.createElement(CopyButton$2, {
    disabled: assert.expected === undefined,
    size: "sm",
    variant: "secondary",
    onClick: function onClick() {
      addAssertion({
        data: {
          assert: assert
        }
      });
    }
  }, "Create assertion");
};

var useCopyCurlRest = function useCopyCurlRest(request, requestData, path) {
  var _useConfig = useConfig(),
    directoryServiceUrl = _useConfig.directoryServiceUrl,
    directoryApiKey = _useConfig.directoryApiKey;
  var _useProfile = useProfile(),
    tenantId = _useProfile.tenantId;
  var _useIdentity = useIdentity(),
    getAccessToken = _useIdentity.getAccessToken;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    accessToken = _useState2[0],
    setAccessToken = _useState2[1];
  useEffect(function () {
    var getToken = function getToken() {
      return __awaiter(void 0, void 0, void 0, _regeneratorRuntime.mark(function _callee() {
        var accessToken;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAccessToken();
            case 2:
              accessToken = _context.sent;
              setAccessToken(accessToken);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    };
    getToken();
  }, [getAccessToken]);
  var authorization = !!directoryApiKey ? "basic ".concat(directoryApiKey) : accessToken;
  var req = useCallback(function () {
    var curl = function curl(options) {
      return "curl '".concat(directoryServiceUrl, "/").concat(path).concat(options.params ? "".concat(options.params) : '', "' \\\n          -H 'aserto-tenant-id: ").concat(tenantId, "' \\\n          -H 'authorization: ").concat(authorization, "' \\\n          -H 'content-type: application/json' \\\n          ").concat(options.payload ? "--data-raw '".concat(options.payload, "'") : '');
    };
    var checkCurl = function checkCurl() {
      return curl({
        payload: JSON.stringify(requestData)
      });
    };
    var objectsCurl = function objectsCurl() {
      return curl({
        params: "?object_type=".concat(requestData.object_type)
      });
    };
    var relationsCurl = function relationsCurl() {
      var subjectCurl = curl({
        params: "?subject_id=".concat(encodeURIComponent(requestData.object_id), "&subject_type=").concat(requestData.object_type)
      });
      var objectCurl = curl({
        params: "?object_id=".concat(encodeURIComponent(requestData.object_id), "&object_type=").concat(requestData.object_type)
      });
      return "".concat(objectCurl, " && ").concat(subjectCurl);
    };
    var objectCurl = function objectCurl() {
      return curl({
        params: "/".concat(requestData.object_type, "/").concat(encodeURIComponent(requestData.object_id))
      });
    };
    var getGraphCurl = function getGraphCurl() {
      return curl({
        params: "/".concat(requestData.object_type, "/").concat(requestData.relation, "/").concat(requestData.subject_type, "?object_id=").concat(encodeURIComponent(requestData.object_id || ''), "&subject_id=").concat(encodeURIComponent(requestData.subject_id || ''))
      });
    };
    switch (request) {
      case 'check':
        return checkCurl();
      case 'objects':
        return objectsCurl();
      case 'relations':
        return relationsCurl();
      case 'find_users':
        return getGraphCurl();
      case 'find_objects':
        return getGraphCurl();
      default:
        return objectCurl();
    }
  }, [request, directoryServiceUrl, path, tenantId, requestData, authorization]);
  return {
    copyCurlRest: function copyCurlRest() {
      return copy(req());
    }
  };
};

var createQuery = function createQuery(_ref) {
  var selectedRequest = _ref.selectedRequest,
    variables = _ref.variables;
  switch (selectedRequest) {
    case 'check':
      return "query Check {\n  check(\n    subject: { id: \"".concat(variables.subjectID, "\", type: \"").concat(variables.subjectType, "\" }\n    object: { id: \"").concat(variables.objectID, "\", type: \"").concat(variables.objectType, "\" }\n    relation: \"").concat(variables.relation, "\"\n  ) {\n    allowed\n  }\n}");
    case 'object':
      return "query GetObject {\n  object(type: \"".concat(variables.typeName, "\", id: \"").concat(variables.id, "\") {\n    type\n    displayName\n    id\n    properties\n    hash\n  }\n}");
    case 'objects':
      return "query GetObjects {\n  objects(first: 30, where: { type: \"".concat(variables.typeName, "\" }) {\n    nodes {\n      id\n      displayName\n      properties\n      hash\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}");
    case 'relations':
      return "query GetObjectRelations {\n  object(type: \"".concat(variables.objectType, "\", id: \"").concat(variables.objectId, "\") {\n    type\n    displayName\n    id\n    properties\n    hash\n    outgoingRelations: relations(side: OBJECT, first: 30) {\n      nodes {\n        subject {\n          id\n          displayName\n          type\n        }\n        relation\n        subjectRelation\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n    incomingRelations: relations(side: SUBJECT, first: 30) {\n      nodes {\n        object {\n          id\n          displayName\n          type\n        }\n        relation\n        subjectRelation\n      }\n      pageInfo {\n        hasNextPage\n        endCursor\n      }\n    }\n  }\n}");
    default:
      return '';
  }
};
var useCopyCurl$2 = function useCopyCurl(query) {
  var _useConfig = useConfig(),
    directoryServiceUrl = _useConfig.directoryServiceUrl,
    directoryApiKey = _useConfig.directoryApiKey;
  var _useProfile = useProfile(),
    tenantId = _useProfile.tenantId;
  var _useIdentity = useIdentity(),
    getAccessToken = _useIdentity.getAccessToken;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    accessToken = _useState2[0],
    setAccessToken = _useState2[1];
  useEffect(function () {
    var getToken = function getToken() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var accessToken;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAccessToken();
            case 2:
              accessToken = _context.sent;
              setAccessToken(accessToken);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    };
    getToken();
  }, [getAccessToken]);
  var authorization = !!directoryApiKey ? "basic ".concat(directoryApiKey) : accessToken;
  var getQueryCurl = useCallback(function () {
    return "curl '".concat(directoryServiceUrl, "/graph/query' \\\n  -H 'aserto-tenant-id: ").concat(tenantId, "' \\\n  -H 'authorization: ").concat(authorization, "' \\\n  -H 'content-type: application/json' \\\n  --data-raw '{\"query\":").concat(JSON.stringify(query), "}' \\\n  ");
  }, [directoryServiceUrl, query, tenantId, authorization]);
  return {
    copyCurl: function copyCurl() {
      return copy(getQueryCurl());
    }
  };
};

var DirectoryEvaluator = function DirectoryEvaluator() {
  var _useDirectoryEvaluato = useDirectoryEvaluatorContext(),
    request = _useDirectoryEvaluato.request,
    subjectType = _useDirectoryEvaluato.subjectType,
    subjectInstance = _useDirectoryEvaluato.subjectInstance,
    relationType = _useDirectoryEvaluato.relationType,
    objectType = _useDirectoryEvaluato.objectType,
    objectInstance = _useDirectoryEvaluato.objectInstance,
    setRequest = _useDirectoryEvaluato.setRequest,
    setSubjectType = _useDirectoryEvaluato.setSubjectType,
    setSubjectInstance = _useDirectoryEvaluato.setSubjectInstance,
    setRelationType = _useDirectoryEvaluato.setRelationType,
    setObjectType = _useDirectoryEvaluato.setObjectType,
    setObjectInstance = _useDirectoryEvaluato.setObjectInstance;
  var REQUEST_PATHS = {
    CHECK: 'api/v3/directory/check',
    OBJECT: 'api/v3/directory/object',
    OBJECTS: 'api/v3/directory/objects',
    RELATIONS: 'api/v3/directory/relations',
    GRAPH: 'api/v3/directory/graph'
  };
  var _useFeatureFlags = useFeatureFlags(),
    hasAssertions = _useFeatureFlags.hasAssertions,
    isGraphQLEnabled = _useFeatureFlags.isGraphQLEnabled;
  var GRAPHQL_SUPPORT = {
    check: isGraphQLEnabled,
    object: isGraphQLEnabled,
    objects: isGraphQLEnabled,
    relations: isGraphQLEnabled,
    find_users: false,
    find_objects: false
  };
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    query = _useState2[0],
    setQuery = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    results = _useState4[0],
    setResults = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    expected = _useState6[0],
    setExpected = _useState6[1];
  var _useState7 = useState('graphql'),
    _useState8 = _slicedToArray(_useState7, 2),
    operatingMode = _useState8[0],
    setOperatingMode = _useState8[1];
  var _useState9 = useState(isGraphQLEnabled),
    _useState10 = _slicedToArray(_useState9, 2),
    supportsGraphQL = _useState10[0],
    setSupportsGraphQL = _useState10[1];
  var navigate = useNavigate();
  var getRequestPath = function getRequestPath() {
    switch (request) {
      case 'check':
        return REQUEST_PATHS.CHECK;
      case 'object':
        return REQUEST_PATHS.OBJECT;
      case 'objects':
        return REQUEST_PATHS.OBJECTS;
      case 'relations':
        return REQUEST_PATHS.RELATIONS;
      case 'find_users':
        return REQUEST_PATHS.GRAPH;
      case 'find_objects':
        return REQUEST_PATHS.GRAPH;
    }
    return '';
  };
  var getPayload = function getPayload(request) {
    switch (request) {
      case 'check':
        return {
          subject_type: subjectType,
          subject_id: String((subjectInstance === null || subjectInstance === void 0 ? void 0 : subjectInstance.value) || ''),
          object_type: objectType,
          object_id: String((objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value) || ''),
          relation: String((relationType === null || relationType === void 0 ? void 0 : relationType.value) || '')
        };
      case 'object':
        return {
          object_type: objectType,
          object_id: String((objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value) || '')
        };
      case 'objects':
        return {
          object_type: objectType
        };
      case 'relations':
        return {
          object_type: objectType,
          object_id: String((objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value) || '')
        };
      case 'find_users':
        return {
          object_type: objectType,
          object_id: String((objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value) || ''),
          subject_type: 'user',
          relation: String((relationType === null || relationType === void 0 ? void 0 : relationType.value) || '')
        };
      case 'find_objects':
        return {
          subject_type: 'user',
          subject_id: String((subjectInstance === null || subjectInstance === void 0 ? void 0 : subjectInstance.value) || ''),
          object_type: objectType,
          relation: String((relationType === null || relationType === void 0 ? void 0 : relationType.value) || '')
        };
    }
  };
  var _useCopyCurl = useCopyCurl$2(query),
    copyCurl = _useCopyCurl.copyCurl;
  var _useCopyCurlRest = useCopyCurlRest(request, getPayload(request), getRequestPath()),
    copyCurlRest = _useCopyCurlRest.copyCurlRest;
  var requestOptions = [{
    label: 'Check',
    value: 'check'
  }, {
    label: 'Get object',
    value: 'object'
  }, {
    label: 'Get objects by type',
    value: 'objects'
  }, {
    label: 'Get relations of object',
    value: 'relations'
  }, {
    label: 'Find objects that a user can access',
    value: 'find_objects'
  }, {
    label: 'Find users that can access an object',
    value: 'find_users'
  }];
  var _Check = Check({
      object_id: String((objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value) || ''),
      object_type: objectType,
      subject_id: String((subjectInstance === null || subjectInstance === void 0 ? void 0 : subjectInstance.value) || ''),
      subject_type: subjectType,
      relation: String((relationType === null || relationType === void 0 ? void 0 : relationType.value) || '')
    }, {
      enabled: false
    }),
    refetchCheck = _Check.refetch;
  var _ObjectGet = ObjectGet(objectType || '', String((objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value) || ''), {}, {
      query: {
        enabled: false
      }
    }),
    refetchObjectData = _ObjectGet.refetch;
  var _ObjectsListInfinite = ObjectsListInfinite({
      object_type: objectType
    }, {
      query: {
        enabled: false
      }
    }),
    refetchObjectsByTypeData = _ObjectsListInfinite.refetch;
  var _RelationsListInfinit = RelationsListInfinite({
      subject_id: String((objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value) || ''),
      subject_type: objectType || '',
      'page.size': 100
    }, {
      query: {
        enabled: false
      }
    }),
    refetchIncomingRelationsData = _RelationsListInfinit.refetch;
  var _RelationsListInfinit2 = RelationsListInfinite({
      object_id: String((objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value) || ''),
      object_type: objectType || '',
      'page.size': 100
    }, {
      query: {
        enabled: false
      }
    }),
    refetchOutgoingRelationsData = _RelationsListInfinit2.refetch;
  var _GetGraph = GetGraph(objectType, String((relationType === null || relationType === void 0 ? void 0 : relationType.value) || ''), subjectType, {
      object_id: String((objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value) || ''),
      subject_id: String((subjectInstance === null || subjectInstance === void 0 ? void 0 : subjectInstance.value) || '')
    }, {
      query: {
        enabled: false
      }
    }),
    refetchGetGraph = _GetGraph.refetch;
  var _ObjectTypesList = ObjectTypesList(),
    objectTypesData = _ObjectTypesList.data;
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    subjectsFilter = _useState12[0],
    setSubjectsFilter = _useState12[1];
  var debouncedSubjectsFilter = useDebounce(subjectsFilter);
  var _ObjectsListInfinite2 = ObjectsListInfinite({
      object_type: subjectType,
      'page.size': 100,
      displayNamePart: debouncedSubjectsFilter
    }, {
      query: {
        enabled: !!subjectType
      }
    }),
    subjectsData = _ObjectsListInfinite2.data,
    hasMoreSubjects = _ObjectsListInfinite2.hasNextPage,
    fetchNextSubjectsData = _ObjectsListInfinite2.fetchNextPage;
  var subjects = useMemo(function () {
    var _a;
    return (_a = subjectsData === null || subjectsData === void 0 ? void 0 : subjectsData.pages.map(function (page) {
      return page.results || [];
    }).flat().map(function (object) {
      return {
        label: object.display_name || object.id,
        value: object.id
      };
    })) !== null && _a !== void 0 ? _a : [];
  }, [subjectsData === null || subjectsData === void 0 ? void 0 : subjectsData.pages]);
  var _PermissionsList = PermissionsList({
      objectType: objectType
    }),
    permissionsData = _PermissionsList.data;
  var permissions = useMemo(function () {
    var _a;
    return ((_a = permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.results) === null || _a === void 0 ? void 0 : _a.map(function (p) {
      return {
        label: p.displayName || p.name,
        value: p.name
      };
    })) || [];
  }, [permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.results]);
  var _RelationTypesList = RelationTypesList({
      objectType: objectType
    }),
    relationTypesData = _RelationTypesList.data;
  var relations = useMemo(function () {
    var _a;
    return (_a = relationTypesData === null || relationTypesData === void 0 ? void 0 : relationTypesData.results) === null || _a === void 0 ? void 0 : _a.map(function (n) {
      return {
        label: n.displayName || n.name,
        value: n.name
      };
    });
  }, [relationTypesData]);
  var relationsPermissions = useMemo(function () {
    return [{
      label: 'Relations',
      options: relations || []
    }, {
      label: 'Permissions',
      options: permissions || []
    }];
  }, [relations, permissions]);
  var objectTypes = useMemo(function () {
    var _a;
    if (!objectTypesData || !objectTypesData.results) {
      return [];
    }
    return (_a = objectTypesData === null || objectTypesData === void 0 ? void 0 : objectTypesData.results) === null || _a === void 0 ? void 0 : _a.map(function (o) {
      return {
        label: o.displayName || o.name,
        value: o.name
      };
    });
  }, [objectTypesData]);
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    objectsFilter = _useState14[0],
    setObjectsFilter = _useState14[1];
  var debouncedObjectsFilter = useDebounce(objectsFilter);
  var _ObjectsListInfinite3 = ObjectsListInfinite({
      object_type: objectType,
      'page.size': 100,
      displayNamePart: debouncedObjectsFilter
    }, {
      query: {
        enabled: !!objectType
      }
    }),
    objectsData = _ObjectsListInfinite3.data,
    hasMoreObjects = _ObjectsListInfinite3.hasNextPage,
    fetchMoreObjects = _ObjectsListInfinite3.fetchNextPage;
  var objectInstances = useMemo(function () {
    var _a;
    return (_a = objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages.map(function (page) {
      return page.results || [];
    }).flat().map(function (object) {
      return {
        label: object.display_name || object.id,
        value: object.id
      };
    })) !== null && _a !== void 0 ? _a : [];
  }, [objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages]);
  var disableButton = useMemo(function () {
    switch (request) {
      case 'check':
        return !relationType || !subjectInstance || !objectInstance;
      case 'object':
        return !objectInstance || !objectType;
      case 'objects':
        return !objectType;
      case 'relations':
        return !objectInstance || !objectType;
      case 'find_users':
        return !objectInstance || !objectType || !relationType;
      case 'find_objects':
        return !subjectInstance || !objectType || !relationType;
      default:
        return !request;
    }
  }, [objectInstance, objectType, relationType, request, subjectInstance]);
  var emptyReplacer = function emptyReplacer(_, value) {
    if (value === '') {
      return undefined;
    }
    return value;
  };
  var evaluate = function evaluate() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _a, _b, _c, _d, _e, _f, data, currentQuery, incomingData, outgoingData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = request;
            _context.next = _context.t0 === 'check' ? 3 : _context.t0 === 'object' ? 9 : _context.t0 === 'objects' ? 23 : _context.t0 === 'relations' ? 37 : _context.t0 === 'find_users' ? 46 : _context.t0 === 'find_objects' ? 60 : 74;
            break;
          case 3:
            _context.next = 5;
            return refetchCheck();
          case 5:
            data = _context.sent.data;
            currentQuery = createQuery({
              selectedRequest: request,
              variables: {
                objectID: String((objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value) || ''),
                objectType: objectType,
                subjectID: String((subjectInstance === null || subjectInstance === void 0 ? void 0 : subjectInstance.value) || ''),
                subjectType: subjectType,
                relation: String((relationType === null || relationType === void 0 ? void 0 : relationType.value) || '')
              }
            });
            setExpected(data === null || data === void 0 ? void 0 : data.check);
            return _context.abrupt("break", 75);
          case 9:
            _context.next = 11;
            return refetchObjectData();
          case 11:
            _context.t2 = _a = _context.sent.data;
            _context.t1 = _context.t2 === null;
            if (_context.t1) {
              _context.next = 15;
              break;
            }
            _context.t1 = _a === void 0;
          case 15:
            if (!_context.t1) {
              _context.next = 19;
              break;
            }
            _context.t3 = void 0;
            _context.next = 20;
            break;
          case 19:
            _context.t3 = _a.result;
          case 20:
            data = _context.t3;
            currentQuery = createQuery({
              selectedRequest: request,
              variables: {
                id: String((objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value) || ''),
                typeName: objectType || ''
              }
            });
            return _context.abrupt("break", 75);
          case 23:
            _context.next = 25;
            return refetchObjectsByTypeData();
          case 25:
            _context.t5 = _b = _context.sent.data;
            _context.t4 = _context.t5 === null;
            if (_context.t4) {
              _context.next = 29;
              break;
            }
            _context.t4 = _b === void 0;
          case 29:
            if (!_context.t4) {
              _context.next = 33;
              break;
            }
            _context.t6 = void 0;
            _context.next = 34;
            break;
          case 33:
            _context.t6 = _b.pages.flatMap(function (page) {
              return page.results || [];
            });
          case 34:
            data = _context.t6;
            currentQuery = createQuery({
              selectedRequest: request,
              variables: {
                typeName: objectType || ''
              }
            });
            return _context.abrupt("break", 75);
          case 37:
            _context.next = 39;
            return refetchIncomingRelationsData();
          case 39:
            incomingData = _context.sent;
            _context.next = 42;
            return refetchOutgoingRelationsData();
          case 42:
            outgoingData = _context.sent;
            data = {
              outgoingRelations: (((_c = outgoingData.data) === null || _c === void 0 ? void 0 : _c.pages.map(function (page) {
                return page.results || [];
              })) || []).flat(),
              incomingRelations: (((_d = incomingData.data) === null || _d === void 0 ? void 0 : _d.pages.map(function (page) {
                return page.results || [];
              })) || []).flat()
            };
            currentQuery = createQuery({
              selectedRequest: request,
              variables: {
                first: 100,
                objectId: String((objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value) || ''),
                objectType: objectType || ''
              }
            });
            return _context.abrupt("break", 75);
          case 46:
            _context.next = 48;
            return refetchGetGraph();
          case 48:
            _context.t8 = _e = _context.sent.data;
            _context.t7 = _context.t8 === null;
            if (_context.t7) {
              _context.next = 52;
              break;
            }
            _context.t7 = _e === void 0;
          case 52:
            if (!_context.t7) {
              _context.next = 56;
              break;
            }
            _context.t9 = void 0;
            _context.next = 57;
            break;
          case 56:
            _context.t9 = _e.results;
          case 57:
            data = _context.t9;
            currentQuery = 'find_users'; // placeholder for copyAsCurl state
            return _context.abrupt("break", 75);
          case 60:
            _context.next = 62;
            return refetchGetGraph();
          case 62:
            _context.t11 = _f = _context.sent.data;
            _context.t10 = _context.t11 === null;
            if (_context.t10) {
              _context.next = 66;
              break;
            }
            _context.t10 = _f === void 0;
          case 66:
            if (!_context.t10) {
              _context.next = 70;
              break;
            }
            _context.t12 = void 0;
            _context.next = 71;
            break;
          case 70:
            _context.t12 = _f.results;
          case 71:
            data = _context.t12;
            currentQuery = 'find_objects'; // placeholder for copyAsCurl state
            return _context.abrupt("break", 75);
          case 74:
            return _context.abrupt("break", 75);
          case 75:
            setResults(JSON.stringify(data, emptyReplacer, 2));
            setQuery(currentQuery);
          case 77:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  };
  useEffect(function () {
    setOperatingMode(supportsGraphQL ? 'graphql' : 'rest');
  }, [supportsGraphQL]);
  return /*#__PURE__*/React.createElement(Container$7, null, /*#__PURE__*/React.createElement(Header$3, null, /*#__PURE__*/React.createElement(Row$2, {
    "$centered": true,
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(Row$2, {
    "$centered": true,
    "$flex": true,
    style: {
      marginRight: 20
    }
  }, /*#__PURE__*/React.createElement(HeaderTitle$1, null, "REQUEST:"), /*#__PURE__*/React.createElement(HeaderSelectContainer$1, null, /*#__PURE__*/React.createElement(Select, {
    isSearchable: false,
    options: requestOptions,
    value: requestOptions.find(function (_ref) {
      var value = _ref.value;
      return value === request;
    }),
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        setRequest(String(option.value));
        setSupportsGraphQL(GRAPHQL_SUPPORT[String(option.value)]);
        setQuery('');
        setResults('');
        setExpected(undefined);
        if (option.value === 'find_objects' || option.value === 'find_users') {
          setSubjectType('user');
          setSubjectInstance(null);
          setObjectInstance(null);
        }
      }
    }
  }))))), /*#__PURE__*/React.createElement(SubContainer, null, /*#__PURE__*/React.createElement(LeftContainer, null, ['check', 'find_objects'].includes(request) && (/*#__PURE__*/React.createElement(ObjectDiv, null, request === 'check' && (/*#__PURE__*/React.createElement(Select, {
    label: "Subject Type",
    options: objectTypes,
    value: objectTypes.find(function (_ref2) {
      var value = _ref2.value;
      return value === subjectType;
    }),
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        setSubjectType(String(option.value));
        setSubjectInstance(null);
      }
    }
  })), /*#__PURE__*/React.createElement(Select, {
    label: "Subject",
    options: subjects,
    value: subjectInstance,
    onChange: setSubjectInstance,
    onInputChange: setSubjectsFilter,
    onMenuScrollToBottom: function onMenuScrollToBottom() {
      hasMoreSubjects && fetchNextSubjectsData && fetchNextSubjectsData();
    }
  }))), ['check', 'object', 'objects', 'relations', 'find_users', 'find_objects'].includes(request) && (/*#__PURE__*/React.createElement(ObjectDiv, null, /*#__PURE__*/React.createElement(Select, {
    label: "Object Type",
    options: objectTypes,
    value: objectTypes.find(function (_ref3) {
      var value = _ref3.value;
      return value === objectType;
    }),
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        setObjectType(String(option.value));
        setObjectInstance(null);
        setRelationType(null);
      }
    }
  }), !['objects', 'find_objects'].includes(request) && (/*#__PURE__*/React.createElement(Select, {
    label: "Instance",
    options: objectInstances,
    value: objectInstance,
    onChange: setObjectInstance,
    onInputChange: setObjectsFilter,
    onMenuScrollToBottom: function onMenuScrollToBottom() {
      hasMoreObjects && fetchMoreObjects && fetchMoreObjects();
    }
  })))), ['check', 'find_users', 'find_objects'].includes(request) && (/*#__PURE__*/React.createElement(Select, {
    label: "Relation",
    modifyCustomStyle: function modifyCustomStyle() {
      return colourStyles;
    },
    options: relationsPermissions,
    value: relationType,
    onChange: setRelationType
  })))), !!request && (/*#__PURE__*/React.createElement(PlayButtonHeader, null, /*#__PURE__*/React.createElement(Row$2, {
    "$centered": true,
    style: {
      height: '100%',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(PlayButton, {
    disabled: disableButton,
    onSubmit: evaluate
  })))), /*#__PURE__*/React.createElement(SubContainer, null, !!request && (/*#__PURE__*/React.createElement(Header$3, null, /*#__PURE__*/React.createElement(Row$2, {
    "$centered": true,
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(SmallScreenPlayDiv, null, /*#__PURE__*/React.createElement(PlayButton, {
    disabled: disableButton,
    onSubmit: evaluate
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      marginLeft: 20
    }
  }, /*#__PURE__*/React.createElement(HeaderTitle$1, null, "OUTPUT:"))))), /*#__PURE__*/React.createElement(NavContainer, null, supportsGraphQL && (/*#__PURE__*/React.createElement(NavTab$1, {
    "$active": operatingMode === 'graphql',
    onClick: function onClick() {
      setOperatingMode('graphql');
    }
  }, /*#__PURE__*/React.createElement("span", null, "GraphQL"))), /*#__PURE__*/React.createElement(NavTab$1, {
    "$active": operatingMode === 'rest',
    onClick: function onClick() {
      setOperatingMode('rest');
    }
  }, /*#__PURE__*/React.createElement("span", null, "REST"))), /*#__PURE__*/React.createElement(RightContainer, null, operatingMode === 'rest' ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EvaluatorContainer$2, null, /*#__PURE__*/React.createElement(EvaluatorLabel, null, "Request"), /*#__PURE__*/React.createElement(ButtonsContainer$8, null, /*#__PURE__*/React.createElement(CopyButton$2, {
    disabled: !query,
    size: "sm",
    variant: "secondary",
    onClick: function onClick() {
      copyCurlRest();
    }
  }, "Copy as cURL"))), /*#__PURE__*/React.createElement(TextBox, {
    "$margin": 11
  }, /*#__PURE__*/React.createElement(Highlight, {
    language: "json"
  }, JSON.stringify(getPayload(request), emptyReplacer, 2))))) : (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EvaluatorContainer$2, null, /*#__PURE__*/React.createElement(EvaluatorLabel, null, "Query"), /*#__PURE__*/React.createElement(ButtonsContainer$8, null, /*#__PURE__*/React.createElement(CopyButton$2, {
    disabled: !query,
    size: "sm",
    variant: "secondary",
    onClick: copyCurl
  }, "Copy as cURL"), /*#__PURE__*/React.createElement(CopyButton$2, {
    disabled: !query,
    size: "sm",
    variant: "secondary",
    onClick: function onClick() {
      return navigate('/ui/directory/playground', {
        state: {
          query: query,
          object_type: objectType,
          object_id: objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value,
          subject_type: subjectType,
          subject_id: subjectInstance === null || subjectInstance === void 0 ? void 0 : subjectInstance.value,
          relation: relationType === null || relationType === void 0 ? void 0 : relationType.value
        }
      });
    }
  }, "Open in Playground"))), /*#__PURE__*/React.createElement(TextBox, {
    "$margin": 11
  }, /*#__PURE__*/React.createElement(Highlight, {
    language: "graphql"
  }, query || '')))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ResultsContainer, null, /*#__PURE__*/React.createElement(Label$1, null, "Results"), /*#__PURE__*/React.createElement(ResultButtonsContainer, null, request === 'check' && hasAssertions && (/*#__PURE__*/React.createElement(AddAssertion, {
    assert: {
      check: {
        object_id: String(objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value),
        object_type: objectType,
        relation: String(relationType === null || relationType === void 0 ? void 0 : relationType.value),
        subject_id: String(subjectInstance === null || subjectInstance === void 0 ? void 0 : subjectInstance.value),
        subject_type: subjectType
      },
      expected: expected
    }
  })))), /*#__PURE__*/React.createElement(TextBox, null, /*#__PURE__*/React.createElement(Highlight, {
    language: "json"
  }, results || '')))));
};

var img$d = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' height='16' viewBox='0 0 448 512'%3e%3c!--! Font Awesome Free 6.4.2 by %40fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons%2c Inc.--%3e %3cstyle%3e svg%7bfill: white%7d %3c/style%3e %3cpath d='M48 96V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm80-16v80H272V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'/%3e%3c/svg%3e";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
window.MonacoEnvironment = {
  getWorker: function getWorker(moduleId, label) {
    switch (label) {
      case 'editorWorkerService':
        return new Worker(new URL('monaco-editor/esm/vs/editor/editor.worker', import.meta.url));
      case 'yaml':
        return new Worker(new URL('monaco-yaml/yaml.worker', import.meta.url));
      case 'json':
        return new Worker(new URL('monaco-editor/esm/vs/language/json/json.worker', import.meta.url));
      default:
        throw new Error("Unknown label ".concat(label, " for moduleId: ").concat(moduleId));
    }
  }
};
var VsCodeAserto = [{
  token: '',
  foreground: '#5c6773'
}, {
  token: 'invalid',
  foreground: theme.mojoAccent2
}, {
  token: 'emphasis',
  fontStyle: 'italic'
}, {
  token: 'strong',
  fontStyle: 'bold'
}, {
  token: 'variable',
  foreground: '#5c6773'
}, {
  token: 'variable.predefined',
  foreground: '#5c6773'
}, {
  token: 'constant',
  foreground: '#f08c36'
}, {
  token: 'comment',
  foreground: theme.grey70,
  fontStyle: 'italic'
}, {
  token: 'number',
  foreground: '#f08c36'
}, {
  token: 'number.hex',
  foreground: '#f08c36'
}, {
  token: 'regexp',
  foreground: '#4dbf99'
}, {
  token: 'annotation',
  foreground: '#00a8ff'
}, {
  token: 'type',
  foreground: '#00a8ff'
}, {
  token: 'delimiter',
  foreground: '#5c6773'
}, {
  token: 'delimiter.html',
  foreground: '#5c6773'
}, {
  token: 'delimiter.xml',
  foreground: '#5c6773'
}, {
  token: 'tag',
  foreground: theme.cooperAccent4
}, {
  token: 'tag.id.jade',
  foreground: theme.cooperAccent4
}, {
  token: 'tag.class.jade',
  foreground: theme.cooperAccent4
}, {
  token: 'meta.scss',
  foreground: theme.cooperAccent4
}, {
  token: 'metatag',
  foreground: theme.cooperAccent4
}, {
  token: 'metatag.content.html',
  foreground: theme.appleAccent4
}, {
  token: 'metatag.html',
  foreground: theme.cooperAccent4
}, {
  token: 'metatag.xml',
  foreground: theme.cooperAccent4
}, {
  token: 'metatag.php',
  fontStyle: 'bold'
}, {
  token: 'key',
  foreground: '#00a8ff'
}, {
  token: 'string.key.json',
  foreground: '#00a8ff'
}, {
  token: 'string.value.json',
  foreground: theme.appleAccent4
}, {
  token: 'attribute.name',
  foreground: '#f08c36'
}, {
  token: 'attribute.value',
  foreground: '#0451A5'
}, {
  token: 'attribute.value.number',
  foreground: '#abb0b6'
}, {
  token: 'attribute.value.unit',
  foreground: theme.appleAccent4
}, {
  token: 'attribute.value.html',
  foreground: theme.appleAccent4
}, {
  token: 'attribute.value.xml',
  foreground: theme.appleAccent4
}, {
  token: 'string',
  foreground: theme.appleAccent4
}, {
  token: 'string.html',
  foreground: theme.appleAccent4
}, {
  token: 'string.sql',
  foreground: theme.appleAccent4
}, {
  token: 'string.yaml',
  foreground: theme.appleAccent4
}, {
  token: 'keyword',
  foreground: '#f2590c'
}, {
  token: 'keyword.json',
  foreground: '#f2590c'
}, {
  token: 'keyword.flow',
  foreground: '#f2590c'
}, {
  token: 'keyword.flow.scss',
  foreground: '#f2590c'
}, {
  token: 'operator.scss',
  foreground: '#666666'
}, {
  token: 'operator.sql',
  foreground: '#778899'
}, {
  token: 'operator.swift',
  foreground: '#666666'
}, {
  token: 'predefined.sql',
  foreground: '#FF00FF'
}];
var MonacoEditor = function MonacoEditor(_ref) {
  var defaultLanguage = _ref.defaultLanguage,
    defaultValue = _ref.defaultValue,
    layoutOptions = _ref.layoutOptions,
    modelPath = _ref.modelPath,
    themeRules = _ref.themeRules,
    beforeMount = _ref.beforeMount,
    onMount = _ref.onMount;
  var handleEditorWillMount = function handleEditorWillMount(monaco) {
    monaco.editor.getModels().forEach(function (model) {
      return model.dispose();
    });
    beforeMount === null || beforeMount === void 0 ? void 0 : beforeMount(monaco);
    monaco.editor.defineTheme('aserto', {
      base: 'vs-dark',
      inherit: true,
      rules: [].concat(VsCodeAserto, _toConsumableArray(themeRules || [])),
      colors: {
        'editor.background': theme.primaryBlack,
        'editor.foreground': '#5c6773',
        'editorIndentGuide.background': theme.indogo20,
        'editorIndentGuide.activeBackground': theme.indogo30,
        'editorBracketHighlight.foreground1': theme.grey90,
        'editorBracketHighlight.foreground2': theme.grey90,
        'editorBracketHighlight.foreground3': theme.grey90,
        'editorBracketHighlight.foreground4': theme.grey90,
        'editorBracketHighlight.foreground5': theme.grey90,
        'editorBracketHighlight.foreground6': theme.grey90,
        'editorBracketHighlight.unexpectedBracket.foreground': theme.grey90
      }
    });
  };
  return /*#__PURE__*/React.createElement(Editor$1, {
    beforeMount: handleEditorWillMount,
    defaultLanguage: defaultLanguage,
    defaultValue: defaultValue,
    options: layoutOptions,
    path: modelPath,
    onMount: onMount
  });
};

var StyledEditor = styled.div.withConfig({
  displayName: "styles__StyledEditor",
  componentId: "k59rgq-0"
})(["height:100vh;"]);
var SaveButton = styled(Button).withConfig({
  displayName: "styles__SaveButton",
  componentId: "k59rgq-1"
})(["width:136px;"]);
var ButtonsContainer$7 = styled.div.withConfig({
  displayName: "styles__ButtonsContainer",
  componentId: "k59rgq-2"
})(["vertical-align:middle;margin-bottom:16px;display:flex;flex-direction:row;justify-content:flex-end;gap:10px;"]);
var Image = styled.img.withConfig({
  displayName: "styles__Image",
  componentId: "k59rgq-3"
})(["margin-bottom:1px;"]);
var ControlsContainer$1 = styled.div.withConfig({
  displayName: "styles__ControlsContainer",
  componentId: "k59rgq-4"
})(["display:flex;flex-direction:column;gap:10px;justify-content:space-between;width:100%;"]);
var PropertiesContainer$2 = styled.div.withConfig({
  displayName: "styles__PropertiesContainer",
  componentId: "k59rgq-5"
})(["display:flex;flex-direction:column;gap:10px;justify-content:space-between;margin:20px;"]);

var ModelEditor = function ModelEditor() {
  var defaultSchema = useMemo(function () {
    return {
      uri: 'https://www.topaz.sh/schema/manifest.json',
      fileMatch: ['file://**/manifest.yaml']
    };
  }, []);
  var _useDirectoryModelCon = useDirectoryModelContext(),
    code = _useDirectoryModelCon.code,
    setCode = _useDirectoryModelCon.setCode,
    setVisible = _useDirectoryModelCon.setVisible;
  var queryClient = useQueryClient();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modified = _useState2[0],
    setModified = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasError = _useState4[0],
    setHasError = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    errors = _useState6[0],
    setErrors = _useState6[1];
  var editorRef = useRef();
  var _useManifestData = useManifestData(),
    manifestData = _useManifestData.data,
    manifestQueryKey = _useManifestData.queryKey,
    isRefetching = _useManifestData.isRefetching;
  var manifest = useMemo(function () {
    return (manifestData === null || manifestData === void 0 ? void 0 : manifestData.toString()) || '';
  }, [manifestData]);
  var setManifest = useDirectoryV3ManifestSet();
  var showError = useShowError();
  var resetCode = useCallback(function () {
    var _a;
    if (!!manifest) {
      setCode(manifest);
      (_a = editorRef === null || editorRef === void 0 ? void 0 : editorRef.current) === null || _a === void 0 ? void 0 : _a.setValue(manifest);
    }
    setHasError(false);
    setErrors([]);
    setModified(false);
  }, [manifest, setCode]);
  var saveCode = useCallback(function () {
    var _a;
    var parsed;
    if (!!code) {
      try {
        parsed = YAML.parseDocument(code);
        (_a = editorRef === null || editorRef === void 0 ? void 0 : editorRef.current) === null || _a === void 0 ? void 0 : _a.setValue(parsed.toString());
        setManifest.mutate({
          data: new Blob([parsed.toString()], {
            type: 'application/yaml'
          })
        }, {
          onSuccess: function onSuccess() {
            queryClient.invalidateQueries(manifestQueryKey);
            setModified(false);
          },
          onError: function onError(error) {
            showError(error);
            setHasError(true);
          }
        });
        setErrors(undefined);
      } catch (e) {
        setErrors(errors === null || errors === void 0 ? void 0 : errors.concat([String(e)]));
      }
    }
  }, [code, setErrors, errors, manifestQueryKey, queryClient, setManifest, showError]);
  var handleOnChange = useCallback(function (value) {
    setModified(true);
    if (value) {
      try {
        YAML.parse(value);
        setCode(value || '');
      } catch (_a) {}
    }
  }, [setCode]);
  var handleEditorWillMount = function handleEditorWillMount(monaco) {
    configureMonacoYaml(monaco, {
      enableSchemaRequest: true,
      schemas: [defaultSchema]
    });
  };
  var handleEditorDidMount = useCallback(function (editor, monaco) {
    var _a, _b, _c, _d;
    monaco.editor.setTheme('aserto');
    editorRef.current = editor;
    (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.onDidChangeModelContent(function () {
      var _a;
      handleOnChange((_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.getValue());
    });
    (_b = editorRef.current) === null || _b === void 0 ? void 0 : _b.onDidChangeModelDecorations(function () {
      var markers = monaco.editor.getModelMarkers({
        owner: 'yaml'
      }).filter(function (m) {
        return m.severity > 4;
      });
      setHasError(markers.length !== 0);
    });
    (_c = editorRef.current) === null || _c === void 0 ? void 0 : _c.updateOptions({
      tabSize: 2,
      fontSize: 14,
      fontLigatures: true,
      scrollbar: {
        verticalScrollbarSize: 4,
        horizontalScrollbarSize: 4
      },
      inlineSuggest: {
        enabled: true
      },
      fontFamily: "'Fira Code', -apple-system, BlinkMacSystemFont, 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell','Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
      minimap: {
        enabled: false
      }
    });
    setCode(manifest);
    (_d = editorRef.current) === null || _d === void 0 ? void 0 : _d.setValue(manifest);
    setModified(false);
  }, [handleOnChange, setCode, setModified, manifest]);
  useEffect(function () {
    var _a;
    if (isRefetching && (setManifest.isIdle || setManifest.isError)) {
      (_a = editorRef === null || editorRef === void 0 ? void 0 : editorRef.current) === null || _a === void 0 ? void 0 : _a.setValue(manifest);
    }
  }, [isRefetching, manifest, setManifest.isIdle, setManifest.isError]);
  useEffect(function () {
    var _a;
    (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.setValue(manifest);
    var markers = monaco.editor.getModelMarkers({
      owner: 'yaml'
    }).filter(function (m) {
      return m.severity > 4;
    });
    setHasError(markers.length !== 0);
    setModified(false);
  }, [manifest, setHasError]);
  return /*#__PURE__*/React.createElement(PropertiesContainer$2, null, /*#__PURE__*/React.createElement(ControlsContainer$1, null, /*#__PURE__*/React.createElement(ButtonsContainer$7, null, /*#__PURE__*/React.createElement(SaveButton, {
    disabled: !modified || hasError || setManifest.isLoading,
    variant: "primary",
    onClick: saveCode
  }, /*#__PURE__*/React.createElement(Image, {
    alt: "plus",
    src: img$d
  }), "\xA0\xA0Save"), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: function onClick() {
      resetCode();
      setVisible(false);
    }
  }, "Cancel"))), /*#__PURE__*/React.createElement(StyledEditor, null, /*#__PURE__*/React.createElement(MonacoEditor, {
    beforeMount: handleEditorWillMount,
    defaultLanguage: "yaml",
    layoutOptions: {
      automaticLayout: true
    },
    modelPath: "manifest.yaml",
    onMount: handleEditorDidMount
  })));
};

var img$c = "data:image/svg+xml,%3csvg width='86' height='62' viewBox='0 0 86 62' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 9.5C0 4.25329 4.25329 0 9.5 0H29.5C34.7467 0 39 4.2533 39 9.5V13.2983C39.7764 13.6094 40.4901 14.1386 41.1794 14.7657C42.5873 16.0464 44.0847 17.8542 45.2693 19.7111C46.246 21.2419 47.1992 22.9076 48.0596 24.6947L50.3696 23.7924L49.5 29.5L44.9919 25.8931L47.1254 25.0596C46.2935 23.3397 45.3725 21.7319 44.4263 20.2489C43.2824 18.4559 41.8403 16.7187 40.5065 15.5054C39.9822 15.0284 39.4882 14.6546 39 14.3988V17.5C39 22.7467 34.7467 27 29.5 27H9.5C4.25329 27 0 22.7467 0 17.5V9.5ZM9.5 3C5.91015 3 3 5.91015 3 9.5V17.5C3 21.0899 5.91015 24 9.5 24H29.5C33.0899 24 36 21.0899 36 17.5V9.5C36 5.91015 33.0899 3 29.5 3H9.5ZM56.8398 21.5L52.7898 30.5L56.8398 39.5H78.1602L82.2102 30.5L78.1602 21.5H56.8398ZM54.9 18.5L49.5 30.5L54.9 42.5H80.1L85.5 30.5L80.1 18.5H54.9ZM9.5 35C4.25329 35 0 39.2533 0 44.5V52.5C0 57.7467 4.25329 62 9.5 62H29.5C34.7467 62 39 57.7467 39 52.5V48.6967C39.7466 48.3526 40.4306 47.7961 41.0882 47.1459C42.48 45.7697 43.9548 43.8326 45.1164 41.8477C46.1158 40.1397 47.0878 38.2766 47.954 36.2751L50.2739 37.0986L49.226 31.421L44.833 35.1673L47.0094 35.9398C46.1683 37.8753 45.2253 39.6816 44.2533 41.3426C43.1288 43.2643 41.7056 45.1291 40.385 46.4348C39.9034 46.9111 39.4482 47.2911 39 47.5642V44.5C39 39.2533 34.7467 35 29.5 35H9.5ZM3 44.5C3 40.9101 5.91015 38 9.5 38H29.5C33.0899 38 36 40.9101 36 44.5V52.5C36 56.0899 33.0899 59 29.5 59H9.5C5.91015 59 3 56.0899 3 52.5V44.5Z' fill='%23E3E3E3'/%3e%3c/svg%3e";

var ObjectType = styled.div.withConfig({
  displayName: "CustomNodes__ObjectType",
  componentId: "tc37sf-0"
})(["width:120px;height:40px;padding:8px;color:", ";.react-flow__handle{opacity:0;}.react-flow__handle-top{top:-1px;}.react-flow__handle-bottom{bottom:-1px;}.react-flow__handle-left{left:-1px;}.react-flow__handle-right{right:-1px;}"], theme.grey100);
var Permission = styled(ObjectType).withConfig({
  displayName: "CustomNodes__Permission",
  componentId: "tc37sf-1"
})(["width:140px;"]);
var Operator = styled(ObjectType).withConfig({
  displayName: "CustomNodes__Operator",
  componentId: "tc37sf-2"
})(["width:40px;"]);
var RelationTypes = styled(ObjectType).withConfig({
  displayName: "CustomNodes__RelationTypes",
  componentId: "tc37sf-3"
})(["width:140px;.react-flow__handle{opacity:0;}"]);
var NodeLabel$1 = styled.div.withConfig({
  displayName: "CustomNodes__NodeLabel",
  componentId: "tc37sf-4"
})(["overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-size:16px;text-align:center;line-height:20px;"]);
var Tooltip = styled.span.withConfig({
  displayName: "CustomNodes__Tooltip",
  componentId: "tc37sf-5"
})(["color:", ";"], theme.grey100);
// collect zoom level changes
var zoomSelector = function zoomSelector(s) {
  return s.transform[2];
};
var ObjectTypeNode = /*#__PURE__*/memo(function (_ref) {
  var data = _ref.data;
  var _a;
  var zoomLevel = useStore(zoomSelector) || 1;
  var fontSize = zoomLevel * 16;
  var offset = zoomLevel * 4;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ObjectType, null, /*#__PURE__*/React.createElement(NodeToolbar, {
    isVisible: data.toolbarVisible && ((_a = data.toolbarValue) === null || _a === void 0 ? void 0 : _a.length) > 11,
    offset: offset,
    position: data.toolbarPosition
  }, /*#__PURE__*/React.createElement(Tooltip, {
    style: {
      fontSize: "".concat(fontSize || 16, "px")
    }
  }, data.toolbarValue)), !!data.targetHandle && /*#__PURE__*/React.createElement(Handle, {
    position: Position.Left,
    type: "target"
  }), /*#__PURE__*/React.createElement(NodeLabel$1, null, data.label), !!data.sourceHandle && /*#__PURE__*/React.createElement(Handle, {
    position: Position.Right,
    type: "source"
  })));
});
var PermissionNode = /*#__PURE__*/memo(function (_ref2) {
  var data = _ref2.data;
  var _a;
  var zoomLevel = useStore(zoomSelector) || 1;
  var fontSize = zoomLevel * 16;
  var offset = zoomLevel * 4;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Permission, null, /*#__PURE__*/React.createElement(NodeToolbar, {
    isVisible: data.toolbarVisible && ((_a = data.toolbarValue) === null || _a === void 0 ? void 0 : _a.length) > 15,
    offset: offset,
    position: data.toolbarPosition
  }, /*#__PURE__*/React.createElement(Tooltip, {
    style: {
      fontSize: "".concat(fontSize || 16, "px")
    }
  }, data.toolbarValue)), !!data.targetHandle && /*#__PURE__*/React.createElement(Handle, {
    position: Position.Left,
    type: "target"
  }), !!data.targetHandle && (/*#__PURE__*/React.createElement(Handle, {
    id: "relation",
    position: Position.Bottom,
    style: {
      left: 76
    },
    type: "target"
  })), !!data.targetHandle && (/*#__PURE__*/React.createElement(Handle, {
    id: "permission",
    position: Position.Bottom,
    style: {
      left: 88
    },
    type: "target"
  })), !!data.targetHandle && (/*#__PURE__*/React.createElement(Handle, {
    id: "parent-relation",
    position: Position.Bottom,
    style: {
      left: 64
    },
    type: "target"
  })), /*#__PURE__*/React.createElement(NodeLabel$1, null, data.label), !!data.sourceHandle && /*#__PURE__*/React.createElement(Handle, {
    position: Position.Right,
    type: "source"
  })));
});
var RelationTypesNode = /*#__PURE__*/memo(function (_ref3) {
  var data = _ref3.data;
  var _a;
  var zoomLevel = useStore(zoomSelector) || 1;
  var fontSize = zoomLevel * 16;
  var offset = zoomLevel * 4;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NodeToolbar, {
    isVisible: data.toolbarVisible && ((_a = data.toolbarValue) === null || _a === void 0 ? void 0 : _a.length) > 15,
    offset: offset,
    position: data.toolbarPosition
  }, /*#__PURE__*/React.createElement(Tooltip, {
    style: {
      fontSize: "".concat(fontSize || 16, "px")
    }
  }, data.toolbarValue)), /*#__PURE__*/React.createElement(RelationTypes, null, !!data.targetHandle && /*#__PURE__*/React.createElement(Handle, {
    position: Position.Left,
    type: "target"
  }), /*#__PURE__*/React.createElement(NodeLabel$1, null, data.label), !!data.sourceHandle && /*#__PURE__*/React.createElement(Handle, {
    position: Position.Right,
    type: "source"
  }), !!data.sourceHandle && /*#__PURE__*/React.createElement(Handle, {
    id: "permission",
    position: Position.Bottom,
    type: "source"
  })));
});
var OperatorNode = /*#__PURE__*/memo(function (_ref4) {
  var data = _ref4.data;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Operator, null, !!data.targetHandle && /*#__PURE__*/React.createElement(Handle, {
    position: Position.Left,
    type: "target"
  }), /*#__PURE__*/React.createElement(NodeLabel$1, null, data.label), !!data.sourceHandle && /*#__PURE__*/React.createElement(Handle, {
    position: Position.Right,
    type: "source"
  }), !!data.sourceHandle && /*#__PURE__*/React.createElement(Handle, {
    id: "permission",
    position: Position.Bottom,
    type: "source"
  })));
});

function computeColor$1(s) {
  return colorListByType$1[s];
}
var colorListByType$1 = {
  object: {
    backgroundColor: theme.cooperAccent1,
    borderColor: theme.cooperAccent3
  },
  subject: {
    backgroundColor: theme.cooperAccent1,
    borderColor: theme.cooperAccent3
  },
  relation: {
    backgroundColor: theme.indogoAccent1,
    borderColor: theme.indogoAccent3
  },
  permission: {
    backgroundColor: theme.plumAccent1,
    borderColor: theme.plumAccent3
  },
  operator: {
    backgroundColor: theme.appleAccent1,
    borderColor: theme.appleAccent3
  }
};

var markerEnd = {
  type: MarkerType.ArrowClosed,
  width: 20,
  height: 20,
  color: theme.grey60
};
/**
 * Generates a graph data structure based on the input `types`.
 * The graph represents relationships between different types of objects and their permissions and relations.
 */
var GetGraphData = function GetGraphData(parsedManifest, nodeStyle) {
  return useMemo(function () {
    // base horizontal position
    var baseY = 0;
    // base position step
    var step = 84;
    // // initial X position
    var objectsX = 40;
    var permissionsX = 340;
    var operatorsX = 600;
    var relationsX = 820;
    var subjectsX = 1120;
    var objectNodes = [];
    var subjectNodes = [];
    var relationNodes = [];
    var permissionNodes = [];
    var operatorNodes = [];
    var objectEdges = [];
    var permissionEdges = [];
    var operatorEdges = [];
    var relationEdges = [];
    parsedManifest.forEach(function (data) {
      var currentDepth = 1;
      var relations = data.relations || [];
      var relationsDepth = relations.length;
      if (relationsDepth > currentDepth) {
        currentDepth = relationsDepth;
      }
      var subjectsCount = 0;
      var uniqueSubjects = relations.flatMap(function (relation) {
        return relation.subjects || [];
      }).filter(function (value, index, array) {
        return array.indexOf(value) === index;
      }).length;
      relations.forEach(function (relation, relationIndex) {
        var _a;
        var subjects = relation.subjects || [];
        var subjectsDepth = subjects.length;
        if (subjectsDepth > currentDepth) {
          currentDepth = subjectsDepth;
        }
        relationNodes.push({
          id: "".concat(data.object, "-").concat(relation.key),
          type: 'relation',
          sourcePosition: Position.Right,
          targetPosition: Position.Left,
          data: {
            context: data.object,
            label: relation.key,
            sourceHandle: true,
            targetHandle: true,
            toolbarValue: relation.key
          },
          position: {
            x: relationsX,
            y: subjectsDepth <= 2 ? baseY + relationIndex * step : baseY + (Math.round(uniqueSubjects / 2) - 2 + relationIndex) * step
          },
          style: nodeStyle('relation')
        });
        // Arrow operator edges
        Object.entries(relation.permissions || {}).forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2);
            _ref2[0];
            var values = _ref2[1];
          values.forEach(function (value) {
            relation.subjects.forEach(function (subject) {
              var target = subject === data.object ? 'relation' : 'parent-relation';
              var id = "".concat(data.object, "-").concat(relation.key, ":").concat(subject, "-").concat(value);
              var edgeExists = relationEdges.findIndex(function (relationEdge) {
                return relationEdge.id === id;
              });
              if (edgeExists === -1) {
                relationEdges.push({
                  id: "".concat(id),
                  source: "".concat(data.object, "-").concat(relation.key),
                  target: "".concat(subject, "-").concat(value),
                  sourceHandle: 'permission',
                  targetHandle: target,
                  markerEnd: markerEnd,
                  type: 'smoothstep',
                  style: {
                    strokeDasharray: '5'
                  }
                });
              }
            });
          });
        });
        subjects.forEach(function (subject) {
          var existingCount = 0;
          var existingSubject = subjectNodes.filter(function (sn) {
            return sn.id === "".concat(data.object, "-").concat(subject, "-subject");
          }).length > 0;
          if (!existingSubject) {
            subjectNodes.push({
              id: "".concat(data.object, "-").concat(subject, "-subject"),
              type: 'subject',
              sourcePosition: Position.Right,
              targetPosition: Position.Left,
              data: {
                context: data.object,
                label: subject,
                sourceHandle: true,
                targetHandle: true,
                toolbarValue: subject
              },
              position: {
                x: subjectsX,
                y: baseY + (subjectsCount - existingCount) * step
              },
              style: nodeStyle('object')
            });
            subjectsCount = subjectsCount + 1;
          } else {
            existingCount = existingCount + 1;
          }
          if (subjectsCount - existingCount > currentDepth) {
            currentDepth = subjectsCount - existingCount;
          }
          relationEdges.push({
            id: "".concat(data.object, "-").concat(relation.key, ":").concat(data.object, "-").concat(subject, "-subject"),
            source: "".concat(data.object, "-").concat(relation.key),
            target: "".concat(data.object, "-").concat(subject, "-subject"),
            markerEnd: markerEnd
          });
        });
        // If there are no permissions for this relation, create an edge between object and relation
        if (((_a = data.permissions) === null || _a === void 0 ? void 0 : _a.filter(function (permission) {
          return permission.relations.has(relation.key);
        }).length) === 0) {
          objectEdges.push({
            id: "".concat(data.object, "-object:").concat(data.object, "-").concat(relation.key),
            source: "".concat(data.object, "-object"),
            target: "".concat(data.object, "-").concat(relation.key),
            markerEnd: markerEnd
          });
        }
      });
      var permissions = data.permissions || [];
      var permissionsDepth = permissions.length;
      if (permissionsDepth > currentDepth) {
        currentDepth = permissionsDepth;
      }
      permissions.forEach(function (permission, permissionIndex) {
        permissionNodes.push({
          id: "".concat(data.object, "-").concat(permission.key),
          type: 'permission',
          sourcePosition: Position.Right,
          targetPosition: Position.Left,
          data: {
            context: data.object,
            label: permission.key,
            sourceHandle: true,
            targetHandle: true,
            toolbarValue: permission.key
          },
          position: {
            x: permissionsX,
            y: baseY + permissionIndex * step
          },
          style: nodeStyle('permission')
        });
        operatorNodes.push({
          id: "".concat(data.object, "-").concat(permission.key, "-").concat(permission.operator),
          type: 'operator',
          sourcePosition: Position.Right,
          targetPosition: Position.Left,
          data: {
            context: data.object,
            permission: permission.key,
            label: permission.operator,
            sourceHandle: true,
            targetHandle: true
          },
          position: {
            x: operatorsX,
            y: baseY + permissionIndex * step
          },
          style: nodeStyle('operator')
        });
        objectEdges.push({
          id: "".concat(data.object, "-object:").concat(data.object, "-").concat(permission.key),
          source: "".concat(data.object, "-object"),
          target: "".concat(data.object, "-").concat(permission.key),
          markerEnd: markerEnd
        });
        permissionEdges.push({
          id: "".concat(data.object, "-").concat(permission.key, ":").concat(data.object, "-").concat(permission.key, "-").concat(permission.operator),
          source: "".concat(data.object, "-").concat(permission.key),
          target: "".concat(data.object, "-").concat(permission.key, "-").concat(permission.operator),
          markerEnd: markerEnd
        });
        var permissionsKeys = permissions.map(function (permission) {
          return permission.key;
        });
        permission.relations.forEach(function (relation) {
          var isPermission = permissionsKeys.includes(relation);
          operatorEdges.push({
            id: "".concat(data.object, "-").concat(permission.key, "-").concat(permission.operator, ":").concat(data.object, "-").concat(relation),
            source: "".concat(data.object, "-").concat(permission.key, "-").concat(permission.operator),
            target: "".concat(data.object, "-").concat(relation),
            sourceHandle: isPermission ? 'permission' : undefined,
            targetHandle: isPermission ? 'permission' : undefined,
            markerEnd: markerEnd,
            type: isPermission ? 'smoothstep' : 'default'
          });
        });
      });
      objectNodes.push({
        id: "".concat(data.object, "-object"),
        type: 'object',
        sourcePosition: Position.Right,
        data: {
          context: data.object,
          label: data.object,
          sourceHandle: true,
          toolbarValue: data.object
        },
        position: {
          x: objectsX,
          y: baseY + (Math.round(currentDepth / 2) - 1) * step
        },
        style: nodeStyle('object')
      });
      // set the new base
      baseY = baseY + currentDepth * step;
    });
    return {
      nodes: objectNodes.concat(operatorNodes).concat(permissionNodes).concat(relationNodes).concat(subjectNodes),
      edges: objectEdges.concat(permissionEdges).concat(operatorEdges).concat(relationEdges)
    };
  }, [parsedManifest, nodeStyle]);
};

var unionIdentifier = '|';
var intersectionIdentifier = '&';
var exclusionIdentifier = '-';
var arrowOperator = '->';
var equalOperator = '=';
var handleArrowOperator = function handleArrowOperator(block, permissionData, permissionKey, entry) {
  var _block$split = block.split(arrowOperator),
    _block$split2 = _slicedToArray(_block$split, 2),
    relation = _block$split2[0],
    permission = _block$split2[1];
  var existingPermissionIndex = permissionData.findIndex(function (permission) {
    return permission.key === permissionKey;
  });
  if (existingPermissionIndex > -1) {
    permissionData[existingPermissionIndex].relations.add(relation);
  } else {
    permissionData.push({
      key: permissionKey,
      operator: unionIdentifier,
      relations: new Set([relation])
    });
  }
  var relationsData = entry.relations || [];
  var existingRelationIndex = relationsData.findIndex(function (relationData) {
    return relationData.key === relation;
  });
  if (existingRelationIndex > -1) {
    if (entry.relations) {
      if (entry.relations[existingRelationIndex].permissions[permissionKey]) {
        entry.relations[existingRelationIndex].permissions[permissionKey].push(permission);
      } else {
        entry.relations[existingRelationIndex].permissions[permissionKey] = [permission];
      }
    }
  }
};
var parseManifest = function parseManifest(manifest) {
  var _a, _b, _c, _d;
  var parsedManifest = [];
  if (!(manifest === null || manifest === void 0 ? void 0 : manifest.types) || typeof manifest.types === 'string') {
    return parsedManifest;
  }
  var _loop = function _loop() {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      typeName = _Object$entries$_i[0],
      type = _Object$entries$_i[1];
    var entry = {
      object: typeName,
      relations: [],
      permissions: []
    };
    var relations = ((_a = type === null || type === void 0 ? void 0 : type.relations) === null || _a === void 0 ? void 0 : _a.constructor) === Object ? type === null || type === void 0 ? void 0 : type.relations : [];
    for (var _i2 = 0, _Object$entries2 = Object.entries(relations); _i2 < _Object$entries2.length; _i2++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
        relation = _Object$entries2$_i[0],
        value = _Object$entries2$_i[1];
      var relationValues = (_c = (_b = value === null || value === void 0 ? void 0 : value.split(" ".concat(unionIdentifier, " "))) === null || _b === void 0 ? void 0 : _b.filter(function (item) {
        return item !== null && item !== '' && item !== ' ';
      })) === null || _c === void 0 ? void 0 : _c.filter(function (item, i, ar) {
        return ar.indexOf(item) === i;
      });
      var relationData = {
        key: relation,
        subjects: relationValues,
        permissions: {}
      };
      entry.relations.push(relationData);
    }
    var permissions = ((_d = type === null || type === void 0 ? void 0 : type.permissions) === null || _d === void 0 ? void 0 : _d.constructor) === Object ? type === null || type === void 0 ? void 0 : type.permissions : [];
    var permissionData = [];
    Object.entries(permissions).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        permissionKey = _ref2[0],
        value = _ref2[1];
      if (value !== null && value !== undefined) {
        if (value.includes(" ".concat(unionIdentifier, " "))) {
          var blocks = value.split(" ".concat(unionIdentifier, " "));
          if (blocks.length > 0) {
            blocks.forEach(function (block) {
              if (block.includes(arrowOperator)) {
                handleArrowOperator(block, permissionData, permissionKey, entry);
              } else {
                var existingPermissionIndex = permissionData.findIndex(function (permission) {
                  return permission.key === permissionKey;
                });
                if (existingPermissionIndex > -1) {
                  permissionData[existingPermissionIndex].relations.add(block);
                } else {
                  permissionData.push({
                    key: permissionKey,
                    operator: unionIdentifier,
                    relations: new Set([block])
                  });
                }
              }
            });
          } else {
            permissionData.push({
              key: permissionKey,
              operator: unionIdentifier,
              relations: new Set(value.split(" ".concat(unionIdentifier, " ")))
            });
          }
        } else if (value.includes(" ".concat(intersectionIdentifier, " "))) {
          permissionData.push({
            key: permissionKey,
            operator: unionIdentifier,
            relations: new Set(value.split(" ".concat(intersectionIdentifier, " ")))
          });
        } else if (value.includes(arrowOperator)) {
          handleArrowOperator(value, permissionData, permissionKey, entry);
        } else if (value.includes(" ".concat(exclusionIdentifier, " "))) {
          permissionData.push({
            key: permissionKey,
            operator: unionIdentifier,
            relations: new Set(value.split(" ".concat(exclusionIdentifier, " ")))
          });
        } else {
          permissionData.push({
            key: permissionKey,
            operator: equalOperator,
            relations: new Set([value])
          });
        }
      }
    });
    Array.prototype.push.apply(entry.permissions, permissionData);
    parsedManifest.push(entry);
  };
  for (var _i = 0, _Object$entries = Object.entries(manifest.types); _i < _Object$entries.length; _i++) {
    _loop();
  }
  return parsedManifest;
};

var mapNodePath = function mapNodePath(parsedManifest) {
  var dataMap = new Map(parsedManifest.map(function (data) {
    return [data.object, data];
  }));
  return function (node) {
    var _a, _b;
    var nodes = [];
    var nodeType = node.type || '';
    var object = node.data.context;
    var target = node.id.split("".concat(object, "-"))[1];
    var data = dataMap.get(object);
    var relations = (data === null || data === void 0 ? void 0 : data.relations) || [];
    var permissions = (data === null || data === void 0 ? void 0 : data.permissions) || [];
    if (nodeType === 'subject') {
      target = target.replace('-subject', '');
      relations = relations.filter(function (relation) {
        return relation.subjects.includes(target);
      });
    }
    if (['object', 'subject', 'permission'].includes(nodeType)) {
      if (['object', 'subject'].includes(nodeType)) {
        nodes.push("".concat(object, "-object"));
        relations.forEach(function (relation) {
          nodes.push("".concat(object, "-").concat(relation.key));
          if (nodeType === 'subject') {
            nodes.push("".concat(object, "-").concat(target, "-subject"));
          } else {
            relation.subjects.forEach(function (subject) {
              nodes.push("".concat(object, "-").concat(subject, "-subject"));
            });
          }
        });
      }
      if (nodeType === 'permission') {
        permissions = ((_a = data === null || data === void 0 ? void 0 : data.permissions) === null || _a === void 0 ? void 0 : _a.filter(function (permission) {
          return permission.key === target;
        })) || [];
      }
      permissions.forEach(function (permission) {
        nodes.push("".concat(object, "-").concat(permission.key));
        nodes.push("".concat(object, "-").concat(permission.key, "-").concat(permission.operator));
        permission.relations.forEach(function (relation) {
          var relationData = relations.find(function (relationData) {
            return relationData.key === relation;
          });
          if (relationData) {
            var newPermData = relationData.permissions[permission.key];
            if (newPermData && newPermData.length > 0) {
              relationData.subjects.forEach(function (subject) {
                var _a, _b;
                var subjectData = dataMap.get(subject);
                var subjectRelation = (_a = subjectData === null || subjectData === void 0 ? void 0 : subjectData.permissions) === null || _a === void 0 ? void 0 : _a.find(function (perm) {
                  return perm.key === permission.key;
                });
                nodes.push("".concat(subject, "-").concat(permission.key));
                nodes.push("".concat(subject, "-").concat(permission.key, "-").concat(permission.operator));
                (_b = subjectRelation === null || subjectRelation === void 0 ? void 0 : subjectRelation.relations) === null || _b === void 0 ? void 0 : _b.forEach(function (relation) {
                  nodes.push("".concat(subject, "-").concat(relation));
                });
                if (nodeType === 'permission') {
                  newPermData.forEach(function (perm) {
                    nodes.push("".concat(subject, "-").concat(perm));
                  });
                }
              });
            } else {
              var permissionData = relationData.permissions[permission.key] || [];
              relationData.subjects.forEach(function (subject) {
                nodes.push("".concat(subject, "-").concat(relation));
                permissionData.forEach(function (perm) {
                  nodes.push("".concat(subject, "-").concat(perm));
                  nodes.push("".concat(subject, "-").concat(perm, "-").concat(permission.operator));
                });
              });
            }
          }
          nodes.push("".concat(object, "-").concat(relation));
        });
      });
    }
    if (nodeType === 'relation') {
      var _permissions = ((_b = data === null || data === void 0 ? void 0 : data.permissions) === null || _b === void 0 ? void 0 : _b.filter(function (permission) {
        return permission.relations.has(target);
      })) || [];
      if (_permissions.length > 0) {
        _permissions.forEach(function (permission) {
          nodes.push("".concat(object, "-").concat(permission.key));
          nodes.push("".concat(object, "-").concat(permission.key, "-").concat(permission.operator));
        });
      } else {
        var relationData = relations.find(function (relationData) {
          return relationData.key === target;
        });
        if (relationData) {
          relationData.subjects.forEach(function (subject) {
            nodes.push("".concat(object, "-").concat(subject, "-subject"));
          });
        }
        nodes.push("".concat(object, "-").concat(target));
        nodes.push("".concat(object, "-object"));
      }
    }
    if (nodeType === 'operator') {
      var permissionKey = node.data.permission;
      var operator = target.replace("".concat(permissionKey, "-"), '');
      nodes.push("".concat(object, "-").concat(permissionKey, "-").concat(operator));
      permissions.filter(function (permission) {
        return permission.operator === operator && permission.key === permissionKey;
      }).forEach(function (permission) {
        nodes.push("".concat(object, "-").concat(permission.key));
        permission.relations.forEach(function (relation) {
          nodes.push("".concat(object, "-").concat(relation));
        });
      });
    }
    return nodes;
  };
};

var ReactFlowContainer$2 = styled.div.withConfig({
  displayName: "Graph__ReactFlowContainer",
  componentId: "sc-1ygi0jx-0"
})(["height:calc(100vh - 160px);width:100%;@media (max-width:912px){height:calc(100vh - 230px);}.react-flow{margin-top:20px;}.react-flow__minimap{background-color:", ";border:1px solid ", ";}.react-flow__node-custom{border:1px solid ", ";border-radius:5px;text-align:center;&:hover{cursor:pointer;}}"], theme.primaryBlack, theme.grey30, theme.grey30);
var nodeTypes$1 = {
  object: ObjectTypeNode,
  subject: ObjectTypeNode,
  permission: PermissionNode,
  relation: RelationTypesNode,
  operator: OperatorNode
};
var ModelFlow = function ModelFlow() {
  var _useDirectoryModelCon = useDirectoryModelContext(),
    code = _useDirectoryModelCon.code;
  var _useNodesState = useNodesState([]),
    _useNodesState2 = _slicedToArray(_useNodesState, 2),
    nodes = _useNodesState2[0],
    setNodes = _useNodesState2[1];
  var _useEdgesState = useEdgesState([]),
    _useEdgesState2 = _slicedToArray(_useEdgesState, 2),
    edges = _useEdgesState2[0],
    setEdges = _useEdgesState2[1];
  var onNodesChange = useCallback(function (changes) {
    return setNodes(function (nds) {
      return applyNodeChanges(changes, nds);
    });
  }, [setNodes]);
  var onEdgesChange = useCallback(function (changes) {
    return setEdges(function (eds) {
      return applyEdgeChanges(changes, eds);
    });
  }, [setEdges]);
  var _useManifest = useManifest(),
    initialManifest = _useManifest.data,
    isLoading = _useManifest.isLoading;
  var navigate = useNavigate();
  var manifest = useManifestToYaml(code) || initialManifest;
  var _useFeatureFlags = useFeatureFlags(),
    hasTemplates = _useFeatureFlags.hasTemplates;
  var nodeStyle = useCallback(function (nodeType) {
    return {
      backgroundColor: theme.primaryBlack,
      borderRadius: nodeType === 'object' ? '16px' : '4px',
      borderColor: computeColor$1(nodeType).borderColor,
      borderWidth: '1px',
      borderStyle: 'solid'
    };
  }, []);
  var parsedManifest = useMemo(function () {
    return parseManifest(manifest);
  }, [manifest]);
  var data = GetGraphData(parsedManifest, nodeStyle);
  useEffect(function () {
    setNodes(data.nodes);
  }, [setNodes, data.nodes]);
  useEffect(function () {
    setEdges(data.edges);
  }, [setEdges, data.edges]);
  var highlightPath = function highlightPath(node, nodes, edges, selection) {
    var getNodePath = mapNodePath(parsedManifest);
    if (node && [].concat(_toConsumableArray(nodes), _toConsumableArray(edges))) {
      var incomerIds = getNodePath(node);
      var outgoerIds = getNodePath(node);
      setNodes(function (prevElements) {
        return prevElements === null || prevElements === void 0 ? void 0 : prevElements.map(function (elem) {
          if (isNode(elem) && (incomerIds.length > 0 || outgoerIds.length > 0)) {
            var highlight = elem.id === node.id || incomerIds.includes(elem.id) || outgoerIds.includes(elem.id);
            elem.style = Object.assign(Object.assign({}, elem.style), {
              opacity: highlight ? 1 : 0.25,
              backgroundColor: highlight ? computeColor$1(elem.type).backgroundColor : theme.primaryBlack
            });
            elem.data = Object.assign(Object.assign({}, elem.data), {
              toolbarVisible: highlight
            });
          }
          return elem;
        });
      });
      setEdges(function (previousEdges) {
        return previousEdges === null || previousEdges === void 0 ? void 0 : previousEdges.map(function (elem) {
          if (selection) {
            var active = elem.source === node.id && outgoerIds.includes(elem.target) || elem.target === node.id && incomerIds.includes(elem.source) || outgoerIds.includes(elem.source) && outgoerIds.includes(elem.target) || incomerIds.includes(elem.source) && incomerIds.includes(elem.target);
            elem.style = Object.assign(Object.assign({}, elem.style), {
              stroke: active ? theme.grey100 : theme.grey60,
              opacity: active ? 1 : 0
            });
            elem.markerEnd = {
              type: MarkerType.ArrowClosed,
              width: 20,
              height: 20,
              color: active ? theme.grey100 : theme.grey60
            };
          } else {
            elem.style = Object.assign(Object.assign({}, elem.style), {
              stroke: theme.grey60,
              opacity: 1
            });
          }
          return elem;
        });
      });
    }
  };
  var resetNodeStyles = function resetNodeStyles() {
    setNodes(function (prevElements) {
      return prevElements === null || prevElements === void 0 ? void 0 : prevElements.map(function (elem) {
        if (isNode(elem)) {
          elem.style = Object.assign(Object.assign({}, elem.style), {
            opacity: 1,
            backgroundColor: theme.primaryBlack,
            borderWidth: '1px'
          });
          elem.data = Object.assign(Object.assign({}, elem.data), {
            toolbarVisible: false
          });
        }
        return elem;
      });
    });
    setEdges(function (prevElements) {
      return prevElements === null || prevElements === void 0 ? void 0 : prevElements.map(function (elem) {
        if (isEdge(elem)) {
          elem.style = Object.assign(Object.assign({}, elem.style), {
            stroke: theme.grey60,
            opacity: 1
          });
          elem.markerEnd = markerEnd;
        }
        return elem;
      });
    });
  };
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    reactFlowInstance = _useState2[0],
    setReactFlowInstance = _useState2[1];
  var onInit = function onInit(rfi) {
    return setReactFlowInstance(rfi);
  };
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedNode = _useState4[0],
    setSelectedNode = _useState4[1];
  var widthSelector = function widthSelector(state) {
    return state.width;
  };
  var heightSelector = function heightSelector(state) {
    return state.height;
  };
  var reactFlowWidth = useStore(widthSelector);
  var reactFlowHeight = useStore(heightSelector);
  useEffect(function () {
    reactFlowInstance === null || reactFlowInstance === void 0 ? void 0 : reactFlowInstance.fitView();
  }, [reactFlowWidth, reactFlowHeight, reactFlowInstance]);
  if (isLoading) {
    return null;
  }
  if (!manifest) {
    return /*#__PURE__*/React.createElement(EmptyTablePlaceholder, {
      body: "",
      header: "No model",
      imgAlt: "no model view",
      imgSrc: img$c,
      node: hasTemplates ? (/*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return navigate('/ui/policies/createpolicy/fromtemplateschema');
        }
      }, "Apply template")) : null
    });
  }
  return /*#__PURE__*/React.createElement(ReactFlowContainer$2, null, /*#__PURE__*/React.createElement(ReactFlow, {
    edges: edges,
    elementsSelectable: true,
    fitView: true,
    nodes: nodes,
    nodesConnectable: false,
    nodesDraggable: false,
    nodeTypes: nodeTypes$1,
    preventScrolling: true,
    proOptions: {
      hideAttribution: true
    },
    snapGrid: [10, 10],
    snapToGrid: true,
    onEdgesChange: onEdgesChange,
    onInit: onInit,
    onNodeClick: function onNodeClick(_event, node) {
      setSelectedNode(node);
      highlightPath(node, nodes, edges, true);
    },
    onNodeMouseEnter: function onNodeMouseEnter(_event, node) {
      return !selectedNode && highlightPath(node, nodes, edges, true);
    },
    onNodeMouseLeave: function onNodeMouseLeave() {
      return !selectedNode && resetNodeStyles();
    },
    onNodesChange: onNodesChange,
    onPaneClick: function onPaneClick() {
      setSelectedNode(undefined);
      resetNodeStyles();
    }
  }, /*#__PURE__*/React.createElement(Controls, {
    position: "top-right",
    showInteractive: false
  })));
};
var ModelGraph = function ModelGraph() {
  return /*#__PURE__*/React.createElement(ReactFlowProvider, null, /*#__PURE__*/React.createElement(ModelFlow, null));
};

var Container$6 = styled.div.withConfig({
  displayName: "Model__Container",
  componentId: "rlamfm-0"
})(["width:calc(100vw - 100px);height:calc(100vh - 140px);@media (max-width:912px){margin-top:20px;width:100vw;height:calc(100vh - 210px);}"]);
var Model = function Model() {
  var _useDirectoryModelCon = useDirectoryModelContext(),
    visible = _useDirectoryModelCon.visible;
  var _useManifestData = useManifestData(),
    isLoading = _useManifestData.isLoading;
  if (isLoading) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Container$6, null, /*#__PURE__*/React.createElement(Allotment, null, /*#__PURE__*/React.createElement(Allotment.Pane, {
    minSize: 400
  }, /*#__PURE__*/React.createElement(Delayed, {
    waitBeforeShow: 50
  }, /*#__PURE__*/React.createElement(ModelGraph, null))), /*#__PURE__*/React.createElement(Allotment.Pane, {
    minSize: 400,
    preferredSize: "40%",
    visible: visible
  }, visible ? /*#__PURE__*/React.createElement(ModelEditor, null) : null)));
};

var img$b = "data:image/svg+xml,%3csvg width='16' height='17' viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M13.9645 7.06393C12.895 7.06393 12.0148 7.89438 11.9351 8.94393H9.76235C9.71652 8.1951 9.33021 7.53592 8.75862 7.11969L10.6446 3.88346C10.9035 4.00294 11.1923 4.07068 11.4949 4.07068C12.6162 4.07068 13.5303 3.15855 13.5303 2.03534C13.5303 0.914128 12.6182 0 11.4949 0C10.3737 0 9.45961 0.912136 9.45961 2.03534C9.45961 2.74431 9.82407 3.36963 10.3737 3.73411L8.49966 6.95641C8.14913 6.76321 7.74688 6.65172 7.31868 6.65172C6.50813 6.65172 5.78718 7.04802 5.34309 7.65747L3.50706 5.97463C3.85558 5.61017 4.07068 5.11429 4.07068 4.57057C4.07068 3.44936 3.15855 2.53523 2.03534 2.53523C0.914128 2.53523 0 3.44737 0 4.57057C0 5.69179 0.912136 6.60591 2.03534 6.60591C2.50333 6.60591 2.93354 6.44857 3.2761 6.18173L5.17203 7.92034C4.97884 8.27086 4.86935 8.67312 4.86935 9.09931C4.86935 9.91381 5.26967 10.6388 5.88501 11.0829L4.77373 13.0087C4.51285 12.8872 4.22211 12.8195 3.91539 12.8195C2.79418 12.8195 1.88005 13.7316 1.88005 14.8549C1.88005 15.9761 2.79219 16.8902 3.91539 16.8902C5.03661 16.8902 5.95073 15.9781 5.95073 14.8549C5.95073 14.1499 5.59028 13.5265 5.04261 13.1601L6.14592 11.2482C6.49444 11.4394 6.89475 11.5469 7.31893 11.5469C8.61737 11.5469 9.68287 10.5313 9.76254 9.25269H11.9353C12.015 10.3022 12.8952 11.1327 13.9647 11.1327C15.0859 11.1327 16 10.2206 16 9.09735C15.9999 7.97809 15.0858 7.064 13.9645 7.064L13.9645 7.06393Z' fill='%23A0A0A0' /%3e%3c/svg%3e";

var img$a = "data:image/svg+xml,%3csvg width='24' height='16' viewBox='0 0 24 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle r='5' transform='matrix(-1 0 0 1 5 8)' fill='%23A0A0A0' /%3e %3cpath d='M12 8.5L17.25 13V10.4286H24V6.57143H17.25V4L12 8.5Z' fill='%23A0A0A0' /%3e%3c/svg%3e";

var img$9 = "data:image/svg+xml,%3csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cg clip-path='url(%23clip0_170_16)'%3e %3cpath d='M1 7.68721C2.36662 7.68721 2.59432 6.94699 2.59432 6.26368C2.59432 5.75115 2.51842 5.12476 2.44252 4.59347C2.34764 4.06196 2.29072 3.18892 2.29072 2.6764C2.29072 0.930284 3.42964 0.190063 5.04267 0.190063H5.44136V1.23388H5.09982C3.97988 1.25285 3.60039 1.8223 3.60039 2.86612C3.60039 3.30276 3.65731 4.09993 3.73321 4.55532C3.79013 5.01093 3.86603 5.58015 3.86603 6.07374C3.885 7.30755 3.35349 7.91474 2.49941 8.14261V8.18056C3.3535 8.38927 3.88502 9.03465 3.86603 10.2494C3.86603 10.762 3.79013 11.3312 3.73321 11.7868C3.65731 12.2614 3.60039 13.0206 3.60039 13.476C3.60039 14.5578 4.03702 15.1083 5.09982 15.1462H5.44136V16.1901H5.04267C3.48633 16.1901 2.29072 15.4878 2.29072 13.5709C2.29072 13.0774 2.34764 12.2233 2.44252 11.711C2.51842 11.1795 2.59432 10.5721 2.59432 10.0598C2.59432 9.45234 2.36662 8.65521 1 8.65521V7.68721Z fill=' fill='%23A0A0A0' /%3e %3cpath d='M6.69434 15.9627C7.11178 14.8238 7.62433 12.812 7.83326 11.4264L9.67426 11.2367C9.21865 12.85 8.38354 14.9568 7.85225 15.8488L6.69434 15.9627ZM7.51023 5.96006C7.51023 5.25776 7.98482 4.76422 8.64916 4.76422C9.31349 4.76422 9.74988 5.25756 9.74988 5.96006C9.74988 6.60539 9.31325 7.1369 8.62995 7.1369C7.96585 7.1369 7.49124 6.60539 7.51023 5.96006V5.96006Z' fill='%23A0A0A0' /%3e %3cpath d='M16.241 8.65539C14.8934 8.65539 14.6657 9.45253 14.6657 10.0599C14.6657 10.5725 14.7416 11.1799 14.8175 11.7112C14.8934 12.2237 14.9693 13.0778 14.9693 13.5711C14.9693 15.488 13.7735 15.8866 12.2174 15.8866H11.8187V15.1464H12.1602C13.204 15.1085 13.6596 14.558 13.6596 13.4762C13.6596 13.0206 13.5837 12.2614 13.5268 11.787C13.4509 11.3314 13.375 10.7622 13.375 10.2496C13.356 9.03478 13.9065 8.38967 14.7606 8.18074V8.14279C13.9065 7.91509 13.3561 7.30768 13.375 6.07392C13.375 5.58037 13.4509 5.01112 13.5268 4.55551C13.584 4.0999 13.6596 3.30276 13.6596 2.8663C13.6596 1.82248 13.2612 1.25299 12.1602 1.23406H11.8187V0.190247H12.1984C13.8306 0.190247 14.9693 0.930467 14.9693 2.67658C14.9693 3.18912 14.8934 4.06219 14.8175 4.59365C14.7416 5.12511 14.6657 5.75156 14.6657 6.26386C14.6657 6.94717 14.8934 7.68739 16.2411 7.68739L16.241 8.65539Z' fill='%23A0A0A0' /%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0_170_16'%3e %3crect width='16' height='16' fill='white' /%3e %3c/clipPath%3e %3c/defs%3e%3c/svg%3e";

var img$8 = "data:image/svg+xml,%3csvg width='24' height='16' viewBox='0 0 24 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3ccircle r='5' transform='matrix(-1 0 0 1 5 8)' fill='%23A0A0A0' /%3e %3cpath d='M24 8.5L18.75 13V10.4286H12V6.57143H18.75V4L24 8.5Z' fill='%23A0A0A0' /%3e%3c/svg%3e";

var img$7 = "data:image/svg+xml,%3csvg width='14' height='16' viewBox='0 0 14 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.619 0H1.63268C0.734716 0 0 0.65309 0 1.4422V14.585C0 15.3741 0.734716 16 1.63268 16H11.619C12.5169 16 13.2517 15.3741 13.2517 14.585V1.4422C13.2517 0.65309 12.5169 0 11.619 0ZM4.48981 6.28563H10.6667V7.34685H4.48981V6.28563ZM2.55785 6.28563H3.61907V7.34685H2.55785V6.28563ZM4.48981 3.891H10.6667V4.97945H4.48981V3.891ZM2.55785 3.891H3.61907V4.97945H2.55785V3.891ZM4.48981 8.6528H10.6667V9.74126H4.48981V8.6528ZM2.55785 8.6528H3.61907V9.74126H2.55785V8.6528ZM4.48981 11.0474H10.6667V12.1359H4.48981V11.0474ZM2.55785 11.0474H3.61907V12.1359H2.55785V11.0474Z' fill='%23A0A0A0' /%3e%3c/svg%3e";

var NavTab = styled(NavLink).withConfig({
  displayName: "styles__NavTab",
  componentId: "w5xoo9-0"
})(["margin-left:20px;margin-top:20px;padding-bottom:10px;cursor:pointer;text-decoration:none;white-space:nowrap;@media (max-width:684px){.tab-name{display:none;}margin-left:40px;}", ""], function (_ref) {
  var theme = _ref.theme;
  return css(["color:", ";&:hover,&.active{text-decoration:none;color:", ";img{filter:brightness(150%);}}&.active{border-bottom:1px solid ", ";}img{margin:0 8px 2px 0;}"], theme.grey70, theme.grey100, theme.lochivarAccent4);
});
var TabGroup$1 = styled.div.withConfig({
  displayName: "styles__TabGroup",
  componentId: "w5xoo9-1"
})(["width:100%;display:inline-flex;border-bottom:1px solid ", ";text-decoration:none;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.grey30;
});

var ObjectInstanceBody = function ObjectInstanceBody() {
  var _useParams = useParams(),
    objectTypeName = _useParams.objectType;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabGroup$1, null, /*#__PURE__*/React.createElement(NavTab, {
    to: "graph"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "graph-icon",
    src: img$b
  }), /*#__PURE__*/React.createElement("span", {
    className: "tab-name"
  }, "Graph")), /*#__PURE__*/React.createElement(NavTab, {
    to: "properties"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: img$7
  }), /*#__PURE__*/React.createElement("span", {
    className: "tab-name"
  }, "Properties")), objectTypeName && (/*#__PURE__*/React.createElement(NavTab, {
    to: "incoming-relations"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: img$a
  }), /*#__PURE__*/React.createElement("span", {
    className: "tab-name"
  }, "Incoming Relations"))), /*#__PURE__*/React.createElement(NavTab, {
    to: "outgoing-relations"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: img$8
  }), /*#__PURE__*/React.createElement("span", {
    className: "tab-name"
  }, "Outgoing Relations")), /*#__PURE__*/React.createElement(NavTab, {
    to: "json"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: img$9
  }), /*#__PURE__*/React.createElement("span", {
    className: "tab-name"
  }, "JSON"))), /*#__PURE__*/React.createElement(Outlet, null));
};

var img$6 = "data:image/svg+xml,%3csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cg clip-path='url(%23clip0_2_6)'%3e %3cpath d='M14 2V2.8C14 3.02089 13.8321 3.2 13.625 3.2H2.375C2.16792 3.2 2 3.02089 2 2.8V2C2 1.77911 2.16792 1.6 2.375 1.6H5.75V0.8C5.75 0.35816 6.08578 0 6.5 0H9.5C9.91422 0 10.25 0.35816 10.25 0.8V1.6H13.625C13.8321 1.6 14 1.77911 14 2V2ZM3.4025 14.512C3.45773 15.3516 4.11339 16.0021 4.9025 16H11.1125C11.9016 16.0021 12.5572 15.3516 12.6125 14.512L13.25 4.8H2.74997L3.4025 14.512Z' fill='%23A0A0A0' /%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0_2_6'%3e %3crect width='16' height='16' fill='white' /%3e %3c/clipPath%3e %3c/defs%3e%3c/svg%3e";

var img$5 = "data:image/svg+xml,%3csvg width='1' height='18' viewBox='0 0 1 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cline x1='0.5' y1='2.18557e-08' x2='0.499999' y2='18' stroke='%23414141' /%3e%3c/svg%3e";

var ContentContainer$8 = styled.div.withConfig({
  displayName: "DataChangedModal__ContentContainer",
  componentId: "sc-1nvbw1i-0"
})(["padding:20px;width:100%;"]);
var ButtonsContainer$6 = styled.div.withConfig({
  displayName: "DataChangedModal__ButtonsContainer",
  componentId: "sc-1nvbw1i-1"
})(["width:100%;flex:1 1 0%;justify-content:flex-end;align-items:flex-end;float:right;display:flex;margin-top:20px;button:first-of-type{margin-right:10px;}"]);
var DataChangedModal = function DataChangedModal(_ref) {
  var changedDataType = _ref.changedDataType,
    show = _ref.show,
    onHide = _ref.onHide,
    onReload = _ref.onReload;
  var queryClient = useQueryClient();
  return /*#__PURE__*/React.createElement(CardModal, {
    cardHeight: "100%",
    show: show,
    title: "".concat(changedDataType, " is out of sync"),
    onHide: onHide
  }, /*#__PURE__*/React.createElement(ContentContainer$8, {
    className: "out-of-sync-object-modal"
  }, /*#__PURE__*/React.createElement("div", null, "The data for this ", changedDataType.toLocaleLowerCase(), " has changed. Choose", ' ', /*#__PURE__*/React.createElement("strong", null, "Reload"), " below to load the new values, or ", /*#__PURE__*/React.createElement("strong", null, "Cancel"), " to cancel this change."), /*#__PURE__*/React.createElement(ButtonsContainer$6, null, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "cancel-btn",
    variant: "secondary",
    onClick: onHide
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "reload-object-btn",
    id: "reload-object",
    onClick: function onClick() {
      queryClient.refetchQueries({
        type: 'active'
      });
      onHide();
      onReload === null || onReload === void 0 ? void 0 : onReload();
    }
  }, "Reload"))));
};

var ContentContainer$7 = styled.div.withConfig({
  displayName: "EditObjectModal__ContentContainer",
  componentId: "sc-18geddc-0"
})(["padding:20px;width:100%;"]);
var FormContainer$2 = styled.div.withConfig({
  displayName: "EditObjectModal__FormContainer",
  componentId: "sc-18geddc-1"
})(["margin-top:18px;"]);
var FieldContainer$4 = styled.div.withConfig({
  displayName: "EditObjectModal__FieldContainer",
  componentId: "sc-18geddc-2"
})(["display:flex;flex-direction:column;gap:12px;margin:12px auto;"]);
var ButtonsContainer$5 = styled.div.withConfig({
  displayName: "EditObjectModal__ButtonsContainer",
  componentId: "sc-18geddc-3"
})(["width:100%;flex:1 1 0%;justify-content:flex-end;align-items:flex-end;float:right;display:flex;margin-top:20px;button:first-of-type{margin-right:10px;}"]);
var EditObjectModal = function EditObjectModal(_ref) {
  var objectInstance = _ref.objectInstance,
    showDataChangedModal = _ref.showDataChangedModal,
    show = _ref.show,
    onHide = _ref.onHide,
    _onSuccess = _ref.onSuccess;
  var _a;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    displayName = _useState2[0],
    setDisplayName = _useState2[1];
  var showError = useShowError();
  var queryClient = useQueryClient();
  var _ObjectTypesList = ObjectTypesList({
      name: objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.type
    }),
    data = _ObjectTypesList.data;
  var objectType = (_a = data === null || data === void 0 ? void 0 : data.results) === null || _a === void 0 ? void 0 : _a[0];
  var objectsListInfiniteQueryKey = ObjectsListInfiniteQueryKey({
    object_type: objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.type
  });
  var relationsListInfiniteQueryKey = RelationsListInfiniteQueryKey();
  var objectGetQueryKey = ObjectGetQueryKey(objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.type, objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.id);
  var updateObject = ObjectSet({
    mutation: {
      onError: function onError(e) {
        if (e.message.includes('hash mismatch')) {
          onHide();
          showDataChangedModal();
        } else {
          showError(e);
        }
      },
      onSuccess: function onSuccess(data) {
        queryClient.invalidateQueries(objectGetQueryKey);
        // remove cache for current object type and all the relations
        queryClient.removeQueries({
          predicate: function predicate(query) {
            return query.queryKey.includes(objectsListInfiniteQueryKey[0]) || query.queryKey.includes(relationsListInfiniteQueryKey[0]);
          }
        });
        _onSuccess === null || _onSuccess === void 0 ? void 0 : _onSuccess(data.result);
      }
    }
  });
  var clearModalState = function clearModalState() {
    setDisplayName(objectInstance.display_name || '');
  };
  var closeModal = function closeModal() {
    clearModalState();
    onHide();
  };
  useEffect(function () {
    var currentObject = objectInstance;
    if (!!currentObject && !!currentObject.display_name) {
      setDisplayName(currentObject.display_name);
    }
  }, [objectInstance]);
  return !!objectInstance ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardModal, {
    cardHeight: "100%",
    show: show,
    title: "Update ".concat((objectType === null || objectType === void 0 ? void 0 : objectType.displayName) || (objectType === null || objectType === void 0 ? void 0 : objectType.name)),
    onHide: closeModal
  }, /*#__PURE__*/React.createElement(ContentContainer$7, {
    className: "add-a-relation-modal-content"
  }, /*#__PURE__*/React.createElement("div", null, "Provide a unique display name for this ".concat((objectType === null || objectType === void 0 ? void 0 : objectType.displayName) || (objectType === null || objectType === void 0 ? void 0 : objectType.name), ", and click the Update button.")), /*#__PURE__*/React.createElement(FormContainer$2, null, /*#__PURE__*/React.createElement(FieldContainer$4, null, /*#__PURE__*/React.createElement(Input, {
    disabled: true,
    label: "ID",
    value: objectInstance.id
  })), /*#__PURE__*/React.createElement(FieldContainer$4, null, /*#__PURE__*/React.createElement(ValidatedInput, {
    autoFocus: true,
    disabled: !objectInstance,
    label: "Display Name",
    validator: DisplayNameValidator,
    value: objectInstance.display_name,
    onChange: function onChange(v) {
      return setDisplayName(v || '');
    }
  }))), /*#__PURE__*/React.createElement(ButtonsContainer$5, null, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "cancel-btn",
    variant: "secondary",
    onClick: closeModal
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "edit-object-modal-btn",
    disabled: updateObject.isLoading,
    id: "edit-object",
    type: "submit",
    onClick: function onClick() {
      var obj = objectInstance;
      if (!obj) {
        return;
      }
      updateObject.mutate({
        data: {
          object: Object.assign(Object.assign({}, obj), {
            display_name: displayName
          })
        }
      });
    }
  }, "Update")))))) : null;
};

var ObjectInstanceHeader = function ObjectInstanceHeader(_ref) {
  var object = _ref.object;
  var _a;
  var showError = useShowError();
  var navigate = useNavigate();
  var _ref2 = object || {},
    objectId = _ref2.id,
    objectType = _ref2.type;
  var safeObjectType = objectType || '';
  var safeObjectId = objectId || '';
  var _ObjectTypesList = ObjectTypesList({
      name: objectType
    }),
    objectTypeData = _ObjectTypesList.data;
  var objectTypes = useMemo(function () {
    return (objectTypeData === null || objectTypeData === void 0 ? void 0 : objectTypeData.results) || [];
  }, [objectTypeData === null || objectTypeData === void 0 ? void 0 : objectTypeData.results]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showEditModal = _useState2[0],
    setShowEditModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showDataChangedModal = _useState4[0],
    setShowDataChangedModal = _useState4[1];
  var queryClient = useQueryClient();
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showDeleteModal = _useState6[0],
    setShowDeleteModal = _useState6[1];
  var objectsListInfiniteQueryKey = ObjectsListInfiniteQueryKey({
    object_type: safeObjectType
  });
  var relationsListInfiniteQueryKey = RelationsListInfiniteQueryKey();
  var objectGetQueryKey = ObjectGetQueryKey(safeObjectType, safeObjectId);
  var displayState = useDirectoryDisplayState();
  var _ObjectDelete = ObjectDelete({
      mutation: {
        onSuccess: function onSuccess() {
          navigate("/ui/directory/objects/".concat(safeObjectType), {
            replace: true
          });
          queryClient.removeQueries(objectGetQueryKey);
          // remove cache for current object type and all the relations
          queryClient.removeQueries({
            predicate: function predicate(query) {
              return query.queryKey.includes(objectsListInfiniteQueryKey[0]) || query.queryKey.includes(relationsListInfiniteQueryKey[0]);
            }
          });
        },
        onError: function onError(error) {
          return showError(error);
        }
      }
    }),
    deleteObjectMutation = _ObjectDelete.mutateAsync,
    isRemoveObjectLoading = _ObjectDelete.isLoading;
  return /*#__PURE__*/React.createElement(ObjectHeaderContainer, null, /*#__PURE__*/React.createElement(EditObjectModal, {
    objectInstance: object,
    show: showEditModal,
    showDataChangedModal: function showDataChangedModal() {
      return setShowDataChangedModal(true);
    },
    onHide: function onHide() {
      return setShowEditModal(false);
    },
    onSuccess: function onSuccess(v) {
      setShowEditModal(false);
      navigate("/ui/directory/objects/".concat(safeObjectType, "/").concat(encodeURIComponent(v.id)), {
        replace: true
      });
    }
  }), /*#__PURE__*/React.createElement(DirectoryDeleteModal, {
    deleteData: {
      type: 'Object Instance',
      name: safeObjectType
    },
    show: showDeleteModal,
    specificText: "Delete the object instance \"".concat(objectId, "\" from the directory. "),
    onClickRemove: function onClickRemove() {
      deleteObjectMutation({
        objectType: safeObjectType,
        objectId: safeObjectId,
        params: {
          with_relations: true
        }
      });
    },
    onHide: function onHide() {
      return setShowDeleteModal(false);
    }
  }), /*#__PURE__*/React.createElement(SpinnerToggle, {
    show: isRemoveObjectLoading
  }), /*#__PURE__*/React.createElement(DataChangedModal, {
    changedDataType: "Object",
    show: showDataChangedModal,
    onHide: function onHide() {
      return setShowDataChangedModal(false);
    }
  }), /*#__PURE__*/React.createElement(Breadcrumb, {
    breadcrumbParts: [{
      text: ((_a = objectTypes[0]) === null || _a === void 0 ? void 0 : _a.displayName) || (object === null || object === void 0 ? void 0 : object.type) || objectType || '',
      url: "/ui/directory/objects/".concat(safeObjectType)
    }, {
      text: (object === null || object === void 0 ? void 0 : object.display_name) || safeObjectId
    }],
    variant: "small"
  }), /*#__PURE__*/React.createElement(EvaluateDisplayState, {
    displayState: displayState.canEditObject
  }, /*#__PURE__*/React.createElement(HeaderButtonContainer, null, /*#__PURE__*/React.createElement(ImageButton, {
    onClick: function onClick() {
      return setShowEditModal(true);
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "",
    src: img$e
  }), "Edit"), /*#__PURE__*/React.createElement("img", {
    alt: "separator",
    height: 27,
    src: img$5
  }), /*#__PURE__*/React.createElement(ImageButton, {
    onClick: function onClick() {
      return setShowDeleteModal(true);
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "delete",
    src: img$6
  }), "Delete"))));
};

var AddButton = styled(Button).withConfig({
  displayName: "styles__AddButton",
  componentId: "s73peg-0"
})(["align-self:flex-start;display:flex;align-items:center;"]);
var UserImage = styled.img.withConfig({
  displayName: "styles__UserImage",
  componentId: "s73peg-1"
})(["width:50px;height:50px;border-radius:50%;margin-left:10px;"]);
var DataRow = styled.div.withConfig({
  displayName: "styles__DataRow",
  componentId: "s73peg-2"
})(["align-items:center;display:flex;flex-direction:row;gap:10px;padding-left:10px;"]);
var DataLabel = styled.span.withConfig({
  displayName: "styles__DataLabel",
  componentId: "s73peg-3"
})(["font-family:Ubuntu Mono;font-weight:bold;font-size:14px;color:", ";white-space:nowrap;"], function (_ref) {
  var theme = _ref.theme;
  return theme.grey100;
});
var DataValue = styled.span.withConfig({
  displayName: "styles__DataValue",
  componentId: "s73peg-4"
})(["font-family:Ubuntu Mono;font-weight:100;font-size:16px;color:", ";word-break:break-all;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.grey70;
});
var Container$5 = styled.div.withConfig({
  displayName: "styles__Container",
  componentId: "s73peg-5"
})(["display:flex;flex-direction:column;font-family:'Roboto';"]);
var ObjectContainer$1 = styled.div.withConfig({
  displayName: "styles__ObjectContainer",
  componentId: "s73peg-6"
})(["margin-left:10px;display:flex;color:", ";font-size:16px;min-height:50px;"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.grey100;
});
var MetadataContainer = styled.div.withConfig({
  displayName: "styles__MetadataContainer",
  componentId: "s73peg-7"
})(["display:flex;flex-direction:column;width:100%;"]);
var RelationTypesTableContainer = styled.div.withConfig({
  displayName: "styles__RelationTypesTableContainer",
  componentId: "s73peg-8"
})(["display:inline-flex;flex-direction:column;width:33%;align-self:start;margin:20px 0px 0px 12px;border-bottom:1px solid ", ";div{overflow-x:hidden;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.primaryBlack;
});
var Tr = styled(RowComponent).withConfig({
  displayName: "styles__Tr",
  componentId: "s73peg-9"
})(["border-left:none !important;border-right:none !important;", "}"], function (_ref5) {
  var active = _ref5.active,
    theme = _ref5.theme;
  return active && css(["background-color:", ";color:", ";box-shadow:inset 4px 0px 0px -1px ", " !important;"], theme.grey20, theme.grey100, theme.lochivarAccent4);
});
var RelationsContainer$1 = styled.div.withConfig({
  displayName: "styles__RelationsContainer",
  componentId: "s73peg-10"
})(["display:inline-flex;flex-direction:column;align-self:start;margin:20px 0px 0px 20px;border-bottom:1px solid ", ";overflow:auto;height:calc(100vh - 384px);"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.primaryBlack;
});
var RelationCardsContainer = styled.div.withConfig({
  displayName: "styles__RelationCardsContainer",
  componentId: "s73peg-11"
})([""]);
var ContentContainer$6 = styled.div.withConfig({
  displayName: "styles__ContentContainer",
  componentId: "s73peg-12"
})(["display:flex;"]);
var FullContainer = styled.div.withConfig({
  displayName: "styles__FullContainer",
  componentId: "s73peg-13"
})(["width:100%;"]);
var NoRelationText = styled.p.withConfig({
  displayName: "styles__NoRelationText",
  componentId: "s73peg-14"
})(["margin:20px 0;"]);
var HighlightedContainer = styled.div.withConfig({
  displayName: "styles__HighlightedContainer",
  componentId: "s73peg-15"
})(["display:flex;background-color:", ";width:100%;min-height:60px;padding:20px;align-items:center;font-family:'Roboto';color:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.grey20;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.grey100;
});
var RelationCard = styled.div.withConfig({
  displayName: "styles__RelationCard",
  componentId: "s73peg-16"
})(["background-color:", ";color:", ";display:inline-flex;width:400px;height:100px;padding:15px;margin:10px 10px 0 0;border-radius:6px;font-size:14px;font-weight:500;cursor:pointer;> div{flex-direction:column;align-items:flex-start display:flex;}.left-auto{margin-left:auto;}&:hover{background-color:", ";color:", ";}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.grey20;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.grey70;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.grey30;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.grey100;
});
var BoldSpan$1 = styled.span.withConfig({
  displayName: "styles__BoldSpan",
  componentId: "s73peg-17"
})(["font-weight:bold;color:", ";word-break:break-all;"], function (_ref13) {
  var theme = _ref13.theme;
  return theme.grey100;
});
var EllipsisDiv$1 = styled.div.withConfig({
  displayName: "styles__EllipsisDiv",
  componentId: "s73peg-18"
})(["display:block;width:325px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"]);
var CardDetails = styled.div.withConfig({
  displayName: "styles__CardDetails",
  componentId: "s73peg-19"
})(["margin-top:12px;"]);

var GenericObjectInstance = function GenericObjectInstance(_ref) {
  var object = _ref.object;
  var _ref2 = object || {},
    objectId = _ref2.id,
    objectType = _ref2.type;
  useEffect(function () {
    window.scrollTo(0, 0);
  }, [objectType, objectId]);
  return /*#__PURE__*/React.createElement(MetadataContainer, null, /*#__PURE__*/React.createElement(ObjectInstanceHeader, {
    object: object
  }), /*#__PURE__*/React.createElement(ObjectContainer$1, null, /*#__PURE__*/React.createElement(Container$5, null, /*#__PURE__*/React.createElement(DataRow, null, /*#__PURE__*/React.createElement(DataLabel, null, "ID:"), /*#__PURE__*/React.createElement(DataValue, null, " ", objectId)))), /*#__PURE__*/React.createElement(ObjectInstanceBody, null));
};

function computeColor(s) {
  return colorListByType[s] || colorList[hashCode(s) % colorList.length];
}
var colorListByType = {
  application: theme.lochivarAccent3,
  group: theme.appleAccent3,
  identity: theme.mojoAccent3,
  resource: theme.indogoAccent3,
  user: theme.plumAccent4
};
var colorList = [theme.apple100, theme.appleAccent1, theme.berry100, theme.berryAccent1, theme.berryAccent3, theme.buckthorn100, theme.buckthornAccent1, theme.buckthornAccent3, theme.cooper100, theme.cooperAccent1, theme.cooperAccent3, theme.indogo100, theme.indogoAccent1, theme.lochivar100, theme.lochivarAccent1, theme.mojo100, theme.mojoAccent1];
function hashCode(s) {
  var hash = 0,
    i,
    chr;
  if (s.length === 0) {
    return hash;
  }
  for (i = 0; i < s.length; i++) {
    chr = s.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash >>> 0;
}

var LabelDiv = styled.div.withConfig({
  displayName: "CustomEdge__LabelDiv",
  componentId: "nkzqje-0"
})(["position:absolute;background:transparent;color:", ";font-size:13px;font-weight:400;transform:", ";&:hover{color:", ";}"], function (_ref) {
  var highlight = _ref.highlight;
  return !!highlight ? theme.grey100 : theme.grey50;
}, function (_ref2) {
  var transform = _ref2.transform;
  return transform;
}, function (_ref3) {
  var highlight = _ref3.highlight;
  return !!highlight ? theme.grey100 : theme.grey50;
});
var EdgeLabel = function EdgeLabel(_ref4) {
  var transform = _ref4.transform,
    label = _ref4.label,
    highlight = _ref4.highlight;
  return /*#__PURE__*/React.createElement(LabelDiv, {
    highlight: highlight,
    transform: transform
  }, label);
};
var CustomEdge = function CustomEdge(_ref5) {
  var id = _ref5.id,
    sourceX = _ref5.sourceX,
    sourceY = _ref5.sourceY,
    targetX = _ref5.targetX,
    targetY = _ref5.targetY,
    sourcePosition = _ref5.sourcePosition,
    targetPosition = _ref5.targetPosition,
    data = _ref5.data,
    _ref5$style = _ref5.style,
    style = _ref5$style === void 0 ? {} : _ref5$style,
    markerEnd = _ref5.markerEnd;
  var _a, _b;
  var _getBezierPath = getBezierPath({
      sourceX: sourceX,
      sourceY: sourceY,
      sourcePosition: sourcePosition,
      targetX: targetX,
      targetY: targetY,
      targetPosition: targetPosition
    }),
    _getBezierPath2 = _slicedToArray(_getBezierPath, 1),
    edgePath = _getBezierPath2[0];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BaseEdge, {
    id: id,
    interactionWidth: 20,
    markerEnd: markerEnd,
    path: edgePath,
    style: Object.assign({
      strokeWidth: data.subjectRelation ? 2 : 1,
      stroke: theme.grey50,
      strokeDasharray: data.subjectRelation && '5,5'
    }, style)
  }), /*#__PURE__*/React.createElement(EdgeLabelRenderer, null, data.startLabel && (/*#__PURE__*/React.createElement(EdgeLabel, {
    highlight: (_a = data.subjectRelation) === null || _a === void 0 ? void 0 : _a.highlight,
    label: data.startLabel,
    transform: "translate(15%, -75%) translate(".concat(sourceX, "px,").concat(sourceY, "px)")
  })), data.endLabel && (/*#__PURE__*/React.createElement(EdgeLabel, {
    highlight: (_b = data.subjectRelation) === null || _b === void 0 ? void 0 : _b.highlight,
    label: data.endLabel,
    transform: "translate(-120%, -75%) translate(".concat(targetX, "px,").concat(targetY, "px)")
  }))));
};
var CustomEdge$1 = /*#__PURE__*/memo(CustomEdge);

var NodeDiv = styled.div.withConfig({
  displayName: "CustomNode__NodeDiv",
  componentId: "sc-15n74y7-0"
})(["width:200px;height:76px;padding:8px;background-color:", ";border:1px solid ", ";border-radius:4px;color:", ";.react-flow__handle{border:1px solid ", ";background:", ";width:1px;height:14px;border-radius:1px;}"], theme.grey20, theme.grey30, theme.grey100, theme.grey30, theme.grey30);
var NodeLabel = styled.div.withConfig({
  displayName: "CustomNode__NodeLabel",
  componentId: "sc-15n74y7-1"
})(["margin-bottom:8px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-size:14px;font-weight:600;"]);
var ObjectTypeButton = styled.span.withConfig({
  displayName: "CustomNode__ObjectTypeButton",
  componentId: "sc-15n74y7-2"
})(["border:1px solid ", ";color:", ";border-radius:4px;padding:3px 8px 6px;font-size:14px;font-weight:400;&:hover{filter:brightness(130%);}span{color:", ";font-weight:600;}"], function (_ref) {
  var color = _ref.color;
  return color;
}, function (_ref2) {
  var color = _ref2.color;
  return color;
}, theme.grey100);
var Filter = styled(Button).withConfig({
  displayName: "CustomNode__Filter",
  componentId: "sc-15n74y7-3"
})(["background-color:", ";color:", ";margin-left:8px;font-size:14px;font-weight:400;padding:0px 4px 0px 8px;height:27px;line-height:14px;border-radius:2px 0px 0px 2px;pointer-events:none;&:hover:not(:disabled),&:visited,&:focus{background-color:", ";}"], theme.grey40, theme.grey100, theme.grey40);
var ResetFilter = styled(Button).withConfig({
  displayName: "CustomNode__ResetFilter",
  componentId: "sc-15n74y7-4"
})(["background-color:", ";color:", ";font-size:14px;font-weight:500;padding:0px 8px;height:27px;line-height:14px;margin-right:36px;border-radius:0px 2px 2px 0px;&:hover:not(:disabled),&:visited,&:focus{background-color:", ";}"], theme.grey40, theme.grey100, theme.mojoAccent3);
var FilterSpan = styled.span.withConfig({
  displayName: "CustomNode__FilterSpan",
  componentId: "sc-15n74y7-5"
})(["font-size:14px;color:", ";"], theme.grey100);
var CustomNode = function CustomNode(_ref3) {
  var data = _ref3.data;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NodeDiv, null, !!data.targetHandle && /*#__PURE__*/React.createElement(Handle, {
    position: Position.Left,
    type: "target"
  }), /*#__PURE__*/React.createElement(NodeLabel, null, data.label), /*#__PURE__*/React.createElement(ObjectTypeButton, {
    color: data.color,
    onClick: function onClick(e) {
      e.stopPropagation();
      data.onObjectTypeClick({
        objectType: data.objectType.value
      });
    }
  }, data.objectType.name, data.subjectRelationLabel && /*#__PURE__*/React.createElement("span", null, data.subjectRelationLabel)), !!data.sourceHandle && /*#__PURE__*/React.createElement(Handle, {
    position: Position.Right,
    type: "source"
  })));
};
var CustomNode$1 = /*#__PURE__*/memo(CustomNode);

var edgeTypes = {
  custom: CustomEdge$1
};
var nodeTypes = {
  custom: CustomNode$1
};
var ObjectGraphComponent = function ObjectGraphComponent(_ref) {
  var object = _ref.object,
    setObject = _ref.setObject;
  var objectId = object.id,
    objectType = object.type;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    objectTypeFilter = _useState2[0],
    setObjectTypeFilter = _useState2[1];
  var _useNodesState = useNodesState([]),
    _useNodesState2 = _slicedToArray(_useNodesState, 2),
    nodes = _useNodesState2[0],
    setNodes = _useNodesState2[1];
  var _useEdgesState = useEdgesState([]),
    _useEdgesState2 = _slicedToArray(_useEdgesState, 2),
    edges = _useEdgesState2[0],
    setEdges = _useEdgesState2[1];
  var showError = useShowError();
  var _RelationsListInfinit = RelationsListInfinite({
      object_id: objectId,
      object_type: objectType,
      with_objects: true,
      'page.size': 100
    }, {
      query: {
        onError: function onError(e) {
          showError(e);
        }
      }
    }),
    outgoingRelationsData = _RelationsListInfinit.data;
  var _RelationsListInfinit2 = RelationsListInfinite({
      subject_id: (object === null || object === void 0 ? void 0 : object.id) || objectId,
      subject_type: (object === null || object === void 0 ? void 0 : object.type) || objectType,
      with_objects: true,
      'page.size': 100
    }, {
      query: {
        onError: function onError(e) {
          showError(e);
        }
      }
    }),
    incomingRelationsData = _RelationsListInfinit2.data;
  var objects = useMemo(function () {
    return {};
  }, []);
  var incomingRelations = useMemo(function () {
    var incomingRelations = (incomingRelationsData === null || incomingRelationsData === void 0 ? void 0 : incomingRelationsData.pages.map(function (relation) {
      Object.assign(objects, relation.objects);
      return relation.results || [];
    }).flat()) || [];
    if (!!objectTypeFilter) {
      return incomingRelations.filter(function (relation) {
        return relation.object_type === objectTypeFilter;
      });
    }
    return incomingRelations;
  }, [incomingRelationsData === null || incomingRelationsData === void 0 ? void 0 : incomingRelationsData.pages, objects, objectTypeFilter]);
  var outgoingRelations = useMemo(function () {
    var outgoingRelations = (outgoingRelationsData === null || outgoingRelationsData === void 0 ? void 0 : outgoingRelationsData.pages.map(function (relation) {
      Object.assign(objects, relation.objects);
      return relation.results || [];
    }).flat()) || [];
    if (!!objectTypeFilter) {
      return outgoingRelations.filter(function (relation) {
        return relation.subject_type === objectTypeFilter;
      });
    }
    return outgoingRelations;
  }, [outgoingRelationsData === null || outgoingRelationsData === void 0 ? void 0 : outgoingRelationsData.pages, objects, objectTypeFilter]);
  var toggleObjectTypeFilter = useCallback(function (_ref2) {
    var objectType = _ref2.objectType;
    setObjectTypeFilter(function (prev) {
      if (objectType === prev) {
        return undefined;
      }
      return objectType;
    });
  }, []);
  var objectNode = useMemo(function () {
    var _a;
    if (!!objectType && !!objectId) {
      return [{
        id: "object:".concat(objectType, ":").concat(objectId),
        type: 'custom',
        data: {
          label: (object === null || object === void 0 ? void 0 : object.display_name) || ((_a = objects["".concat(objectType, ":").concat(objectId)]) === null || _a === void 0 ? void 0 : _a.display_name) || objectId,
          targetHandle: true,
          sourceHandle: true,
          color: computeColor(objectType),
          objectType: {
            name: objectType,
            value: objectType
          },
          id: objectId,
          onObjectTypeClick: toggleObjectTypeFilter
        },
        position: {
          x: 450,
          y: 200
        }
      }];
    }
    return [];
  }, [objectId, objectType, object === null || object === void 0 ? void 0 : object.display_name, toggleObjectTypeFilter, objects]);
  var incomingNodes = useMemo(function () {
    return incomingRelations.map(function (o, i) {
      var _a;
      return {
        id: "incoming:".concat(o === null || o === void 0 ? void 0 : o.object_type, ":").concat(o === null || o === void 0 ? void 0 : o.object_id, "#").concat(o.relation, "#").concat(o.subject_relation || ''),
        type: 'custom',
        data: {
          label: ((_a = objects["".concat(o === null || o === void 0 ? void 0 : o.object_type, ":").concat(o === null || o === void 0 ? void 0 : o.object_id)]) === null || _a === void 0 ? void 0 : _a.display_name) || (o === null || o === void 0 ? void 0 : o.object_id),
          sourceHandle: true,
          color: computeColor((o === null || o === void 0 ? void 0 : o.object_type) || ''),
          objectType: {
            name: o === null || o === void 0 ? void 0 : o.object_type,
            value: o === null || o === void 0 ? void 0 : o.object_type
          },
          id: o === null || o === void 0 ? void 0 : o.object_id,
          onObjectTypeClick: toggleObjectTypeFilter
        },
        position: {
          x: 50,
          y: 100 * i + 50
        }
      };
    });
  }, [incomingRelations, toggleObjectTypeFilter, objects]);
  var incomingEdges = useMemo(function () {
    return incomingRelations.map(function (o) {
      var id = "incoming-e".concat(o === null || o === void 0 ? void 0 : o.object_type, ":").concat(o === null || o === void 0 ? void 0 : o.object_id, "#").concat(o.relation, "-").concat(o === null || o === void 0 ? void 0 : o.subject_type, ":").concat(o === null || o === void 0 ? void 0 : o.subject_id, "#").concat(o.subject_relation || '');
      return {
        id: id,
        data: o.subject_relation ? {
          startLabel: o.relation,
          subjectRelation: {
            val: o.subject_relation,
            highlight: false
          }
        } : {
          startLabel: o === null || o === void 0 ? void 0 : o.relation
        },
        source: "incoming:".concat(o === null || o === void 0 ? void 0 : o.object_type, ":").concat(o === null || o === void 0 ? void 0 : o.object_id, "#").concat(o.relation, "#").concat(o.subject_relation || ''),
        target: "object:".concat(o === null || o === void 0 ? void 0 : o.subject_type, ":").concat(o === null || o === void 0 ? void 0 : o.subject_id),
        markerEnd: {
          type: MarkerType.ArrowClosed,
          width: o.subject_relation ? 10 : 20,
          height: o.subject_relation ? 10 : 20,
          color: "".concat(theme.grey50)
        },
        type: 'custom'
      };
    });
  }, [incomingRelations]);
  var outgoingNodes = useMemo(function () {
    return outgoingRelations.map(function (o, i) {
      var _a;
      return {
        id: "outgoing:".concat(o === null || o === void 0 ? void 0 : o.subject_type, ":").concat(o === null || o === void 0 ? void 0 : o.subject_id, "#").concat(o.relation, "#").concat(o.subject_relation || ''),
        type: 'custom',
        data: {
          label: ((_a = objects["".concat(o === null || o === void 0 ? void 0 : o.subject_type, ":").concat(o === null || o === void 0 ? void 0 : o.subject_id)]) === null || _a === void 0 ? void 0 : _a.display_name) || (o === null || o === void 0 ? void 0 : o.subject_id),
          targetHandle: true,
          color: computeColor((o === null || o === void 0 ? void 0 : o.subject_type) || ''),
          objectType: {
            name: o.subject_relation ? "".concat(o === null || o === void 0 ? void 0 : o.subject_type, "#").concat(o === null || o === void 0 ? void 0 : o.subject_relation) : o === null || o === void 0 ? void 0 : o.subject_type,
            value: o === null || o === void 0 ? void 0 : o.subject_type
          },
          id: o === null || o === void 0 ? void 0 : o.subject_id,
          onObjectTypeClick: toggleObjectTypeFilter
        },
        position: {
          x: 850,
          y: 100 * i + 50
        }
      };
    });
  }, [outgoingRelations, toggleObjectTypeFilter, objects]);
  var outgoingEdges = useMemo(function () {
    return outgoingRelations.map(function (o) {
      return {
        id: "outgoing-e".concat(o === null || o === void 0 ? void 0 : o.object_type, ":").concat(o === null || o === void 0 ? void 0 : o.object_id, "#").concat(o.relation, "-").concat(o === null || o === void 0 ? void 0 : o.subject_type, ":").concat(o === null || o === void 0 ? void 0 : o.subject_id, "#").concat(o.subject_relation || ''),
        data: o.subject_relation ? {
          endLabel: o.relation,
          subjectRelation: {
            val: o.subject_relation,
            highlight: false
          }
        } : {
          endLabel: o === null || o === void 0 ? void 0 : o.relation
        },
        source: "object:".concat(o === null || o === void 0 ? void 0 : o.object_type, ":").concat(o === null || o === void 0 ? void 0 : o.object_id),
        target: "outgoing:".concat(o === null || o === void 0 ? void 0 : o.subject_type, ":").concat(o === null || o === void 0 ? void 0 : o.subject_id, "#").concat(o.relation, "#").concat(o.subject_relation || ''),
        markerEnd: {
          type: MarkerType.ArrowClosed,
          width: o.subject_relation ? 10 : 20,
          height: o.subject_relation ? 10 : 20,
          color: "".concat(theme.grey50)
        },
        type: 'custom'
      };
    });
  }, [outgoingRelations]);
  var allNodes = useMemo(function () {
    return objectNode.concat(outgoingNodes).concat(incomingNodes);
  }, [incomingNodes, outgoingNodes, objectNode]);
  var allEdges = useMemo(function () {
    return incomingEdges.concat(outgoingEdges);
  }, [incomingEdges, outgoingEdges]);
  useEffect(function () {
    setNodes(allNodes);
  }, [setNodes, allNodes]);
  useEffect(function () {
    setEdges(allEdges);
  }, [setEdges, allEdges]);
  var highlightPath = function highlightPath(edge, edges) {
    var incomingNode = edge.source;
    var centerNode = edge.target;
    var outgoingRelationEdges = edges.filter(function (e) {
      var _a;
      return ((_a = e.data) === null || _a === void 0 ? void 0 : _a.endLabel) === edge.data.subjectRelation.val;
    });
    var nodeIds = [incomingNode, centerNode].concat(outgoingRelationEdges.map(function (o) {
      return o.target;
    }));
    var edgeIds = [edge.id].concat(outgoingRelationEdges.map(function (o) {
      return o.id;
    }));
    setNodes(function (prevElements) {
      return prevElements === null || prevElements === void 0 ? void 0 : prevElements.map(function (elem) {
        if (isNode(elem)) {
          elem.style = Object.assign(Object.assign({}, elem.style), {
            borderWidth: '2px',
            borderColor: nodeIds.includes(elem.id) ? theme.grey100 : theme.grey30,
            opacity: nodeIds.includes(elem.id) ? 1 : 0.25
          });
          if (elem.id === centerNode) {
            elem.data = Object.assign(Object.assign({}, elem.data), {
              subjectRelationLabel: "#".concat(edge.data.subjectRelation.val)
            });
          }
        }
        return elem;
      });
    });
    setEdges(function (previousEdges) {
      return previousEdges === null || previousEdges === void 0 ? void 0 : previousEdges.map(function (elem) {
        var highlight = edgeIds.includes(elem.id);
        elem.style = {
          stroke: highlight ? theme.grey100 : theme.grey50,
          opacity: highlight ? 1 : 0.25,
          color: theme.grey100
        };
        elem.markerEnd = Object.assign(Object.assign({}, elem.markerEnd), {
          color: highlight ? theme.grey100 : theme.grey50
        });
        if (elem.data.subjectRelation) {
          elem.data = Object.assign(Object.assign({}, elem.data), {
            subjectRelation: Object.assign(Object.assign({}, elem.data.subjectRelation), {
              highlight: highlight
            })
          });
        }
        return elem;
      });
    });
  };
  var resetNodeStyles = function resetNodeStyles() {
    setNodes(function (prevElements) {
      return prevElements === null || prevElements === void 0 ? void 0 : prevElements.map(function (elem) {
        if (isNode(elem)) {
          elem.style = Object.assign(Object.assign({}, elem.style), {
            borderColor: theme.grey30,
            borderWidth: '1px',
            opacity: 1
          });
          if (elem.data.subjectRelationLabel) {
            var _a = elem.data;
              _a.subjectRelationLabel;
              var newData = __rest(_a, ["subjectRelationLabel"]);
            elem.data = newData;
          }
        }
        return elem;
      });
    });
    setEdges(function (prevElements) {
      return prevElements === null || prevElements === void 0 ? void 0 : prevElements.map(function (elem) {
        if (isEdge(elem)) {
          if (elem.data.subjectRelation) {
            elem.data = Object.assign(Object.assign({}, elem.data), {
              subjectRelation: Object.assign(Object.assign({}, elem.data.subjectRelation), {
                highlight: false
              })
            });
          }
          elem.style = Object.assign(Object.assign({}, elem.style), {
            stroke: theme.grey60,
            opacity: 1
          });
          elem.markerEnd = Object.assign(Object.assign({}, elem.markerEnd), {
            color: theme.grey50
          });
        }
        return elem;
      });
    });
  };
  return /*#__PURE__*/React.createElement(ReactFlow, {
    edges: edges,
    edgeTypes: edgeTypes,
    nodes: nodes,
    nodesConnectable: false,
    nodeTypes: nodeTypes,
    proOptions: {
      hideAttribution: true
    },
    onEdgeMouseEnter: function onEdgeMouseEnter(e, edge) {
      return edge.target === objectNode[0].id && !!edge.data.subjectRelation && highlightPath(edge, edges);
    },
    onEdgeMouseLeave: function onEdgeMouseLeave(e, edge) {
      return edge.target === objectNode[0].id && !!edge.data.subjectRelation && resetNodeStyles();
    },
    onNodeClick: function onNodeClick(e, node) {
      var object = {
        id: node.data.id,
        type: node.data.objectType.value
      };
      setObject(object);
    }
  }, /*#__PURE__*/React.createElement(Panel, {
    hidden: !objectTypeFilter,
    position: "top-right",
    style: {
      backgroundColor: theme.primaryBlack,
      opacity: 0.95,
      padding: '15px 8px',
      marginTop: '0px',
      borderRadius: '2px'
    }
  }, /*#__PURE__*/React.createElement(FilterSpan, null, "Filter:"), /*#__PURE__*/React.createElement(Filter, {
    node: objectTypeFilter,
    variant: "secondary-borderless"
  }, objectTypeFilter), /*#__PURE__*/React.createElement(ResetFilter, {
    variant: "secondary-borderless",
    onClick: function onClick() {
      setObjectTypeFilter(undefined);
    }
  }, "x")), /*#__PURE__*/React.createElement(Controls, {
    position: "top-right"
  }));
};

var ReactFlowContainer$1 = styled.div.withConfig({
  displayName: "ObjectGraph__ReactFlowContainer",
  componentId: "sc-15lumz4-0"
})(["height:calc(100vh - 315px);width:calc(100vw - 200px);@media (max-width:1198px){width:calc(100vw - 250px);}@media (max-width:912px){height:calc(100vh - 365px);width:100vw;}.react-flow__node-custom{border:1px solid ", ";border-radius:5px;text-align:center;&:hover{cursor:pointer;}}"], theme.grey30);
var ObjectGraph = function ObjectGraph(_ref) {
  var object = _ref.object;
  var navigate = useNavigate();
  var _ref2 = object || {},
    objectId = _ref2.id,
    objectType = _ref2.type;
  var obj = {
    id: objectId || '',
    type: objectType || '',
    display_name: (object === null || object === void 0 ? void 0 : object.display_name) || objectId
  };
  var setObject = useCallback(function (o) {
    navigate("/ui/directory/objects/".concat(o.type, "/").concat(encodeURIComponent(o.id)));
  }, [navigate]);
  return /*#__PURE__*/React.createElement(ContentContainer$6, null, /*#__PURE__*/React.createElement(ReactFlowContainer$1, null, /*#__PURE__*/React.createElement(ObjectGraphComponent, {
    object: obj,
    setObject: setObject
  })));
};

var CopyJsonButton = styled(CopyButton$4).withConfig({
  displayName: "styles__CopyJsonButton",
  componentId: "sc-3zu31o-0"
})(["align-self:flex-start;"]);
var PropertiesContainer$1 = styled.div.withConfig({
  displayName: "styles__PropertiesContainer",
  componentId: "sc-3zu31o-1"
})(["display:flex;flex-direction:column;gap:15px;justify-content:space-between;margin:20px;"]);
var CopiedToClipboard = styled.div.withConfig({
  displayName: "styles__CopiedToClipboard",
  componentId: "sc-3zu31o-2"
})(["color:", ";padding:5px;"], theme.grey70);
var CopyContainer = styled.div.withConfig({
  displayName: "styles__CopyContainer",
  componentId: "sc-3zu31o-3"
})(["display:flex;"]);

var ObjectJson = function ObjectJson(_ref) {
  var object = _ref.object;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCopied = _useState2[0],
    setIsCopied = _useState2[1];
  return /*#__PURE__*/React.createElement(PropertiesContainer$1, null, /*#__PURE__*/React.createElement(CopyContainer, null, /*#__PURE__*/React.createElement(CopyJsonButton, {
    variant: "secondary",
    onClick: function onClick() {
      copy(JSON.stringify(object, null, 2));
      setIsCopied(true);
      setTimeout(function () {
        setIsCopied(false);
      }, 1000);
    }
  }, "Copy"), isCopied ? /*#__PURE__*/React.createElement(CopiedToClipboard, null, "Copied to clipboard") : null), /*#__PURE__*/React.createElement(CodeEditor, {
    value: JSON.stringify(object, null, 2)
  }));
};

var ButtonsContainer$4 = styled.div.withConfig({
  displayName: "styles__ButtonsContainer",
  componentId: "sc-1shbjjz-0"
})(["display:flex;flex-direction:row;gap:10px;"]);
var ControlsContainer = styled.div.withConfig({
  displayName: "styles__ControlsContainer",
  componentId: "sc-1shbjjz-1"
})(["display:flex;flex-direction:column;gap:10px;justify-content:space-between;width:100%;"]);
var ErrorMessage = styled.span.withConfig({
  displayName: "styles__ErrorMessage",
  componentId: "sc-1shbjjz-2"
})(["color:", ";"], theme.mojoAccent3);
var PropertiesContainer = styled.div.withConfig({
  displayName: "styles__PropertiesContainer",
  componentId: "sc-1shbjjz-3"
})(["display:flex;flex-direction:column;gap:10px;justify-content:space-between;margin:20px;"]);

var ObjectProperties = function ObjectProperties(_ref) {
  var object = _ref.object;
  var queryClient = useQueryClient();
  var _ref2 = object || {},
    objectId = _ref2.id,
    objectType = _ref2.type,
    properties = _ref2.properties;
  var objectsListInfiniteQueryKey = ObjectsListInfiniteQueryKey({
    object_type: objectType
  });
  var objectGetQueryKey = ObjectGetQueryKey(objectType || '', objectId || '');
  var _ObjectSet = ObjectSet({
      mutation: {
        onSuccess: function onSuccess() {
          queryClient.invalidateQueries(objectsListInfiniteQueryKey);
          queryClient.invalidateQueries(objectGetQueryKey);
        }
      }
    }),
    updateObject = _ObjectSet.mutate,
    updatingObject = _ObjectSet.isLoading;
  var displayState = useDirectoryDisplayState();
  var showSuccessMessage = useShowSuccessMessage();
  var showError = useShowError();
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    code = _useState2[0],
    setCode = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    modified = _useState4[0],
    setModified = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showErrorMessage = _useState6[0],
    setShowErrorMessage = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showDataChangedModal = _useState8[0],
    setShowDataChangedModal = _useState8[1];
  var _useState9 = useState(),
    _useState10 = _slicedToArray(_useState9, 2),
    error = _useState10[0],
    setError = _useState10[1];
  var resetCode = useCallback(function () {
    if (!!properties) {
      setCode(JSON.stringify(properties, null, 2));
      setModified(false);
    }
    setError(undefined);
    setShowErrorMessage(false);
  }, [properties]);
  var saveCode = useCallback(function () {
    if (!!object) {
      var parsed;
      if (!!code) {
        try {
          parsed = JSON.parse(code);
          setError(undefined);
        } catch (e) {
          setError(String(e));
          setShowErrorMessage(true);
        }
      }
      if (!!parsed) {
        updateObject({
          data: {
            object: Object.assign(Object.assign({}, object), {
              properties: JSON.parse(code)
            })
          }
        }, {
          onError: function onError(e) {
            if (e.message.includes('hash mismatch')) {
              setShowDataChangedModal(true);
            } else {
              showError(e);
            }
          },
          onSuccess: function onSuccess() {
            showSuccessMessage('Properties updated successfully.');
            setModified(false);
          }
        });
      }
    }
  }, [code, object, showError, showSuccessMessage, updateObject]);
  useEffect(function () {
    resetCode();
  }, [resetCode]);
  return /*#__PURE__*/React.createElement(PropertiesContainer, null, !!object ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ControlsContainer, null, /*#__PURE__*/React.createElement(EvaluateDisplayState, {
    displayState: displayState.canEditObject
  }, /*#__PURE__*/React.createElement(ButtonsContainer$4, null, /*#__PURE__*/React.createElement(Button, {
    disabled: !modified || updatingObject,
    variant: "secondary",
    onClick: resetCode
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    disabled: !modified || updatingObject,
    variant: "primary",
    onClick: saveCode
  }, "Save"))), showErrorMessage ? /*#__PURE__*/React.createElement(ErrorMessage, null, error) : /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement(CodeEditor, {
    hasError: !!error,
    readOnly: updatingObject || !displayState.canEditObject.enabled,
    value: code,
    onValueChange: function onValueChange(c) {
      setCode(c);
      setModified(true);
      try {
        JSON.parse(c);
        setShowErrorMessage(false);
        setError(undefined);
      } catch (e) {
        setError(String(e));
      }
    }
  }), /*#__PURE__*/React.createElement(DataChangedModal, {
    changedDataType: "Object",
    show: showDataChangedModal,
    onHide: function onHide() {
      return setShowDataChangedModal(false);
    }
  }))) : 'This object is external to the directory.');
};

var img$4 = "data:image/svg+xml,%3csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M14 6.11333H7.88667V0H6.11333V6.11333H0V7.88667H6.11333V14H7.88667V7.88667H14V6.11333Z' fill='%23E7E7E7' /%3e%3c/svg%3e";

var useObjectRelationTypes = function useObjectRelationTypes(subjectType) {
  var _useManifest = useManifest(),
    manifest = _useManifest.data;
  var result = useMemo(function () {
    var parsedManifest = parseManifest(manifest);
    var objectType = {};
    parsedManifest.forEach(function (entry) {
      entry.relations.forEach(function (relation) {
        relation.subjects.forEach(function (subject) {
          var _ref = subject.match(/:|#/g) ? subject.split(/:|#/g) : [subject],
            _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0];
            _ref2[1];
          if (key === subjectType) {
            objectType[entry.object] = (objectType[entry.object] || new Set()).add(relation.key);
          }
        });
      });
    });
    return objectType;
  }, [manifest, subjectType]);
  return result;
};

var useSubjectRelationTypes = function useSubjectRelationTypes(objectType, relationKey) {
  var _useManifest = useManifest(),
    manifest = _useManifest.data;
  var result = useMemo(function () {
    var _a, _b, _c, _d;
    var parsedManifest = parseManifest(manifest);
    var data = {};
    (_d = (_c = (_b = (_a = parsedManifest.find(function (entry) {
      return entry.object === objectType;
    })) === null || _a === void 0 ? void 0 : _a.relations) === null || _b === void 0 ? void 0 : _b.find(function (relation) {
      return relation.key === relationKey;
    })) === null || _c === void 0 ? void 0 : _c.subjects) === null || _d === void 0 ? void 0 : _d.forEach(function (subject) {
      var _ref = subject.match(/:|#/g) ? subject.split(/:|#/g) : [subject],
        _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      data[key] = data[key] || new Set();
      value && data[key].add(value);
    });
    return data;
  }, [manifest, objectType, relationKey]);
  return result;
};

var ContentContainer$5 = styled.div.withConfig({
  displayName: "AddRelationModal__ContentContainer",
  componentId: "sog1qt-0"
})(["padding:20px;width:100%;"]);
var FormContainer$1 = styled.div.withConfig({
  displayName: "AddRelationModal__FormContainer",
  componentId: "sog1qt-1"
})(["margin-top:18px;"]);
var FieldContainer$3 = styled.div.withConfig({
  displayName: "AddRelationModal__FieldContainer",
  componentId: "sog1qt-2"
})(["display:flex;flex-direction:column;gap:12px;margin:12px auto;"]);
var ButtonsContainer$3 = styled.div.withConfig({
  displayName: "AddRelationModal__ButtonsContainer",
  componentId: "sog1qt-3"
})(["width:100%;flex:1 1 0%;justify-content:flex-end;align-items:flex-end;float:right;display:flex;margin-top:20px;button:first-of-type{margin-right:10px;}"]);
var AddRelationModal = function AddRelationModal(_ref) {
  var relationSideProperty = _ref.relationSideProperty,
    relation = _ref.relation,
    onSave = _ref.onSave,
    onHide = _ref.onHide,
    show = _ref.show,
    object = _ref.object;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    selectedObjectType = _useState2[0],
    setSelectedObjectType = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedObjectKey = _useState4[0],
    setSelectedObjectKey = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedSubjectRelation = _useState6[0],
    setSelectedSubjectRelation = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    filter = _useState8[0],
    setFilter = _useState8[1];
  var debouncedFilter = useDebounce(filter);
  var safeObjectType = (object === null || object === void 0 ? void 0 : object.type) || '';
  var subjectTypes = useSubjectRelationTypes(relation.objectType, relation.type);
  var _ObjectTypesList = ObjectTypesList(),
    objectTypesData = _ObjectTypesList.data;
  var objectTypes = useMemo(function () {
    var _a;
    return (_a = objectTypesData === null || objectTypesData === void 0 ? void 0 : objectTypesData.results) === null || _a === void 0 ? void 0 : _a.filter(function (objectType) {
      return Object.keys(subjectTypes).includes(objectType.name);
    }).map(function (p) {
      return {
        label: p.displayName || p.name,
        value: p.name
      };
    });
  }, [objectTypesData, subjectTypes]);
  var _ObjectsListInfinite = ObjectsListInfinite({
      object_type: selectedObjectType !== null && selectedObjectType !== void 0 ? selectedObjectType : '',
      'page.size': 100,
      displayNamePart: debouncedFilter
    }, {
      query: {
        enabled: !!selectedObjectType
      }
    }),
    objectsData = _ObjectsListInfinite.data,
    isLoadingObjectRelations = _ObjectsListInfinite.isLoading,
    hasMoreObjectRelations = _ObjectsListInfinite.hasNextPage,
    fetchNextObjectRelations = _ObjectsListInfinite.fetchNextPage;
  var objects = useMemo(function () {
    return objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages.map(function (page) {
      return page.results || [];
    }).flat().map(function (object) {
      return {
        label: object.display_name || object.id,
        value: object.id
      };
    });
  }, [objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages]);
  var _RelationTypesList = RelationTypesList({
      objectType: relationSideProperty === 'object' ? object === null || object === void 0 ? void 0 : object.type : selectedObjectType || ''
    }),
    subjectRelationTypeData = _RelationTypesList.data;
  var subjectRelationTypes = useMemo(function () {
    var _a, _b;
    return (_b = (_a = subjectRelationTypeData === null || subjectRelationTypeData === void 0 ? void 0 : subjectRelationTypeData.results) === null || _a === void 0 ? void 0 : _a.filter(function (objectType) {
      return Object.keys(subjectTypes).includes(objectType.objectType) && Array.from(subjectTypes[objectType.objectType].values()).includes(objectType.name);
    })) === null || _b === void 0 ? void 0 : _b.map(function (sr) {
      return {
        label: sr.displayName,
        value: sr.name
      };
    });
  }, [subjectRelationTypeData === null || subjectRelationTypeData === void 0 ? void 0 : subjectRelationTypeData.results, subjectTypes]);
  useEffect(function () {
    relationSideProperty === 'object' && show && setSelectedObjectType(relation.objectType);
  }, [relation.objectType, relationSideProperty, show]);
  var clearRelationModal = function clearRelationModal() {
    onHide();
    setSelectedObjectKey(null);
    setSelectedObjectType(null);
    setSelectedSubjectRelation(null);
  };
  var onKeyDown = function onKeyDown(e) {
    if (e.key === 'Escape') {
      clearRelationModal();
    }
  };
  var subjectRelations = useMemo(function () {
    return relationSideProperty === 'object' ? subjectTypes[String(object === null || object === void 0 ? void 0 : object.type)] || new Set() : subjectTypes[String(selectedObjectType)] || new Set();
  }, [selectedObjectType, subjectTypes, relationSideProperty, object === null || object === void 0 ? void 0 : object.type]);
  useEffect(function () {
    if (subjectRelations.size === 1) {
      setSelectedSubjectRelation(_toConsumableArray(subjectRelations)[0]);
    }
  }, [subjectRelations]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardModal, {
    cardHeight: "100%",
    show: show,
    title: "Add a ".concat(relation.type, " relation"),
    onHide: clearRelationModal
  }, /*#__PURE__*/React.createElement(ContentContainer$5, {
    className: "add-a-relation-modal-content"
  }, /*#__PURE__*/React.createElement("div", null, relationSideProperty === 'subject' ? "Select a subject type, then select the subject for a new outgoing ".concat(relation.type, " relation, and then click the Add relation button.") : "Select the ".concat(relation.objectType, " that should have a ").concat(relation.type, " relation to this Subject, and click the Add relation button.")), /*#__PURE__*/React.createElement(FormContainer$1, null, relationSideProperty === 'subject' && (/*#__PURE__*/React.createElement(FieldContainer$3, null, /*#__PURE__*/React.createElement(Select, {
    autoFocus: true,
    className: "subject-type-select",
    label: "Subject Type",
    name: "subject-type-select",
    options: objectTypes,
    onChange: function onChange(o) {
      setSelectedObjectType(!!o ? String(o.value) : undefined);
      setSelectedObjectKey(null);
      setSelectedSubjectRelation(undefined);
    },
    onKeyDown: onKeyDown
  }))), /*#__PURE__*/React.createElement(Label$1, null, relationSideProperty === 'subject' ? 'Subject' : "".concat(relation.objectType.charAt(0).toUpperCase() + relation.objectType.slice(1))), /*#__PURE__*/React.createElement(CreatableSelect, {
    autoFocus: relationSideProperty === 'object',
    className: "relation-select",
    inputValue: filter,
    isClearable: true,
    isLoading: isLoadingObjectRelations,
    name: "relation-select",
    options: objects,
    styles: colourStyles,
    value: (objects === null || objects === void 0 ? void 0 : objects.find(function (o) {
      return o.value === selectedObjectKey;
    })) || null,
    onChange: function onChange(o) {
      return setSelectedObjectKey(!!o ? String(o.value) : undefined);
    },
    onInputChange: setFilter,
    onKeyDown: onKeyDown,
    onMenuScrollToBottom: function onMenuScrollToBottom() {
      hasMoreObjectRelations && fetchNextObjectRelations();
    }
  }), subjectRelations.size > 1 && (/*#__PURE__*/React.createElement(FieldContainer$3, null, /*#__PURE__*/React.createElement(Select, {
    className: "subject-relation-select",
    label: relationSideProperty === 'object' ? "".concat(safeObjectType.charAt(0).toUpperCase() + safeObjectType.slice(1), " Subject Relation") : 'Subject Relation',
    name: "subject-relation-select",
    options: subjectRelationTypes,
    onChange: function onChange(o) {
      return setSelectedSubjectRelation(!!o ? String(o.value) : undefined);
    },
    onKeyDown: onKeyDown
  })))), /*#__PURE__*/React.createElement(ButtonsContainer$3, null, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "cancel-btn",
    variant: "secondary",
    onClick: clearRelationModal
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "add-relation-modal-btn",
    disabled: !selectedObjectKey || !selectedObjectType || !onSave,
    id: "add-relation",
    type: "submit",
    onClick: function onClick() {
      !!selectedObjectKey && (onSave === null || onSave === void 0 ? void 0 : onSave(selectedObjectType || '', selectedObjectKey, selectedSubjectRelation || undefined));
      clearRelationModal();
    }
  }, "Add relation")))));
};

var ObjectRelations = function ObjectRelations(_ref) {
  var relationSide = _ref.relationSide,
    object = _ref.object;
  var _a;
  var queryClient = useQueryClient();
  var _ref2 = object || {},
    objectId = _ref2.id,
    objectType = _ref2.type;
  var _useParams = useParams(),
    relationSubject = _useParams.relationSubject,
    relationType = _useParams.relationType;
  var safeObjectType = objectType || '';
  var safeObjectId = objectId || '';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAddRelationModal = _useState2[0],
    setShowAddRelationModal = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    relationTypesTableData = _useState4[0],
    setRelationTypesTableData = _useState4[1];
  var isOutgoingRelations = useMemo(function () {
    return relationSide === 'outgoing';
  }, [relationSide]);
  var _useDirectoryDataCont = useDirectoryDataContext(),
    relationsQueryKey = _useDirectoryDataCont.relationsQueryKey;
  var showError = useShowError();
  var _RelationsListInfinit = RelationsListInfinite({
      object_id: objectId,
      object_type: objectType,
      with_objects: true,
      'page.size': 100
    }),
    outgoingRelationsData = _RelationsListInfinit.data,
    outgoingRelationsQueryKey = _RelationsListInfinit.queryKey;
  var _RelationsListInfinit2 = RelationsListInfinite({
      subject_id: objectId,
      subject_type: objectType,
      with_objects: true,
      'page.size': 100
    }),
    incomingRelationsData = _RelationsListInfinit2.data,
    incomingRelationsQueryKey = _RelationsListInfinit2.queryKey;
  var _RelationSet = RelationSet({
      mutation: {
        onError: function onError(e) {
          showError(e);
        },
        onSettled: function onSettled() {
          queryClient.invalidateQueries(incomingRelationsQueryKey);
          queryClient.invalidateQueries(outgoingRelationsQueryKey);
          queryClient.invalidateQueries(relationsQueryKey);
        },
        onSuccess: function onSuccess() {
          queryClient.invalidateQueries(incomingRelationsQueryKey);
          queryClient.invalidateQueries(outgoingRelationsQueryKey);
          queryClient.invalidateQueries(relationsQueryKey);
        }
      }
    }),
    addRelation = _RelationSet.mutate;
  var _RelationDelete = RelationDelete({
      mutation: {
        onSettled: function onSettled() {
          queryClient.invalidateQueries(incomingRelationsQueryKey);
          queryClient.invalidateQueries(outgoingRelationsQueryKey);
          queryClient.invalidateQueries(relationsQueryKey);
        },
        onSuccess: function onSuccess() {
          queryClient.invalidateQueries(incomingRelationsQueryKey);
          queryClient.invalidateQueries(outgoingRelationsQueryKey);
          queryClient.invalidateQueries(relationsQueryKey);
        }
      }
    }),
    _removeRelation = _RelationDelete.mutate;
  var getRelationSetter = function getRelationSetter(selectedObjectType, selectedObjectId, selectedSubjectRelation) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    !!relationType && !!safeObjectId ? isOutgoingRelations ? addRelation({
      data: {
        relation: {
          relation: relationType,
          object_type: safeObjectType,
          subject_type: selectedObjectType,
          object_id: safeObjectId,
          subject_id: selectedObjectId,
          subject_relation: selectedSubjectRelation
        }
      }
    }) : addRelation({
      data: {
        relation: {
          relation: relationType,
          object_type: selectedObjectType,
          subject_type: safeObjectType,
          subject_relation: selectedSubjectRelation,
          object_id: selectedObjectId,
          subject_id: safeObjectId
        }
      }
    }) : undefined;
  };
  var _RelationTypesList = RelationTypesList(),
    relationTypes = _RelationTypesList.data;
  var relationTypesColumns = [{
    Header: 'Name',
    style: {
      cellWidth: 'c50%'
    },
    disableSortBy: false,
    Cell: function Cell(_ref3) {
      var row = _ref3.row;
      var _a;
      return /*#__PURE__*/React.createElement(Link, {
        to: "/ui/directory/objects/".concat(safeObjectType, "/").concat(encodeURIComponent(safeObjectId), "/").concat(relationSide, "-relations/").concat(row.original.relationObjectTypeName || '', "/").concat(row.original.name || '')
      }, (_a = row.original.name) !== null && _a !== void 0 ? _a : '');
    }
  }, {
    Header: 'Type',
    style: {
      cellWidth: 'c50%'
    },
    Cell: function Cell(_ref4) {
      var row = _ref4.row;
      return /*#__PURE__*/React.createElement(React.Fragment, null, row.original.relationObjectTypeName);
    }
  }];
  var objects = useMemo(function () {
    return {};
  }, []);
  var objectTypes = useObjectRelationTypes(safeObjectType);
  var incomingRelations = useMemo(function () {
    return (incomingRelationsData === null || incomingRelationsData === void 0 ? void 0 : incomingRelationsData.pages.map(function (relation) {
      Object.assign(objects, relation.objects);
      return relation.results || [];
    }).flat()) || [];
  }, [incomingRelationsData === null || incomingRelationsData === void 0 ? void 0 : incomingRelationsData.pages, objects]);
  useEffect(function () {
    var _a;
    var types = ((_a = relationTypes === null || relationTypes === void 0 ? void 0 : relationTypes.results) === null || _a === void 0 ? void 0 : _a.filter(function (r) {
      return !isOutgoingRelations || r.objectType === objectType;
    }).map(function (r) {
      return {
        name: r.name,
        relationObjectTypeName: r.objectType
      };
    })) || [];
    if (!isOutgoingRelations) {
      types = Object.keys(objectTypes).flatMap(function (objectType) {
        return Array.from(objectTypes[objectType].values()).map(function (type) {
          return {
            name: type,
            relationObjectTypeName: objectType
          };
        }).flat();
      });
    }
    setRelationTypesTableData(types);
  }, [incomingRelations, isOutgoingRelations, objectType, objectTypes, relationTypes === null || relationTypes === void 0 ? void 0 : relationTypes.results]);
  var relationCardDisplayName = useCallback(function (o, target) {
    var _a;
    return ((_a = objects["".concat(o === null || o === void 0 ? void 0 : o["".concat(target, "_type")], ":").concat(o === null || o === void 0 ? void 0 : o["".concat(target, "_id")])]) === null || _a === void 0 ? void 0 : _a.display_name) || (o === null || o === void 0 ? void 0 : o["".concat(target, "_id")]) || '';
  }, [objects]);
  var subjectRelationName = function subjectRelationName(o) {
    if (o === null || o === void 0 ? void 0 : o.subject_relation) {
      return "".concat(o === null || o === void 0 ? void 0 : o.subject_type, "#").concat(o === null || o === void 0 ? void 0 : o.subject_relation);
    }
    return '';
  };
  var outgoingRelations = useMemo(function () {
    return (outgoingRelationsData === null || outgoingRelationsData === void 0 ? void 0 : outgoingRelationsData.pages.map(function (relation) {
      Object.assign(objects, relation.objects);
      return relation.results || [];
    }).flat()) || [];
  }, [outgoingRelationsData === null || outgoingRelationsData === void 0 ? void 0 : outgoingRelationsData.pages, objects]);
  var relationsToSubjectsTableData = useMemo(function () {
    return !!relationType && isOutgoingRelations && outgoingRelations.filter(function (o) {
      return String(o === null || o === void 0 ? void 0 : o.relation) === relationType;
    }).map(function (o) {
      return {
        relation: (o === null || o === void 0 ? void 0 : o.relation) || '',
        relationCardType: (o === null || o === void 0 ? void 0 : o.subject_type) || '',
        relationCardKey: (o === null || o === void 0 ? void 0 : o.subject_id) || '',
        relationCardDisplayName: relationCardDisplayName(o, 'subject'),
        subjectRelationName: subjectRelationName(o),
        removeRelation: function removeRelation() {
          return _removeRelation({
            params: {
              object_type: safeObjectType,
              object_id: safeObjectId,
              relation: (o === null || o === void 0 ? void 0 : o.relation) || '',
              subject_type: (o === null || o === void 0 ? void 0 : o.subject_type) || '',
              subject_id: (o === null || o === void 0 ? void 0 : o.subject_id) || '',
              subject_relation: o.subject_relation
            }
          });
        }
      };
    }) || [];
  }, [isOutgoingRelations, outgoingRelations, relationType, _removeRelation, safeObjectId, safeObjectType, relationCardDisplayName]);
  var outgoingDestinationObjectType = useMemo(function () {
    var _a;
    var subjectType = (_a = relationsToSubjectsTableData === null || relationsToSubjectsTableData === void 0 ? void 0 : relationsToSubjectsTableData[0]) === null || _a === void 0 ? void 0 : _a.relationCardType;
    return isOutgoingRelations && !!subjectType ? subjectType[0].toUpperCase() + subjectType.slice(1) : 'Object';
  }, [isOutgoingRelations, relationsToSubjectsTableData]);
  var relationsToObjectsTableData = useMemo(function () {
    return !!relationType && !isOutgoingRelations && incomingRelations.filter(function (o) {
      return String(o === null || o === void 0 ? void 0 : o.object_type) === relationSubject && String(o === null || o === void 0 ? void 0 : o.relation) === relationType;
    }).map(function (o) {
      return {
        relation: (o === null || o === void 0 ? void 0 : o.relation) || '',
        relationCardType: (o === null || o === void 0 ? void 0 : o.object_type) || '',
        relationCardKey: (o === null || o === void 0 ? void 0 : o.object_id) || '',
        relationCardDisplayName: relationCardDisplayName(o, 'object'),
        subjectRelationName: subjectRelationName(o),
        removeRelation: function removeRelation() {
          return _removeRelation({
            params: {
              object_type: (o === null || o === void 0 ? void 0 : o.object_type) || '',
              object_id: (o === null || o === void 0 ? void 0 : o.object_id) || '',
              relation: (o === null || o === void 0 ? void 0 : o.relation) || '',
              subject_type: safeObjectType,
              subject_id: safeObjectId,
              subject_relation: o.subject_relation
            }
          });
        }
      };
    }) || [];
  }, [isOutgoingRelations, incomingRelations, relationSubject, relationType, _removeRelation, safeObjectId, safeObjectType, relationCardDisplayName]);
  var relationInstancesData = useMemo(function () {
    return isOutgoingRelations ? relationsToSubjectsTableData : relationsToObjectsTableData;
  }, [isOutgoingRelations, relationsToObjectsTableData, relationsToSubjectsTableData]);
  var displayState = useDirectoryDisplayState();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AddRelationModal, {
    object: object,
    relation: {
      type: relationType !== null && relationType !== void 0 ? relationType : '',
      objectType: (_a = relationSubject === null || relationSubject === void 0 ? void 0 : relationSubject.split('#')[0]) !== null && _a !== void 0 ? _a : ''
    },
    relationSideProperty: isOutgoingRelations ? 'subject' : 'object',
    show: showAddRelationModal,
    onHide: function onHide() {
      return setShowAddRelationModal(false);
    },
    onSave: getRelationSetter
  }), /*#__PURE__*/React.createElement(HighlightedContainer, null, isOutgoingRelations ? "The Outgoing relations tab shows relations from this ".concat(objectType, " to other subjects (").concat(objectType, " \u2192 ").concat(outgoingDestinationObjectType, ").") : "The Incoming relations tab shows relations from other objects into this ".concat(objectType, " (Object \u2192 ").concat(objectType, ").")), /*#__PURE__*/React.createElement(ContentContainer$6, null, /*#__PURE__*/React.createElement(RelationTypesTableContainer, null, !!relationTypesTableData.length ? (/*#__PURE__*/React.createElement(_DataTable, {
    columns: relationTypesColumns,
    data: relationTypesTableData,
    rowComponent: function rowComponent(rowProps) {
      return /*#__PURE__*/React.createElement(Tr, Object.assign({}, rowProps, {
        active: rowProps.row.original.relationObjectTypeName === relationSubject && rowProps.row.original.name === relationType
      }));
    },
    sticky: true
  })) : "This ".concat(objectType, " has no ").concat(relationSide, " relations.")), /*#__PURE__*/React.createElement(RelationsContainer$1, null, !!relationType && (/*#__PURE__*/React.createElement(EvaluateDisplayState, {
    displayState: displayState.canAddRelation
  }, /*#__PURE__*/React.createElement(AddButton, {
    variant: "secondary",
    onClick: function onClick() {
      return setShowAddRelationModal(true);
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "plus",
    src: img$4
  }), "\xA0\xA0Add a relation"))), /*#__PURE__*/React.createElement(RelationCardsContainer, null, !!relationInstancesData.length ? relationInstancesData.map(function (r, i) {
    return /*#__PURE__*/React.createElement(UndecoratedLink, {
      key: i,
      to: "/ui/directory/objects/".concat(r.relationCardType, "/").concat(encodeURIComponent(r.relationCardKey))
    }, /*#__PURE__*/React.createElement(RelationCard, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BoldSpan$1, null, String(r.relationCardDisplayName || r.relationCardKey)), r.relationCardDisplayName && (/*#__PURE__*/React.createElement(CardDetails, null, /*#__PURE__*/React.createElement(EllipsisDiv$1, null, /*#__PURE__*/React.createElement(BoldSpan$1, null, "Id: "), /*#__PURE__*/React.createElement("span", null, r.relationCardKey)), r.subjectRelationName && (/*#__PURE__*/React.createElement(EllipsisDiv$1, null, /*#__PURE__*/React.createElement(BoldSpan$1, null, "Subject relation: "), /*#__PURE__*/React.createElement("span", null, " ", String(r.subjectRelationName))))))), /*#__PURE__*/React.createElement(EvaluateDisplayState, {
      displayState: displayState.canRemoveRelation
    }, /*#__PURE__*/React.createElement(ImageButton, {
      className: "left-auto",
      onClick: function onClick(e) {
        e.preventDefault();
        r.removeRelation();
      }
    }, ' ', /*#__PURE__*/React.createElement("img", {
      alt: "delete",
      src: img$6
    })))));
  }) : !!relationType && (/*#__PURE__*/React.createElement(NoRelationText, null, "This ", objectType, " has no ", relationSide, " relations of type ", relationType, "."))))));
};

var img$3 = "data:image/svg+xml,%3csvg width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M80 40C80 50.8988 75.6412 60.7795 68.5717 67.994C67.2527 57.8481 62.8876 49.3036 55.4766 44.5298C55.2701 44.3912 55.0242 44.3237 54.776 44.3375C54.5277 44.3512 54.2908 44.4454 54.1008 44.6059C50.1654 47.514 45.3937 49.0688 40.5005 49.0376C35.6127 49.033 30.8518 47.482 26.8992 44.6068C26.8136 44.5454 26.7212 44.4952 26.6243 44.4568C26.4966 44.4062 26.361 44.3762 26.2224 44.3685C25.9786 44.355 25.7362 44.4113 25.5234 44.5307C17.9019 49.4418 13.4988 58.3453 12.3219 68.8778C4.72791 61.5974 0 51.3508 0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40ZM57.5399 26.0394C57.5399 35.45 49.911 43.0788 40.5005 43.0788C31.0898 43.0788 23.4611 35.45 23.4611 26.0394C23.4611 16.6288 31.0898 9 40.5005 9C49.911 9 57.5399 16.6288 57.5399 26.0394Z' fill='%23A0A0A0'/%3e%3ccircle cx='40' cy='40' r='39.5' stroke='%23A0A0A0'/%3e%3c/svg%3e";

var UserPropertiesSchema = z.object({
  email: z.string().optional(),
  picture: z.string().optional().default(img$3).transform(function (v) {
    return v === '' ? img$3 : v;
  })
});
var parseAsUserProperties = function parseAsUserProperties() {
  var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return UserPropertiesSchema.parse(target || {});
};

var UserObjectInstance = function UserObjectInstance(_ref) {
  var object = _ref.object;
  var _ref2 = object || {},
    objectId = _ref2.id,
    objectType = _ref2.type;
  var userProps = parseAsUserProperties(object === null || object === void 0 ? void 0 : object.properties);
  useEffect(function () {
    window.scrollTo(0, 0);
  }, [objectType, objectId]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FullContainer, null, /*#__PURE__*/React.createElement(ObjectInstanceHeader, {
    object: object
  }), /*#__PURE__*/React.createElement(ObjectContainer$1, null, /*#__PURE__*/React.createElement(UserImage, {
    alt: "show",
    src: userProps.picture,
    onError: function onError(event) {
      event.currentTarget.src = img$3;
    }
  }), /*#__PURE__*/React.createElement(Container$5, null, !!object && (/*#__PURE__*/React.createElement(DataRow, null, /*#__PURE__*/React.createElement(DataLabel, null, "Email:\xA0\xA0\xA0"), /*#__PURE__*/React.createElement(DataValue, null, userProps.email))), /*#__PURE__*/React.createElement(DataRow, null, /*#__PURE__*/React.createElement(DataLabel, null, "User ID:"), /*#__PURE__*/React.createElement(DataValue, null, " ", objectId)))), /*#__PURE__*/React.createElement(ObjectInstanceBody, null)));
};

var ObjectInstanceRouter = function ObjectInstanceRouter() {
  var _useParams = useParams(),
    objectType = _useParams.objectType,
    objectId = _useParams.objectId;
  var safeObjectType = objectType || '';
  var safeObjectId = objectId || '';
  var _ObjectGet = ObjectGet(safeObjectType, safeObjectId, {}, {
      query: {
        retry: false,
        meta: {
          showError: false
        }
      }
    }),
    objectData = _ObjectGet.data,
    isLoading = _ObjectGet.isLoading;
  var object = useMemo(function () {
    return (objectData === null || objectData === void 0 ? void 0 : objectData.result) || {
      id: safeObjectId,
      type: safeObjectType
    };
  }, [objectData, safeObjectId, safeObjectType]);
  if (isLoading) {
    return null;
  }
  var element;
  switch (objectType) {
    case 'user':
      element = /*#__PURE__*/React.createElement(UserObjectInstance, {
        object: object
      });
      break;
    default:
      element = /*#__PURE__*/React.createElement(GenericObjectInstance, {
        object: object
      });
      break;
  }
  return /*#__PURE__*/React.createElement(Routes, null, /*#__PURE__*/React.createElement(Route, {
    element: element,
    path: ""
  }, /*#__PURE__*/React.createElement(Route, {
    element: /*#__PURE__*/React.createElement(ObjectGraph, {
      object: object
    }),
    path: "graph"
  }), /*#__PURE__*/React.createElement(Route, {
    element: /*#__PURE__*/React.createElement(ObjectProperties, {
      object: object
    }),
    path: "properties"
  }), /*#__PURE__*/React.createElement(Route, {
    element: /*#__PURE__*/React.createElement(ObjectRelations, {
      object: object,
      relationSide: "incoming"
    }),
    path: "incoming-relations"
  }), /*#__PURE__*/React.createElement(Route, {
    element: /*#__PURE__*/React.createElement(ObjectRelations, {
      object: object,
      relationSide: "outgoing"
    }),
    path: "outgoing-relations"
  }), /*#__PURE__*/React.createElement(Route, {
    element: /*#__PURE__*/React.createElement(ObjectRelations, {
      object: object,
      relationSide: "incoming"
    }),
    path: "incoming-relations/:relationSubject/:relationType"
  }), /*#__PURE__*/React.createElement(Route, {
    element: /*#__PURE__*/React.createElement(ObjectRelations, {
      object: object,
      relationSide: "outgoing"
    }),
    path: "outgoing-relations/:relationSubject/:relationType"
  }), /*#__PURE__*/React.createElement(Route, {
    element: /*#__PURE__*/React.createElement(ObjectJson, {
      object: object
    }),
    path: "json"
  }), /*#__PURE__*/React.createElement(Route, {
    element: /*#__PURE__*/React.createElement(Navigate, {
      replace: true,
      to: "graph"
    }),
    index: true
  }), /*#__PURE__*/React.createElement(Route, {
    element: /*#__PURE__*/React.createElement(Navigate, {
      replace: true,
      to: "graph"
    }),
    path: "*"
  })));
};

var nameAvailableResponse = {
  isAvailable: true,
  reason: ''
};
var useIsAvailableDebounced = function useIsAvailableDebounced(useTarget) {
  var useDebouncedTarget = function useDebouncedTarget(name, defaultName) {
    var debouncedName = useDebounce(name, 200);
    var _useState = useState(nameAvailableResponse),
      _useState2 = _slicedToArray(_useState, 2),
      response = _useState2[0],
      setResponse = _useState2[1];
    var serverResponse = useTarget(debouncedName, defaultName);
    useEffect(function () {
      return setResponse(serverResponse);
    }, [serverResponse]);
    return response;
  };
  return useDebouncedTarget;
};

var useIsIdAvailable = function useIsIdAvailable(objectType, currentId) {
  return useMemo(function () {
    var useIsObjectTypeKeyAvailable = function useIsObjectTypeKeyAvailable(id) {
      var queryResult = ObjectsListInfinite({
        object_type: objectType,
        id: id
      }, {
        query: {
          enabled: !!objectType && id !== currentId
        }
      });
      var response = useMemo(function () {
        var _a, _b;
        var matches = ((_b = (_a = queryResult.data) === null || _a === void 0 ? void 0 : _a.pages.flatMap(function (page) {
          return page.results || [];
        })) === null || _b === void 0 ? void 0 : _b.filter(function (object) {
          return object.id === id;
        })) || [];
        var isAvailable = !id || id === currentId || queryResult.isFetching || !!queryResult.error || !queryResult.data || matches.length === 0;
        return {
          isAvailable: isAvailable,
          reason: isAvailable ? '' : 'That ID is already in use'
        };
      }, [id, queryResult.data, queryResult.error, queryResult.isFetching]);
      return response;
    };
    var useIsObjectIdAvailableDebounced = function useIsObjectIdAvailableDebounced(id, defaultId) {
      var useRunTarget = function useRunTarget() {
        return useIsAvailableDebounced(useIsObjectTypeKeyAvailable);
      };
      var run = useMemo(useRunTarget, []);
      return run(id, defaultId);
    };
    return useIsObjectIdAvailableDebounced;
  }, [currentId, objectType]);
};

var ContentContainer$4 = styled.div.withConfig({
  displayName: "AddObjectModal__ContentContainer",
  componentId: "cer01y-0"
})(["padding:20px;width:100%;"]);
var FormContainer = styled.div.withConfig({
  displayName: "AddObjectModal__FormContainer",
  componentId: "cer01y-1"
})(["margin-top:18px;"]);
var FieldContainer$2 = styled.div.withConfig({
  displayName: "AddObjectModal__FieldContainer",
  componentId: "cer01y-2"
})(["display:flex;flex-direction:column;gap:12px;margin:12px auto;"]);
var ButtonsContainer$2 = styled.div.withConfig({
  displayName: "AddObjectModal__ButtonsContainer",
  componentId: "cer01y-3"
})(["width:100%;flex:1 1 0%;justify-content:flex-end;align-items:flex-end;float:right;display:flex;margin-top:20px;button:first-of-type{margin-right:10px;}"]);
var AddObjectModal = function AddObjectModal(_ref) {
  var objectTypeName = _ref.objectTypeName,
    onHide = _ref.onHide,
    _onSuccess = _ref.onSuccess,
    show = _ref.show;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    id = _useState2[0],
    setId = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    displayName = _useState4[0],
    setDisplayName = _useState4[1];
  var showError = useShowError();
  var queryClient = useQueryClient();
  var objectsListInfiniteQueryKey = ObjectsListInfiniteQueryKey({
    object_type: objectTypeName
  });
  var relationsListInfiniteQueryKey = RelationsListInfiniteQueryKey();
  var objectGetQueryKey = ObjectGetQueryKey(objectTypeName, id);
  var setObject = ObjectSet({
    mutation: {
      onError: function onError(e) {
        showError(e);
      },
      onSuccess: function onSuccess(o) {
        clearModalState();
        queryClient.invalidateQueries(objectGetQueryKey);
        // remove cache for current object type and all the relations
        queryClient.removeQueries({
          predicate: function predicate(query) {
            return query.queryKey.includes(objectsListInfiniteQueryKey[0]) || query.queryKey.includes(relationsListInfiniteQueryKey[0]);
          }
        });
        _onSuccess === null || _onSuccess === void 0 ? void 0 : _onSuccess(o.result);
      }
    }
  });
  var clearModalState = function clearModalState() {
    setId('');
    setDisplayName('');
  };
  var closeModal = function closeModal() {
    clearModalState();
    onHide();
  };
  var isIdAvailable = useIsIdAvailable(objectTypeName);
  return !!objectTypeName ? (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardModal, {
    cardHeight: "100%",
    show: show,
    title: "Add ".concat(objectTypeName),
    onHide: closeModal
  }, /*#__PURE__*/React.createElement(ContentContainer$4, {
    className: "add-a-relation-modal-content"
  }, /*#__PURE__*/React.createElement("div", null, "Provide a unique ID and a display name for this ".concat(objectTypeName, ", and click the Add button.")), /*#__PURE__*/React.createElement(FormContainer, null, /*#__PURE__*/React.createElement(FieldContainer$2, null, /*#__PURE__*/React.createElement(ValidatedInput, {
    autoFocus: true,
    label: "ID",
    useIsAvailable: isIdAvailable,
    validator: IdValidator,
    onChange: function onChange(v) {
      return setId(v || '');
    }
  })), /*#__PURE__*/React.createElement(FieldContainer$2, null, /*#__PURE__*/React.createElement(ValidatedInput, {
    label: "Display Name",
    validator: DisplayNameValidator,
    onChange: function onChange(v) {
      return setDisplayName(v || '');
    }
  }))), /*#__PURE__*/React.createElement(ButtonsContainer$2, null, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "cancel-btn",
    variant: "secondary",
    onClick: closeModal
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "add-relation-modal-btn",
    disabled: id === '' || setObject.isLoading,
    id: "add-relation",
    type: "submit",
    onClick: function onClick() {
      return setObject.mutate({
        data: {
          object: {
            type: objectTypeName,
            id: id,
            display_name: displayName
          }
        }
      });
    }
  }, "Add")))))) : null;
};

var Header$2 = styled(ObjectHeaderContainer).withConfig({
  displayName: "styles__Header",
  componentId: "sc-22g6ve-0"
})(["flex-direction:column;justify-content:space-evenly;align-items:inherit;font-weight:bold;"]);
var SubHeader = styled.div.withConfig({
  displayName: "styles__SubHeader",
  componentId: "sc-22g6ve-1"
})(["display:flex;flex-direction:row;gap:30px;align-items:center;"]);
var TitleContainer = styled.div.withConfig({
  displayName: "styles__TitleContainer",
  componentId: "sc-22g6ve-2"
})(["width:100%;display:flex;align-items:center;justify-content:space-between;flex-driection:row;"]);

var ObjectsHeader = function ObjectsHeader(_ref) {
  var children = _ref.children,
    className = _ref.className;
  var navigate = useNavigate();
  var queryClient = useQueryClient();
  var displayState = useDirectoryDisplayState();
  var _useParams = useParams(),
    objectTypeName = _useParams.objectType;
  var safeObjectType = objectTypeName || '';
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAddModal = _useState2[0],
    setShowAddModal = _useState2[1];
  return /*#__PURE__*/React.createElement(Header$2, {
    className: className
  }, /*#__PURE__*/React.createElement(AddObjectModal, {
    objectTypeName: objectTypeName,
    show: showAddModal,
    onHide: function onHide() {
      return setShowAddModal(false);
    },
    onSuccess: function onSuccess(v) {
      setShowAddModal(false);
      queryClient.refetchQueries({
        type: 'active'
      });
      navigate("/ui/directory/objects/".concat(safeObjectType, "/").concat(encodeURIComponent(v.id)), {
        replace: true
      });
    }
  }), /*#__PURE__*/React.createElement(TitleContainer, null, /*#__PURE__*/React.createElement(SubHeader, null, /*#__PURE__*/React.createElement(EvaluateDisplayState, {
    displayState: displayState.canEditManifest
  }, /*#__PURE__*/React.createElement(AddButton$1, {
    variant: "secondary",
    onClick: function onClick() {
      return setShowAddModal(true);
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "plus",
    src: img$4
  }), "Add")), children)));
};

var Container$4 = styled.div.withConfig({
  displayName: "styles__Container",
  componentId: "ff0teo-0"
})(["width:100%;@media (max-width:912px){margin-top:94px;}"]);
var PageHeaderInput = styled(Input).withConfig({
  displayName: "styles__PageHeaderInput",
  componentId: "ff0teo-1"
})(["max-width:330px;width:330px;"]);
var PageHeaderInputFind = styled(Input).withConfig({
  displayName: "styles__PageHeaderInputFind",
  componentId: "ff0teo-2"
})(["max-width:330px;width:330px;border-radius:4px 0 0 4px;"]);
var UsersContainer = styled.div.withConfig({
  displayName: "styles__UsersContainer",
  componentId: "ff0teo-3"
})(["width:100%;margin-bottom:25px;padding:0px 25px;"]);
var SubjectCard = styled.div.withConfig({
  displayName: "styles__SubjectCard",
  componentId: "ff0teo-4"
})(["background-color:", ";color:", ";display:", ";width:450px;padding:10px;margin:10px 10px 0 0;border-radius:6px;align-items:center;font-size:14px;font-weight:500;cursor:pointer;> div{flex-direction:column;display:flex;gap:3px;}img{margin-right:10px;width:90px;height:90px;object-fit:cover;border-radius:50%;}&:hover{background-color:", ";color:", ";}"], theme.grey20, theme.grey70, function (_ref) {
  var inline = _ref.inline;
  return !!inline ? 'inline-flex' : 'flex';
}, theme.grey30, theme.grey100);
var BoldSpan = styled.span.withConfig({
  displayName: "styles__BoldSpan",
  componentId: "ff0teo-5"
})(["font-weight:bold;color:", ";"], theme.grey100);
var EllipsisDiv = styled.div.withConfig({
  displayName: "styles__EllipsisDiv",
  componentId: "ff0teo-6"
})(["display:block;width:315px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"]);
var FindButton = styled(Button).withConfig({
  displayName: "styles__FindButton",
  componentId: "ff0teo-7"
})(["height:36px;"]);

var Container$3 = styled.div.withConfig({
  displayName: "GenericObjects__Container",
  componentId: "a0oe46-0"
})(["width:100%;@media (max-width:912px){margin-top:94px;}"]);
var BreakDiv$1 = styled.div.withConfig({
  displayName: "GenericObjects__BreakDiv",
  componentId: "a0oe46-1"
})(["word-break:break-all;"]);
var Objects = function Objects() {
  var _useParams = useParams(),
    objectTypeName = _useParams.objectType;
  var safeObjectType = objectTypeName || '';
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    objects = _useState2[0],
    setObjects = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchKey = _useState4[0],
    setSearchKey = _useState4[1];
  var _useFeatureFlags = useFeatureFlags(),
    isGraphQLEnabled = _useFeatureFlags.isGraphQLEnabled;
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    filter = _useState6[0],
    setFilter = _useState6[1];
  var debouncedFilter = useDebounce(filter);
  useEffect(function () {
    return setFilter('');
  }, [objectTypeName]);
  var showError = useShowError();
  var _ObjectTypesList = ObjectTypesList(),
    data = _ObjectTypesList.data;
  var objectTypes = useMemo(function () {
    return ((data === null || data === void 0 ? void 0 : data.results) || []).map(function (o) {
      return o.name;
    });
  }, [data === null || data === void 0 ? void 0 : data.results]);
  var _ObjectsListInfinite = ObjectsListInfinite({
      object_type: objectTypeName,
      'page.size': 100,
      displayNamePart: debouncedFilter
    }, {
      query: {
        onError: function onError(e) {
          showError(e);
        },
        enabled: objectTypes.includes(safeObjectType)
      }
    }),
    objectsData = _ObjectsListInfinite.data,
    isFetchingObjects = _ObjectsListInfinite.isFetching,
    hasMoreObjects = _ObjectsListInfinite.hasNextPage,
    fetchMoreObjects = _ObjectsListInfinite.fetchNextPage;
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    findError = _useState8[0],
    setFindError = _useState8[1];
  var _ObjectGet = ObjectGet(safeObjectType, searchKey, {}, {
      query: {
        enabled: false,
        retry: false,
        meta: {
          showError: false
        },
        onError: function onError() {
          setObjects([]);
          setFindError(true);
        },
        onSettled: function onSettled(data, error) {
          if (error) {
            setObjects([]);
            setFindError(true);
          }
          if (data) {
            setObjects([data.result]);
            setFindError(false);
          }
        }
      }
    }),
    refetchObject = _ObjectGet.refetch;
  var listObjects = useMemo(function () {
    var _a;
    return (_a = objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages.map(function (page) {
      return page.results || [];
    }).flat()) !== null && _a !== void 0 ? _a : [];
  }, [objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages]);
  useEffect(function () {
    setObjects(listObjects);
  }, [listObjects]);
  var fetchData = useIsScrollable({
    isFetching: isFetchingObjects,
    hasMoreData: hasMoreObjects || false,
    fetchNextData: fetchMoreObjects
  });
  useCallback(function () {
    fetchData();
  }, [fetchData]);
  var columns = [{
    Header: 'ID',
    style: {
      cellWidth: '50%'
    },
    Cell: function Cell(_ref) {
      var row = _ref.row;
      return /*#__PURE__*/React.createElement(BreakDiv$1, null, row.original.key);
    }
  }, {
    Header: 'Name',
    style: {
      cellWidth: '50%'
    },
    Cell: function Cell(_ref2) {
      var row = _ref2.row;
      return /*#__PURE__*/React.createElement(Link, {
        to: "/ui/directory/objects/".concat(safeObjectType, "/").concat(encodeURIComponent(row.original.key))
      }, /*#__PURE__*/React.createElement(BreakDiv$1, null, row.original.name));
    }
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container$3, null, /*#__PURE__*/React.createElement(ObjectsHeader, null, isGraphQLEnabled ? (/*#__PURE__*/React.createElement(PageHeaderInput, {
    placeholder: "Find",
    value: filter,
    onChange: function onChange(e) {
      setFilter(e.target.value);
    }
  })) : (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageHeaderInput, {
    "data-testid": "filter-input",
    placeholder: "Find",
    value: searchKey,
    onChange: function onChange(e) {
      if (e.target.value === '' || e.target.value === undefined) {
        setObjects(listObjects);
      }
      setSearchKey(e.target.value);
    }
  }), /*#__PURE__*/React.createElement(FindButton, {
    disabled: !searchKey,
    onClick: function onClick() {
      setSearchKey(searchKey);
      refetchObject();
    }
  }, "\xA0Find\xA0")))), !!objects.length ? (/*#__PURE__*/React.createElement(_DataTable, {
    columns: columns,
    data: objects.map(function (object) {
      return {
        name: object.display_name || object.id,
        key: object.id
      };
    }),
    paging: {
      dataLength: objects.length,
      loadingContent: [{
        key: 'loading...',
        name: 'loading...'
      }],
      hasMore: function hasMore() {
        return !!hasMoreObjects;
      },
      getNext: function getNext() {
        return fetchMoreObjects();
      }
    },
    sticky: true
  })) : (/*#__PURE__*/React.createElement(EmptyTablePlaceholder, {
    body: findError ? "" : "To add one, click the \"Add\" button in the top left.",
    header: findError ? "Could not find any object with key: \"".concat(searchKey, "\"") : "There are no objects of type ".concat(safeObjectType, "."),
    imgAlt: "Empty Directory",
    imgSrc: img$g
  })), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("br", null));
};

var img$2 = "data:image/svg+xml,%3csvg width='100' height='100' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M82.7225 78.5593V77.2542C82.7225 68.6407 80.8901 61.8542 77.2251 56.8949C76.178 55.3288 76.9633 53.2407 78.534 52.9797C79.8429 52.7186 81.1518 52.4576 82.7225 52.4576C95.5497 52.4576 100 64.2034 100 72.2949C100 76.4712 91.3613 78.5593 82.7225 78.5593ZM50 42.278C41.623 42.278 34.8168 35.4915 34.8168 27.139C34.8168 18.7864 41.623 12 50 12C58.377 12 65.1832 18.7864 65.1832 27.139C65.1832 35.4915 58.377 42.278 50 42.278ZM82.4607 47.7593C76.178 47.7593 70.9424 42.539 70.9424 36.2746C70.9424 30.0102 76.178 24.7898 82.4607 24.7898C88.7435 24.7898 93.9791 30.0102 93.9791 36.2746C93.9791 42.539 88.7435 47.7593 82.4607 47.7593ZM17.2775 47.4983C10.9948 47.4983 6.02094 42.539 6.02094 36.2746C6.02094 30.0102 10.9948 25.0508 17.2775 25.0508C23.5602 25.0508 28.534 30.0102 28.534 36.2746C28.534 42.539 23.5602 47.4983 17.2775 47.4983ZM50 48.5424C66.4921 48.5424 78.0105 54.8068 78.0105 76.4712C78.0105 82.2136 71.7277 89 50 89C28.2723 89 21.9895 82.9966 21.9895 76.4712C21.9895 54.5458 33.2461 48.5424 50 48.5424ZM0 72.817C0 64.7254 4.18848 52.9797 17.2775 52.9797C18.8482 52.9797 20.1571 53.2407 21.466 53.5017C23.2984 54.0237 23.822 56.1119 22.7749 57.4169C19.1099 62.3763 17.2775 69.1627 17.2775 77.7763V79.0814C8.63874 79.0814 0 76.9932 0 72.817Z' fill='%23e7e7e7'/%3e%3c/svg%3e";

var UserObjects = function UserObjects() {
  var _useParams = useParams(),
    objectType = _useParams.objectType;
  var safeObjectType = objectType || '';
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    filter = _useState2[0],
    setFilter = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchKey = _useState4[0],
    setSearchKey = _useState4[1];
  var debouncedFilter = useDebounce(filter);
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    users = _useState6[0],
    setUsers = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    findFilter = _useState8[0],
    setFindFilter = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    findError = _useState10[0],
    setFindError = _useState10[1];
  var _ObjectTypesList = ObjectTypesList(),
    data = _ObjectTypesList.data;
  var objectTypes = useMemo(function () {
    return ((data === null || data === void 0 ? void 0 : data.results) || []).map(function (o) {
      return o.name;
    });
  }, [data === null || data === void 0 ? void 0 : data.results]);
  var showError = useShowError();
  var _ObjectsListInfinite = ObjectsListInfinite({
      object_type: safeObjectType,
      'page.size': 100,
      displayNamePart: debouncedFilter
    }, {
      query: {
        onError: function onError(e) {
          showError(e);
        },
        enabled: objectTypes.includes(safeObjectType)
      }
    }),
    usersData = _ObjectsListInfinite.data,
    isFetchingUsers = _ObjectsListInfinite.isFetching,
    hasMoreUsers = _ObjectsListInfinite.hasNextPage,
    fetchNextUsersData = _ObjectsListInfinite.fetchNextPage;
  var listUsers = useMemo(function () {
    var _a;
    return (_a = usersData === null || usersData === void 0 ? void 0 : usersData.pages.map(function (page) {
      return page.results || [];
    }).flat()) !== null && _a !== void 0 ? _a : [];
  }, [usersData === null || usersData === void 0 ? void 0 : usersData.pages]);
  useEffect(function () {
    setUsers(listUsers);
  }, [listUsers]);
  var _useFeatureFlags = useFeatureFlags(),
    isGraphQLEnabled = _useFeatureFlags.isGraphQLEnabled;
  var _ObjectGet = ObjectGet(safeObjectType, findFilter, {}, {
      query: {
        enabled: false,
        retry: false,
        meta: {
          showError: false
        },
        onError: function onError() {
          setUsers([]);
          setFindError(true);
        },
        onSettled: function onSettled(data, error) {
          if (error) {
            setUsers([]);
            setFindError(true);
          }
          if (data) {
            setUsers([data.result]);
            setFindError(false);
          }
        }
      }
    }),
    refetchUser = _ObjectGet.refetch;
  var fetchData = useIsScrollable({
    isFetching: isFetchingUsers,
    hasMoreData: hasMoreUsers || false,
    fetchNextData: fetchNextUsersData
  });
  useCallback(function () {
    fetchData();
  }, [fetchData]);
  return /*#__PURE__*/React.createElement(Container$4, null, /*#__PURE__*/React.createElement(ObjectsHeader, null, isGraphQLEnabled ? (/*#__PURE__*/React.createElement(PageHeaderInput, {
    placeholder: "Find",
    value: filter,
    onChange: function onChange(e) {
      setFilter(e.target.value);
    }
  })) : (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageHeaderInputFind, {
    placeholder: "User ID",
    value: findFilter,
    onChange: function onChange(e) {
      if (e.target.value === '' || e.target.value === undefined) {
        setUsers(listUsers);
      }
      setFindFilter(e.target.value);
    }
  }), /*#__PURE__*/React.createElement(FindButton, {
    disabled: !findFilter,
    onClick: function onClick() {
      setSearchKey(findFilter);
      refetchUser();
    }
  }, "\xA0Find\xA0")))), /*#__PURE__*/React.createElement(UsersContainer, null, !!users.length ? (/*#__PURE__*/React.createElement(InfiniteScroll, {
    dataLength: users.length,
    hasMore: !!hasMoreUsers,
    loader: isFetchingUsers,
    next: fetchNextUsersData
  }, users.map(function (u) {
    var _a;
    var userProps = parseAsUserProperties(u.properties);
    return /*#__PURE__*/React.createElement(UndecoratedLink, {
      key: u.id,
      to: "/ui/directory/objects/".concat(safeObjectType, "/").concat(encodeURIComponent(u.id))
    }, /*#__PURE__*/React.createElement(SubjectCard, {
      inline: true
    }, /*#__PURE__*/React.createElement("img", {
      alt: (_a = u.display_name) !== null && _a !== void 0 ? _a : u.id,
      src: userProps.picture,
      onError: function onError(event) {
        event.currentTarget.src = img$3;
      }
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BoldSpan, null, u.display_name), /*#__PURE__*/React.createElement("span", null, userProps.email), /*#__PURE__*/React.createElement(EllipsisDiv, null, /*#__PURE__*/React.createElement(BoldSpan, null, "ID: "), /*#__PURE__*/React.createElement("span", null, u.id)))));
  }))) : (/*#__PURE__*/React.createElement(EmptyTablePlaceholder, {
    body: findError ? "" : "To add one, click the \"Add\" button in the top left.",
    header: findError ? "Could not find any object with key: \"".concat(searchKey, "\"") : "There are no objects of type ".concat(objectType, "."),
    imgAlt: "Empty Directory",
    imgSrc: img$2
  }))));
};

var ObjectsSelector = function ObjectsSelector() {
  var _useParams = useParams(),
    objectType = _useParams.objectType;
  var _ObjectTypesList = ObjectTypesList(),
    data = _ObjectTypesList.data;
  var objectTypes = useMemo(function () {
    return ((data === null || data === void 0 ? void 0 : data.results) || []).map(function (o) {
      return o.name;
    });
  }, [data === null || data === void 0 ? void 0 : data.results]);
  useEffect(function () {
    window.scrollTo(0, 0);
  }, [objectType]);
  if (!objectType || !objectTypes.includes(objectType)) {
    return null;
  }
  switch (objectType) {
    case 'user':
      return /*#__PURE__*/React.createElement(UserObjects, null);
    default:
      return /*#__PURE__*/React.createElement(Objects, null);
  }
};

var __defProp = Object.defineProperty, __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty, __propIsEnum = Object.prototype.propertyIsEnumerable;
var __knownSymbol = (name, symbol) => (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: !0, configurable: !0, writable: !0, value }) : obj[key] = value, __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b))
      __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
  return a;
}, __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __await = function(promise, isYieldStar) {
  this[0] = promise, this[1] = isYieldStar;
}, __asyncGenerator = (__this, __arguments, generator) => {
  var resume = (k, v, yes, no) => {
    try {
      var x = generator[k](v), isAwait = (v = x.value) instanceof __await, done = x.done;
      Promise.resolve(isAwait ? v[0] : v).then((y) => isAwait ? resume(k === "return" ? k : "next", v[1] ? { done: y.done, value: y.value } : y, yes, no) : yes({ value: y, done })).catch((e) => resume("throw", e, yes, no));
    } catch (e) {
      no(e);
    }
  }, method = (k) => it[k] = (x) => new Promise((yes, no) => resume(k, x, yes, no)), it = {};
  return generator = generator.apply(__this, __arguments), it[__knownSymbol("asyncIterator")] = () => it, method("next"), method("throw"), method("return"), it;
};
var __forAwait = (obj, it, method) => (it = obj[__knownSymbol("asyncIterator")]) ? it.call(obj) : (obj = obj[__knownSymbol("iterator")](), it = {}, method = (key, fn) => (fn = obj[key]) && (it[key] = (arg) => new Promise((yes, no, done) => (arg = fn.call(obj, arg), done = arg.done, Promise.resolve(arg.value).then((value) => yes({ value, done }), no)))), method("next"), method("return"), it);

async function e(e,t){let n=e.headers["content-type"];if(!n||!~n.indexOf("multipart/"))return e;let r=n.indexOf("boundary="),i="-";if(~r){let e=r+9,t=n.indexOf(";",e);i=n.slice(e,t>-1?t:void 0).trim().replace(/"/g,"");}return async function*(e,t,n){let r,i,f,a=!n||!n.multiple,l=Buffer.byteLength(t),o=Buffer.alloc(0),s=[];e:for await(let n of e){r=o.byteLength,o=Buffer.concat([o,n]);let e=n.indexOf(t);for(~e?r+=e:r=o.indexOf(t),s=[];~r;){let e=o.subarray(0,r),n=o.subarray(r+l);if(i){let t=e.indexOf("\r\n\r\n")+4,r=e.lastIndexOf("\r\n",t),i=!1,l=e.subarray(t,r>-1?void 0:r),o=String(e.subarray(0,t)).trim().split("\r\n"),d={},y=o.length;for(;f=o[--y];f=f.split(": "),d[f.shift().toLowerCase()]=f.join(": "));if(f=d["content-type"],f&&~f.indexOf("application/json"))try{l=JSON.parse(String(l)),i=!0;}catch(e){}if(f={headers:d,body:l,json:i},a?yield f:s.push(f),45===n[0]&&45===n[1])break e}else t="\r\n"+t,i=l+=2;o=n,r=o.indexOf(t);}s.length&&(yield s);}s.length&&(yield s);}(e,`--${i}`,t)}

/**
 * Attaches a cleanup handler to a AsyncIterable.
 *
 * @param source The source that should have a return handler attached
 * @param onReturn The return handler that should be attached
 * @returns
 */
function withHandlers(source, onReturn, onThrow) {
    const stream = (async function* withReturnSource() {
        yield* source;
    })();
    const originalReturn = stream.return.bind(stream);
    if (onReturn) {
        stream.return = (...args) => {
            onReturn();
            return originalReturn(...args);
        };
    }
    if (onThrow) {
        const originalThrow = stream.throw.bind(stream);
        stream.throw = (err) => {
            onThrow(err);
            return originalThrow(err);
        };
    }
    return stream;
}

function createDeferred() {
    const d = {};
    d.promise = new Promise((resolve, reject) => {
        d.resolve = resolve;
        d.reject = reject;
    });
    return d;
}
/**
 * makePushPullAsyncIterableIterator
 *
 * The iterable will publish values until return or throw is called.
 * Afterwards it is in the completed state and cannot be used for publishing any further values.
 * It will handle back-pressure and keep pushed values until they are consumed by a source.
 */
function makePushPullAsyncIterableIterator() {
    let state = {
        type: "running" /* running */
    };
    let next = createDeferred();
    const values = [];
    function pushValue(value) {
        if (state.type !== "running" /* running */) {
            return;
        }
        values.push(value);
        next.resolve();
        next = createDeferred();
    }
    const source = (async function* PushPullAsyncIterableIterator() {
        while (true) {
            if (values.length > 0) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                yield values.shift();
            }
            else {
                if (state.type === "error" /* error */) {
                    throw state.error;
                }
                if (state.type === "finished" /* finished */) {
                    return;
                }
                await next.promise;
            }
        }
    })();
    const stream = withHandlers(source, () => {
        if (state.type !== "running" /* running */) {
            return;
        }
        state = {
            type: "finished" /* finished */
        };
        next.resolve();
    }, (error) => {
        if (state.type !== "running" /* running */) {
            return;
        }
        state = {
            type: "error" /* error */,
            error
        };
        next.resolve();
    });
    return {
        pushValue,
        asyncIterableIterator: stream
    };
}

const makeAsyncIterableIteratorFromSink = (make) => {
    const { pushValue, asyncIterableIterator } = makePushPullAsyncIterableIterator();
    const dispose = make({
        next: (value) => {
            pushValue(value);
        },
        complete: () => {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            asyncIterableIterator.return();
        },
        error: (err) => {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            asyncIterableIterator.throw(err);
        }
    });
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const originalReturn = asyncIterableIterator.return;
    let returnValue = undefined;
    asyncIterableIterator.return = () => {
        if (returnValue === undefined) {
            dispose();
            returnValue = originalReturn();
        }
        return returnValue;
    };
    return asyncIterableIterator;
};

function isAsyncIterable(input) {
    return (typeof input === "object" &&
        input !== null &&
        // The AsyncGenerator check is for Safari on iOS which currently does not have
        // Symbol.asyncIterator implemented
        // That means every custom AsyncIterable must be built using a AsyncGeneratorFunction (async function * () {})
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (input[Symbol.toStringTag] === "AsyncGenerator" ||
            (Symbol.asyncIterator && Symbol.asyncIterator in input)));
}

const errorHasCode = (err) => typeof err == "object" && err !== null && "code" in err, isSubscriptionWithName = (document, name) => {
  let isSubscription = !1;
  return visit(document, {
    OperationDefinition(node) {
      var _a;
      name === ((_a = node.name) == null ? void 0 : _a.value) && node.operation === "subscription" && (isSubscription = !0);
    }
  }), isSubscription;
}, createSimpleFetcher = (options, httpFetch) => async (graphQLParams, fetcherOpts) => (await httpFetch(options.url, {
  method: "POST",
  body: JSON.stringify(graphQLParams),
  headers: __spreadValues(__spreadValues({
    "content-type": "application/json"
  }, options.headers), fetcherOpts == null ? void 0 : fetcherOpts.headers)
})).json();
async function createWebsocketsFetcherFromUrl(url, connectionParams) {
  let wsClient;
  try {
    const { createClient } = await import('./index-5baf21d1.js');
    return wsClient = createClient({ url, connectionParams }), createWebsocketsFetcherFromClient(wsClient);
  } catch (err) {
    if (errorHasCode(err) && err.code === "MODULE_NOT_FOUND")
      throw new Error(
        "You need to install the 'graphql-ws' package to use websockets when passing a 'subscriptionUrl'"
      );
    console.error(`Error creating websocket client for ${url}`, err);
  }
}
const createWebsocketsFetcherFromClient = (wsClient) => (graphQLParams) => makeAsyncIterableIteratorFromSink(
  (sink) => wsClient.subscribe(graphQLParams, __spreadProps(__spreadValues({}, sink), {
    error(err) {
      err instanceof CloseEvent ? sink.error(
        new Error(
          `Socket closed with event ${err.code} ${err.reason || ""}`.trim()
        )
      ) : sink.error(err);
    }
  }))
), createLegacyWebsocketsFetcher = (legacyWsClient) => (graphQLParams) => {
  const observable = legacyWsClient.request(graphQLParams);
  return makeAsyncIterableIteratorFromSink(
    (sink) => observable.subscribe(sink).unsubscribe
  );
}, createMultipartFetcher = (options, httpFetch) => function(graphQLParams, fetcherOpts) {
  return __asyncGenerator(this, null, function* () {
    const response = yield new __await(httpFetch(options.url, {
      method: "POST",
      body: JSON.stringify(graphQLParams),
      headers: __spreadValues(__spreadValues({
        "content-type": "application/json",
        accept: "application/json, multipart/mixed"
      }, options.headers), fetcherOpts == null ? void 0 : fetcherOpts.headers)
    }).then(
      (r) => e(r, {
        multiple: !0
      })
    ));
    if (!isAsyncIterable(response))
      return yield response.json();
    try {
      for (var iter = __forAwait(response), more, temp, error; more = !(temp = yield new __await(iter.next())).done; more = !1) {
        const chunk = temp.value;
        if (chunk.some((part) => !part.json)) {
          const message = chunk.map(
            (part) => `Headers::
${part.headers}

Body::
${part.body}`
          );
          throw new Error(
            `Expected multipart chunks to be of json type. got:
${message}`
          );
        }
        yield chunk.map((part) => part.body);
      }
    } catch (temp) {
      error = [temp];
    } finally {
      try {
        more && (temp = iter.return) && (yield new __await(temp.call(iter)));
      } finally {
        if (error)
          throw error[0];
      }
    }
  });
};
async function getWsFetcher(options, fetcherOpts) {
  if (options.wsClient)
    return createWebsocketsFetcherFromClient(options.wsClient);
  if (options.subscriptionUrl)
    return createWebsocketsFetcherFromUrl(options.subscriptionUrl, __spreadValues(__spreadValues({}, options.wsConnectionParams), fetcherOpts == null ? void 0 : fetcherOpts.headers));
  const legacyWebsocketsClient = options.legacyClient || options.legacyWsClient;
  if (legacyWebsocketsClient)
    return createLegacyWebsocketsFetcher(legacyWebsocketsClient);
}

function createGraphiQLFetcher(options) {
  const httpFetch = options.fetch || typeof window != "undefined" && window.fetch;
  if (!httpFetch)
    throw new Error("No valid fetcher implementation available");
  options.enableIncrementalDelivery = options.enableIncrementalDelivery !== !1;
  const simpleFetcher = createSimpleFetcher(options, httpFetch), httpFetcher = options.enableIncrementalDelivery ? createMultipartFetcher(options, httpFetch) : simpleFetcher;
  return async (graphQLParams, fetcherOpts) => {
    if (graphQLParams.operationName === "IntrospectionQuery")
      return (options.schemaFetcher || simpleFetcher)(
        graphQLParams,
        fetcherOpts
      );
    if (fetcherOpts != null && fetcherOpts.documentAST ? isSubscriptionWithName(
      fetcherOpts.documentAST,
      graphQLParams.operationName || void 0
    ) : !1) {
      const wsFetcher = await getWsFetcher(options, fetcherOpts);
      if (!wsFetcher)
        throw new Error(
          `Your GraphiQL createFetcher is not properly configured for websocket subscriptions yet. ${options.subscriptionUrl ? `Provided URL ${options.subscriptionUrl} failed` : "Please provide subscriptionUrl, wsClient or legacyClient option first."}`
        );
      return wsFetcher(graphQLParams);
    }
    return httpFetcher(graphQLParams, fetcherOpts);
  };
}

var Container$2 = styled.div.withConfig({
  displayName: "Playground__Container",
  componentId: "sc-1co9slg-0"
})(["height:100%;width:100%;padding:30px 30px 30px 0;.CodeMirror-gutter{background-color:#121212;}.graphiql-container{height:1000px;background-color:#121212;.graphiql-editors{background-color:#121212;}}"]);
var DirectoryPlayground = function DirectoryPlayground() {
  var _useConfig = useConfig(),
    directoryServiceUrl = _useConfig.directoryServiceUrl,
    directoryApiKey = _useConfig.directoryApiKey;
  var _useProfile = useProfile(),
    tenantId = _useProfile.tenantId;
  var _useIdentity = useIdentity(),
    getAccessToken = _useIdentity.getAccessToken;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    accessToken = _useState2[0],
    setAccessToken = _useState2[1];
  useEffect(function () {
    var getToken = function getToken() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var accessToken;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAccessToken();
            case 2:
              accessToken = _context.sent;
              setAccessToken(accessToken);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    };
    getToken();
  }, [getAccessToken]);
  var authorization = !!directoryApiKey ? "basic ".concat(directoryApiKey) : accessToken;
  var locationState = useLocation().state;
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    query = _useState4[0],
    setQuery = _useState4[1];
  var _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    headers = _useState6[0],
    setHeaders = _useState6[1];
  var _useStorage = useStorage('graphiql:tabIds', []),
    _useStorage2 = _slicedToArray(_useStorage, 2),
    tabIds = _useStorage2[0],
    setTabIds = _useStorage2[1];
  useEffect(function () {
    setHeaders("{\n  \"Aserto-Tenant-Id\": \"".concat(tenantId, "\",\n  \"Authorization\": \"").concat(authorization, "\"\n}"));
  }, [authorization, tenantId]);
  var fetcher = createGraphiQLFetcher({
    url: "".concat(directoryServiceUrl, "/graph/query")
  });
  useEffect(function () {
    if (!!locationState && !!locationState.query) {
      setQuery(locationState.query);
    }
  }, [locationState]);
  return /*#__PURE__*/React.createElement(Container$2, null, /*#__PURE__*/React.createElement(GraphiQL, {
    defaultEditorToolsVisibility: "headers",
    defaultQuery: "query GetUsers {\n  objects(first: 30, where: {type: \"user\"}) {\n    nodes {\n      id\n      displayName\n      properties\n    }\n  }\n}",
    editorTheme: "seti",
    fetcher: fetcher,
    headers: headers,
    query: query,
    shouldPersistHeaders: true,
    onEditQuery: function onEditQuery(value) {
      setQuery(value);
    },
    onTabChange: function onTabChange(tabState) {
      setHeaders(undefined);
      if (!tabIds.includes(tabState.tabs[tabState.activeTabIndex].id) && tabState.tabs[tabState.activeTabIndex].title === '<untitled>' && tabState.tabs[tabState.activeTabIndex].query === '') {
        setHeaders("{\n  \"Aserto-Tenant-Id\": ".concat(tenantId, ",\n  \"Authorization\": ").concat(authorization, "\n}"));
        setTabIds(function (prev) {
          return [].concat(_toConsumableArray(prev), [tabState.tabs[tabState.activeTabIndex].id]);
        });
      }
    }
  }));
};

var DataContainer = styled.div.withConfig({
  displayName: "styles__DataContainer",
  componentId: "sc-1rmtq9n-0"
})(["padding-left:12px;width:100%;"]);
var SelectContainer = styled.div.withConfig({
  displayName: "styles__SelectContainer",
  componentId: "sc-1rmtq9n-1"
})(["display:inline-flex;z-index:1;position:fixed;width:calc(98% - 222px);padding-top:8px;background-color:", ";@media (max-width:912px){width:calc(98% + 12px);padding-top:12px;}"], theme.primaryBlack);
var ObjectContainer = styled.div.withConfig({
  displayName: "styles__ObjectContainer",
  componentId: "sc-1rmtq9n-2"
})(["width:100%;padding-top:12px;padding-bottom:12px;padding-left:12px;padding-right:16px;"]);
var SubjectContainer = styled.div.withConfig({
  displayName: "styles__SubjectContainer",
  componentId: "sc-1rmtq9n-3"
})(["padding-top:12px;padding-bottom:12px;padding-right:32px;width:100%;padding-left:16px;@media (max-width:912px){padding-right:12px;}"]);
var Label = styled.h5.withConfig({
  displayName: "styles__Label",
  componentId: "sc-1rmtq9n-4"
})(["padding-bottom:12px;border-bottom:2px solid ", ";width:100%;"], theme.grey20);
var FieldsContainer = styled.div.withConfig({
  displayName: "styles__FieldsContainer",
  componentId: "sc-1rmtq9n-5"
})(["padding-top:12px;gap:16px;display:inline-flex;width:100%;"]);
var ObjectTypeContainer = styled.div.withConfig({
  displayName: "styles__ObjectTypeContainer",
  componentId: "sc-1rmtq9n-6"
})(["width:100%;"]);
var ObjectIdContainer = styled.div.withConfig({
  displayName: "styles__ObjectIdContainer",
  componentId: "sc-1rmtq9n-7"
})(["width:100%;}"]);
var RelationsContainer = styled.div.withConfig({
  displayName: "styles__RelationsContainer",
  componentId: "sc-1rmtq9n-8"
})(["width:100%;"]);
var SubjectTypeContainer = styled.div.withConfig({
  displayName: "styles__SubjectTypeContainer",
  componentId: "sc-1rmtq9n-9"
})(["width:100%;"]);
var SubjectIdContainer = styled.div.withConfig({
  displayName: "styles__SubjectIdContainer",
  componentId: "sc-1rmtq9n-10"
})(["width:100%;"]);
var SubjectRelationContainer = styled.div.withConfig({
  displayName: "styles__SubjectRelationContainer",
  componentId: "sc-1rmtq9n-11"
})(["width:100%;"]);
var BreakDiv = styled.div.withConfig({
  displayName: "styles__BreakDiv",
  componentId: "sc-1rmtq9n-12"
})(["word-break:break-all;"]);
var FilterInput = styled(Input).withConfig({
  displayName: "styles__FilterInput",
  componentId: "sc-1rmtq9n-13"
})(["flex-grow:1;font-size:14px;height:36px;&:disabled{background-color:", ";}"], theme.grey10);
var TableWrapper = styled.div.withConfig({
  displayName: "styles__TableWrapper",
  componentId: "sc-1rmtq9n-14"
})(["margin-top:166px;table{margin-left:12px;}thead th{display:none;}tbody tr{border:none;}tbody tr td{padding:8px;}tbody tr td:nth-child(4){border-right:2px solid ", ";}"], theme.grey20);
var LabelContainer = styled.div.withConfig({
  displayName: "styles__LabelContainer",
  componentId: "sc-1rmtq9n-15"
})(["display:flex;flex-direction:row;justify-content:space-between;"]);
var EmptyTableContainer = styled.div.withConfig({
  displayName: "styles__EmptyTableContainer",
  componentId: "sc-1rmtq9n-16"
})(["margin-top:200px;"]);

var RelationsTable = function RelationsTable() {
  var _useDirectoryDataCont = useDirectoryDataContext(),
    objectType = _useDirectoryDataCont.objectType,
    setObjectType = _useDirectoryDataCont.setObjectType,
    subjectType = _useDirectoryDataCont.subjectType,
    setSubjectType = _useDirectoryDataCont.setSubjectType,
    relation = _useDirectoryDataCont.relation,
    setRelation = _useDirectoryDataCont.setRelation,
    objectIdPart = _useDirectoryDataCont.objectIdPart,
    setObjectIdPart = _useDirectoryDataCont.setObjectIdPart,
    subjectIdPart = _useDirectoryDataCont.subjectIdPart,
    setSubjectIdPart = _useDirectoryDataCont.setSubjectIdPart,
    subjectRelation = _useDirectoryDataCont.subjectRelation,
    setSubjectRelation = _useDirectoryDataCont.setSubjectRelation,
    objectId = _useDirectoryDataCont.objectId,
    setObjectId = _useDirectoryDataCont.setObjectId,
    subjectId = _useDirectoryDataCont.subjectId,
    setSubjectId = _useDirectoryDataCont.setSubjectId,
    setRelationsQueryKey = _useDirectoryDataCont.setRelationsQueryKey;
  var _useFeatureFlags = useFeatureFlags(),
    isGraphQLEnabled = _useFeatureFlags.isGraphQLEnabled;
  var debouncedObjectIdPart = useDebounce(objectIdPart);
  var debouncedSubjectIdPart = useDebounce(subjectIdPart);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    relationsList = _useState2[0],
    setRelationsList = _useState2[1];
  var _ObjectTypesList = ObjectTypesList(),
    objectTypesData = _ObjectTypesList.data;
  var _RelationTypesList = RelationTypesList({
      objectType: objectType
    }),
    objectRelationTypesData = _RelationTypesList.data;
  var _RelationTypesList2 = RelationTypesList({
      objectType: subjectType
    }),
    subjectRelationTypesData = _RelationTypesList2.data;
  var objectTypeOptions = useMemo(function () {
    return [{
      label: 'All',
      value: ''
    }].concat(((objectTypesData === null || objectTypesData === void 0 ? void 0 : objectTypesData.results) || []).map(function (objectType) {
      return {
        label: objectType.displayName || objectType.name,
        value: objectType.name
      };
    }));
  }, [objectTypesData === null || objectTypesData === void 0 ? void 0 : objectTypesData.results]);
  var objectRelationTypeOptions = useMemo(function () {
    return [{
      label: 'All',
      value: ''
    }].concat(((objectRelationTypesData === null || objectRelationTypesData === void 0 ? void 0 : objectRelationTypesData.results) || []).map(function (relationType) {
      return {
        label: relationType.displayName || relationType.name,
        value: relationType.name
      };
    }));
  }, [objectRelationTypesData === null || objectRelationTypesData === void 0 ? void 0 : objectRelationTypesData.results]);
  var subjectRelationTypeOptions = useMemo(function () {
    return [{
      label: 'All',
      value: ''
    }].concat(((subjectRelationTypesData === null || subjectRelationTypesData === void 0 ? void 0 : subjectRelationTypesData.results) || []).map(function (relationType) {
      return {
        label: relationType.displayName || relationType.name,
        value: relationType.name
      };
    }));
  }, [subjectRelationTypesData === null || subjectRelationTypesData === void 0 ? void 0 : subjectRelationTypesData.results]);
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isFilter = _useState4[0],
    setIsFilter = _useState4[1];
  var _RelationsListInfinit = RelationsListInfinite({
      object_type: objectType,
      objectIdPart: objectType ? debouncedObjectIdPart : objectId,
      object_id: objectId,
      subject_type: subjectType,
      subjectIdPart: subjectType ? debouncedSubjectIdPart : subjectId,
      subject_id: subjectId,
      relation: relation,
      subject_relation: subjectRelation,
      'page.size': 100
    }, {
      query: {
        enabled: isGraphQLEnabled || isFilter,
        keepPreviousData: true
      }
    }),
    relationsData = _RelationsListInfinit.data,
    isFetchingRelations = _RelationsListInfinit.isFetching,
    hasMoreRelations = _RelationsListInfinit.hasNextPage,
    fetchMoreRelations = _RelationsListInfinit.fetchNextPage,
    relationsQueryKey = _RelationsListInfinit.queryKey;
  var tableRef = useRef();
  var relations = useMemo(function () {
    return (relationsData === null || relationsData === void 0 ? void 0 : relationsData.pages.map(function (relation) {
      return relation.results || [];
    }).flat()) || [];
  }, [relationsData === null || relationsData === void 0 ? void 0 : relationsData.pages]);
  useEffect(function () {
    setRelationsList(relations);
  }, [relations]);
  useEffect(function () {
    setIsFilter(false);
  }, [setIsFilter]);
  useEffect(function () {
    isGraphQLEnabled && setRelationsQueryKey(relationsQueryKey);
  }, [setRelationsQueryKey, relationsQueryKey, isGraphQLEnabled]);
  var fetchData = useIsScrollable({
    isFetching: isFetchingRelations,
    hasMoreData: hasMoreRelations || false,
    fetchNextData: fetchMoreRelations
  });
  useCallback(function () {
    fetchData();
  }, [fetchData]);
  var columns = [{
    id: 'Object Type',
    style: {
      cellWidth: '16.66%'
    },
    Cell: function Cell(_ref) {
      var row = _ref.row;
      return /*#__PURE__*/React.createElement("div", null, row.original.object_type);
    }
  }, {
    id: 'Object Id',
    style: {
      cellWidth: '16.66%'
    },
    Cell: function Cell(_ref2) {
      var row = _ref2.row;
      return /*#__PURE__*/React.createElement(Link, {
        to: "/ui/directory/objects/".concat(row.original.object_type, "/").concat(encodeURIComponent(row.original.object_id))
      }, /*#__PURE__*/React.createElement(BreakDiv, null, row.original.object_id));
    }
  }, {
    id: 'Relation',
    style: {
      cellWidth: '16.66%'
    },
    Cell: function Cell(_ref3) {
      var row = _ref3.row;
      return /*#__PURE__*/React.createElement("div", null, row.original.relation);
    }
  }, {
    id: 'delimiter',
    style: {
      cellWidth: '2px'
    },
    Cell: function Cell() {
      return /*#__PURE__*/React.createElement("div", null);
    }
  }, {
    id: 'blank',
    style: {
      cellWidth: '8px'
    },
    Cell: function Cell() {
      return /*#__PURE__*/React.createElement("div", null);
    }
  }, {
    id: 'Subject Type',
    style: {
      cellWidth: '16.66%'
    },
    Cell: function Cell(_ref4) {
      var row = _ref4.row;
      return /*#__PURE__*/React.createElement("div", null, row.original.subject_type);
    }
  }, {
    id: 'Subject Id',
    style: {
      cellWidth: '16.66%'
    },
    Cell: function Cell(_ref5) {
      var row = _ref5.row;
      return /*#__PURE__*/React.createElement(Link, {
        to: "/ui/directory/objects/".concat(row.original.subject_type, "/").concat(encodeURIComponent(row.original.subject_id))
      }, /*#__PURE__*/React.createElement(BreakDiv, null, row.original.subject_id));
    }
  }, {
    id: 'Subject Relation',
    style: {
      cellWidth: '16.66%'
    },
    Cell: function Cell(_ref6) {
      var row = _ref6.row;
      return /*#__PURE__*/React.createElement("div", null, row.original.subject_relation);
    }
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectContainer, null, /*#__PURE__*/React.createElement(ObjectContainer, null, /*#__PURE__*/React.createElement(Label, null, "Object"), /*#__PURE__*/React.createElement(FieldsContainer, null, /*#__PURE__*/React.createElement(ObjectTypeContainer, null, /*#__PURE__*/React.createElement(Select, {
    defaultValue: {
      label: 'All',
      value: ''
    },
    label: "Type",
    options: objectTypeOptions,
    value: objectTypeOptions.find(function (option) {
      return option.value === objectType || '';
    }),
    onChange: function onChange(option) {
      if ((option === null || option === void 0 ? void 0 : option.value) !== '') {
        setObjectType(String(option === null || option === void 0 ? void 0 : option.value));
        setRelation('');
      } else {
        setObjectType(undefined);
        setRelation('');
        isGraphQLEnabled ? setObjectIdPart('') : setObjectId('');
      }
      !isGraphQLEnabled && setIsFilter(true);
    }
  })), /*#__PURE__*/React.createElement(ObjectIdContainer, null, /*#__PURE__*/React.createElement(FilterInput, {
    disabled: !objectType || objectType === '',
    label: "Id",
    placeholder: "",
    value: isGraphQLEnabled ? objectIdPart || '' : objectId || '',
    onChange: function onChange(e) {
      if (isGraphQLEnabled) {
        setObjectIdPart(e.target.value);
      } else {
        setIsFilter(false);
        setObjectId(e.target.value);
      }
    },
    onClickSearch: isGraphQLEnabled ? undefined : function () {
      setIsFilter(true);
    }
  })), /*#__PURE__*/React.createElement(RelationsContainer, null, /*#__PURE__*/React.createElement(Select, {
    defaultValue: {
      label: 'All',
      value: ''
    },
    disabled: !objectType || objectType === '',
    label: "Relation",
    options: objectRelationTypeOptions,
    value: objectRelationTypeOptions.find(function (option) {
      return option.value === relation || '';
    }),
    onChange: function onChange(option) {
      setRelation(String(option === null || option === void 0 ? void 0 : option.value));
      !isGraphQLEnabled && setIsFilter(true);
    }
  })))), /*#__PURE__*/React.createElement(SubjectContainer, null, /*#__PURE__*/React.createElement(LabelContainer, null, /*#__PURE__*/React.createElement(Label, null, "Subject")), /*#__PURE__*/React.createElement(FieldsContainer, null, /*#__PURE__*/React.createElement(SubjectTypeContainer, null, /*#__PURE__*/React.createElement(Select, {
    defaultValue: {
      label: 'All',
      value: ''
    },
    label: "Type",
    options: objectTypeOptions,
    value: objectTypeOptions.find(function (option) {
      return option.value === (subjectType || '');
    }),
    onChange: function onChange(option) {
      if ((option === null || option === void 0 ? void 0 : option.value) !== '') {
        setSubjectType(String(option === null || option === void 0 ? void 0 : option.value));
        setSubjectRelation(undefined);
      } else {
        setSubjectType(undefined);
        setSubjectRelation(undefined);
        isGraphQLEnabled ? setSubjectIdPart('') : setSubjectId('');
      }
      !isGraphQLEnabled && setIsFilter(true);
    }
  })), /*#__PURE__*/React.createElement(SubjectIdContainer, null, /*#__PURE__*/React.createElement(FilterInput, {
    disabled: !subjectType || subjectType === '',
    label: "Id",
    placeholder: "",
    value: isGraphQLEnabled ? subjectIdPart || '' : subjectId || '',
    onChange: function onChange(e) {
      if (isGraphQLEnabled) {
        setSubjectIdPart(e.target.value);
      } else {
        setIsFilter(false);
        setSubjectId(e.target.value);
      }
    },
    onClickSearch: isGraphQLEnabled ? undefined : function () {
      setIsFilter(true);
    }
  })), /*#__PURE__*/React.createElement(SubjectRelationContainer, null, /*#__PURE__*/React.createElement(Select, {
    defaultValue: {
      label: 'All',
      value: ''
    },
    disabled: !subjectType || subjectType === '',
    label: "Relation",
    options: subjectRelationTypeOptions,
    value: subjectRelationTypeOptions.find(function (option) {
      return option.value === (subjectRelation || '');
    }),
    onChange: function onChange(option) {
      if ((option === null || option === void 0 ? void 0 : option.value) !== '') {
        setSubjectRelation(String(option === null || option === void 0 ? void 0 : option.value));
      } else {
        setSubjectRelation(undefined);
      }
      !isGraphQLEnabled && setIsFilter(true);
    }
  }))))), isFetchingRelations || !!relations.length ? (/*#__PURE__*/React.createElement(TableWrapper, null, /*#__PURE__*/React.createElement(_DataTable, {
    columns: columns,
    data: relationsList,
    mRef: tableRef,
    paging: {
      dataLength: relationsList.length,
      loadingContent: [{
        object_type: 'loading...',
        object_id: 'loading...',
        relation: 'loading...',
        subject_type: 'loading...',
        subject_id: 'loading...',
        subject_relation: 'loading...'
      }],
      hasMore: function hasMore() {
        return !!hasMoreRelations;
      },
      getNext: function getNext() {
        return fetchMoreRelations();
      }
    },
    sticky: true
  }))) : (/*#__PURE__*/React.createElement(EmptyTableContainer, null, /*#__PURE__*/React.createElement(EmptyTablePlaceholder, {
    body: "",
    header: "No relations",
    imgAlt: "Empty Directory",
    imgSrc: img$g
  }))));
};

var Relations = function Relations() {
  return /*#__PURE__*/React.createElement(DataContainer, null, /*#__PURE__*/React.createElement(RelationsTable, null));
};

var isEmailAddressValid = function isEmailAddressValid(email) {
  var result = z.string().email().safeParse(email);
  return result.success;
};

var ContentContainer$3 = styled.div.withConfig({
  displayName: "MemberModal__ContentContainer",
  componentId: "e8t72g-0"
})(["padding:20px;width:100%;"]);
var InputContainer = styled.div.withConfig({
  displayName: "MemberModal__InputContainer",
  componentId: "e8t72g-1"
})(["margin-bottom:20px;"]);
var ButtonsContainer$1 = styled.div.withConfig({
  displayName: "MemberModal__ButtonsContainer",
  componentId: "e8t72g-2"
})(["display:flex;flex-direction:row;width:100%;align-items:center;justify-content:flex-end;button:first-of-type{margin-right:10px;}"]);
var MemberModal = function MemberModal(_ref) {
  var onClickHide = _ref.onClickHide,
    show = _ref.show,
    onClickAdd = _ref.onClickAdd,
    options = _ref.options,
    title = _ref.title,
    hasInvites = _ref.hasInvites;
  var inputRef = useRef(null);
  var formInitialState = useMemo(function () {
    var _a;
    return {
      email: '',
      role: String((_a = options[0]) === null || _a === void 0 ? void 0 : _a.value)
    };
  }, [options]);
  var defaultRole = useMemo(function () {
    return options.find(function (opt) {
      return opt.value === formInitialState.role;
    }) || options[0];
  }, [options, formInitialState]);
  var _useState = useState(formInitialState),
    _useState2 = _slicedToArray(_useState, 2),
    formContent = _useState2[0],
    setMemberFormContent = _useState2[1];
  useEffect(function () {
    setMemberFormContent(formInitialState);
  }, [setMemberFormContent, formInitialState]);
  var clearForm = function clearForm() {
    setMemberFormContent(formInitialState);
    onClickHide();
  };
  var onSubmit = function onSubmit() {
    onClickAdd(formContent);
    clearForm();
  };
  var setMemberFormContentForKey = function setMemberFormContentForKey(key, value) {
    setMemberFormContent(function (form) {
      return Object.assign(Object.assign({}, form), _defineProperty({}, key, value.trim()));
    });
  };
  var isValidEmail = useMemo(function () {
    return isEmailAddressValid(formContent.email);
  }, [formContent.email]);
  var shouldDisableButton = !isValidEmail;
  var onKeyDown = function onKeyDown(e) {
    if (e.key === 'Escape') {
      clearForm();
    }
  };
  var shouldShowError = formContent.email.length > 6 && formContent.email.includes('@') && !isValidEmail;
  return /*#__PURE__*/React.createElement(CardModal, {
    cardHeight: 350,
    show: show,
    title: title,
    onHide: clearForm
  }, /*#__PURE__*/React.createElement(ContentContainer$3, null, /*#__PURE__*/React.createElement(InputContainer, null, /*#__PURE__*/React.createElement(Input, {
    ref: inputRef,
    error: shouldShowError ? 'Invalid e-mail address' : '',
    info: hasInvites ? 'The invite will be sent to this e-mail address' : '',
    label: "Email address",
    value: formContent.email,
    onChange: function onChange(e) {
      return setMemberFormContentForKey('email', e.target.value);
    },
    onKeyDown: onKeyDown
  })), /*#__PURE__*/React.createElement(InputContainer, null, /*#__PURE__*/React.createElement(Select, {
    defaultValue: defaultRole,
    label: "Role",
    name: "role",
    options: options,
    onChange: function onChange(option) {
      setMemberFormContentForKey('role', String(option.value));
    },
    onKeyDown: onKeyDown
  })), /*#__PURE__*/React.createElement(ButtonsContainer$1, null, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: clearForm
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    disabled: shouldDisableButton,
    type: "submit",
    onClick: onSubmit
  }, hasInvites ? 'Invite' : 'Add'))));
};

var CellWithImage = styled.div.withConfig({
  displayName: "MembersTable__CellWithImage",
  componentId: "sc-7w4s1k-0"
})(["display:flex;align-items:center;img{width:40px;border-radius:20px;height:40px;margin-right:10px;}"]);
var BoldText = styled.div.withConfig({
  displayName: "MembersTable__BoldText",
  componentId: "sc-7w4s1k-1"
})(["font-weight:bold;"]);
var TopRightButton = styled(Button).withConfig({
  displayName: "MembersTable__TopRightButton",
  componentId: "sc-7w4s1k-2"
})(["float:right;margin-right:-20px;"]);
var ActionButton = styled(Button).withConfig({
  displayName: "MembersTable__ActionButton",
  componentId: "sc-7w4s1k-3"
})(["margin-left:10px;min-width:100px;"]);
var ButtonsContainer = styled.div.withConfig({
  displayName: "MembersTable__ButtonsContainer",
  componentId: "sc-7w4s1k-4"
})(["margin-top:24px;display:flex;flex-direction:row;gap:8px;justify-content:flex-end;"]);
var MembersTable = function MembersTable(_ref) {
  var data = _ref.data,
    displayState = _ref.displayState,
    onClickAddMember = _ref.onClickAddMember,
    onClickUpdateRole = _ref.onClickUpdateRole,
    onClickRemoveMember = _ref.onClickRemoveMember,
    rolesOptions = _ref.rolesOptions,
    ownerRole = _ref.ownerRole,
    hasInvitations = _ref.hasInvitations,
    isSysAdmin = _ref.isSysAdmin,
    _ref$manageSystem = _ref.manageSystem,
    manageSystem = _ref$manageSystem === void 0 ? false : _ref$manageSystem,
    _ref$sticky = _ref.sticky,
    sticky = _ref$sticky === void 0 ? true : _ref$sticky;
  var _a;
  var _useProfile = useProfile(),
    account = _useProfile.account;
  var isUserAnOwner = ((_a = data.find(function (e) {
    return e.id === (account === null || account === void 0 ? void 0 : account.id);
  })) === null || _a === void 0 ? void 0 : _a.role) === ownerRole;
  var lastOwner = data.filter(function (e) {
    return e.role === ownerRole;
  }).length === 1;
  var columns = [{
    Header: 'Member',
    style: {
      cellWidth: '50%'
    },
    Cell: function Cell(_ref2) {
      var row = _ref2.row;
      return /*#__PURE__*/React.createElement(CellWithImage, null, /*#__PURE__*/React.createElement("img", {
        alt: "profile-image",
        src: row.original.picture || img$j
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BoldText, null, row.original.display_name), /*#__PURE__*/React.createElement("div", null, row.original.email)));
    }
  }, {
    Header: 'Role',
    style: {
      cellWidth: '20%'
    },
    disableSortBy: true,
    Cell: function Cell(_ref3) {
      var row = _ref3.row;
      var _a;
      var selectRef = useRef(null);
      var userRowRole = row.original.role;
      var isCurrentUser = row.original.id === (account === null || account === void 0 ? void 0 : account.id);
      var disableProps = useMemo(function () {
        if (isSysAdmin) {
          return {
            disabled: false,
            shouldDisabledOptions: false,
            visible: true
          };
        }
        if (isUserAnOwner) {
          if (isCurrentUser) {
            return {
              disabled: true
            };
          } else {
            return {};
          }
        } else {
          if (isCurrentUser) {
            return {
              disabled: false,
              shouldDisabledOptions: true,
              visible: true
            };
          }
          return {
            disabled: true
          };
        }
      }, [isCurrentUser]);
      useEffect(function () {
        var _a;
        (_a = selectRef === null || selectRef === void 0 ? void 0 : selectRef.current) === null || _a === void 0 ? void 0 : _a.setValue(rolesOptions.find(function (opt) {
          return opt.value === userRowRole;
        }), 'select-option');
      }, [userRowRole, selectRef]);
      var onBlur = function onBlur(firstSelectedOption) {
        var _a;
        (_a = selectRef === null || selectRef === void 0 ? void 0 : selectRef.current) === null || _a === void 0 ? void 0 : _a.setValue(firstSelectedOption, 'select-option');
      };
      return /*#__PURE__*/React.createElement(React.Fragment, null, isUserAnOwner || isSysAdmin ? (/*#__PURE__*/React.createElement(SelectWithoutControl, Object.assign({
        closeMenuOnScroll: function closeMenuOnScroll(e) {
          return !(e.target === document);
        }
      }, disableProps, {
        defaultValue: rolesOptions.find(function (opt) {
          return opt.value === userRowRole;
        }),
        options: rolesOptions,
        onBlur: onBlur,
        onChange: function onChange(option) {
          onClickUpdateRole(row.original.id, String(option === null || option === void 0 ? void 0 : option.value));
        }
      }))) : (/*#__PURE__*/React.createElement(React.Fragment, null, (_a = rolesOptions.find(function (opt) {
        return opt.value === userRowRole;
      })) === null || _a === void 0 ? void 0 : _a.label)));
    }
  }, {
    Header: function Header() {
      return /*#__PURE__*/React.createElement(EvaluateDisplayState, {
        displayState: displayState
      }, /*#__PURE__*/React.createElement(TopRightButton, {
        "data-testid": "invite-member-btn",
        onClick: onClickAddMember
      }, manageSystem ? 'Assign user' : hasInvitations ? 'Invite member...' : 'Add member'));
    },
    accessor: 'id',
    style: {
      cellWidth: '30%',
      headerCell: {
        textAlign: 'center'
      }
    },
    disableSortBy: true,
    Cell: function Cell(_ref4) {
      var row = _ref4.row;
      var isCurrentUser = row.original.id === (account === null || account === void 0 ? void 0 : account.id);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ButtonsContainer, null, isCurrentUser ? (!isUserAnOwner || !lastOwner) && (/*#__PURE__*/React.createElement(ActionButton, {
        variant: "danger",
        onClick: function onClick() {
          return onClickRemoveMember(row.original.id || '');
        }
      }, manageSystem ? 'Revoke Access' : 'Leave')) : (/*#__PURE__*/React.createElement(React.Fragment, null, (isUserAnOwner || isSysAdmin) && (/*#__PURE__*/React.createElement(ActionButton, {
        variant: "danger",
        onClick: function onClick() {
          return onClickRemoveMember(row.original.id || '');
        }
      }, manageSystem ? 'Revoke Access' : 'Remove'))))));
    }
  }];
  return /*#__PURE__*/React.createElement(_DataTable, {
    columns: columns,
    data: data,
    sticky: sticky
  });
};

var PolicyEvaluatorContext = /*#__PURE__*/React.createContext({
  decisions: '["allowed", "visible", "enabled"]',
  identity: null,
  input: '',
  options: 'PATH_SEPARATOR_DOT',
  pathFreeText: '',
  pathSelect: '',
  policyInstance: '',
  query: '',
  queryMetrics: undefined,
  queryTrace: undefined,
  queryTraceLevel: 'TRACE_LEVEL_NOTES',
  queryTraceSummary: undefined,
  request: 'IS',
  resourceContext: '',
  type: 'IDENTITY_TYPE_NONE',
  setDecisions: function setDecisions() {},
  setIdentity: function setIdentity() {},
  setInput: function setInput() {},
  setOptions: function setOptions() {},
  setPathFreeText: function setPathFreeText() {},
  setPathSelect: function setPathSelect() {},
  setPolicyInstance: function setPolicyInstance() {},
  setQuery: function setQuery() {},
  setRequest: function setRequest() {},
  setResourceContext: function setResourceContext() {},
  setType: function setType() {},
  subjectType: '',
  subjectInstance: {
    label: '',
    value: ''
  },
  permission: {
    label: '',
    value: ''
  },
  relationType: {
    label: '',
    value: ''
  },
  objectType: '',
  objectInstance: {
    label: '',
    value: ''
  },
  setSubjectType: function setSubjectType() {},
  setSubjectInstance: function setSubjectInstance() {},
  setPermission: function setPermission() {},
  setRelationType: function setRelationType() {},
  setObjectType: function setObjectType() {},
  setObjectInstance: function setObjectInstance() {},
  setPolicyContextError: function setPolicyContextError() {},
  policyContextError: undefined
});
var usePolicyEvaluatorErrorContext = function usePolicyEvaluatorErrorContext() {
  return useContext(PolicyEvaluatorContext);
};
var useDecisionTreePolicyEvaluatorContext = function useDecisionTreePolicyEvaluatorContext() {
  return useContext(PolicyEvaluatorContext);
};
var useQueryPolicyEvaluatorContext = function useQueryPolicyEvaluatorContext() {
  return useContext(PolicyEvaluatorContext);
};
var useCommonPolicyEvaluatorContext = function useCommonPolicyEvaluatorContext() {
  return useContext(PolicyEvaluatorContext);
};
var useIsPolicyEvaluatorContext = function useIsPolicyEvaluatorContext() {
  return useContext(PolicyEvaluatorContext);
};
var useRebacPolicyEvaluatorContext = function useRebacPolicyEvaluatorContext() {
  return useContext(PolicyEvaluatorContext);
};
var useContentPolicyEvaluatorContext = function useContentPolicyEvaluatorContext() {
  return useContext(PolicyEvaluatorContext);
};
var useActivePolicyInstanceContext = function useActivePolicyInstanceContext() {
  return useContext(PolicyEvaluatorContext);
};
var useCondensedContentPolicyEvaluatorContext = function useCondensedContentPolicyEvaluatorContext() {
  return useContext(PolicyEvaluatorContext);
};
var PolicyEvaluatorContextProvider = function PolicyEvaluatorContextProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    subjectType = _useState2[0],
    setSubjectType = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    permission = _useState4[0],
    setPermission = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    policyContextError = _useState6[0],
    setPolicyContextError = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    resourceContextError = _useState8[0],
    setResourceContextError = _useState8[1];
  var _useState9 = useState('{}'),
    _useState10 = _slicedToArray(_useState9, 2),
    policyContextState = _useState10[0],
    setPolicyContextState = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    policyInstance = _useState12[0],
    setPolicyInstance = _useState12[1];
  var getFieldContextState = useCallback(function (fieldName) {
    try {
      var json = JSON.parse(policyContextState || '{}');
      if (json && policyInstance) {
        if (['queryMetrics', 'queryTrace', 'queryTraceSummary'].includes(fieldName)) {
          return json[policyInstance] && json[policyInstance][fieldName] || false;
        }
        return json[policyInstance] && String(json[policyInstance][fieldName] || '') || '';
      }
    } catch (_a) {}
    return '';
  }, [policyContextState, policyInstance]);
  var setFieldContextState = useCallback(function (field, value) {
    setPolicyContextState(function (prevState) {
      try {
        var json = JSON.parse(prevState || '{}');
        if (json && policyInstance) {
          return JSON.stringify(Object.assign(Object.assign({}, json), _defineProperty({}, policyInstance, Object.assign(Object.assign({}, json[policyInstance]), _defineProperty({}, field, value)))));
        }
      } catch (_a) {}
      return prevState;
    });
  }, [policyInstance, setPolicyContextState]);
  var deleteContextStateField = useCallback(function (field) {
    setPolicyContextState(function (prevState) {
      try {
        var json = JSON.parse(prevState || '{}');
        if (json && policyInstance && json[policyInstance] && json[policyInstance][field]) {
          delete json[policyInstance][field];
          return JSON.stringify(json);
        }
      } catch (_a) {}
      return prevState;
    });
  }, [policyInstance, setPolicyContextState]);
  var objectType = useMemo(function () {
    return getFieldContextState('object_type') || null;
  }, [getFieldContextState]);
  var setObjectType = useCallback(function (value) {
    setFieldContextState('object_type', value);
  }, [setFieldContextState]);
  var options = useMemo(function () {
    return getFieldContextState('options') || 'PATH_SEPARATOR_DOT';
  }, [getFieldContextState]);
  var setOptions = useCallback(function (value) {
    setFieldContextState('options', value);
  }, [setFieldContextState]);
  var resourceContext = useMemo(function () {
    return getFieldContextState('resource_context');
  }, [getFieldContextState]);
  var setResourceContext = useCallback(function (resourceContext) {
    setFieldContextState('resource_context', resourceContext);
  }, [setFieldContextState]);
  var request = useMemo(function () {
    return getFieldContextState('request') || '';
  }, [getFieldContextState]);
  var setRequest = useCallback(function (value) {
    setFieldContextState('request', value);
  }, [setFieldContextState]);
  var type = useMemo(function () {
    var type = getFieldContextState('type');
    return type || 'IDENTITY_TYPE_NONE';
  }, [getFieldContextState]);
  var setType = useCallback(function (type) {
    setFieldContextState('type', type);
  }, [setFieldContextState]);
  var subjectInstance = useMemo(function () {
    var subject = getFieldContextState('subject');
    return subject && JSON.parse(subject) || null;
  }, [getFieldContextState]);
  var setSubjectInstance = useCallback(function (instance) {
    if (!!instance) {
      setFieldContextState('subject', JSON.stringify(instance));
    } else {
      deleteContextStateField('subject');
    }
  }, [deleteContextStateField, setFieldContextState]);
  var objectInstance = useMemo(function () {
    var object = getFieldContextState('object');
    return object && JSON.parse(object) || null;
  }, [getFieldContextState]);
  var setObjectInstance = useCallback(function (object) {
    if (!!object) {
      setFieldContextState('object', JSON.stringify(object));
    } else {
      deleteContextStateField('object');
    }
  }, [deleteContextStateField, setFieldContextState]);
  var relationType = useMemo(function () {
    var relation = getFieldContextState('relation_type');
    return relation && JSON.parse(relation) || null;
  }, [getFieldContextState]);
  var setRelationType = useCallback(function (relation) {
    if (!!relation) {
      setFieldContextState('relation_type', JSON.stringify(relation));
    } else {
      deleteContextStateField('relation_type');
    }
  }, [deleteContextStateField, setFieldContextState]);
  var identity = useMemo(function () {
    return getFieldContextState('identity');
  }, [getFieldContextState]);
  var setIdentity = useCallback(function (value) {
    if (!!value) {
      setFieldContextState('identity', value);
    } else {
      deleteContextStateField('identity');
    }
  }, [deleteContextStateField, setFieldContextState]);
  var input = useMemo(function () {
    return getFieldContextState('input');
  }, [getFieldContextState]);
  var setInput = useCallback(function (value) {
    setFieldContextState('input', value);
  }, [setFieldContextState]);
  var decisions = useMemo(function () {
    return getFieldContextState('decisions') || '["allowed"]';
  }, [getFieldContextState]);
  var setDecisions = useCallback(function (value) {
    setFieldContextState('decisions', value);
  }, [setFieldContextState]);
  var pathFreeText = useMemo(function () {
    return getFieldContextState('path_free_text');
  }, [getFieldContextState]);
  var setPathFreeText = useCallback(function (value) {
    setFieldContextState('path_free_text', value);
  }, [setFieldContextState]);
  var pathSelect = useMemo(function () {
    return getFieldContextState('path_select');
  }, [getFieldContextState]);
  var setPathSelect = useCallback(function (path) {
    setFieldContextState('path_select', path);
  }, [setFieldContextState]);
  var query = useMemo(function () {
    return getFieldContextState('query');
  }, [getFieldContextState]);
  var setQuery = useCallback(function (value) {
    setFieldContextState('query', value);
  }, [setFieldContextState]);
  var queryMetrics = useMemo(function () {
    return getFieldContextState('queryMetrics');
  }, [getFieldContextState]);
  var setQueryMetrics = useCallback(function (value) {
    setFieldContextState('queryMetrics', value);
  }, [setFieldContextState]);
  var queryTrace = useMemo(function () {
    return getFieldContextState('queryTrace');
  }, [getFieldContextState]);
  var setQueryTrace = useCallback(function (value) {
    setFieldContextState('queryTrace', value);
  }, [setFieldContextState]);
  var queryTraceLevel = useMemo(function () {
    return getFieldContextState('queryTraceLevel') || 'TRACE_LEVEL_NOTES';
  }, [getFieldContextState]);
  var setQueryTraceLevel = useCallback(function (value) {
    setFieldContextState('queryTraceLevel', value);
  }, [setFieldContextState]);
  var queryTraceSummary = useMemo(function () {
    return getFieldContextState('queryTraceSummary');
  }, [getFieldContextState]);
  var setQueryTraceSummary = useCallback(function (value) {
    setFieldContextState('queryTraceSummary', value);
  }, [setFieldContextState]);
  var value = useMemo(function () {
    return {
      decisions: decisions,
      identity: identity,
      input: input,
      options: options,
      pathFreeText: pathFreeText,
      pathSelect: pathSelect,
      query: query,
      queryMetrics: queryMetrics,
      queryTrace: queryTrace,
      queryTraceLevel: queryTraceLevel,
      queryTraceSummary: queryTraceSummary,
      resourceContext: resourceContext,
      request: request,
      setDecisions: setDecisions,
      setIdentity: setIdentity,
      setInput: setInput,
      setOptions: setOptions,
      setPathFreeText: setPathFreeText,
      setPathSelect: setPathSelect,
      setQuery: setQuery,
      setQueryMetrics: setQueryMetrics,
      setQueryTrace: setQueryTrace,
      setQueryTraceLevel: setQueryTraceLevel,
      setQueryTraceSummary: setQueryTraceSummary,
      setRequest: setRequest,
      setResourceContext: setResourceContext,
      setType: setType,
      type: type,
      subjectType: subjectType,
      subjectInstance: subjectInstance,
      permission: permission,
      relationType: relationType,
      objectType: objectType,
      objectInstance: objectInstance,
      setSubjectType: setSubjectType,
      setSubjectInstance: setSubjectInstance,
      setPermission: setPermission,
      setRelationType: setRelationType,
      setObjectType: setObjectType,
      setObjectInstance: setObjectInstance,
      setPolicyInstance: setPolicyInstance,
      policyContextError: policyContextError,
      setPolicyContextError: setPolicyContextError,
      resourceContextError: resourceContextError,
      setResourceContextError: setResourceContextError
    };
  }, [decisions, identity, input, options, pathFreeText, pathSelect, query, queryMetrics, queryTrace, queryTraceLevel, queryTraceSummary, resourceContext, request, setDecisions, setIdentity, setInput, setOptions, setPathFreeText, setPathSelect, setQuery, setQueryMetrics, setQueryTrace, setQueryTraceLevel, setQueryTraceSummary, setRequest, setResourceContext, setType, type, subjectType, subjectInstance, permission, relationType, objectType, objectInstance, setSubjectInstance, setRelationType, setObjectType, setObjectInstance, policyContextError, resourceContextError]);
  return /*#__PURE__*/React.createElement(PolicyEvaluatorContext.Provider, {
    value: value
  }, children);
};

var useCopyCurl$1 = function useCopyCurl(payload, path) {
  var _useConfig = useConfig(),
    authorizerServiceUrl = _useConfig.authorizerServiceUrl,
    authorizerApiKey = _useConfig.authorizerApiKey;
  var _useProfile = useProfile(),
    tenantId = _useProfile.tenantId;
  var _useIdentity = useIdentity(),
    getAccessToken = _useIdentity.getAccessToken;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    accessToken = _useState2[0],
    setAccessToken = _useState2[1];
  useEffect(function () {
    var getToken = function getToken() {
      return __awaiter(void 0, void 0, void 0, _regeneratorRuntime.mark(function _callee() {
        var accessToken;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAccessToken();
            case 2:
              accessToken = _context.sent;
              setAccessToken(accessToken);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
    };
    getToken();
  }, [getAccessToken]);
  var authorization = !!authorizerApiKey ? "basic ".concat(authorizerApiKey) : accessToken;
  var request = useCallback(function () {
    return "curl '".concat(authorizerServiceUrl, "/").concat(path, "' \\\n  -H 'aserto-tenant-id: ").concat(tenantId, "' \\\n  -H 'authorization: ").concat(authorization, "' \\\n  -H 'content-type: application/json' \\\n  --data-raw '").concat(payload, "' \\\n  ");
  }, [authorizerServiceUrl, authorization, payload, tenantId, path]);
  return {
    copyCurl: function copyCurl() {
      return copy(request());
    }
  };
};

var DecisionTreeTableWrapper = styled.div.withConfig({
  displayName: "styles__DecisionTreeTableWrapper",
  componentId: "sc-1p0bxku-0"
})(["margin-top:32px;min-height:252px;height:calc(100vh - 642px);"]);
var Cell = styled.div.withConfig({
  displayName: "styles__Cell",
  componentId: "sc-1p0bxku-1"
})(["min-width:180px;height:100%;display:flex;align-items:flex-start;"]);
var ModuleCell = styled.div.withConfig({
  displayName: "styles__ModuleCell",
  componentId: "sc-1p0bxku-2"
})(["box-sizing:border-box;display:block;overflow:hidden;word-break:break-all;max-width:20vw;"]);
var CodeCell = styled.div.withConfig({
  displayName: "styles__CodeCell",
  componentId: "sc-1p0bxku-3"
})(["box-sizing:border-box;display:block;font-weight:400;overflow-x:scroll;word-break:break-all;::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;min-width:80px;"]);
var CellOverflow = styled.div.withConfig({
  displayName: "styles__CellOverflow",
  componentId: "sc-1p0bxku-4"
})(["box-sizing:border-box;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;line-height:1.2em;"]);

var columns = [{
  Header: 'Module',
  style: {
    cellWidth: '70%'
  },
  Cell: function Cell$1(_ref) {
    var row = _ref.row;
    return /*#__PURE__*/React.createElement(Cell, null, /*#__PURE__*/React.createElement(ModuleCell, Object.assign({}, row.getToggleRowExpandedProps()), /*#__PURE__*/React.createElement(CellOverflow, null, row.original.module)));
  }
}, {
  Header: 'Decision',
  style: {
    cellWidth: '30%'
  },
  Cell: function Cell$1(_ref2) {
    var row = _ref2.row;
    return /*#__PURE__*/React.createElement(Cell, null, /*#__PURE__*/React.createElement(CodeCell, Object.assign({}, row.getToggleRowExpandedProps()), /*#__PURE__*/React.createElement(Highlight, {
      language: "json"
    }, row.original.decision)));
  }
}];
var DecisionTreeTable = function DecisionTreeTable(_ref3) {
  var data = _ref3.data;
  var list = Object.keys(data.path).map(function (module) {
    return {
      module: module,
      decision: JSON.stringify(data.path[module], null, 1).replace('\n}', ' }').replace('{\n', '{').replace(/,\n/g, ',')
    };
  });
  return /*#__PURE__*/React.createElement(DecisionTreeTableWrapper, null, /*#__PURE__*/React.createElement(_DataTable, {
    columns: columns,
    data: list,
    sticky: true
  }));
};

var Container$1 = styled.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-1daz11n-0"
})(["position:relative;font-family:'Roboto';min-width:620px;width:100%;"]);
var Header$1 = styled.div.withConfig({
  displayName: "styles__Header",
  componentId: "sc-1daz11n-1"
})(["background-color:#2a2a2a;padding:12px;width:100%;@media (min-width:1328px){padding:20px;height:82px;z-index:9;}"]);
var ContentContainer$2 = styled.div.withConfig({
  displayName: "styles__ContentContainer",
  componentId: "sc-1daz11n-2"
})(["display:flex;width:auto;margin:0 auto;"]);
var HeaderSelectContainer = styled.div.withConfig({
  displayName: "styles__HeaderSelectContainer",
  componentId: "sc-1daz11n-3"
})(["flex:1;max-width:300px;margin-left:10px;"]);
var InputTopMargin = styled.div.withConfig({
  displayName: "styles__InputTopMargin",
  componentId: "sc-1daz11n-4"
})(["margin-top:10px;"]);
var EvaluatorStyledInput = styled(Input).withConfig({
  displayName: "styles__EvaluatorStyledInput",
  componentId: "sc-1daz11n-5"
})(["height:36px;"]);
var HeaderTitle = styled.div.withConfig({
  displayName: "styles__HeaderTitle",
  componentId: "sc-1daz11n-6"
})(["font-size:16px;font-weight:bold;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.grey100;
});
var SideContent$1 = styled.div.withConfig({
  displayName: "styles__SideContent",
  componentId: "sc-1daz11n-7"
})(["height:calc(100vh - 14rem);@media (max-width:1328px){height:calc(100vh - 19.4rem);}position:relative;overflow:", ";overflow-x:hidden;flex:1;max-width:50%;padding:20px;", ""], function (_ref2) {
  var $overflow = _ref2.$overflow;
  return $overflow || 'auto';
}, function (_ref3) {
  var theme = _ref3.theme,
    $left = _ref3.$left,
    $right = _ref3.$right;
  if ($left) {
    return css(["border-right:1px solid ", ";"], theme.grey20);
  } else if ($right) {
    return css(["margin-right:15px;"]);
  }
});
var Curve = styled.div.withConfig({
  displayName: "styles__Curve",
  componentId: "sc-1daz11n-8"
})(["border-width:0px;width:13px;height:22px;border-bottom-width:1px;border-left-width:1px;border-style:solid;border-color:#414141;border-bottom-left-radius:6px;background-color:#121212;background-size:cover;margin-bottom:-10px;"]);
var FieldContainer$1 = styled.div.withConfig({
  displayName: "styles__FieldContainer",
  componentId: "sc-1daz11n-9"
})(["flex:1;margin-top:", ";margin-left:", ";margin-bottom:", ";"], function (_ref4) {
  var $marginTop = _ref4.$marginTop;
  return "".concat($marginTop, "px");
}, function (_ref5) {
  var $marginLeft = _ref5.$marginLeft;
  return "".concat($marginLeft, "px");
}, function (_ref6) {
  var _ref6$$marginBottom = _ref6.$marginBottom,
    $marginBottom = _ref6$$marginBottom === void 0 ? 20 : _ref6$$marginBottom;
  return "".concat($marginBottom, "px");
});
var SeparationDots = styled.div.withConfig({
  displayName: "styles__SeparationDots",
  componentId: "sc-1daz11n-10"
})(["font-size:30px;margin:5px 5px 0;"]);
var QueryOptionsContainer = styled.div.withConfig({
  displayName: "styles__QueryOptionsContainer",
  componentId: "sc-1daz11n-11"
})(["display:flex;flex-direction:column;padding:8px;label{font-size:16px;}> div{height:40px;}"]);
var SelectTraceContainer = styled.div.withConfig({
  displayName: "styles__SelectTraceContainer",
  componentId: "sc-1daz11n-12"
})(["display:flex;flex-direction:row;gap:32px;"]);
var IsDecisionsWrapper = styled.div.withConfig({
  displayName: "styles__IsDecisionsWrapper",
  componentId: "sc-1daz11n-13"
})(["display:flex;flex-direction:column;padding:10px;"]);
var ColumnWrapper$1 = styled.div.withConfig({
  displayName: "styles__ColumnWrapper",
  componentId: "sc-1daz11n-14"
})(["display:flex;flex-direction:column;width:100%;"]);
var IsDecisionWrapper = styled.div.withConfig({
  displayName: "styles__IsDecisionWrapper",
  componentId: "sc-1daz11n-15"
})(["display:flex;flex-direction:row;width:100%;font-size:14px;margin-top:17px;font-family:SFMono-Regular,Menlo,Monaco,Consolas,'Liberation Mono','Courier New',monospace;font-weight:600;"]);
var DecisionLabel = styled.div.withConfig({
  displayName: "styles__DecisionLabel",
  componentId: "sc-1daz11n-16"
})(["flex:1;"]);
var DecisionValue = styled.div.withConfig({
  displayName: "styles__DecisionValue",
  componentId: "sc-1daz11n-17"
})(["flex:5;"]);
var Triangle = styled.div.withConfig({
  displayName: "styles__Triangle",
  componentId: "sc-1daz11n-18"
})(["width:0;height:0;border-width:0 7.5px 10px 7.5px;border-style:solid;transform:rotate(90deg);", ""], function (_ref7) {
  var $disabled = _ref7.$disabled;
  if ($disabled) {
    return css(["border-color:transparent transparent #c3c3c3 transparent;"]);
  } else {
    return css(["border-color:transparent transparent #ffffff transparent;"]);
  }
});
var Tick = styled.img.withConfig({
  displayName: "styles__Tick",
  componentId: "sc-1daz11n-19"
})(["height:14px;width:18px;padding:0 5px 0 0;"]);
var CondensedEvaluatorHeader = styled(Row$2).withConfig({
  displayName: "styles__CondensedEvaluatorHeader",
  componentId: "sc-1daz11n-20"
})(["border-bottom:1px solid #000000;"]);
var InstructionText = styled.div.withConfig({
  displayName: "styles__InstructionText",
  componentId: "sc-1daz11n-21"
})(["font-size:14px;padding-top:14px;"]);
var CondensedEvaluatorForm = styled.div.withConfig({
  displayName: "styles__CondensedEvaluatorForm",
  componentId: "sc-1daz11n-22"
})(["font-size:14px;line-height:1.5rem;font-family:SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,'Courier New','monospace';> textarea{font-weight:400;font-size:14px;font-family:SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,'Courier New','monospace';}"]);
var CondensedEvaluatorBody = styled(Row$2).withConfig({
  displayName: "styles__CondensedEvaluatorBody",
  componentId: "sc-1daz11n-23"
})(["padding:10px 10px 5px 10px;background-color:#2a2a2a;width:98%;margin-top:10px;margin-bottom:5px;"]);
var CondensedEvaluatorLeftColumn = styled(Col).withConfig({
  displayName: "styles__CondensedEvaluatorLeftColumn",
  componentId: "sc-1daz11n-24"
})(["flex:2;padding-left:10px;padding-right:10px;"]);
var CondensedEvaluatorRightColumn = styled(Col).withConfig({
  displayName: "styles__CondensedEvaluatorRightColumn",
  componentId: "sc-1daz11n-25"
})(["flex:2;margin-left:15px;"]);
var CopyButton$1 = styled(Button).withConfig({
  displayName: "styles__CopyButton",
  componentId: "sc-1daz11n-26"
})(["height:24px;line-height:50%;&:active{box-shadow:0 5px ", ";transform:translateY(4px);}"], theme.grey20);
var ResultsLabel = styled(Label$1).withConfig({
  displayName: "styles__ResultsLabel",
  componentId: "sc-1daz11n-27"
})(["margin-top:28px;"]);
var EvaluatorContainer$1 = styled.div.withConfig({
  displayName: "styles__EvaluatorContainer",
  componentId: "sc-1daz11n-28"
})(["display:flex;justify-content:space-between;height:32px;"]);
var TabGroup = styled.div.withConfig({
  displayName: "styles__TabGroup",
  componentId: "sc-1daz11n-29"
})(["width:100%;display:inline-flex;border-bottom:1px solid ", ";margin-bottom:8px;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.grey30;
});
var Tab = styled(Label$1).withConfig({
  displayName: "styles__Tab",
  componentId: "sc-1daz11n-30"
})(["margin-left:20px;margin-top:28px;margin-bottom:0;padding-bottom:12px;cursor:pointer;white-space:nowrap;", ""], function (_ref9) {
  var theme = _ref9.theme,
    $active = _ref9.$active;
  return css(["color:", ";&:hover{color:", ";}", ""], theme.grey70, theme.grey100, $active && "color: ".concat(theme.grey100, ";\n        border-bottom: 1px solid ").concat(theme.lochivarAccent4, ";\n        "));
});
var ResultsTextBox = styled(TextBox).withConfig({
  displayName: "styles__ResultsTextBox",
  componentId: "sc-1daz11n-31"
})(["min-height:252px;height:calc(100vh - 640px);"]);
var ResourceTextArea = styled(TextArea$1).withConfig({
  displayName: "styles__ResourceTextArea",
  componentId: "sc-1daz11n-32"
})(["border-color:", " !important;min-height:252px;height:calc(100vh - 640px);"], function (_ref10) {
  var $hasError = _ref10.$hasError;
  return $hasError ? theme.mojoAccent3 : theme.grey40;
});
var HighlightedOutput = styled.div.withConfig({
  displayName: "styles__HighlightedOutput",
  componentId: "sc-1daz11n-33"
})(["height:100%;.monaco-editor{position:absolute !important;}"]);

var CurveContainer = styled.div.withConfig({
  displayName: "Subfield__CurveContainer",
  componentId: "sc-1kdhfnm-0"
})(["margin-top:-10px;"]);
var SubField = function SubField(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CurveContainer, null, /*#__PURE__*/React.createElement(Curve, null)), children);
};

var Decisions = function Decisions() {
  var _useCommonPolicyEvalu = useCommonPolicyEvaluatorContext(),
    decisions = _useCommonPolicyEvalu.decisions,
    setDecisions = _useCommonPolicyEvalu.setDecisions;
  var _usePolicyEvaluatorEr = usePolicyEvaluatorErrorContext(),
    policyContextError = _usePolicyEvaluatorEr.policyContextError;
  return /*#__PURE__*/React.createElement(SubField, null, /*#__PURE__*/React.createElement(Row$2, {
    "$centered": true,
    "$marginLeft": 20
  }, /*#__PURE__*/React.createElement(FieldContainer$1, null, /*#__PURE__*/React.createElement(Input, {
    error: policyContextError,
    label: "Decisions",
    value: decisions,
    onChange: function onChange(e) {
      return setDecisions(e.target.value);
    }
  }))));
};

var ResourceContext = function ResourceContext() {
  var _useFeatureFlags = useFeatureFlags(),
    isGraphQLEnabled = _useFeatureFlags.isGraphQLEnabled;
  var _useRebacPolicyEvalua = useRebacPolicyEvaluatorContext(),
    objectType = _useRebacPolicyEvalua.objectType,
    setObjectType = _useRebacPolicyEvalua.setObjectType,
    setObjectInstance = _useRebacPolicyEvalua.setObjectInstance,
    setRelationType = _useRebacPolicyEvalua.setRelationType,
    setPermission = _useRebacPolicyEvalua.setPermission;
  var _useCommonPolicyEvalu = useCommonPolicyEvaluatorContext(),
    setResourceContext = _useCommonPolicyEvalu.setResourceContext,
    resourceContext = _useCommonPolicyEvalu.resourceContext;
  var _usePolicyEvaluatorEr = usePolicyEvaluatorErrorContext(),
    resourceContextError = _usePolicyEvaluatorEr.resourceContextError;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    objectsFilter = _useState2[0],
    setObjectsFilter = _useState2[1];
  var _PermissionsList = PermissionsList({
      objectType: objectType
    }),
    permissionsData = _PermissionsList.data;
  var permissions = useMemo(function () {
    var _a;
    if (objectType === undefined || objectType === '') {
      return [];
    }
    return ((_a = permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.results) === null || _a === void 0 ? void 0 : _a.map(function (p) {
      return {
        label: p.displayName || p.name,
        value: p.name
      };
    })) || [];
  }, [permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.results, objectType]);
  var _RelationTypesList = RelationTypesList(),
    relationTypesData = _RelationTypesList.data;
  var relations = useMemo(function () {
    var _a;
    return ((_a = relationTypesData === null || relationTypesData === void 0 ? void 0 : relationTypesData.results) === null || _a === void 0 ? void 0 : _a.filter(function (relation) {
      return relation.objectType === objectType;
    }).map(function (n) {
      return {
        label: n.displayName || n.name,
        value: n.name
      };
    })) || [];
  }, [objectType, relationTypesData === null || relationTypesData === void 0 ? void 0 : relationTypesData.results]);
  var _ObjectsListInfinite = ObjectsListInfinite({
      object_type: objectType,
      'page.size': 100,
      id: objectsFilter
    }, {
      query: {
        enabled: isGraphQLEnabled
      }
    }),
    objectsData = _ObjectsListInfinite.data;
  var objectInstances = useMemo(function () {
    var _a;
    return (_a = objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages.map(function (page) {
      return page.results || [];
    }).flat().map(function (object) {
      return {
        label: object.display_name || object.id,
        value: object.id
      };
    })) !== null && _a !== void 0 ? _a : [];
  }, [objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages]);
  useEffect(function () {
    setObjectInstance(objectInstances[0] || null);
  }, [objectInstances, setObjectInstance]);
  return /*#__PURE__*/React.createElement(FieldContainer$1, null, /*#__PURE__*/React.createElement(Label$1, null, "Resource Context"), /*#__PURE__*/React.createElement(ResourceTextArea, {
    "$hasError": !!resourceContextError,
    placeholder: '{ "id": "123" }',
    rows: 10,
    value: resourceContext,
    onChange: function onChange(e) {
      var value = e.target.value;
      setResourceContext(value);
      handleChange(value, setObjectType, isGraphQLEnabled, setObjectsFilter, setObjectInstance, setRelationType, relations, setPermission, permissions);
    },
    onPaste: function onPaste(e) {
      var value = e.clipboardData.getData('Text');
      handleChange(value, setObjectType, isGraphQLEnabled, setObjectsFilter, setObjectInstance, setRelationType, relations, setPermission, permissions);
    }
  }));
};
var handleChange = function handleChange(value, setObjectType, isGraphQLEnabled, setObjectsFilter, setObjectInstance, setRelationType, relations, setPermission, permissions) {
  var ctx = {
    object_type: '',
    object_key: '',
    relation: '',
    permission: ''
  };
  try {
    ctx = JSON.parse(value !== '' ? value : '{}');
  } catch (_a) {}
  var newObjectType = ctx['object_type'] || '';
  var newObjectKey = ctx['object_key'];
  var newRelation = ctx['relation'];
  var newPermission = ctx['permission'];
  setObjectType(newObjectType);
  if (isGraphQLEnabled) {
    if (newObjectKey) {
      setObjectsFilter(newObjectKey);
    }
  } else {
    setObjectInstance({
      label: newObjectKey,
      value: newObjectKey
    });
  }
  setRelationType(relations.find(function (rel) {
    return rel.value === newRelation;
  }) || null);
  setPermission(permissions.find(function (per) {
    return per.value === newPermission;
  }) || null);
};

var SectionTitleContainer = styled.div.withConfig({
  displayName: "SectionTitleContainer",
  componentId: "sc-1xiuyke-0"
})(["margin-bottom:12px;"]);

var decisionTreeOptions = [{
  label: 'PATH_SEPARATOR_DOT',
  value: 'PATH_SEPARATOR_DOT'
}, {
  label: 'PATH_SEPARATOR_SLASH',
  value: 'PATH_SEPARATOR_SLASH'
}];
var PolicyDecisiontreeFields = function PolicyDecisiontreeFields() {
  var _useDecisionTreePolic = useDecisionTreePolicyEvaluatorContext(),
    options = _useDecisionTreePolic.options,
    setOptions = _useDecisionTreePolic.setOptions,
    pathFreeText = _useDecisionTreePolic.pathFreeText,
    setPathFreeText = _useDecisionTreePolic.setPathFreeText;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FieldContainer$1, null, /*#__PURE__*/React.createElement(Select, {
    label: "Options",
    name: "decisiontree-options",
    options: decisionTreeOptions,
    value: decisionTreeOptions.find(function (_ref) {
      var value = _ref.value;
      return options === value;
    }),
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        setOptions(option === null || option === void 0 ? void 0 : option.value);
      }
    }
  })), /*#__PURE__*/React.createElement(SectionTitleContainer, null, /*#__PURE__*/React.createElement(Label$1, null, "Policy Context")), /*#__PURE__*/React.createElement(SubField, null, /*#__PURE__*/React.createElement(Row$2, {
    "$centered": true,
    "$marginLeft": 20
  }, /*#__PURE__*/React.createElement(FieldContainer$1, null, /*#__PURE__*/React.createElement(Input, {
    defaultValue: pathFreeText,
    label: "Path",
    placeholder: "Policy path",
    onChange: function onChange(e) {
      return setPathFreeText(e.target.value);
    }
  })))), /*#__PURE__*/React.createElement(Decisions, null), /*#__PURE__*/React.createElement(ResourceContext, null));
};

var PolicyIsFields = function PolicyIsFields(_ref) {
  var policyModules = _ref.policyModules;
  var _useIsPolicyEvaluator = useIsPolicyEvaluatorContext(),
    pathSelect = _useIsPolicyEvaluator.pathSelect,
    setPathSelect = _useIsPolicyEvaluator.setPathSelect;
  var policyModulesOptions = useMemo(function () {
    return policyModules.map(function (module) {
      return {
        label: module.package_path,
        value: module.package_path
      };
    });
  }, [policyModules]);
  useEffect(function () {
    if (!pathSelect && !!policyModulesOptions && policyModulesOptions.length > 0) {
      setPathSelect(String(policyModulesOptions[0].value));
    }
  }, [pathSelect, policyModulesOptions, setPathSelect]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SectionTitleContainer, null, /*#__PURE__*/React.createElement(Label$1, null, "Policy Context")), /*#__PURE__*/React.createElement(SubField, null, /*#__PURE__*/React.createElement(Row$2, {
    "$centered": true,
    "$marginLeft": 20
  }, /*#__PURE__*/React.createElement(FieldContainer$1, null, /*#__PURE__*/React.createElement(Select, {
    label: "Path",
    name: "path-select",
    options: policyModulesOptions,
    value: policyModulesOptions.find(function (option) {
      return option.value === pathSelect;
    }),
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        setPathSelect(String(option.value));
      }
    }
  })))), /*#__PURE__*/React.createElement(Decisions, null), /*#__PURE__*/React.createElement(ResourceContext, null));
};

var PolicyQueryFields = function PolicyQueryFields() {
  var queryPolicyEvaluatorContext = useQueryPolicyEvaluatorContext();
  var input = queryPolicyEvaluatorContext.input,
    pathFreeText = queryPolicyEvaluatorContext.pathFreeText,
    query = queryPolicyEvaluatorContext.query,
    queryMetrics = queryPolicyEvaluatorContext.queryMetrics,
    queryTrace = queryPolicyEvaluatorContext.queryTrace,
    queryTraceLevel = queryPolicyEvaluatorContext.queryTraceLevel,
    queryTraceSummary = queryPolicyEvaluatorContext.queryTraceSummary,
    setInput = queryPolicyEvaluatorContext.setInput,
    setPathFreeText = queryPolicyEvaluatorContext.setPathFreeText,
    setQuery = queryPolicyEvaluatorContext.setQuery,
    setQueryMetrics = queryPolicyEvaluatorContext.setQueryMetrics,
    setQueryTrace = queryPolicyEvaluatorContext.setQueryTrace,
    setQueryTraceLevel = queryPolicyEvaluatorContext.setQueryTraceLevel,
    setQueryTraceSummary = queryPolicyEvaluatorContext.setQueryTraceSummary;
  var traceOptions = [{
    label: 'TRACE_LEVEL_NOTES',
    value: 'TRACE_LEVEL_NOTES'
  }, {
    label: 'TRACE_LEVEL_OFF',
    value: 'TRACE_LEVEL_OFF'
  }, {
    label: 'TRACE_LEVEL_FULL',
    value: 'TRACE_LEVEL_FULL'
  }, {
    label: 'TRACE_LEVEL_FAILS',
    value: 'TRACE_LEVEL_FAILS'
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldContainer$1, null, /*#__PURE__*/React.createElement(Label$1, {
    htmlFor: "queryOptions"
  }, "Options"), /*#__PURE__*/React.createElement(QueryOptionsContainer, null, /*#__PURE__*/React.createElement(SelectTraceContainer, null, /*#__PURE__*/React.createElement(Checkbox, {
    checked: queryTrace,
    label: "Trace",
    onChange: setQueryTrace
  }), queryTrace && (/*#__PURE__*/React.createElement(Select, {
    name: "trace-select",
    options: traceOptions,
    value: traceOptions.find(function (option) {
      return option.value === queryTraceLevel;
    }) || traceOptions[0],
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        setQueryTraceLevel(option.value);
      }
    }
  }))), /*#__PURE__*/React.createElement(Checkbox, {
    checked: queryTraceSummary,
    label: "Trace Summary",
    onChange: setQueryTraceSummary
  }), /*#__PURE__*/React.createElement(Checkbox, {
    checked: queryMetrics,
    label: "Metrics",
    onChange: setQueryMetrics
  }))), /*#__PURE__*/React.createElement(SectionTitleContainer, null, /*#__PURE__*/React.createElement(Label$1, null, "Policy Context")), /*#__PURE__*/React.createElement(SubField, null, /*#__PURE__*/React.createElement(Row$2, {
    "$centered": true,
    "$marginLeft": 20
  }, /*#__PURE__*/React.createElement(FieldContainer$1, null, /*#__PURE__*/React.createElement(Input, {
    defaultValue: pathFreeText || '',
    label: "Path",
    placeholder: "Policy path",
    onChange: function onChange(e) {
      return setPathFreeText(e.target.value);
    }
  })))), /*#__PURE__*/React.createElement(Decisions, null), /*#__PURE__*/React.createElement(FieldContainer$1, null, /*#__PURE__*/React.createElement(Label$1, {
    htmlFor: "query"
  }, "Query"), /*#__PURE__*/React.createElement(TextArea$1, {
    id: "query",
    placeholder: "x = data; y = input",
    rows: 10,
    value: String(query),
    onChange: function onChange(e) {
      setQuery(e.target.value);
    }
  })), /*#__PURE__*/React.createElement(FieldContainer$1, null, /*#__PURE__*/React.createElement(Label$1, {
    htmlFor: "input"
  }, "Input"), /*#__PURE__*/React.createElement(TextArea$1, {
    id: "input",
    placeholder: '{ "foo": "bar" }',
    rows: 10,
    value: String(input),
    onChange: function onChange(e) {
      setInput(e.target.value);
    }
  })), /*#__PURE__*/React.createElement(ResourceContext, null));
};

var RebacEvaluator = function RebacEvaluator() {
  var _useRebacPolicyEvalua = useRebacPolicyEvaluatorContext(),
    subjectType = _useRebacPolicyEvalua.subjectType,
    relationType = _useRebacPolicyEvalua.relationType,
    objectType = _useRebacPolicyEvalua.objectType,
    subjectInstance = _useRebacPolicyEvalua.subjectInstance,
    objectInstance = _useRebacPolicyEvalua.objectInstance,
    setSubjectType = _useRebacPolicyEvalua.setSubjectType,
    setRelationType = _useRebacPolicyEvalua.setRelationType,
    setObjectType = _useRebacPolicyEvalua.setObjectType,
    setObjectInstance = _useRebacPolicyEvalua.setObjectInstance,
    setSubjectInstance = _useRebacPolicyEvalua.setSubjectInstance;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    objectsFilter = _useState2[0],
    setObjectsFilter = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    filter = _useState4[0],
    setFilter = _useState4[1];
  var _useContentPolicyEval = useContentPolicyEvaluatorContext(),
    request = _useContentPolicyEval.request,
    identity = _useContentPolicyEval.identity,
    setType = _useContentPolicyEval.setType,
    setIdentity = _useContentPolicyEval.setIdentity;
  var _useCommonPolicyEvalu = useCommonPolicyEvaluatorContext(),
    resourceContext = _useCommonPolicyEvalu.resourceContext,
    setResourceContext = _useCommonPolicyEvalu.setResourceContext;
  var _useIsPolicyEvaluator = useIsPolicyEvaluatorContext(),
    setPathSelect = _useIsPolicyEvaluator.setPathSelect;
  var _ObjectTypesList = ObjectTypesList(),
    objectTypesData = _ObjectTypesList.data;
  var _useFeatureFlags = useFeatureFlags(),
    isGraphQLEnabled = _useFeatureFlags.isGraphQLEnabled;
  var debouncedFilter = useDebounce(filter);
  var debouncedObjectsFilter = useDebounce(objectsFilter);
  useEffect(function () {
    setSubjectType('user');
  });
  var _ObjectsListInfinite = ObjectsListInfinite({
      object_type: subjectType,
      'page.size': 100,
      displayNamePart: debouncedFilter
    }, {
      query: {
        enabled: !!subjectType && isGraphQLEnabled
      }
    }),
    subjectsData = _ObjectsListInfinite.data,
    hasMoreSubjects = _ObjectsListInfinite.hasNextPage,
    fetchNextSubjectsData = _ObjectsListInfinite.fetchNextPage;
  var subjects = useMemo(function () {
    var _a;
    return (_a = subjectsData === null || subjectsData === void 0 ? void 0 : subjectsData.pages.map(function (page) {
      return page.results || [];
    }).flat().map(function (object) {
      var userProps = parseAsUserProperties(object.properties);
      return {
        label: object.display_name || object.id,
        value: userProps.email
      };
    })) !== null && _a !== void 0 ? _a : [];
  }, [subjectsData === null || subjectsData === void 0 ? void 0 : subjectsData.pages]);
  var _RelationTypesList = RelationTypesList(),
    relationTypesData = _RelationTypesList.data;
  var relations = useMemo(function () {
    var _a;
    return (_a = relationTypesData === null || relationTypesData === void 0 ? void 0 : relationTypesData.results) === null || _a === void 0 ? void 0 : _a.filter(function (relation) {
      return relation.objectType === objectType;
    }).map(function (n) {
      return {
        label: n.displayName || n.name,
        value: n.name
      };
    });
  }, [objectType, relationTypesData]);
  var objectTypes = useMemo(function () {
    var _a;
    return ((_a = objectTypesData === null || objectTypesData === void 0 ? void 0 : objectTypesData.results) === null || _a === void 0 ? void 0 : _a.map(function (o) {
      return {
        label: o.displayName || o.name,
        value: o.name
      };
    })) || [];
  }, [objectTypesData === null || objectTypesData === void 0 ? void 0 : objectTypesData.results]);
  var _ObjectsListInfinite2 = ObjectsListInfinite({
      object_type: objectType,
      'page.size': 100,
      displayNamePart: debouncedObjectsFilter
    }, {
      query: {
        enabled: isGraphQLEnabled
      }
    }),
    objectsData = _ObjectsListInfinite2.data,
    hasMoreObjects = _ObjectsListInfinite2.hasNextPage,
    fetchMoreObjects = _ObjectsListInfinite2.fetchNextPage;
  var objectInstances = useMemo(function () {
    var _a;
    return (_a = objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages.map(function (page) {
      return page.results || [];
    }).flat().map(function (object) {
      return {
        label: object.display_name || object.id,
        value: object.id
      };
    })) !== null && _a !== void 0 ? _a : [];
  }, [objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages]);
  var _PermissionsList = PermissionsList({
      objectType: objectType
    }),
    permissionsData = _PermissionsList.data;
  var permissions = useMemo(function () {
    var _a;
    if (objectType === undefined || objectType === '') {
      return [];
    }
    return ((_a = permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.results) === null || _a === void 0 ? void 0 : _a.map(function (p) {
      return {
        label: p.displayName || p.name,
        value: p.name
      };
    })) || [];
  }, [permissionsData === null || permissionsData === void 0 ? void 0 : permissionsData.results, objectType]);
  var relationsPermissions = [{
    label: 'Relations',
    options: relations || []
  }, {
    label: 'Permissions',
    options: permissions || []
  }];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row$2, {
    "$centered": true
  }, /*#__PURE__*/React.createElement(FieldContainer$1, null, isGraphQLEnabled ? (/*#__PURE__*/React.createElement(Select, {
    inputValue: filter,
    label: "Subject",
    options: subjects,
    value: subjectInstance,
    onChange: function onChange(option) {
      setType('IDENTITY_TYPE_SUB');
      setSubjectInstance(option);
      setIdentity(String(option === null || option === void 0 ? void 0 : option.value));
    },
    onInputChange: setFilter,
    onMenuScrollToBottom: function onMenuScrollToBottom() {
      hasMoreSubjects && fetchNextSubjectsData && fetchNextSubjectsData();
    }
  })) : (/*#__PURE__*/React.createElement(EvaluatorStyledInput, {
    label: "Subject",
    placeholder: "Identity",
    value: identity || '',
    onChange: function onChange(e) {
      setIdentity(e.target.value);
      setType('IDENTITY_TYPE_SUB');
    }
  })))), /*#__PURE__*/React.createElement(Row$2, {
    "$centered": true
  }, /*#__PURE__*/React.createElement(FieldContainer$1, null, /*#__PURE__*/React.createElement(Select, {
    label: "Object Type",
    options: objectTypes,
    value: objectTypes.find(function (_ref) {
      var value = _ref.value;
      return value === objectType;
    }),
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        setResourceContext(JSON.stringify(Object.assign(Object.assign({}, JSON.parse(resourceContext !== '' ? resourceContext : '{}')), {
          object_type: String(option.value),
          object_id: ''
        }), null, 2));
        setObjectType(String(option.value));
        setObjectInstance(null);
        setRelationType(null);
      }
    }
  })), /*#__PURE__*/React.createElement(FieldContainer$1, {
    "$marginLeft": 20
  }, isGraphQLEnabled ? (/*#__PURE__*/React.createElement(Select, {
    label: "Object",
    options: objectInstances,
    value: objectInstance,
    onChange: function onChange(option) {
      setObjectInstance(option);
      setResourceContext(JSON.stringify(Object.assign(Object.assign({}, JSON.parse(resourceContext !== '' ? resourceContext : '{}')), {
        object_id: String(option === null || option === void 0 ? void 0 : option.value)
      }), null, 2));
    },
    onInputChange: setObjectsFilter,
    onMenuScrollToBottom: function onMenuScrollToBottom() {
      hasMoreObjects && fetchMoreObjects && fetchMoreObjects();
    }
  })) : (/*#__PURE__*/React.createElement(InputTopMargin, null, /*#__PURE__*/React.createElement(EvaluatorStyledInput, {
    label: "Object ID",
    placeholder: "Object ID",
    value: (objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value) || '',
    onChange: function onChange(e) {
      setObjectInstance({
        label: e.target.value,
        value: e.target.value
      });
      setResourceContext(JSON.stringify(Object.assign(Object.assign({}, JSON.parse(resourceContext !== '' ? resourceContext : '{}')), {
        object_id: String(e.target.value)
      }), null, 2));
    }
  }))))), request === 'CHECK' && (/*#__PURE__*/React.createElement(FieldContainer$1, null, /*#__PURE__*/React.createElement(Select, {
    label: "Relation",
    modifyCustomStyle: function modifyCustomStyle() {
      return colourStyles;
    },
    options: relationsPermissions,
    value: relationType,
    onChange: function onChange(option) {
      setRelationType(option);
      setPathSelect('rebac.check');
      var context = JSON.parse(resourceContext !== '' ? resourceContext : '{}');
      delete context['permission'];
      setResourceContext(JSON.stringify(Object.assign(Object.assign({}, context), {
        relation: String(option === null || option === void 0 ? void 0 : option.value)
      }), null, 2));
    }
  }))));
};

var identityOptions = [{
  label: 'Anonymous',
  value: 'IDENTITY_TYPE_NONE'
}, {
  label: 'JWT',
  value: 'IDENTITY_TYPE_JWT'
}, {
  label: 'Subject',
  value: 'IDENTITY_TYPE_SUB'
}, {
  label: 'Manual',
  value: 'IDENTITY_TYPE_MANUAL'
}];
var REQUEST_PATHS = {
  CHECK: 'api/v2/authz/is',
  IS: 'api/v2/authz/is',
  DECISIONTREE: 'api/v2/authz/decisiontree',
  QUERY: 'api/v2/authz/query'
};
var MonacoTheme = [{
  token: 'constant',
  foreground: '#A8FF60'
}, {
  token: 'number',
  foreground: '#FF66FF'
}, {
  token: 'number.hex',
  foreground: '#FF66FF'
}, {
  token: 'annotation',
  foreground: '#96CBFE'
}, {
  token: 'type',
  foreground: '#96CBFE'
}, {
  token: 'delimiter',
  foreground: '#CCCCCC'
}, {
  token: 'delimiter.html',
  foreground: '#CCCCCC'
}, {
  token: 'delimiter.xml',
  foreground: '#CCCCCC'
}, {
  token: 'editorBracketHighlight',
  foreground: '#CCCCCC'
}, {
  token: 'metatag.content.html',
  foreground: '#A8FF60'
}, {
  token: 'key',
  foreground: '#96CBFE'
}, {
  token: 'string.key.json',
  foreground: '#96CBFE'
}, {
  token: 'string.value.json',
  foreground: '#A8FF60'
}, {
  token: 'attribute.value.unit',
  foreground: '#A8FF60'
}, {
  token: 'attribute.value.html',
  foreground: '#A8FF60'
}, {
  token: 'attribute.value.xml',
  foreground: '#A8FF60'
}, {
  token: 'string',
  foreground: '#A8FF60'
}, {
  token: 'string.html',
  foreground: '#A8FF60'
}, {
  token: 'string.sql',
  foreground: '#A8FF60'
}, {
  token: 'string.yaml',
  foreground: '#A8FF60'
}, {
  token: 'keyword',
  foreground: '#99CC99'
}, {
  token: 'keyword.json',
  foreground: '#99CC99'
}, {
  token: 'keyword.flow',
  foreground: '#99CC99'
}, {
  token: 'keyword.flow.scss',
  foreground: '#99CC99'
}];
function isDecisionTreeResponse(output) {
  return (output === null || output === void 0 ? void 0 : output.path) !== undefined;
}
var PolicyEvaluatorContent = function PolicyEvaluatorContent(_ref) {
  var output = _ref.output,
    onSubmit = _ref.onSubmit,
    onRequestChange = _ref.onRequestChange,
    policyModules = _ref.policyModules,
    users = _ref.users,
    filter = _ref.filter,
    setFilter = _ref.setFilter,
    hasMoreUsers = _ref.hasMoreUsers,
    fetchNextUsersData = _ref.fetchNextUsersData,
    isRebac = _ref.isRebac,
    requestBody = _ref.requestBody;
  var usersOptions = useMemo(function () {
    return users.map(function (user) {
      var userProps = parseAsUserProperties(user.properties);
      return {
        label: user.display_name ? user.display_name : '',
        value: userProps.email ? userProps.email : ''
      };
    });
  }, [users]);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    requestPath = _useState2[0],
    setRequestPath = _useState2[1];
  var _useCopyCurl = useCopyCurl$1(JSON.stringify(requestBody), requestPath || REQUEST_PATHS['IS']),
    copyCurl = _useCopyCurl.copyCurl;
  var editorRef = useRef();
  var _useContentPolicyEval = useContentPolicyEvaluatorContext(),
    request = _useContentPolicyEval.request,
    setRequest = _useContentPolicyEval.setRequest,
    identity = _useContentPolicyEval.identity,
    setIdentity = _useContentPolicyEval.setIdentity,
    type = _useContentPolicyEval.type,
    setType = _useContentPolicyEval.setType,
    queryMetrics = _useContentPolicyEval.queryMetrics,
    queryTrace = _useContentPolicyEval.queryTrace,
    queryTraceSummary = _useContentPolicyEval.queryTraceSummary;
  var _usePolicyEvaluatorEr = usePolicyEvaluatorErrorContext(),
    policyContextError = _usePolicyEvaluatorEr.policyContextError,
    resourceContextError = _usePolicyEvaluatorEr.resourceContextError;
  var _useRebacPolicyEvalua = useRebacPolicyEvaluatorContext(),
    subjectInstance = _useRebacPolicyEvalua.subjectInstance,
    setSubjectInstance = _useRebacPolicyEvalua.setSubjectInstance;
  var requestOptions = useMemo(function () {
    return isRebac ? [{
      label: 'Check ',
      value: 'CHECK'
    }, {
      label: 'Is',
      value: 'IS'
    }, {
      label: 'decisiontree',
      value: 'DECISIONTREE'
    }, {
      label: 'query',
      value: 'QUERY'
    }] : [{
      label: 'Is',
      value: 'IS'
    }, {
      label: 'decisiontree',
      value: 'DECISIONTREE'
    }, {
      label: 'query',
      value: 'QUERY'
    }];
  }, [isRebac]);
  var handleEditorDidMount = function handleEditorDidMount(editor, monaco) {
    monaco.editor.setTheme('aserto');
    editorRef.current = editor;
  };
  useEffect(function () {
    if (!request) {
      var option = requestOptions[0].value;
      setRequest(option);
      setRequestPath(REQUEST_PATHS[option]);
    }
  }, [isRebac, request, requestOptions, setRequest, setRequestPath]);
  var _useFeatureFlags = useFeatureFlags(),
    isGraphQLEnabled = _useFeatureFlags.isGraphQLEnabled;
  var _useState3 = useState('Results'),
    _useState4 = _slicedToArray(_useState3, 2),
    activeQueryTab = _useState4[0],
    setActiveQueryTab = _useState4[1];
  var queryResult = output === null || output === void 0 ? void 0 : output.response;
  var queryMetricsOutput = output === null || output === void 0 ? void 0 : output.metrics;
  var queryTraceOutput = output === null || output === void 0 ? void 0 : output.trace;
  var queryTraceSummaryOutput = output === null || output === void 0 ? void 0 : output.trace_summary;
  var queryOutput = useMemo(function () {
    if (request === 'QUERY') {
      switch (activeQueryTab) {
        case 'Results':
          return queryResult;
        case 'Trace':
          return queryTraceOutput;
        case 'Metrics':
          return queryMetricsOutput;
        case 'Trace Summary':
          return queryTraceSummaryOutput;
        default:
          return;
      }
    }
  }, [activeQueryTab, queryMetricsOutput, queryResult, queryTraceOutput, queryTraceSummaryOutput, request]);
  useEffect(function () {
    var _a;
    var outputString;
    if (request === 'QUERY') {
      outputString = JSON.stringify(queryOutput, null, 2);
    } else {
      outputString = JSON.stringify(output, null, 2);
    }
    (_a = editorRef.current) === null || _a === void 0 ? void 0 : _a.setValue(outputString);
  }, [output, queryOutput, request]);
  useEffect(function () {
    return setActiveQueryTab('Results');
  }, [output]);
  useEffect(function () {
    if (!queryMetrics && activeQueryTab === 'Metrics' || !queryTrace && activeQueryTab === 'Trace' || !queryTraceSummary && activeQueryTab === 'Trace Summary') {
      setActiveQueryTab('Results');
    }
  }, [activeQueryTab, queryMetrics, queryTrace, queryTraceSummary]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ColumnWrapper$1, null, /*#__PURE__*/React.createElement(Header$1, null, /*#__PURE__*/React.createElement(Row$2, {
    "$centered": true,
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(Row$2, {
    "$centered": true,
    "$flex": true,
    style: {
      marginRight: 20
    }
  }, /*#__PURE__*/React.createElement(HeaderTitle, null, "REQUEST:"), /*#__PURE__*/React.createElement(HeaderSelectContainer, null, /*#__PURE__*/React.createElement(Select, {
    isSearchable: false,
    modifyCustomStyle: function modifyCustomStyle(style) {
      return Object.assign(Object.assign({}, style), {
        option: function option(styles, _ref2) {
          var isDisabled = _ref2.isDisabled,
            isFocused = _ref2.isFocused,
            isSelected = _ref2.isSelected,
            data = _ref2.data;
          return Object.assign(Object.assign({}, styles), {
            borderBottom: data.value === 'CHECK' ? "2px ".concat(theme.grey30, " solid") : '',
            backgroundColor: isDisabled ? theme.grey20 : isFocused ? theme.grey40 : isSelected ? theme.grey20 : theme.grey20,
            borderLeft: isSelected ? "5px solid ".concat(theme.lochivarAccent3) : "5px solid transparent",
            color: isFocused ? theme.grey100 : theme.grey70,
            height: '100%',
            minHeight: 36,
            fontSize: 14,
            lineHeight: '20px',
            cursor: isDisabled ? 'not-allowed' : 'default',
            ':active': Object.assign(Object.assign({}, styles[':active']), {
              backgroundColor: theme.grey40
            }),
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
          });
        }
      });
    },
    options: requestOptions,
    value: requestOptions.find(function (_ref3) {
      var value = _ref3.value;
      return value === request;
    }),
    onChange: function onChange(option) {
      if ((option === null || option === void 0 ? void 0 : option.value) !== request) {
        onRequestChange === null || onRequestChange === void 0 ? void 0 : onRequestChange();
      }
      if (option === null || option === void 0 ? void 0 : option.value) {
        setRequest(option.value);
        setRequestPath(REQUEST_PATHS[option.value]);
      }
    }
  }))), /*#__PURE__*/React.createElement(PlayButton, {
    disabled: !!policyContextError || !!resourceContextError,
    onSubmit: onSubmit
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      marginLeft: 20
    }
  }, /*#__PURE__*/React.createElement(HeaderTitle, null, "OUTPUT:")))), /*#__PURE__*/React.createElement(Container$1, null, /*#__PURE__*/React.createElement(ContentContainer$2, null, /*#__PURE__*/React.createElement(SideContent$1, {
    "$left": true
  }, request === 'CHECK' ? (/*#__PURE__*/React.createElement(RebacEvaluator, null)) : (/*#__PURE__*/React.createElement(Row$2, {
    "$centered": true
  }, /*#__PURE__*/React.createElement(FieldContainer$1, null, /*#__PURE__*/React.createElement(Select, {
    label: "Identity Context",
    options: identityOptions,
    value: identityOptions.find(function (_ref4) {
      var value = _ref4.value;
      return type === value;
    }),
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        if (option.value === 'IDENTITY_TYPE_NONE') {
          setSubjectInstance(null);
        }
        setType(option === null || option === void 0 ? void 0 : option.value);
        setIdentity(null);
      }
    }
  })), type === 'IDENTITY_TYPE_SUB' && (isGraphQLEnabled ? (/*#__PURE__*/React.createElement(FieldContainer$1, {
    "$marginLeft": 10,
    "$marginTop": 32
  }, /*#__PURE__*/React.createElement(Select, {
    inputValue: filter,
    options: usersOptions,
    value: subjectInstance,
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        setSubjectInstance(option);
        setIdentity(String(option === null || option === void 0 ? void 0 : option.value));
      }
    },
    onInputChange: setFilter,
    onMenuScrollToBottom: function onMenuScrollToBottom() {
      hasMoreUsers && fetchNextUsersData && fetchNextUsersData();
    }
  }))) : (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SeparationDots, null, ":"), /*#__PURE__*/React.createElement(FieldContainer$1, {
    "$marginTop": 32
  }, /*#__PURE__*/React.createElement(EvaluatorStyledInput, {
    placeholder: "Identity",
    value: identity || '',
    onChange: function onChange(e) {
      return setIdentity(e.target.value);
    }
  }))))), (type === 'IDENTITY_TYPE_MANUAL' || type === 'IDENTITY_TYPE_JWT') && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SeparationDots, null, ":"), /*#__PURE__*/React.createElement(FieldContainer$1, {
    "$marginTop": 32
  }, /*#__PURE__*/React.createElement(EvaluatorStyledInput, {
    placeholder: "Identity",
    value: identity || '',
    onChange: function onChange(e) {
      return setIdentity(e.target.value);
    }
  })))))), request === 'DECISIONTREE' && /*#__PURE__*/React.createElement(PolicyDecisiontreeFields, null), request === 'IS' && !!policyModules && (/*#__PURE__*/React.createElement(PolicyIsFields, {
    policyModules: policyModules
  })), request === 'QUERY' && /*#__PURE__*/React.createElement(PolicyQueryFields, null)), /*#__PURE__*/React.createElement(SideContent$1, {
    "$right": true
  }, /*#__PURE__*/React.createElement(EvaluatorContainer$1, null, /*#__PURE__*/React.createElement(Label$1, null, "Request"), /*#__PURE__*/React.createElement(CopyButton$1, {
    disabled: !requestBody,
    size: "sm",
    variant: "secondary",
    onClick: copyCurl
  }, "Copy as cURL")), /*#__PURE__*/React.createElement(TextBox, {
    "$height": 262
  }, /*#__PURE__*/React.createElement(Highlight, {
    language: "json"
  }, JSON.stringify(requestBody, null, 2))), (request === 'IS' || request === 'CHECK') && output && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ResultsLabel, null, "Results"), /*#__PURE__*/React.createElement(ResultsTextBox, null, /*#__PURE__*/React.createElement(HighlightedOutput, null, /*#__PURE__*/React.createElement(MonacoEditor, {
    defaultLanguage: "json",
    defaultValue: JSON.stringify(output, null, 2),
    layoutOptions: {
      automaticLayout: true,
      fontSize: 14,
      lineNumbers: 'off',
      minimap: {
        autohide: true
      },
      readOnly: true,
      scrollBeyondLastLine: false
    },
    themeRules: MonacoTheme,
    onMount: handleEditorDidMount
  }))))), request === 'DECISIONTREE' && isDecisionTreeResponse(output) && (/*#__PURE__*/React.createElement(DecisionTreeTable, {
    data: output
  })), request === 'QUERY' && queryOutput && (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabGroup, null, /*#__PURE__*/React.createElement(Tab, {
    "$active": activeQueryTab === 'Results',
    onClick: function onClick() {
      return setActiveQueryTab('Results');
    }
  }, "Results"), !!queryTrace && (/*#__PURE__*/React.createElement(Tab, {
    "$active": activeQueryTab === 'Trace',
    onClick: function onClick() {
      return setActiveQueryTab('Trace');
    }
  }, "Trace")), !!queryTraceSummary && (/*#__PURE__*/React.createElement(Tab, {
    "$active": activeQueryTab === 'Trace Summary',
    onClick: function onClick() {
      return setActiveQueryTab('Trace Summary');
    }
  }, "Trace Summary")), !!queryMetrics && (/*#__PURE__*/React.createElement(Tab, {
    "$active": activeQueryTab === 'Metrics',
    onClick: function onClick() {
      return setActiveQueryTab('Metrics');
    }
  }, "Metrics"))), /*#__PURE__*/React.createElement(ResultsTextBox, null, /*#__PURE__*/React.createElement(HighlightedOutput, null, /*#__PURE__*/React.createElement(MonacoEditor, {
    defaultLanguage: "json",
    defaultValue: JSON.stringify(queryOutput, null, 2),
    layoutOptions: {
      automaticLayout: true,
      fontSize: 14,
      lineNumbers: 'off',
      minimap: {
        autohide: true
      },
      readOnly: true,
      scrollBeyondLastLine: false
    },
    themeRules: MonacoTheme,
    onMount: handleEditorDidMount
  }))))))))));
};

var img$1 = "data:image/svg+xml,%3csvg width='18px' height='18px' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' fill='none'%3e %3cpath fill='red' d='M12.78 4.28a.75.75 0 00-1.06-1.06L8 6.94 4.28 3.22a.75.75 0 00-1.06 1.06L6.94 8l-3.72 3.72a.75.75 0 101.06 1.06L8 9.06l3.72 3.72a.75.75 0 101.06-1.06L9.06 8l3.72-3.72z' /%3e%3c/svg%3e";

var TrueValue = function TrueValue() {
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Tick, {
    src: img$u
  }));
};
var FalseValue = function FalseValue() {
  return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Tick, {
    src: img$1
  }));
};
function isIsResponse(output) {
  return output.decisions !== undefined;
}
var PolicyEvaluatorContentCondensed = function PolicyEvaluatorContentCondensed(_ref) {
  var output = _ref.output,
    onSubmit = _ref.onSubmit,
    policyModules = _ref.policyModules,
    selectedModuleId = _ref.selectedModuleId,
    users = _ref.users,
    setFilter = _ref.setFilter,
    hasMoreUsers = _ref.hasMoreUsers,
    fetchNextUsersData = _ref.fetchNextUsersData;
  var _a;
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    objectInstance = _React$useState2[0],
    setObjectInstance = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    objectsFilter = _React$useState4[0],
    setObjectsFilter = _React$useState4[1];
  var debouncedObjectsFilter = useDebounce(objectsFilter);
  var isPost = (selectedModuleId === null || selectedModuleId === void 0 ? void 0 : selectedModuleId.includes('todoApp.POST.todos')) || (selectedModuleId === null || selectedModuleId === void 0 ? void 0 : selectedModuleId.includes('rebac.check'));
  var isGet = selectedModuleId === null || selectedModuleId === void 0 ? void 0 : selectedModuleId.includes('todoApp.GET');
  var isCommon = selectedModuleId === null || selectedModuleId === void 0 ? void 0 : selectedModuleId.includes('todoApp.common');
  var usersOptions = useMemo(function () {
    return users.map(function (user) {
      var userProps = parseAsUserProperties(user.properties);
      return {
        label: user.display_name ? user.display_name : '',
        value: user.id || userProps.email || ''
      };
    });
  }, [users]);
  var _ObjectsListInfinite = ObjectsListInfinite({
      object_type: 'resource',
      'page.size': 100,
      displayNamePart: debouncedObjectsFilter
    }),
    objectsData = _ObjectsListInfinite.data,
    hasMoreObjects = _ObjectsListInfinite.hasNextPage,
    fetchMoreObjects = _ObjectsListInfinite.fetchNextPage;
  var objectInstances = useMemo(function () {
    var _a;
    return (_a = objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages.map(function (page) {
      return page.results || [];
    }).flat().map(function (object) {
      return {
        label: object.display_name || object.id,
        value: object.id
      };
    })) !== null && _a !== void 0 ? _a : [];
  }, [objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages]);
  var containerRef = useRef(null);
  var _useCondensedContentP = useCondensedContentPolicyEvaluatorContext(),
    setPathSelect = _useCondensedContentP.setPathSelect,
    setDecisions = _useCondensedContentP.setDecisions,
    setIdentity = _useCondensedContentP.setIdentity,
    setRequest = _useCondensedContentP.setRequest,
    setResourceContext = _useCondensedContentP.setResourceContext,
    identity = _useCondensedContentP.identity,
    resourceContext = _useCondensedContentP.resourceContext;
  useEffect(function () {
    if (selectedModuleId) {
      var path = policyModules === null || policyModules === void 0 ? void 0 : policyModules.find(function (module) {
        return module.id === selectedModuleId;
      });
      if (path && path.package_path) {
        setPathSelect(path.package_path);
        setRequest('IS');
        setDecisions('["allowed"]');
      }
    }
  }, [policyModules, selectedModuleId, setDecisions, setPathSelect, setRequest]);
  useEffect(function () {
    if (isPost) {
      setResourceContext("{\n  \"object_type\": \"resource-creator\",\n  \"object_id\": \"resource-creators\",\n  \"relation\": \"member\"\n}");
    } else {
      setResourceContext("{\n  \"object_id\": \"".concat(objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value, "\"\n}"));
    }
  }, [identity, objectInstance, isPost, setResourceContext]);
  return isCommon ? (/*#__PURE__*/React.createElement(React.Fragment, null)) : (/*#__PURE__*/React.createElement(Container$1, {
    ref: containerRef,
    style: {
      paddingTop: 10,
      marginTop: 5
    }
  }, /*#__PURE__*/React.createElement(HeaderTitle, null, "Evaluate selected module"), /*#__PURE__*/React.createElement(CondensedEvaluatorBody, null, /*#__PURE__*/React.createElement(CondensedEvaluatorLeftColumn, null, /*#__PURE__*/React.createElement(Row$2, {
    "$centered": true
  }, /*#__PURE__*/React.createElement(FieldContainer$1, {
    "$marginBottom": 10
  }, /*#__PURE__*/React.createElement(Select, {
    label: "Identity Context",
    options: usersOptions,
    value: usersOptions.find(function (option) {
      return option.value === identity;
    }),
    onChange: function onChange(option) {
      if (option === null || option === void 0 ? void 0 : option.value) {
        setIdentity(option === null || option === void 0 ? void 0 : option.value);
      }
    },
    onInputChange: setFilter,
    onMenuScrollToBottom: function onMenuScrollToBottom() {
      hasMoreUsers && fetchNextUsersData && fetchNextUsersData();
    }
  }))), !isPost && !isGet && (/*#__PURE__*/React.createElement(Row$2, {
    "$centered": true
  }, /*#__PURE__*/React.createElement(FieldContainer$1, {
    "$marginBottom": 10
  }, /*#__PURE__*/React.createElement(Select, {
    label: "Todo",
    options: objectInstances,
    value: objectInstance,
    onChange: function onChange(option) {
      setObjectInstance(option);
      setResourceContext(JSON.stringify({
        object_id: String(option === null || option === void 0 ? void 0 : option.value)
      }, null, 2));
    },
    onInputChange: setObjectsFilter,
    onMenuScrollToBottom: function onMenuScrollToBottom() {
      hasMoreObjects && fetchMoreObjects && fetchMoreObjects();
    }
  })))), !isGet && (/*#__PURE__*/React.createElement(Row$2, {
    "$centered": true
  }, /*#__PURE__*/React.createElement(FieldContainer$1, {
    "$marginBottom": 10
  }, /*#__PURE__*/React.createElement(Label$1, null, "Resource Context"), /*#__PURE__*/React.createElement(CondensedEvaluatorForm, null, /*#__PURE__*/React.createElement(TextArea$1, {
    placeholder: "{ }",
    rows: isPost ? 5 : 4,
    value: String(resourceContext),
    onChange: function onChange(e) {
      setResourceContext(e.target.value);
    }
  })))))), /*#__PURE__*/React.createElement(CondensedEvaluatorRightColumn, {
    "data-testid": "output"
  }, /*#__PURE__*/React.createElement(CondensedEvaluatorHeader, null, /*#__PURE__*/React.createElement(Col, {
    "$flex": 1,
    style: {
      padding: 12
    }
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !identity,
    style: {
      marginTop: 3,
      width: 120,
      height: 40
    },
    onClick: onSubmit
  }, /*#__PURE__*/React.createElement(Row$2, null, /*#__PURE__*/React.createElement(Col, {
    "$flex": 4
  }, "Evaluate"), /*#__PURE__*/React.createElement(Col, {
    "$flex": 1,
    style: {
      paddingTop: 5
    }
  }, /*#__PURE__*/React.createElement(Triangle, {
    "$disabled": !identity
  }))))), /*#__PURE__*/React.createElement(Col, {
    "$flex": 3
  }, /*#__PURE__*/React.createElement(InstructionText, null, "Choose Identity and Resource contexts, then click the Evaluate button to see the resulting decision."))), /*#__PURE__*/React.createElement(IsDecisionsWrapper, null, /*#__PURE__*/React.createElement(HeaderTitle, null, "Decision"), !!output && isIsResponse(output) && ((_a = output.decisions) === null || _a === void 0 ? void 0 : _a.map(function (entry, key) {
    return /*#__PURE__*/React.createElement(IsDecisionWrapper, {
      key: key
    }, /*#__PURE__*/React.createElement(DecisionLabel, null, entry.decision), /*#__PURE__*/React.createElement(DecisionValue, null, entry.is ? TrueValue() : FalseValue(), entry.is ? "true" : "false"));
  })))))));
};

var PolicyEvaluatorComponent = function PolicyEvaluatorComponent(props) {
  return props.condensed ? (/*#__PURE__*/React.createElement(PolicyEvaluatorContentCondensed, Object.assign({}, props))) : (/*#__PURE__*/React.createElement(PolicyEvaluatorContent, Object.assign({}, props)));
};

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var Evaluator = function Evaluator(_ref) {
  var authorizerPolicyInstance = _ref.authorizerPolicyInstance,
    condensed = _ref.condensed,
    isRebac = _ref.isRebac,
    selectedModuleId = _ref.selectedModuleId;
  var _useFeatureFlags = useFeatureFlags(),
    isGraphQLEnabled = _useFeatureFlags.isGraphQLEnabled;
  var _useAuthzQuery = useAuthzQuery(),
    getAuthzQuery = _useAuthzQuery.mutateAsync;
  var _useAuthzIs = useAuthzIs(),
    getAuthzIs = _useAuthzIs.mutateAsync;
  var _useAuthzDecisionTree = useAuthzDecisionTree(),
    getAuthzDecisiontree = _useAuthzDecisionTree.mutateAsync;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    output = _useState2[0],
    setOutput = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    requestBody = _useState4[0],
    setRequestBody = _useState4[1];
  var _useListPolicyModules = useListPolicyModules(authorizerPolicyInstance, 'id,package_path,raw'),
    listPolicyModules = _useListPolicyModules.data;
  var _useParams = useParams(),
    policyInstance = _useParams.id;
  var _useActivePolicyInsta = useActivePolicyInstanceContext(),
    setPolicyInstance = _useActivePolicyInsta.setPolicyInstance;
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    filter = _useState6[0],
    setFilter = _useState6[1];
  var debouncedFilter = useDebounce(filter);
  var _ObjectsListInfinite = ObjectsListInfinite({
      object_type: 'user',
      'page.size': 100,
      displayNamePart: debouncedFilter
    }, {
      query: {
        onError: function onError(e) {
          showError(e);
        },
        enabled: isGraphQLEnabled
      }
    }),
    usersData = _ObjectsListInfinite.data,
    hasMoreUsers = _ObjectsListInfinite.hasNextPage,
    fetchNextUsersData = _ObjectsListInfinite.fetchNextPage;
  var users = useMemo(function () {
    if (!usersData || !usersData.pages) {
      return [];
    }
    var result = [];
    var condensedUsers = usersData.pages.map(function (page) {
      return page.results || [];
    }).flat();
    var _iterator = _createForOfIteratorHelper(condensedUsers),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var user = _step.value;
        var userProps = parseAsUserProperties(user.properties);
        result.push({
          properties: userProps,
          id: user.id,
          display_name: user.display_name,
          email: userProps.email || ''
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return result;
  }, [usersData]);
  var policyModules = useMemo(function () {
    if (!listPolicyModules || !listPolicyModules.result) {
      return;
    }
    return listPolicyModules.result.map(function (module) {
      var _a;
      return {
        id: module.id,
        package_path: (_a = module.package_path) === null || _a === void 0 ? void 0 : _a.replace('data.', ''),
        raw: module.raw
      };
    }).sort(function (a, b) {
      return a.package_path < b.package_path ? -1 : 1;
    });
  }, [listPolicyModules]);
  var getOperationBasedOnType = function getOperationBasedOnType(type) {
    var operationsObj = {
      QUERY: getAuthzQuery,
      IS: getAuthzIs,
      DECISIONTREE: getAuthzDecisiontree,
      CHECK: getAuthzIs
    };
    return operationsObj[type];
  };
  var onExecute = function onExecute(type, body) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var operation, responseData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            operation = getOperationBasedOnType(type);
            _context.prev = 1;
            _context.next = 4;
            return operation(body);
          case 4:
            responseData = _context.sent;
            setOutput(responseData);
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            setOutput(ensureError(_context.t0).message);
          case 11:
            _context.prev = 11;
            window.scrollTo(0, 0);
            return _context.finish(11);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8, 11, 14]]);
    }));
  };
  var evaluatorContext = useContentPolicyEvaluatorContext();
  var condensedEvaluatorContext = useCondensedContentPolicyEvaluatorContext();
  var type = 'IDENTITY_TYPE_SUB';
  var pathSelect = condensedEvaluatorContext.pathSelect;
  var request = condensedEvaluatorContext.request;
  var decisions = condensedEvaluatorContext.decisions;
  var resourceContext = condensedEvaluatorContext.resourceContext;
  var input = condensedEvaluatorContext.input;
  var query = condensedEvaluatorContext.query;
  var queryMetrics = condensedEvaluatorContext.queryMetrics;
  var queryTrace = condensedEvaluatorContext.queryTrace;
  var queryTraceLevel = 'TRACE_LEVEL_NOTES';
  var queryTraceSummary = condensedEvaluatorContext.queryTraceSummary;
  var pathFreeText = condensedEvaluatorContext.pathFreeText;
  var options = condensedEvaluatorContext.options;
  var identity = condensedEvaluatorContext.identity;
  if (!condensed) {
    pathSelect = evaluatorContext.pathSelect;
    request = evaluatorContext.request;
    decisions = evaluatorContext.decisions;
    resourceContext = evaluatorContext.resourceContext;
    input = evaluatorContext.input;
    query = evaluatorContext.query;
    queryMetrics = evaluatorContext.queryMetrics;
    queryTrace = evaluatorContext.queryTrace;
    queryTraceLevel = evaluatorContext.queryTraceLevel;
    queryTraceSummary = evaluatorContext.queryTraceSummary;
    pathFreeText = evaluatorContext.pathFreeText;
    options = evaluatorContext.options;
    identity = evaluatorContext.identity;
    type = evaluatorContext.type;
  }
  var showError = useShowError();
  var _usePolicyEvaluatorEr = usePolicyEvaluatorErrorContext(),
    setPolicyContextError = _usePolicyEvaluatorEr.setPolicyContextError,
    setResourceContextError = _usePolicyEvaluatorEr.setResourceContextError;
  var generateResourceContext = useCallback(function () {
    setResourceContextError(undefined);
    try {
      return Object.assign({}, resourceContext && {
        resource_context: JSON.parse(resourceContext || '{}')
      });
    } catch (_a) {
      setResourceContextError('Resource context is not a valid JSON.');
      return {};
    }
  }, [resourceContext, setResourceContextError]);
  var generatePolicyContext = useCallback(function () {
    setPolicyContextError(undefined);
    try {
      if (request === 'CHECK') {
        return {
          policy_context: {
            decisions: ['allowed'],
            path: 'rebac.check'
          }
        };
      }
      return Object.assign({}, decisions && {
        policy_context: {
          decisions: JSON.parse(decisions || '[]'),
          path: request === 'IS' ? pathSelect : pathFreeText
        }
      });
    } catch (error) {
      setPolicyContextError("Decisions: \"".concat(decisions, "\" is not a valid array. \n Error: ").concat(error));
      return {};
    }
  }, [decisions, pathFreeText, pathSelect, request, setPolicyContextError]);
  var generateIdentityContext = useCallback(function () {
    return {
      identity_context: {
        type: type,
        identity: identity
      }
    };
  }, [identity, type]);
  var generateQueryOptions = useCallback(function () {
    return {
      metrics: !!queryMetrics,
      trace: !!queryTrace ? queryTraceLevel : undefined,
      trace_summary: !!queryTraceSummary
    };
  }, [queryMetrics, queryTrace, queryTraceLevel, queryTraceSummary]);
  useEffect(function () {
    var policyInstanceContextRequest = {};
    var resourceContextRequest = generateResourceContext();
    var policyContextRequest = generatePolicyContext();
    var identityContextRequest = generateIdentityContext();
    var queryOptions = generateQueryOptions();
    if (authorizerPolicyInstance.policyInstanceName && authorizerPolicyInstance.policyInstanceLabel) {
      policyInstanceContextRequest = {
        policy_instance: {
          name: authorizerPolicyInstance.policyInstanceName,
          instance_label: authorizerPolicyInstance.policyInstanceLabel
        }
      };
    }
    var payload = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, identityContextRequest), request === 'DECISIONTREE' && {
      options: {
        path_separator: options
      }
    }), request === 'QUERY' && query && {
      query: query
    }), request === 'QUERY' && input && {
      input: input
    }), request === 'QUERY' && {
      options: queryOptions
    }), resourceContextRequest), policyContextRequest), policyInstanceContextRequest);
    setRequestBody(payload);
  }, [generateResourceContext, generatePolicyContext, generateIdentityContext, generateQueryOptions, authorizerPolicyInstance.policyInstanceName, authorizerPolicyInstance.policyInstanceLabel, request, options, query, input]);
  var onSubmit = function onSubmit() {
    return onExecute(request, requestBody);
  };
  useEffect(function () {
    setPolicyInstance(policyInstance || authorizerPolicyInstance.authorizerInstance || '');
  }, [authorizerPolicyInstance.authorizerInstance, policyInstance, setPolicyInstance]);
  return /*#__PURE__*/React.createElement(PolicyEvaluatorComponent, {
    condensed: condensed,
    "data-testid": "evaluator-component",
    fetchNextUsersData: fetchNextUsersData,
    filter: filter,
    hasMoreUsers: hasMoreUsers,
    isRebac: isRebac,
    output: output,
    policyLabel: authorizerPolicyInstance.policyInstanceName,
    policyModules: policyModules,
    policyName: authorizerPolicyInstance.policyInstanceLabel,
    requestBody: requestBody,
    selectedModuleId: selectedModuleId,
    setFilter: setFilter,
    users: users,
    onRequestChange: function onRequestChange() {
      return setOutput('');
    },
    onSubmit: onSubmit
  });
};

var DemoAppRequestGeneratorContext = /*#__PURE__*/React.createContext({
  subjectType: '',
  subjectInstance: {
    label: '',
    value: ''
  },
  operationType: {
    label: '',
    value: ''
  },
  objectType: '',
  objectInstance: {
    label: '',
    value: ''
  },
  setSubjectType: function setSubjectType() {},
  setSubjectInstance: function setSubjectInstance() {},
  setOperationType: function setOperationType() {},
  setObjectType: function setObjectType() {},
  setObjectInstance: function setObjectInstance() {}
});
var useDemoAppRequestGeneratorContext = function useDemoAppRequestGeneratorContext() {
  return useContext(DemoAppRequestGeneratorContext);
};
var DemoAppRequestGeneratorContextProvider = function DemoAppRequestGeneratorContextProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    subjectType = _useState2[0],
    setSubjectType = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    subjectInstance = _useState4[0],
    setSubjectInstance = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    operationType = _useState6[0],
    setOperationType = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    objectType = _useState8[0],
    setObjectType = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    objectInstance = _useState10[0],
    setObjectInstance = _useState10[1];
  var value = useMemo(function () {
    return {
      subjectType: subjectType,
      subjectInstance: subjectInstance,
      operationType: operationType,
      objectType: objectType,
      objectInstance: objectInstance,
      setSubjectType: setSubjectType,
      setSubjectInstance: setSubjectInstance,
      setOperationType: setOperationType,
      setObjectType: setObjectType,
      setObjectInstance: setObjectInstance
    };
  }, [objectInstance, objectType, operationType, subjectInstance, subjectType]);
  return /*#__PURE__*/React.createElement(DemoAppRequestGeneratorContext.Provider, {
    value: value
  }, children);
};

var useCopyCurl = function useCopyCurl(request) {
  return {
    copyCurl: function copyCurl() {
      return copy(request);
    }
  };
};

var ReactFlowContainer = styled.div.withConfig({
  displayName: "ObjectGraphBrowser__ReactFlowContainer",
  componentId: "sc-1bcuyim-0"
})(["height:calc(100vh - 150px);.react-flow__node-custom{border:1px solid ", ";border-radius:5px;text-align:center;&:hover{cursor:pointer;}}"], theme.grey30);
var ObjectGraphBrowser = function ObjectGraphBrowser() {
  var _useDemoAppRequestGen = useDemoAppRequestGeneratorContext(),
    subjectType = _useDemoAppRequestGen.subjectType,
    subjectInstance = _useDemoAppRequestGen.subjectInstance,
    objectType = _useDemoAppRequestGen.objectType,
    objectInstance = _useDemoAppRequestGen.objectInstance;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    subject = _useState2[0],
    setSubject = _useState2[1];
  useEffect(function () {
    var sub = {
      id: subjectInstance === null || subjectInstance === void 0 ? void 0 : subjectInstance.value,
      type: subjectType,
      display_name: (subjectInstance === null || subjectInstance === void 0 ? void 0 : subjectInstance.label) || String(subjectInstance === null || subjectInstance === void 0 ? void 0 : subjectInstance.value)
    };
    setSubject(sub);
  }, [subjectType, subjectInstance]);
  useEffect(function () {
    var sub = {
      id: objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value,
      type: objectType
    };
    setSubject(sub);
  }, [objectType, objectInstance]);
  return subject && subject.type && subject.id ? (/*#__PURE__*/React.createElement(ReactFlowContainer, null, /*#__PURE__*/React.createElement(ObjectGraphComponent, {
    object: subject,
    setObject: setSubject
  }))) : (/*#__PURE__*/React.createElement("div", null));
};

var Container = styled.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-10ysg6l-0"
})(["position:relative;font-family:'Roboto';min-width:620px;width:100%;"]);
var ContentContainer$1 = styled.div.withConfig({
  displayName: "styles__ContentContainer",
  componentId: "sc-10ysg6l-1"
})(["display:flex;width:auto;margin:0 auto;"]);
var FieldContainer = styled.div.withConfig({
  displayName: "styles__FieldContainer",
  componentId: "sc-10ysg6l-2"
})(["flex:1;margin-top:", ";margin-left:", ";margin-bottom:", ";"], function (_ref) {
  var $marginTop = _ref.$marginTop;
  return "".concat($marginTop, "px");
}, function (_ref2) {
  var $marginLeft = _ref2.$marginLeft;
  return "".concat($marginLeft, "px");
}, function (_ref3) {
  var _ref3$$marginBottom = _ref3.$marginBottom,
    $marginBottom = _ref3$$marginBottom === void 0 ? 20 : _ref3$$marginBottom;
  return "".concat($marginBottom, "px");
});
var SideContent = styled.div.withConfig({
  displayName: "styles__SideContent",
  componentId: "sc-10ysg6l-3"
})(["height:calc(100vh - 1rem);@media (max-width:1328px){height:calc(100vh - 1rem);}position:relative;overflow:", ";overflow-x:hidden;flex:1;padding:20px;", ""], function (_ref4) {
  var $overflow = _ref4.$overflow;
  return $overflow || 'auto';
}, function (_ref5) {
  var theme = _ref5.theme,
    $left = _ref5.$left,
    $right = _ref5.$right;
  if ($left) {
    return css(["max-width:30%;border-right:1px solid ", ";"], theme.grey20);
  } else if ($right) {
    return css(["max-width:70%;margin-right:15px;"]);
  }
});
var ColumnWrapper = styled.div.withConfig({
  displayName: "styles__ColumnWrapper",
  componentId: "sc-10ysg6l-4"
})(["display:flex;flex-direction:column;width:100%;"]);
var CopyButton = styled(Button).withConfig({
  displayName: "styles__CopyButton",
  componentId: "sc-10ysg6l-5"
})(["height:24px;line-height:50%;&:active{box-shadow:0 5px ", ";transform:translateY(4px);}"], theme.grey20);
var EvaluatorContainer = styled.div.withConfig({
  displayName: "styles__EvaluatorContainer",
  componentId: "sc-10ysg6l-6"
})(["display:flex;justify-content:space-between;height:32px;"]);

var defaultOperationOptions = [{
  label: 'GET',
  value: 'GET'
}, {
  label: 'PUT',
  value: 'PUT'
}, {
  label: 'DELETE',
  value: 'DELETE'
}];
var SubjectObjectOperationSelector = function SubjectObjectOperationSelector(_ref) {
  var selectorObjectType = _ref.selectorObjectType,
    _ref$operationsSelect = _ref.operationsSelectOptions,
    operationsSelectOptions = _ref$operationsSelect === void 0 ? defaultOperationOptions : _ref$operationsSelect;
  var _useDemoAppRequestGen = useDemoAppRequestGeneratorContext(),
    subjectType = _useDemoAppRequestGen.subjectType,
    objectType = _useDemoAppRequestGen.objectType,
    subjectInstance = _useDemoAppRequestGen.subjectInstance,
    objectInstance = _useDemoAppRequestGen.objectInstance,
    operationType = _useDemoAppRequestGen.operationType,
    setSubjectType = _useDemoAppRequestGen.setSubjectType,
    setObjectType = _useDemoAppRequestGen.setObjectType,
    setObjectInstance = _useDemoAppRequestGen.setObjectInstance,
    setSubjectInstance = _useDemoAppRequestGen.setSubjectInstance,
    setOperationType = _useDemoAppRequestGen.setOperationType;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    objectsFilter = _useState2[0],
    setObjectsFilter = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    filter = _useState4[0],
    setFilter = _useState4[1];
  var debouncedObjectsFilter = useDebounce(objectsFilter);
  var objectTypeDisplayName = objectType.charAt(0).toUpperCase() + objectType.slice(1);
  useEffect(function () {
    setSubjectType('user');
    setObjectType(selectorObjectType);
    setOperationType(operationsSelectOptions[0]);
  }, [setSubjectType, setObjectType, setOperationType, selectorObjectType, operationsSelectOptions]);
  var _ObjectsListInfinite = ObjectsListInfinite({
      object_type: subjectType,
      'page.size': 100,
      displayNamePart: '@the-smiths.com'
    }, {
      query: {
        enabled: !!subjectType
      }
    }),
    smithsSubjectsData = _ObjectsListInfinite.data;
  var _ObjectsListInfinite2 = ObjectsListInfinite({
      object_type: subjectType,
      'page.size': 100,
      displayNamePart: '@the-citadel.com'
    }, {
      query: {
        enabled: !!subjectType
      }
    }),
    citadelSubjectsData = _ObjectsListInfinite2.data;
  var subjects = useMemo(function () {
    var _a, _b;
    return ((_a = smithsSubjectsData === null || smithsSubjectsData === void 0 ? void 0 : smithsSubjectsData.pages.map(function (page) {
      return page.results || [];
    }).flat().map(function (object) {
      return {
        label: object.display_name || object.id,
        value: object.id
      };
    })) !== null && _a !== void 0 ? _a : []).concat((_b = citadelSubjectsData === null || citadelSubjectsData === void 0 ? void 0 : citadelSubjectsData.pages.map(function (page) {
      return page.results || [];
    }).flat().map(function (object) {
      return {
        label: object.display_name || object.id,
        value: object.id
      };
    })) !== null && _b !== void 0 ? _b : []);
  }, [smithsSubjectsData === null || smithsSubjectsData === void 0 ? void 0 : smithsSubjectsData.pages, citadelSubjectsData === null || citadelSubjectsData === void 0 ? void 0 : citadelSubjectsData.pages]);
  var _ObjectsListInfinite3 = ObjectsListInfinite({
      object_type: objectType,
      'page.size': 100,
      displayNamePart: debouncedObjectsFilter
    }),
    objectsData = _ObjectsListInfinite3.data,
    hasMoreObjects = _ObjectsListInfinite3.hasNextPage,
    fetchMoreObjects = _ObjectsListInfinite3.fetchNextPage;
  var objectInstances = useMemo(function () {
    var _a;
    return (_a = objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages.map(function (page) {
      return page.results || [];
    }).flat().map(function (object) {
      return {
        label: object.display_name || object.id,
        value: object.id
      };
    })) !== null && _a !== void 0 ? _a : [];
  }, [objectsData === null || objectsData === void 0 ? void 0 : objectsData.pages]);
  useEffect(function () {
    if (subjects.length > 0) {
      setSubjectInstance(subjects[0]);
    }
  }, [subjectType, subjects, setSubjectInstance]);
  useEffect(function () {
    if (objectInstances.length > 0) {
      setObjectInstance(objectInstances[0]);
    }
  }, [objectType, objectInstances, setObjectInstance]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row$2, {
    "$centered": true
  }, /*#__PURE__*/React.createElement(FieldContainer, null, /*#__PURE__*/React.createElement(Select, {
    inputValue: filter,
    label: "User",
    options: subjects,
    value: subjectInstance,
    onChange: function onChange(option) {
      setSubjectInstance(option);
    },
    onInputChange: setFilter
  }))), /*#__PURE__*/React.createElement(Row$2, {
    "$centered": true
  }, /*#__PURE__*/React.createElement(FieldContainer, null, /*#__PURE__*/React.createElement(Select, {
    label: objectTypeDisplayName,
    options: objectInstances,
    value: objectInstances.find(function (_ref2) {
      var value = _ref2.value;
      return (objectInstance === null || objectInstance === void 0 ? void 0 : objectInstance.value) === value;
    }),
    onChange: function onChange(option) {
      setObjectInstance(option);
    },
    onInputChange: setObjectsFilter,
    onMenuScrollToBottom: function onMenuScrollToBottom() {
      hasMoreObjects && fetchMoreObjects && fetchMoreObjects();
    }
  }))), /*#__PURE__*/React.createElement(FieldContainer, null, /*#__PURE__*/React.createElement(Select, {
    label: "Operation",
    modifyCustomStyle: function modifyCustomStyle() {
      return colourStyles;
    },
    options: operationsSelectOptions,
    value: operationType,
    onChange: function onChange(option) {
      setOperationType(option);
    }
  })));
};

var PASSWORD = 'V@erySecre#t123!';
var RequestGenerator = function RequestGenerator(_ref) {
  var getToken = _ref.getToken,
    token = _ref.token,
    selectorObjectType = _ref.selectorObjectType,
    operationsSelectOptions = _ref.operationsSelectOptions,
    encodeObjectInstance = _ref.encodeObjectInstance;
  var _a, _b, _c, _d, _e, _f;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    requestBody = _useState2[0],
    setRequestBody = _useState2[1];
  var _useCopyCurl = useCopyCurl(requestBody || ''),
    copyCurl = _useCopyCurl.copyCurl;
  var demoAppRequestGeneratorContext = useDemoAppRequestGeneratorContext();
  var email = (_a = demoAppRequestGeneratorContext.subjectInstance) === null || _a === void 0 ? void 0 : _a.value;
  var isPost = ((_b = demoAppRequestGeneratorContext.operationType) === null || _b === void 0 ? void 0 : _b.value) === 'POST';
  var url = isPost ? "localhost:3001/".concat(selectorObjectType) : "localhost:3001/".concat(selectorObjectType, "/").concat(encodeObjectInstance ? encodeURIComponent((_d = (_c = demoAppRequestGeneratorContext.objectInstance) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : '') : (_e = demoAppRequestGeneratorContext.objectInstance) === null || _e === void 0 ? void 0 : _e.value);
  var body = isPost ? "-d '{ \"".concat(demoAppRequestGeneratorContext.objectType, "\": \"").concat((_f = demoAppRequestGeneratorContext.objectInstance) === null || _f === void 0 ? void 0 : _f.value, "\" }'") : '';
  var generateAuthorizationHeader = useCallback(function () {
    return "-H 'Authorization: Bearer ".concat(token, "'");
  }, [token]);
  var generateCurl = useCallback(function () {
    var _a;
    return "curl -X ".concat((_a = demoAppRequestGeneratorContext.operationType) === null || _a === void 0 ? void 0 : _a.value, " ").concat(url, " ").concat(body, " \\\n  -H 'content-type: application/json' \\\n  ").concat(generateAuthorizationHeader());
  }, [generateAuthorizationHeader, demoAppRequestGeneratorContext.operationType, body, url]);
  useEffect(function () {
    if (email) {
      getToken(email, PASSWORD);
    }
  }, [email, getToken]);
  useEffect(function () {
    var curl = generateCurl();
    setRequestBody(curl);
  }, [generateCurl]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ColumnWrapper, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(ContentContainer$1, null, /*#__PURE__*/React.createElement(SideContent, {
    "$left": true
  }, "Copy as cURL and paste in a terminal.", /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(SubjectObjectOperationSelector, {
    operationsSelectOptions: operationsSelectOptions,
    selectorObjectType: selectorObjectType
  }), /*#__PURE__*/React.createElement(EvaluatorContainer, null, /*#__PURE__*/React.createElement(Label$1, null, "Request"), /*#__PURE__*/React.createElement(CopyButton, {
    disabled: !requestBody,
    size: "sm",
    variant: "secondary",
    onClick: copyCurl
  }, "Copy as cURL")), /*#__PURE__*/React.createElement(TextBox, {
    "$height": 150
  }, /*#__PURE__*/React.createElement(Highlight, {
    language: "bash"
  }, requestBody || ''))), /*#__PURE__*/React.createElement(SideContent, {
    "$right": true
  }, "Explore the relationships between users and objects to understand which cURLs succeed and which fail.", /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(ObjectGraphBrowser, null))))));
};

function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}

var _templateObject;
var GlobalStyle = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  #root,\n  #app {\n    height: 100%;\n  }\n  html,\n  body {\n    height: 100%;\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',\n    'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    background-color: ", ";\n    color: ", ";\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    color: ", ";\n  }\n\n  &::-webkit-scrollbar {\n    width: 10px;\n    height: 10px;\n    background-color: ", ";\n  }\n\n  &::-webkit-scrollbar-corner {\n    background-color: ", ";\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: ", ";\n    border-radius: 10px;\n  }\n  &::-webkit-scrollbar-track {\n    margin: 4px;\n    border-radius: 10px;\n  }\n\n  code {\n    font-family: 'Ubuntu Mono', source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n    color: ", ";\n  }\n\n  /* link treatment */\n  a {\n    color: ", ";\n  }\n  a:hover {\n    text-decoration: underline;\n    color: ", "\n  }\n\n  textarea {\n    resize: none;\n  }\n\n  :root {\n    --focus-border: ", ";\n    --separator-border: ", ";\n  }\n\n  .allotment-module_splitView__L-yRc.allotment-module_separatorBorder__x-rDS\n    > .allotment-module_splitViewContainer__rQnVa\n    > .allotment-module_splitViewView__MGZ6O:not(:first-child)::before {\n    background-color: var(--separator-border);\n    content: ' ';\n    left: 0;\n    pointer-events: none;\n    position: absolute;\n    top: 0;\n    z-index: 0;\n  }\n\n  .monaco-editor .vertical {\n    z-index: 0 !important;\n  }\n\n  .modal-content {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  @media (min-width: 800px) {\n    .left-item:after {\n      content: \"\";\n      background: ", ";\n      position: absolute;\n      bottom: 16px;\n      height: 50%;\n      right: 206px;\n      width: 1px;\n    }\n  }\n\n  .overflow-y-hidden {\n    overflow-y: hidden;\n }\n"])), theme.primaryBlack, theme.grey70, theme.grey100, theme.grey10, theme.grey10, theme.grey40, theme.lochivarAccent4, theme.lochivarAccent4, theme.lochivarAccent3, theme.primary, theme.grey30, theme.grey20, theme.grey100, theme.grey30);

var getAvailabilityReasonForConsole = function getAvailabilityReasonForConsole(serviceReason) {
  if (!serviceReason) {
    return '';
  } else if (serviceReason.indexOf(' is invalid. It must validate regex: ^[a-z][a-z0-9\\-]{3,29}$') > 0) {
    return 'Start with a letter. Must be 4 to 30 lowercase alphanumeric characters or dashes.';
  } else if (serviceReason === 'repository name already exists') {
    return 'That name is already in use.';
  } else {
    return serviceReason;
  }
};

function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var InformationalError = function (_Error) {
  function InformationalError(message, title) {
    var _this;
    _classCallCheck(this, InformationalError);
    _this = _callSuper(this, InformationalError, [message]);
    _this.title = title;
    return _this;
  }
  _inherits(InformationalError, _Error);
  return _createClass(InformationalError);
}(_wrapNativeSuper(Error));

var AnonymousIdentityProvider = function AnonymousIdentityProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(GenericIdentityProvider, {
    identity: {
      user: undefined,
      getAccessToken: function getAccessToken() {
        return Promise.resolve('');
      },
      logout: function logout() {}
    }
  }, children);
};

var AnonymousProvider = function AnonymousProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(AnonymousIdentityProvider, null, children);
};

var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='36' height='36' viewBox='0 0 36 36'%3e %3cdefs%3e %3clinearGradient id='linear-gradient' x1='0.5' x2='0.5' y2='1' gradientUnits='objectBoundingBox'%3e %3cstop offset='0' stop-color='%2370d0d3'/%3e %3cstop offset='1' stop-color='%23048a8f'/%3e %3c/linearGradient%3e %3cclipPath id='clip-Aserto-logo'%3e %3crect width='36' height='36'/%3e %3c/clipPath%3e %3c/defs%3e %3cg id='Aserto-logo' clip-path='url(%23clip-Aserto-logo)'%3e %3crect width='36' height='36' fill='rgba(18%2c18%2c18%2c0)'/%3e %3cg id='Group_13' data-name='Group 13' transform='translate(-726.339 -78.675)'%3e %3cpath id='Subtraction_117' data-name='Subtraction 117' d='M-4032-3964a18.168%2c18.168%2c0%2c0%2c1-3.307-.3%2c17.888%2c17.888%2c0%2c0%2c1-3.1-.87l10-19.617%2c8.307%2c16.289a18.136%2c18.136%2c0%2c0%2c1-2.557%2c1.885%2c17.992%2c17.992%2c0%2c0%2c1-2.875%2c1.416%2c17.93%2c17.93%2c0%2c0%2c1-3.135.891A18.169%2c18.169%2c0%2c0%2c1-4032-3964Zm14.379-7.17L-4032-4000a18.106%2c18.106%2c0%2c0%2c1%2c3.628.365%2c17.889%2c17.889%2c0%2c0%2c1%2c3.378%2c1.049%2c17.985%2c17.985%2c0%2c0%2c1%2c3.058%2c1.66%2c18.121%2c18.121%2c0%2c0%2c1%2c2.664%2c2.2%2c18.181%2c18.181%2c0%2c0%2c1%2c2.2%2c2.664%2c18.015%2c18.015%2c0%2c0%2c1%2c1.66%2c3.058%2c17.867%2c17.867%2c0%2c0%2c1%2c1.049%2c3.379A18.118%2c18.118%2c0%2c0%2c1-4014-3982a17.978%2c17.978%2c0%2c0%2c1-.958%2c5.809%2c17.94%2c17.94%2c0%2c0%2c1-2.663%2c5.02Zm-28.758%2c0a17.927%2c17.927%2c0%2c0%2c1-2.663-5.02A17.966%2c17.966%2c0%2c0%2c1-4050-3982a18.15%2c18.15%2c0%2c0%2c1%2c.367-3.635%2c17.96%2c17.96%2c0%2c0%2c1%2c1.047-3.371%2c18%2c18%2c0%2c0%2c1%2c1.66-3.057%2c18.152%2c18.152%2c0%2c0%2c1%2c2.2-2.664%2c18.145%2c18.145%2c0%2c0%2c1%2c2.664-2.2%2c18%2c18%2c0%2c0%2c1%2c3.058-1.66%2c17.922%2c17.922%2c0%2c0%2c1%2c3.379-1.049A18.157%2c18.157%2c0%2c0%2c1-4032-4000Z' transform='translate(4776.336 4078.675)' fill='url(%23linear-gradient)'/%3e %3c/g%3e %3c/g%3e %3c/svg%3e";

var ScreenContainer = styled.div.withConfig({
  displayName: "login__ScreenContainer",
  componentId: "sc-6ibtmc-0"
})(["display:flex;align-items:stretch;background-color:", ";width:100vw;height:100vh;position:relative;"], function (_ref) {
  var theme = _ref.theme;
  return theme.primaryBlack;
});
var Header = styled.div.withConfig({
  displayName: "login__Header",
  componentId: "sc-6ibtmc-1"
})(["height:80px;width:100vw;background-color:", ";border:1px solid ", ";position:fixed;left:0;top:0;display:flex;justify-content:flex-start;align-items:center;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.grey20;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.grey30;
});
var Body = styled.div.withConfig({
  displayName: "login__Body",
  componentId: "sc-6ibtmc-2"
})(["margin-top:80px;display:flex;width:100vw;flex-direction:column;justify-content:center;"]);
var LoginBoxContainer = styled.div.withConfig({
  displayName: "login__LoginBoxContainer",
  componentId: "sc-6ibtmc-3"
})(["width:540px;background-color:", ";border-radius:6px;margin:auto;display:flex;flex-direction:column;justify-content:space-between;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.grey10;
});
var LogoImg = styled.img.withConfig({
  displayName: "login__LogoImg",
  componentId: "sc-6ibtmc-4"
})(["width:48px;height:48px;margin-left:24px;"]);
var AsertoTitle = styled.div.withConfig({
  displayName: "login__AsertoTitle",
  componentId: "sc-6ibtmc-5"
})(["font-size:20px;font-weight:bold;color:", ";margin-left:6px;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fullWhite;
});
var WelcomeContainer = styled.div.withConfig({
  displayName: "login__WelcomeContainer",
  componentId: "sc-6ibtmc-6"
})(["font-size:var(--title-font-size);color:", ";height:64px;background-color:", ";display:flex;justify-content:flex-start;align-items:center;border-top-left-radius:6px;border-top-right-radius:6px;padding:0 0 0 20px;font-weight:bold;letter-spacing:1px;line-height:24px;"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.grey100;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.grey20;
});
var ContentContainer = styled.div.withConfig({
  displayName: "login__ContentContainer",
  componentId: "sc-6ibtmc-7"
})(["padding:12px 20px;display:flex;flex-direction:column;gap:8px;align-content:center;justify-content:center;"]);
var ContinueButtonContainer = styled(Button).withConfig({
  displayName: "login__ContinueButtonContainer",
  componentId: "sc-6ibtmc-8"
})(["width:100%;height:36px;margin-bottom:24px;"]);
var ApiKeyLogin = function ApiKeyLogin(_ref8) {
  var setApiKey = _ref8.setApiKey,
    loginFunc = _ref8.loginFunc;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    formApiKey = _useState2[0],
    setFormApiKey = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var handleInput = function handleInput(event) {
    setFormApiKey(event.currentTarget.value);
  };
  var handleSubmit = function handleSubmit(event) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var error;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return loginFunc(formApiKey);
          case 3:
            error = _context.sent;
            if (!!error) {
              setErrorMessage("Authentication failed.");
            } else {
              setApiKey(formApiKey);
            }
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            setErrorMessage("Unexpected error.");
          case 10:
            event.preventDefault();
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
  };
  return /*#__PURE__*/React.createElement(ScreenContainer, null, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(LogoImg, {
    alt: "Aserto logo",
    src: img,
    width: "120"
  }), /*#__PURE__*/React.createElement(AsertoTitle, null, "Aserto")), /*#__PURE__*/React.createElement(Body, null, /*#__PURE__*/React.createElement(LoginBoxContainer, null, /*#__PURE__*/React.createElement(WelcomeContainer, null, "Welcome to Aserto Console!"), /*#__PURE__*/React.createElement(ContentContainer, null, "Enter your API key to securely access your account. If you don't have an API key yet, please contact your Administrator to obtain one.", /*#__PURE__*/React.createElement(Input, {
    error: errorMessage,
    placeholder: "Api Key",
    shouldShowHideShowButton: true,
    type: "password",
    onChange: handleInput
  }), /*#__PURE__*/React.createElement(ContinueButtonContainer, {
    disabled: formApiKey === '',
    type: "submit",
    onClick: handleSubmit
  }, "Continue")))));
};

var ApiKeyContext = /*#__PURE__*/React.createContext({
  apiKey: undefined,
  setApiKey: function setApiKey() {},
  loginFunc: function loginFunc() {
    return Promise.resolve(undefined);
  }
});
var ApiKeyIdentityProvider = function ApiKeyIdentityProvider(_ref) {
  var loginFunc = _ref.loginFunc,
    children = _ref.children;
  var _useStorage = useStorage('apiKey', undefined),
    _useStorage2 = _slicedToArray(_useStorage, 2),
    apiKey = _useStorage2[0],
    setApiKey = _useStorage2[1];
  var value = useMemo(function () {
    return {
      apiKey: apiKey,
      setApiKey: setApiKey,
      loginFunc: loginFunc
    };
  }, [apiKey, setApiKey, loginFunc]);
  if (!!apiKey) {
    return /*#__PURE__*/React.createElement(GenericIdentityProvider, {
      identity: {
        user: {
          name: 'API Key'
        },
        getAccessToken: function getAccessToken() {
          return Promise.resolve("Basic ".concat(apiKey));
        },
        logout: function logout() {
          localStorage.removeItem('apiKey');
          window.location.href = '/';
        }
      }
    }, children);
  }
  return /*#__PURE__*/React.createElement(ApiKeyContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(ApiKeyLogin, {
    loginFunc: loginFunc,
    setApiKey: setApiKey
  }));
};

var ApiKeyProvider = function ApiKeyProvider(_ref) {
  var loginFunc = _ref.loginFunc,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(ApiKeyIdentityProvider, {
    loginFunc: loginFunc
  }, children);
};

var OdicIdentityProviderContext = /*#__PURE__*/React.createContext(undefined);
var OidcIdentityProvider = function OidcIdentityProvider(_ref) {
  var oidcClientId = _ref.oidcClientId,
    oidcDomain = _ref.oidcDomain,
    children = _ref.children;
  var _a, _b, _c, _d, _e;
  var auth = useAuth();
  var logout = auth.signOutRedirect,
    oidcUser = auth.userData;
  var wrappedLogout = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var url;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!oidcDomain.endsWith('auth0.com')) {
              _context.next = 7;
              break;
            }
            // @see: https://auth0.com/docs/api/authentication#logout
            // this is workaround for auth0, which has non-conforming session termination.
            url = "".concat(oidcDomain, "/v2/logout?client_id=").concat(oidcClientId, "&returnTo=").concat(encodeURIComponent(window.location.origin));
            window.location.href = url;
            localStorage.clear();
            sessionStorage.clear();
            _context.next = 11;
            break;
          case 7:
            _context.next = 9;
            return logout();
          case 9:
            localStorage.clear();
            sessionStorage.clear();
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  }, [logout, oidcClientId, oidcDomain]);
  var isAuthenticated = useMemo(function () {
    return !!(oidcUser === null || oidcUser === void 0 ? void 0 : oidcUser.id_token);
  }, [oidcUser === null || oidcUser === void 0 ? void 0 : oidcUser.id_token]);
  var getAccessTokenSilently = useCallback(function () {
    var _a;
    return Promise.resolve("Bearer ".concat((_a = auth.userData) === null || _a === void 0 ? void 0 : _a.id_token));
  }, [auth.userData]);
  return isAuthenticated ? (/*#__PURE__*/React.createElement(OdicIdentityProviderContext.Provider, {
    value: null
  }, /*#__PURE__*/React.createElement(GenericIdentityProvider, {
    identity: {
      user: {
        sub: (_a = oidcUser === null || oidcUser === void 0 ? void 0 : oidcUser.profile) === null || _a === void 0 ? void 0 : _a.sub,
        email: (_b = oidcUser === null || oidcUser === void 0 ? void 0 : oidcUser.profile) === null || _b === void 0 ? void 0 : _b.email,
        name: (_c = oidcUser === null || oidcUser === void 0 ? void 0 : oidcUser.profile) === null || _c === void 0 ? void 0 : _c.name,
        picture: (_d = oidcUser === null || oidcUser === void 0 ? void 0 : oidcUser.profile) === null || _d === void 0 ? void 0 : _d.picture,
        nickname: (_e = oidcUser === null || oidcUser === void 0 ? void 0 : oidcUser.profile) === null || _e === void 0 ? void 0 : _e.nickname
      },
      getAccessToken: getAccessTokenSilently,
      logout: wrappedLogout
    }
  }, children))) : null;
};

var OidcProvider = function OidcProvider(_ref) {
  var children = _ref.children,
    oidcClientId = _ref.oidcClientId,
    oidcDomain = _ref.oidcDomain;
  if (oidcClientId && oidcDomain) {
    var configuration = {
      authority: oidcDomain,
      clientId: oidcClientId,
      scope: 'openid profile email',
      redirectUri: window.location.origin,
      revokeTokensOnSignout: true
    };
    return /*#__PURE__*/React.createElement(AuthProvider, Object.assign({}, configuration), /*#__PURE__*/React.createElement(OidcIdentityProvider, {
      oidcClientId: oidcClientId,
      oidcDomain: oidcDomain
    }, children));
  }
  throw Error('Invalid OIDC configuration, please provide a valid OIDC client ID and domain.');
};

function reducer(state, action) {
  switch (action.type) {
    case 'SET_CURRENT_MODAL':
      {
        var modal = action.modal;
        return Object.assign(Object.assign({}, state), {
          currentModal: modal
        });
      }
    default:
      assertUnreachable(action.type);
  }
}
function getInitialState() {
  return {
    currentModal: null
  };
}

var CurrentModalContext = /*#__PURE__*/React.createContext(null);
var CurrentModalContextProvider = function CurrentModalContextProvider(_ref) {
  var children = _ref.children,
    appState = _ref.appState;
  var currentModal = appState.currentModal;
  return /*#__PURE__*/React.createElement(CurrentModalContext.Provider, {
    value: currentModal
  }, children);
};
function useCurrentModalContext() {
  return useContext(CurrentModalContext);
}

var DispatchContext = /*#__PURE__*/React.createContext(function () {});
var DispatchContextProvider = function DispatchContextProvider(_ref) {
  var children = _ref.children,
    dispatch = _ref.dispatch;
  return /*#__PURE__*/React.createElement(DispatchContext.Provider, {
    value: dispatch
  }, children);
};
function useDispatchContext() {
  return useContext(DispatchContext);
}

var AppStateContextProvider = function AppStateContextProvider(_ref) {
  var children = _ref.children;
  var _useReducer = useReducer(reducer, getInitialState()),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    appState = _useReducer2[0],
    dispatch = _useReducer2[1];
  var contextProviders = [CurrentModalContextProvider
  // Add more context providers here
  ];
  for (var _i = 0, _contextProviders = contextProviders; _i < _contextProviders.length; _i++) {
    var ContextProvider = _contextProviders[_i];
    children = /*#__PURE__*/React.createElement(ContextProvider, {
      appState: appState,
      dispatch: dispatch
    }, children);
  }
  return /*#__PURE__*/React.createElement(DispatchContextProvider, {
    dispatch: dispatch
  }, children);
};

export { AccountNameValidator, ActionableInput, AddTypeButton, AnonymousProvider, ApiError, ApiErrorResponseSchema, ApiKeyProvider, AppStateContextProvider, AsertoNameValidator, AsertoNavBar, AsertoNavLink, Assertions, BackendServicesAuthProvider, BaseButtonWithIconElement as BaseIconButton, BigErrorCardModal, Breadcrumb, Button, Card, CardModal, CardText$2 as CardText, Checkbox, CodeEditor, Col, ConfirmationModal, CopyButton$4 as CopyButton, CreateRepoButton, CreateTenantModal, DangerZone, _DataTable as DataTable, Delayed, DeleteConfirmationModal, DeleteModal, DemoAppRequestGeneratorContextProvider, Frame as Directory, DirectoryContextProvider, DirectoryEvaluator, Ellipsis, EmptyTablePlaceholder, ErrorCardModal, ErrorModalProvider, ErrorText, EvaluateDisplayState, Evaluator, FeatureFlagsProvider, Frame, FullScreenModal, FullScreenOnMobile, GenericIdentityProvider, GenericObjectInstance, GlobalStyle, Highlight, Info, InfoText, InformationalError, Input, InternalConfigProvider, InternalProfileProvider, Label$1 as Label, Link, Logout, ManifestDelete, MemberModal, MembersTable, MemoryStorageProvider, Model, ObjectGetQueryKey, ObjectGraph, ObjectInstanceRouter as ObjectInstance, ObjectJson, ObjectProperties, ObjectRelations, ObjectSet, ObjectsSelector as Objects, ObjectsListInfiniteQueryKey, OidcProvider, OptionsButton, OptionsSelect, PaddedContent, PageHeader, PageHeaderContent, PageTitle, PlayButton, DirectoryPlayground as Playground, PolicyCard, PolicyEvaluatorContextProvider, PopoverMenu, RefreshButton, RelationSet, Relations, RelationsListInfiniteQueryKey, RequestGenerator, Row$2 as Row, RowComponent, Select, SelectContainer$4 as SelectContainer, SelectDirectory, SelectWithoutControl, SpinnerProvider, SpinnerToggle, StatusBallWithText, SubHeader$1 as SubHeader, SuccessBannerProvider, SwitchButton, TableContainer, TextArea$1 as TextArea, TooltipDialog, UndecoratedLink, UserCard, UserObjectInstance, ValidatedInput, VerticalTab, VerticalTabs, VerticalTabsLayout, VisualStates, WarningCardModal, createMemoryStorage, ensureError, flatten, getAvailabilityReasonForConsole, getVisualState, isEmailAddressValid, theme, useAsertoApi, useAsertoApiWithAnonymousAccess, useAsertoApiWithAuth, useCurrentModalContext, useDebounce, useDeviceDetect, useDirectoryContext, useDirectoryModelContext, useDirectoryV3ManifestSet, useDispatchContext, useFeatureFlags, useIdentity, useIsAvailableDebounced, useIsIdAvailable as useIsKeyAvailable, useIsScrollable, useLegacyIdentities, useListPolicyModules, useQueryParam, useShowError, useShowSuccessMessage, useStorage, v1Api, v2Api };
